webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	var ngRoute = __webpack_require__(16);
	var ngSanitize = __webpack_require__(37);
	var Raven = __webpack_require__(120);
	var ngRaven = __webpack_require__(29).moduleName;
	__webpack_require__(34);
	
	__webpack_require__(39);
	__webpack_require__(40);
	
	if (true) {
	  // Never bother sending data to sentry
	  Raven.setShouldSendCallback(function() { return false });
	  // Allow Raven.install() to succeed
	  Raven.isSetup = function() { return true; }
	}
	
	Raven
	  .config((""), {
	    release: '1.173.0'
	  })
	  .addPlugin(__webpack_require__(29), angular)
	  .install();
	
	Raven.setTagsContext({
	  environment: ("dev")
	});
	
	
	angular.module('app', [ngRaven, ngRoute, ngSanitize, 'pickadate'])
	  .filter('moment', __webpack_require__(165))
	  .filter('duration', __webpack_require__(161))
	  .filter('durationSeconds', __webpack_require__(162))
	  .filter('weightInKg', __webpack_require__(167))
	  .filter('activeRoutePlans', __webpack_require__(160))
	  .filter('fleetCustomers', __webpack_require__(163))
	  .filter('fleetRoutes', __webpack_require__(164))
	  .filter('receivedSms', __webpack_require__(166))
	  .directive('calendar', __webpack_require__(137))
	  .directive('tooltip', __webpack_require__(159))
	  .directive('spinner', __webpack_require__(157))
	  .directive('initials', __webpack_require__(144))
	  .directive('routeName', __webpack_require__(155))
	  .directive('fileOnChange', __webpack_require__(141))
	  .directive('planCustomersTabs', __webpack_require__(151))
	  .directive('map', __webpack_require__(145))
	  .directive('mapCoordinates', __webpack_require__(146))
	  .directive('moveStopLocation', __webpack_require__(147))
	  .directive('addressHelper', __webpack_require__(135))
	  .directive('page', __webpack_require__(148))
	  .directive('pageHeader', __webpack_require__(149))
	  .directive('pageTitle', __webpack_require__(150))
	  .directive('distributionHeader', __webpack_require__(139))
	  .directive('print', __webpack_require__(153))
	  .directive('deliveryCount', __webpack_require__(138))
	  .directive('statusDeliveries', __webpack_require__(158))
	  .directive('imageModal', __webpack_require__(143))
	  .directive('animateOnChange', __webpack_require__(136))
	  .directive('sortable', __webpack_require__(156))
	  .directive('planRoutesStats', __webpack_require__(152))
	  .directive('fleetDashboardStats', __webpack_require__(142))
	  .directive('downtimeWarnings', __webpack_require__(140))
	  .directive('progressBar', __webpack_require__(154))
	  .service('http', __webpack_require__(198))
	  .service('serverError', __webpack_require__(205))
	  .service('pusher', __webpack_require__(203))
	  .service('load', __webpack_require__(199))
	  .service('login', __webpack_require__(201))
	  .service('router', __webpack_require__(204))
	  .service('modal', __webpack_require__(202))
	  .service('storage', __webpack_require__(206))
	  .service('clock', __webpack_require__(194))
	  .service('editRoute', __webpack_require__(196))
	  .service('editCustomer', __webpack_require__(195))
	  .service('loadScript', __webpack_require__(200))
	  .service('editRoutePlan', __webpack_require__(197))
	  .controller('indexCtrl', __webpack_require__(129))
	  .controller('commonCtrl', __webpack_require__(125))
	  .controller('settingsCtrl', __webpack_require__(133))
	  .controller('planCtrl', __webpack_require__(130))
	  .controller('distributionCtrl', __webpack_require__(126))
	  .controller('planCustomersCtrl', __webpack_require__(131))
	  .controller('planRoutesCtrl', __webpack_require__(132))
	  .controller('fleetCtrl', __webpack_require__(128))
	  .controller('driverUsersCtrl', __webpack_require__(127))
	  .controller('usersCtrl', __webpack_require__(134))
	  .constant('config', __webpack_require__(10).constant)
	  .config(__webpack_require__(10).config)
	  .run(__webpack_require__(10).run);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Merge two attribute objects giving precedence
	 * to values in object `b`. Classes are special-cased
	 * allowing for arrays and merging/joining appropriately
	 * resulting in a string.
	 *
	 * @param {Object} a
	 * @param {Object} b
	 * @return {Object} a
	 * @api private
	 */
	
	exports.merge = function merge(a, b) {
	  if (arguments.length === 1) {
	    var attrs = a[0];
	    for (var i = 1; i < a.length; i++) {
	      attrs = merge(attrs, a[i]);
	    }
	    return attrs;
	  }
	  var ac = a['class'];
	  var bc = b['class'];
	
	  if (ac || bc) {
	    ac = ac || [];
	    bc = bc || [];
	    if (!Array.isArray(ac)) ac = [ac];
	    if (!Array.isArray(bc)) bc = [bc];
	    a['class'] = ac.concat(bc).filter(nulls);
	  }
	
	  for (var key in b) {
	    if (key != 'class') {
	      a[key] = b[key];
	    }
	  }
	
	  return a;
	};
	
	/**
	 * Filter null `val`s.
	 *
	 * @param {*} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function nulls(val) {
	  return val != null && val !== '';
	}
	
	/**
	 * join array as classes.
	 *
	 * @param {*} val
	 * @return {String}
	 */
	exports.joinClasses = joinClasses;
	function joinClasses(val) {
	  return (Array.isArray(val) ? val.map(joinClasses) :
	    (val && typeof val === 'object') ? Object.keys(val).filter(function (key) { return val[key]; }) :
	    [val]).filter(nulls).join(' ');
	}
	
	/**
	 * Render the given classes.
	 *
	 * @param {Array} classes
	 * @param {Array.<Boolean>} escaped
	 * @return {String}
	 */
	exports.cls = function cls(classes, escaped) {
	  var buf = [];
	  for (var i = 0; i < classes.length; i++) {
	    if (escaped && escaped[i]) {
	      buf.push(exports.escape(joinClasses([classes[i]])));
	    } else {
	      buf.push(joinClasses(classes[i]));
	    }
	  }
	  var text = joinClasses(buf);
	  if (text.length) {
	    return ' class="' + text + '"';
	  } else {
	    return '';
	  }
	};
	
	
	exports.style = function (val) {
	  if (val && typeof val === 'object') {
	    return Object.keys(val).map(function (style) {
	      return style + ':' + val[style];
	    }).join(';');
	  } else {
	    return val;
	  }
	};
	/**
	 * Render the given attribute.
	 *
	 * @param {String} key
	 * @param {String} val
	 * @param {Boolean} escaped
	 * @param {Boolean} terse
	 * @return {String}
	 */
	exports.attr = function attr(key, val, escaped, terse) {
	  if (key === 'style') {
	    val = exports.style(val);
	  }
	  if ('boolean' == typeof val || null == val) {
	    if (val) {
	      return ' ' + (terse ? key : key + '="' + key + '"');
	    } else {
	      return '';
	    }
	  } else if (0 == key.indexOf('data') && 'string' != typeof val) {
	    if (JSON.stringify(val).indexOf('&') !== -1) {
	      console.warn('Since Jade 2.0.0, ampersands (`&`) in data attributes ' +
	                   'will be escaped to `&amp;`');
	    };
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will eliminate the double quotes around dates in ' +
	                   'ISO form after 2.0.0');
	    }
	    return ' ' + key + "='" + JSON.stringify(val).replace(/'/g, '&apos;') + "'";
	  } else if (escaped) {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + exports.escape(val) + '"';
	  } else {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + val + '"';
	  }
	};
	
	/**
	 * Render the given attributes object.
	 *
	 * @param {Object} obj
	 * @param {Object} escaped
	 * @return {String}
	 */
	exports.attrs = function attrs(obj, terse){
	  var buf = [];
	
	  var keys = Object.keys(obj);
	
	  if (keys.length) {
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i]
	        , val = obj[key];
	
	      if ('class' == key) {
	        if (val = joinClasses(val)) {
	          buf.push(' ' + key + '="' + val + '"');
	        }
	      } else {
	        buf.push(exports.attr(key, val, false, terse));
	      }
	    }
	  }
	
	  return buf.join('');
	};
	
	/**
	 * Escape the given string of `html`.
	 *
	 * @param {String} html
	 * @return {String}
	 * @api private
	 */
	
	var jade_encode_html_rules = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;'
	};
	var jade_match_html = /[&<>"]/g;
	
	function jade_encode_char(c) {
	  return jade_encode_html_rules[c] || c;
	}
	
	exports.escape = jade_escape;
	function jade_escape(html){
	  var result = String(html).replace(jade_match_html, jade_encode_char);
	  if (result === '' + html) return html;
	  else return result;
	};
	
	/**
	 * Re-throw the given `err` in context to the
	 * the jade in `filename` at the given `lineno`.
	 *
	 * @param {Error} err
	 * @param {String} filename
	 * @param {String} lineno
	 * @api private
	 */
	
	exports.rethrow = function rethrow(err, filename, lineno, str){
	  if (!(err instanceof Error)) throw err;
	  if ((typeof window != 'undefined' || !filename) && !str) {
	    err.message += ' on line ' + lineno;
	    throw err;
	  }
	  try {
	    str = str || __webpack_require__(207).readFileSync(filename, 'utf8')
	  } catch (ex) {
	    rethrow(err, null, lineno)
	  }
	  var context = 3
	    , lines = str.split('\n')
	    , start = Math.max(lineno - context, 0)
	    , end = Math.min(lines.length, lineno + context);
	
	  // Error context
	  var context = lines.slice(start, end).map(function(line, i){
	    var curr = i + start + 1;
	    return (curr == lineno ? '  > ' : '    ')
	      + curr
	      + '| '
	      + line;
	  }).join('\n');
	
	  // Alter exception message
	  err.path = filename;
	  err.message = (filename || 'Jade') + ':' + lineno
	    + '\n' + context + '\n\n' + err.message;
	  throw err;
	};
	
	exports.DebugItem = function DebugItem(lineno, filename) {
	  this.lineno = lineno;
	  this.filename = filename;
	}


/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(5);
	
	module.exports.toObject = function(array) {
	  return array.reduce(function(object, value) {
	    if (value) object[value.id] = value;
	    return object;
	  }, {});
	};
	
	module.exports.mapDrivers = function(drivers) {
	  return drivers.reduce(function (driver, value) {
	    if (value) driver[value.userName] = value;
	    return driver;
	  },{});
	}
	
	module.exports.values = function(object) {
	  return Object.keys(object).map(function(key) {
	    return object[key];
	  });
	};
	
	module.exports.toDate = function(timestamp) {
	  if (typeof timestamp !== 'string') return timestamp;
	  return moment(timestamp).startOf('minute').toDate();
	};
	
	var toTime = function(time) {
	  if (time) {
	    if (typeof time === 'string') {
	      time = time.trim();
	    }
	
	    if (typeof time === 'string') {
	      if (time.length === 4) {
	        return time.slice(0, 2) + ':' + time.slice(2, 4);
	      }
	      if (time.length === 5) {
	        return time;
	      }
	    }
	
	    // Assumes full timestamp to be parsed
	    var mom = moment(time);
	    if (mom.isValid()) {
	      return mom.format('HH:mm');
	    }
	  }
	  return time || null;
	};
	module.exports.toTime = toTime;
	
	module.exports.toDateWithTime = function(date, time) {
	  var hh_mm = toTime(time);
	  if (date && hh_mm) {
	    var hh = time.slice(0, 2);
	    var mm = time.slice(3, 5);
	
	    return moment(date).hour(hh).minute(mm).startOf('minute');
	  }
	  return null;
	};
	
	module.exports.toDateNoon = function(dateString) {
	  return moment.utc(dateString).hours(12).toISOString(); // Set to noon
	};
	
	module.exports.isSameDay = function(date1, date2) {
	  return moment(date1).isSame(date2, 'day');
	};
	
	module.exports.delayInMinutes = function(timestamp, estimatedTimestamp) {
	  if (timestamp && estimatedTimestamp && timestamp > estimatedTimestamp) {
	    var ms = timestamp.getTime() - estimatedTimestamp.getTime();
	    return Math.floor(ms / 60000);
	  }
	};
	
	module.exports.delayForHumans = function(delayInMinutes) {
	  if (delayInMinutes) {
	    var hours = Math.floor(delayInMinutes / 60);
	    var days = Math.floor(hours / 24);
	
	    if (days) return '';
	    if (hours >= 2) return '+' + hours + 'h';
	    return '+' + delayInMinutes + 'm';
	  }
	};
	
	module.exports.formatZip = function(zip, countryCode) {
	  if (countryCode.toUpperCase() === 'NO') {
	    return ('0000' + zip).slice(-4);
	  } else {
	    return zip; // TODO Add more country-rules
	  }
	};
	
	module.exports.formatPhone = function(phone) {
	  phone = (phone || '').replace(/\s/g, '');
	
	  if (phone.length >= 10) {
	    phone = phone.replace(/^\+?47/, '');
	  }
	
	  if (phone.length === 8) {
	    phone = phone.slice(0, 3) + ' ' + phone.slice(3, 5) + ' ' + phone.slice(5, 8);
	  }
	
	  return phone;
	};
	
	module.exports.driverName = function(driverUsername, drivers) {
	  var driver = drivers[driverUsername];
	
	  if (! driver) return '';
	
	  return (driver.firstName ? driver.firstName : driver.name);
	};
	
	module.exports.latinize = function(rawInput) {
	  // http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
	  var base64map="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";
	  var Latinise={};
	  Latinise.latin_map=JSON.parse(decodeURIComponent(escape(atob(base64map))));
	  return rawInput.replace(/[^A-Za-z0-9\[\] ]/g, function(a){
	    return Latinise.latin_map[a] || a;
	  });
	};
	
	module.exports.aggregateProductsForCustomers = function(customers) {
	  var productMap = {};
	
	  customers.forEach(function(customer) {
	    customer.deliveries.forEach(function(delivery) {
	      if (delivery.notCancelled()) {
	        if (productMap[delivery.product]) {
	          productMap[delivery.product].count += delivery.productCount;
	        } else {
	          productMap[delivery.product] = { name: delivery.product, count: delivery.productCount };
	        }
	      }
	    });
	  });
	
	  return productMap;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var en = __webpack_require__(112);
	var nb = __webpack_require__(114);
	var sv = __webpack_require__(115);
	var fr = __webpack_require__(113);
	
	var moment = __webpack_require__(6);
	
	var fallbackLanguage = 'en';
	var language = fallbackLanguage;
	var translations = { en: en, nb: nb, sv: sv, fr: fr };
	
	module.exports.getLanguage = function() {
	  return language;
	};
	
	module.exports.setLanguage = function(lang) {
	  //console.log('translate.setLanguage('+lang+')');
	  language = lang;
	
	  moment.locale(lang); // Keep i18n-locale in moment-lib in sync
	};
	
	module.exports.t = function(key) {
	  //console.log('translate t', language, key);
	  var output = translations[language][key];
	  if (output && arguments.length > 1) {
	    for (i=1; i<arguments.length; i++) {
	      output = output.replace(new RegExp('%'+i, 'g'), arguments[i]);
	    }
	  }
	  return (output == null? '{'+key+'}' : output);
	};
	
	module.exports.tu = function(key) {
	  return t(key).toUpperCase();
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(6);
	__webpack_require__(27);
	
	function useColonAsTimeSeparator(formats) {
	  for (var key in formats) {
	    formats[key] = formats[key].replace('H.', 'H:');
	  }
	}
	
	moment.locale('nb');
	useColonAsTimeSeparator(moment.localeData('nb')._longDateFormat);
	
	moment.updateLocale('nb', {
	  longDateFormat: {
	    lll: 'dddd D. MMMM',
	    llll: 'dddd D. MMMM YYYY'
	  }
	});
	
	moment.updateLocale('en', {
	  longDateFormat: {
	    LT: 'HH:mm',
	    lll: 'dddd, MMMM D',
	    llll: 'dddd, MMMM D, YYYY'
	  }
	});
	
	module.exports = moment;


/***/ },
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var t = __webpack_require__(4).t;
	
	function File(file) {
	  angular.extend(this, file);
	}
	
	File.prototype.customerSystemIds = function(customers) {
	  if (this.customerSystemId) {
	    return [this.customerSystemId];
	  }
	
	  return customers
	    .filter(function(customer) {
	      return customer.fileId === this.id;
	    }, this)
	    .map(function(customer) {
	      return customer.customerSystemId;
	    })
	    .filter(function(id, index, list) {
	      return list.indexOf(id) === index;
	    });
	};
	
	File.prototype.statusClass = function() {
	  if (this.id === File.individual.id) return 'manual';
	  if (this.status === 0) return 'uploading';
	  if (this.status === 1) return 'linking';
	  if (this.status === 3) return 'error';
	  return 'done';
	};
	
	File.prototype.errorMessage = function(key, map) {
	  var fieldName, fieldValue;
	
	  if (map && map['user.import.file.error.incomplete.row']) {
	    var rowNumber = map['user.import.file.error.incomplete.row'];
	    return t('planFilesIncompleteRowError', rowNumber);
	  } else if (map && map['user.import.file.error.missing.property.name']) {
	    fieldName = map['user.import.file.error.missing.property.name'];
	    return t('planFilesMissingPropertyNameError', fieldName);
	  } else if (map && map['user.import.file.error.invalid.property.length']) {
	    fieldName = map['user.import.file.error.invalid.property.length'];
	    return t('planFilesInvalidPropertyLengthError', fieldName);
	  } else if (map && map['user.import.file.error.duplicate.order-line-ids']) {
	    fieldName = map['user.import.file.error.duplicate.order-line-ids'];
	    return t('planFilesDuplicateOrderLineIdError', fieldName);
	  } else if (map && map['user.import.file.error.duplicate.parcel-numbers']) {
	    fieldName = map['user.import.file.error.duplicate.parcel-numbers'];
	    return t('planFilesDuplicateParcelNumberError', fieldName);
	  } else if (map && map['user.import.file.error.duplicate.header']) {
	    details = map['user.import.file.error.duplicate.header'];
	    return details;
	  } else if (map && map['user.import.file.error.unknown.header']) {
	    columnNames = map['user.import.file.error.unknown.header'];
	    return t('planFilesUnknownHeaderError', columnNames);
	  } else if (key === 'user.import.file.error.unsupported-file-type') {
	    return t('planFilesUnknownFileTypeError');
	  } else if (key === 'user.import.file.datatype.error') {
	    for (fieldName in map) {  // There should be only one entry
	      fieldValue = map[fieldName];
	    }
	    return t('planFilesDatatypeError', fieldValue, fieldName);
	  } else if (key === 'linker.failed') {
	    return t('planFilesAddressLinkerError');
	  } else {
	    return t('planFilesUnknownError');
	  }
	};
	
	File.individual = new File({
	  id: 'individual',
	  name: t('planFilesIndividual')
	});
	
	module.exports = File;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(30);
	
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function isObject(what) {
	  return typeof what === 'object' && what !== null;
	}
	
	// Yanked from https://git.io/vS8DV re-used under CC0
	// with some tiny modifications
	function isError(value) {
	  switch (Object.prototype.toString.call(value)) {
	    case '[object Error]':
	      return true;
	    case '[object Exception]':
	      return true;
	    case '[object DOMException]':
	      return true;
	    default:
	      return value instanceof Error;
	  }
	}
	
	function isErrorEvent(value) {
	  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
	}
	
	function isDOMError(value) {
	  return Object.prototype.toString.call(value) === '[object DOMError]';
	}
	
	function isDOMException(value) {
	  return Object.prototype.toString.call(value) === '[object DOMException]';
	}
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function isPlainObject(what) {
	  return Object.prototype.toString.call(what) === '[object Object]';
	}
	
	function isString(what) {
	  return Object.prototype.toString.call(what) === '[object String]';
	}
	
	function isArray(what) {
	  return Object.prototype.toString.call(what) === '[object Array]';
	}
	
	function isEmptyObject(what) {
	  if (!isPlainObject(what)) return false;
	
	  for (var _ in what) {
	    if (what.hasOwnProperty(_)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function supportsErrorEvent() {
	  try {
	    new ErrorEvent(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsDOMError() {
	  try {
	    new DOMError(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsDOMException() {
	  try {
	    new DOMException(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsFetch() {
	  if (!('fetch' in _window)) return false;
	
	  try {
	    new Headers(); // eslint-disable-line no-new
	    new Request(''); // eslint-disable-line no-new
	    new Response(); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	// https://caniuse.com/#feat=referrer-policy
	// It doesn't. And it throw exception instead of ignoring this parameter...
	// REF: https://github.com/getsentry/raven-js/issues/1233
	function supportsReferrerPolicy() {
	  if (!supportsFetch()) return false;
	
	  try {
	    // eslint-disable-next-line no-new
	    new Request('pickleRick', {
	      referrerPolicy: 'origin'
	    });
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsPromiseRejectionEvent() {
	  return typeof PromiseRejectionEvent === 'function';
	}
	
	function wrappedCallback(callback) {
	  function dataCallback(data, original) {
	    var normalizedData = callback(data) || data;
	    if (original) {
	      return original(normalizedData) || normalizedData;
	    }
	    return normalizedData;
	  }
	
	  return dataCallback;
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	function objectMerge(obj1, obj2) {
	  if (!obj2) {
	    return obj1;
	  }
	  each(obj2, function(key, value) {
	    obj1[key] = value;
	  });
	  return obj1;
	}
	
	/**
	 * This function is only used for react-native.
	 * react-native freezes object that have already been sent over the
	 * js bridge. We need this function in order to check if the object is frozen.
	 * So it's ok that objectFrozen returns false if Object.isFrozen is not
	 * supported because it's not relevant for other "platforms". See related issue:
	 * https://github.com/getsentry/react-native-sentry/issues/57
	 */
	function objectFrozen(obj) {
	  if (!Object.isFrozen) {
	    return false;
	  }
	  return Object.isFrozen(obj);
	}
	
	function truncate(str, max) {
	  if (typeof max !== 'number') {
	    throw new Error('2nd argument to `truncate` function should be a number');
	  }
	  if (typeof str !== 'string' || max === 0) {
	    return str;
	  }
	  return str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return Object.prototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	  // Combine an array of regular expressions and strings into one large regexp
	  // Be mad.
	  var sources = [],
	    i = 0,
	    len = patterns.length,
	    pattern;
	
	  for (; i < len; i++) {
	    pattern = patterns[i];
	    if (isString(pattern)) {
	      // If it's a string, we need to escape it
	      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	    } else if (pattern && pattern.source) {
	      // If it's a regexp already, we want to extract the source
	      sources.push(pattern.source);
	    }
	    // Intentionally skip other cases
	  }
	  return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	  var pairs = [];
	  each(o, function(key, value) {
	    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	  });
	  return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	  if (typeof url !== 'string') return {};
	  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	
	  // coerce to undefined values to empty string so we don't get 'undefined'
	  var query = match[6] || '';
	  var fragment = match[8] || '';
	  return {
	    protocol: match[2],
	    host: match[4],
	    path: match[5],
	    relative: match[5] + query + fragment // everything minus origin
	  };
	}
	function uuid4() {
	  var crypto = _window.crypto || _window.msCrypto;
	
	  if (!isUndefined(crypto) && crypto.getRandomValues) {
	    // Use window.crypto API if available
	    // eslint-disable-next-line no-undef
	    var arr = new Uint16Array(8);
	    crypto.getRandomValues(arr);
	
	    // set 4 in byte 7
	    arr[3] = (arr[3] & 0xfff) | 0x4000;
	    // set 2 most significant bits of byte 9 to '10'
	    arr[4] = (arr[4] & 0x3fff) | 0x8000;
	
	    var pad = function(num) {
	      var v = num.toString(16);
	      while (v.length < 4) {
	        v = '0' + v;
	      }
	      return v;
	    };
	
	    return (
	      pad(arr[0]) +
	      pad(arr[1]) +
	      pad(arr[2]) +
	      pad(arr[3]) +
	      pad(arr[4]) +
	      pad(arr[5]) +
	      pad(arr[6]) +
	      pad(arr[7])
	    );
	  } else {
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	      var r = (Math.random() * 16) | 0,
	        v = c === 'x' ? r : (r & 0x3) | 0x8;
	      return v.toString(16);
	    });
	  }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	  /* eslint no-extra-parens:0*/
	  var MAX_TRAVERSE_HEIGHT = 5,
	    MAX_OUTPUT_LEN = 80,
	    out = [],
	    height = 0,
	    len = 0,
	    separator = ' > ',
	    sepLength = separator.length,
	    nextStr;
	
	  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	    nextStr = htmlElementAsString(elem);
	    // bail out if
	    // - nextStr is the 'html' element
	    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	    //   (ignore this limit if we are on the first iteration)
	    if (
	      nextStr === 'html' ||
	      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
	    ) {
	      break;
	    }
	
	    out.push(nextStr);
	
	    len += nextStr.length;
	    elem = elem.parentNode;
	  }
	
	  return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	  var out = [],
	    className,
	    classes,
	    key,
	    attr,
	    i;
	
	  if (!elem || !elem.tagName) {
	    return '';
	  }
	
	  out.push(elem.tagName.toLowerCase());
	  if (elem.id) {
	    out.push('#' + elem.id);
	  }
	
	  className = elem.className;
	  if (className && isString(className)) {
	    classes = className.split(/\s+/);
	    for (i = 0; i < classes.length; i++) {
	      out.push('.' + classes[i]);
	    }
	  }
	  var attrWhitelist = ['type', 'name', 'title', 'alt'];
	  for (i = 0; i < attrWhitelist.length; i++) {
	    key = attrWhitelist[i];
	    attr = elem.getAttribute(key);
	    if (attr) {
	      out.push('[' + key + '="' + attr + '"]');
	    }
	  }
	  return out.join('');
	}
	
	/**
	 * Returns true if either a OR b is truthy, but not both
	 */
	function isOnlyOneTruthy(a, b) {
	  return !!(!!a ^ !!b);
	}
	
	/**
	 * Returns true if both parameters are undefined
	 */
	function isBothUndefined(a, b) {
	  return isUndefined(a) && isUndefined(b);
	}
	
	/**
	 * Returns true if the two input exception interfaces have the same content
	 */
	function isSameException(ex1, ex2) {
	  if (isOnlyOneTruthy(ex1, ex2)) return false;
	
	  ex1 = ex1.values[0];
	  ex2 = ex2.values[0];
	
	  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;
	
	  // in case both stacktraces are undefined, we can't decide so default to false
	  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;
	
	  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
	}
	
	/**
	 * Returns true if the two input stack trace interfaces have the same content
	 */
	function isSameStacktrace(stack1, stack2) {
	  if (isOnlyOneTruthy(stack1, stack2)) return false;
	
	  var frames1 = stack1.frames;
	  var frames2 = stack2.frames;
	
	  // Exit early if frame count differs
	  if (frames1.length !== frames2.length) return false;
	
	  // Iterate through every frame; bail out if anything differs
	  var a, b;
	  for (var i = 0; i < frames1.length; i++) {
	    a = frames1[i];
	    b = frames2[i];
	    if (
	      a.filename !== b.filename ||
	      a.lineno !== b.lineno ||
	      a.colno !== b.colno ||
	      a['function'] !== b['function']
	    )
	      return false;
	  }
	  return true;
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  if (obj == null) return;
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  obj[name].__raven__ = true;
	  obj[name].__orig__ = orig;
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns {string}
	 */
	function safeJoin(input, delimiter) {
	  if (!isArray(input)) return '';
	
	  var output = [];
	
	  for (var i = 0; i < input.length; i++) {
	    try {
	      output.push(String(input[i]));
	    } catch (e) {
	      output.push('[value cannot be serialized]');
	    }
	  }
	
	  return output.join(delimiter);
	}
	
	// Default Node.js REPL depth
	var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
	// 50kB, as 100kB is max payload size, so half sounds reasonable
	var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
	var MAX_SERIALIZE_KEYS_LENGTH = 40;
	
	function utf8Length(value) {
	  return ~-encodeURI(value).split(/%..|./).length;
	}
	
	function jsonSize(value) {
	  return utf8Length(JSON.stringify(value));
	}
	
	function serializeValue(value) {
	  if (typeof value === 'string') {
	    var maxLength = 40;
	    return truncate(value, maxLength);
	  } else if (
	    typeof value === 'number' ||
	    typeof value === 'boolean' ||
	    typeof value === 'undefined'
	  ) {
	    return value;
	  }
	
	  var type = Object.prototype.toString.call(value);
	
	  // Node.js REPL notation
	  if (type === '[object Object]') return '[Object]';
	  if (type === '[object Array]') return '[Array]';
	  if (type === '[object Function]')
	    return value.name ? '[Function: ' + value.name + ']' : '[Function]';
	
	  return value;
	}
	
	function serializeObject(value, depth) {
	  if (depth === 0) return serializeValue(value);
	
	  if (isPlainObject(value)) {
	    return Object.keys(value).reduce(function(acc, key) {
	      acc[key] = serializeObject(value[key], depth - 1);
	      return acc;
	    }, {});
	  } else if (Array.isArray(value)) {
	    return value.map(function(val) {
	      return serializeObject(val, depth - 1);
	    });
	  }
	
	  return serializeValue(value);
	}
	
	function serializeException(ex, depth, maxSize) {
	  if (!isPlainObject(ex)) return ex;
	
	  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
	  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;
	
	  var serialized = serializeObject(ex, depth);
	
	  if (jsonSize(stringify(serialized)) > maxSize) {
	    return serializeException(ex, depth - 1);
	  }
	
	  return serialized;
	}
	
	function serializeKeysForMessage(keys, maxLength) {
	  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
	  if (!Array.isArray(keys)) return '';
	
	  keys = keys.filter(function(key) {
	    return typeof key === 'string';
	  });
	  if (keys.length === 0) return '[object has no keys]';
	
	  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
	  if (keys[0].length >= maxLength) return keys[0];
	
	  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
	    var serialized = keys.slice(0, usedKeys).join(', ');
	    if (serialized.length > maxLength) continue;
	    if (usedKeys === keys.length) return serialized;
	    return serialized + '\u2026';
	  }
	
	  return '';
	}
	
	function sanitize(input, sanitizeKeys) {
	  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
	    return input;
	
	  var sanitizeRegExp = joinRegExp(sanitizeKeys);
	  var sanitizeMask = '********';
	  var safeInput;
	
	  try {
	    safeInput = JSON.parse(stringify(input));
	  } catch (o_O) {
	    return input;
	  }
	
	  function sanitizeWorker(workerInput) {
	    if (isArray(workerInput)) {
	      return workerInput.map(function(val) {
	        return sanitizeWorker(val);
	      });
	    }
	
	    if (isPlainObject(workerInput)) {
	      return Object.keys(workerInput).reduce(function(acc, k) {
	        if (sanitizeRegExp.test(k)) {
	          acc[k] = sanitizeMask;
	        } else {
	          acc[k] = sanitizeWorker(workerInput[k]);
	        }
	        return acc;
	      }, {});
	    }
	
	    return workerInput;
	  }
	
	  return sanitizeWorker(safeInput);
	}
	
	module.exports = {
	  isObject: isObject,
	  isError: isError,
	  isErrorEvent: isErrorEvent,
	  isDOMError: isDOMError,
	  isDOMException: isDOMException,
	  isUndefined: isUndefined,
	  isFunction: isFunction,
	  isPlainObject: isPlainObject,
	  isString: isString,
	  isArray: isArray,
	  isEmptyObject: isEmptyObject,
	  supportsErrorEvent: supportsErrorEvent,
	  supportsDOMError: supportsDOMError,
	  supportsDOMException: supportsDOMException,
	  supportsFetch: supportsFetch,
	  supportsReferrerPolicy: supportsReferrerPolicy,
	  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
	  wrappedCallback: wrappedCallback,
	  each: each,
	  objectMerge: objectMerge,
	  truncate: truncate,
	  objectFrozen: objectFrozen,
	  hasKey: hasKey,
	  joinRegExp: joinRegExp,
	  urlencode: urlencode,
	  uuid4: uuid4,
	  htmlTreeAsString: htmlTreeAsString,
	  htmlElementAsString: htmlElementAsString,
	  isSameException: isSameException,
	  isSameStacktrace: isSameStacktrace,
	  parseUrl: parseUrl,
	  fill: fill,
	  safeJoin: safeJoin,
	  serializeException: serializeException,
	  serializeKeysForMessage: serializeKeysForMessage,
	  sanitize: sanitize
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	var moment = __webpack_require__(6);
	
	var util = __webpack_require__(3);
	var Delivery = __webpack_require__(12);
	var File = __webpack_require__(7);
	
	function Customer(customer) {
	  angular.extend(this, customer);
	  this.updateDeliveryEstimate(customer);
	  this.fileId = this.fileId || File.individual.id;
	  this.fullAddress = fullAddress(this);
	  this.latitude = this.latitude || null;
	  this.longitude = this.longitude || null;
	  this.description = this.description && this.description.replace(/\\n/g, '\n');
	  this.deliveries = (this.deliveries || [])
	    .map(function(delivery) {
	      return new Delivery(delivery, this);
	    }, this)
	    .sort(function(d1, d2) {
	      return d1.product.localeCompare(d2.product);
	    });
	  this.notifications = (this.notifications || []);
	  this.callLogs = (this.callLogs || []);
	}
	
	function fullAddress(customer) {
	  // TODO handle missing values
	  return customer.address + ', ' + customer.zipAndCity();
	}
	
	Customer.prototype.deliveryCount = function() {
	  return this.deliveries.filter(function(delivery) {
	    return delivery.deliveryStatus !== 11; // CANCELLED
	  }).length;
	};
	
	Customer.prototype.hasReceivedComingSms = function() {
	  var received = false;
	  if(this.notifications.length != 0 ) {
	      this.notifications.forEach(function(notification) {
	          if(notification.isComingNotification && this.routeId === notification.routeId) {
	              received = true;
	          }
	      }, this);
	  }
	
	  return received;
	};
	
	Customer.prototype.zipAndCity = function() {
	  return util.formatZip(this.zip, this.country) + ' ' + this.city;
	};
	
	Customer.prototype.findDelivery = function(deliveryId) {
	  return this.deliveries.filter(function(delivery) {
	    return delivery.id === deliveryId;
	  })[0];
	};
	
	Customer.prototype.findDeliveries = function(status) {
	  return this.deliveries.filter(function(delivery) {
	    return delivery.status === status;
	  });
	};
	
	Customer.prototype.filterDeliveries = function(status, delayed) {
	  return this.deliveries.filter(function(delivery) {
	    return (! status || delivery.status === status) &&
	           (! delayed || delivery.delayed());
	  });
	};
	
	Customer.prototype.delayed = function() {
	  return this.deliveries.some(function(delivery) {
	    return delivery.delayed();
	  });
	};
	
	Customer.prototype.estimateOutsideDeliveryWindow = function() {
	  if (! this.estimatedTimestampDone || ! this.deliveryWindow()) return;
	
	  var tooEarly = moment(this.estimatedTimestampDone).isBefore(this.deliveryWindowStart);
	  var tooLate = moment(this.estimatedTimestampDone).isAfter(this.deliveryWindowStop);
	
	  if (tooEarly || tooLate) {
	    return true;
	  }
	};
	
	Customer.prototype.outsideDeliveryWindow = function(start, stop) {
	  if (start && this.deliveryWindowStop && moment(this.deliveryWindowStop).isSameOrBefore(start)) {
	    return true;
	  }
	  if (stop && this.deliveryWindowStart && moment(this.deliveryWindowStart).isSameOrAfter(stop)) {
	    return true;
	  }
	};
	
	Customer.prototype.notCancelled = function() {
	  return this.deliveries.some(function(delivery) {
	    return delivery.notCancelled();
	  });
	};
	
	Customer.prototype.allCancelled = function() {
	  return this.deliveries.every(function(delivery) {
	    return delivery.status === 'cancelled';
	  });
	};
	
	// Customer has at least ONE deviation and NONE delivered and NONE unaccounted for
	Customer.prototype.allDeviationOrCancelled = function() {
	  return this.anyDeviations() && this.deliveries.every(function(delivery) {
	    return delivery.status === 'deviation' || delivery.status === 'cancelled';
	  });
	};
	
	Customer.prototype.allDelivered = function() {
	  if (! this.notCancelled()) return false; // All cancelled - none have been handled by driver
	
	  return this.deliveries.every(function(delivery) {
	    return delivery.allDelivered() || ! delivery.notCancelled();
	  });
	};
	
	Customer.prototype.anyDelivered = function() {
	  return this.deliveries.some(function(delivery) {
	    return delivery.status === 'delivered' || delivery.status === 'partiallyDelivered';
	  });
	};
	
	Customer.prototype.anyDeliveries = function() {
	  return this.deliveries.some(function(delivery) {
	    return delivery.notCancelled();
	  });
	};
	
	Customer.prototype.anyDeviations = function() {
	  return this.deliveries.some(function(delivery) {
	    return delivery.status === 'deviation';
	  });
	};
	
	Customer.prototype.anyUnAccountedDeliveries = function() {
	  return this.deliveries.some(function(delivery) {
	    return (delivery.deliveryStatus === 0 || delivery.deliveryStatus === 6);
	  });
	};
	
	Customer.prototype.anyProductCounts = function() {
	  return this.deliveries.some(function(delivery) {
	    return delivery.productCount > 1;
	  });
	};
	
	Customer.prototype.deliveryStatusTimestamp = function() {
	  var timestamp = 0;
	
	  this.deliveries.forEach(function(delivery) {
	    if (delivery.showStatus() && delivery.statusTimestamp > timestamp) {
	      timestamp = delivery.statusTimestamp;
	    }
	  });
	
	  return timestamp || undefined;
	};
	
	Customer.prototype.updateDeliveryEstimate = function(data) {
	  this.estimatedTimestampDone = util.toDate(data.estimatedTimestampDone);
	};
	
	Customer.prototype.updateRouteSequence = function(data) {
	  this.routeSequence = data.routeSequence;
	};
	
	Customer.prototype.deliveryWindow = function() {
	  if (this.deliveryWindowStart || this.deliveryWindowStop) {
	    var start = this.deliveryWindowStart ? moment(this.deliveryWindowStart).format('HH:mm') : '';
	    var stop = this.deliveryWindowStop ? moment(this.deliveryWindowStop).format('HH:mm') : '';
	    return start + '-' + stop;
	  }
	};
	
	Customer.prototype.editable = function() {
	  return this.fileId === File.individual.id;
	};
	
	Customer.prototype.deletable = function(routePlanHasRoutes) {
	  return this.editable() && ! routePlanHasRoutes && this.id;
	};
	
	Customer.prototype.cancellable = function(routePlanHasRoutes, cancelled) {
	  return (! this.editable() || routePlanHasRoutes) && this.id && ! cancelled;
	};
	
	Customer.prototype.editClone = function() {
	  var customer = {
	    deliveries: this.deliveries.map(function(delivery) {
	      return delivery.editClone();
	    })
	  };
	
	  var props = ['id', 'routePlanId', 'fileId', 'customerSystemId', 'orderId', 'name', 'co', 'phone1', 'phone2',
	               'deliveryWindowStart', 'deliveryWindowStop', 'duration', 'address', 'zip', 'city',
	               'country', 'latitude', 'longitude', 'deliveryPointId', 'transportPointId',
	               'editable', 'deletable', 'cancellable', 'findDelivery', 'anyProductCounts', 'description', 'imageUrl', 'suggestedRoute', 'routeId', 'stopLocationId'];
	
	  props.forEach(function(prop) {
	    customer[prop] = this[prop];
	  }, this);
	
	  return customer;
	};
	
	module.exports = Customer;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(5);
	var translate = __webpack_require__(4);
	
	config.$inject = ['$routeProvider', '$localeProvider', 'pickadateI18nProvider', 'routerProvider'];
	
	function config($routeProvider, $localeProvider, pickadateI18nProvider, routerProvider) {
	  routerProvider.$get().config($routeProvider);
	  configPickadate($localeProvider, pickadateI18nProvider);
	}
	
	function configPickadate($localeProvider, pickadateI18nProvider) {
	  pickadateI18nProvider.translations = {
	    prev: '<',
	    next: '>'
	  };
	
	  // Hack to get norwegian month and day names in the calendar
	  // (angular-pickadate gets the translations from Angular's $locale service)
	  $localeProvider.$get = function() {
	    return {
	      id: 'nb',
	
	      DATETIME_FORMATS: {
	        MONTH: moment.localeData('nb')._months,
	        SHORTDAY: moment.localeData('nb')._weekdaysMin
	      },
	
	      // Used by the Angular number filter
	      NUMBER_FORMATS: {
	        DECIMAL_SEP: ',',
	        GROUP_SEP: '\u00a0',
	        PATTERNS: [{
	          lgSize: 3,
	          negPre: '-',
	          negSuf: '',
	          posPre: '',
	          posSuf: ''
	        }]
	      }
	    };
	  };
	}
	
	run.$inject = ['$document', '$rootScope', 'login', 'storage', 'config'];
	
	function run($document, $rootScope, login, storage, config) {
	  login.checkAuth();
	
	  login.initLanguage();
	
	  $rootScope.t = translate.t; // Set global i18n-method
	  $rootScope.tu = translate.tu; // Set global i18n-method
	
	  // Hack to enable click events on any element in iOS
	  $document.one('touchstart', function() {
	    $document.find('body').css('cursor', 'pointer');
	  });
	}
	
	module.exports = {
	  constant: {
	    languages: [
	      { id: 'en', name: 'English' },
	      { id: 'nb', name: 'Norsk' },
	      { id: 'fr', name: 'Français' },
	      { id: 'sv', name: 'Svenska' },
	      //{ id: 'fi', name: 'Suomalainen' }
	    ],
	    // This has to match the CSS! (variables.styl)
	    routeColors: [
	      '#479ff6',
	      '#d9441d',
	      '#772cb5',
	      '#21897e',
	      '#e27012',
	      '#447db5',
	      '#4ec2d3',
	      '#f6c347',
	      '#07529c',
	      '#6C210f',
	      '#411863',
	      '#4ad3c6',
	      '#f2b27b',
	      '#89add2',
	      '#8dd7e2',
	      '#fae09e'
	    ]
	  },
	  config: config,
	  run: run
	};
	
	window.HW_config = {
	  selector: '#HW_wrapper',
	  account: 'wx84nx',
	  translations: {
	    title: 'Siste endringer',
	    readMore: 'Les mer'
	  }
	};


/***/ },
/* 11 */
/***/ function(module, exports) {

	var countDone = function(list) {
	  return list.filter(function(object) {
	    return object.allDelivered();
	  }).length;
	};
	
	var countNotCancelled = function(list) {
	  return list.filter(function(object) {
	    return object.notCancelled();
	  }).length;
	};
	
	var countDelivered = function(list) {
	  return list.filter(function(object) {
	    return object.anyDelivered();
	  }).length;
	};
	
	var countDeviation = function(list) {
	  return list.filter(function(object) {
	    return object.allDeviationOrCancelled();
	  }).length;
	};
	
	var countCancelled = function(list) {
	  return list.filter(function(object) {
	    return object.allCancelled();
	  }).length;
	};
	
	function Count(stops) {
	  this.stops = stops;
	
	  this.countStopLocationsNotCancelled = function() {
	    return countNotCancelled(stops);
	  };
	
	  this.countCustomers = function() {
	    return stops.reduce(function(count, stop) {
	      return count + stop.customers.length;
	    }, 0);
	  };
	
	  this.countCustomersNotCancelled = function() {
	    return stops.reduce(function(count, stop) {
	      return count + countNotCancelled(stop.customers);
	    }, 0);
	  };
	
	  this.countDeliveriesNotCancelled = function() {
	    return stops.reduce(function(count, stop) {
	      return count + countNotCancelled(stop.deliveries());
	    }, 0);
	  };
	
	  this.countCustomersDelivered = function() {
	    return stops.reduce(function(count, stop) {
	      return count + countDelivered(stop.customers);
	    }, 0);
	  };
	
	  this.countCustomersCancelled = function() {
	    return stops.reduce(function(count, stop) {
	      return count + countCancelled(stop.customers);
	    }, 0);
	  };
	
	  this.countCustomersDeviation = function() {
	    return stops.reduce(function(count, stop) {
	      return count + countDeviation(stop.customers);
	    }, 0);
	  };
	
	  this.countStopLocationsDone = function() {
	    return countDone(stops);
	  };
	
	  this.countCustomersDone = function() {
	    return stops.reduce(function(count, stop) {
	      return count + countDone(stop.customers);
	    }, 0);
	  };
	
	  this.countDeliveriesDone = function() {
	    return stops.reduce(function(count, stop) {
	      return count + countDone(stop.deliveries());
	    }, 0);
	  };
	
	}
	
	module.exports = Count;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var util = __webpack_require__(3);
	
	function Delivery(delivery, customer) {
	  angular.extend(this, delivery);
	  this.status = this.getStatus();
	  this.statusTimestamp = util.toDate(this.deliveryStatusTimestamp);
	  this.estimatedTimestamp = customer.estimatedTimestampDone;
	}
	
	Delivery.prototype.getStatus = function() {
	  var status = this.deliveryStatus || 0;
	  if (status === 1 || status === 2 || status === 12 || status === 13 || status === 15) {
	    return 'delivered';
	  } else if (status === 14) {
	    return 'partiallyDelivered';
	  } else if (status === 0 || status === 6) {
	    return 'notDelivered';
	  } else if (status === 11) {
	    return 'cancelled';
	  } else {
	    return 'deviation';
	  }
	};
	
	Delivery.prototype.delayed = function() {
	  if (this.status === 'notDelivered') {
	    return this.estimatedTimestamp && new Date() > this.estimatedTimestamp;
	  } else {
	    return this.statusTimestamp && this.estimatedTimestamp &&
	           this.statusTimestamp > this.estimatedTimestamp;
	  }
	};
	
	Delivery.prototype.notCancelled = function() {
	  return this.status !== 'cancelled';
	};
	
	Delivery.prototype.allDelivered = function() {
	  return this.status !== 'notDelivered' && this.status !== 'cancelled';
	};
	
	Delivery.prototype.showStatus = function() {
	  return ! (this.deliveryStatus === 0 || this.deliveryStatus === 6 || this.deliveryStatus === 11);
	};
	
	Delivery.prototype.editClone = function() {
	  var delivery = {};
	
	  ['id', 'product', 'productCount', 'productCountAdjusted', 'orderLineId', 'parcelNumber', 'getStatus', 'deliveryStatus'].forEach(function(prop) {
	    delivery[prop] = this[prop];
	  }, this);
	
	  return delivery;
	};
	
	module.exports = Delivery;


/***/ },
/* 13 */
/***/ function(module, exports) {

	/* global ol */
	
	var deliveredIcon = '<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg">' +
	  '<path d="M3.197 5.814L.893 3.51l-.768.768L3.197 7.35 9.78.768 9.01 0 3.198 5.814z" fill="white" />' +
	  '</svg>';
	
	var deviationIcon = '<svg width="7" height="8" viewBox="0 0 7 8" xmlns="http://www.w3.org/2000/svg">' +
	  '<path d="M4.12 4L6.87 1.247a.437.437 0 1 0-.62-.62L3.5 3.382.747.63a.438.438 0 1 0-.62.62L2.882 4 .13 6.753a.437.437 0 1 0 .62.62L3.5 4.618 6.253 7.37a.436.436 0 0 0 .62 0 .437.437 0 0 0 0-.62L4.118 4z" fill="white" />' +
	  '</svg>';
	
	var icons = {
	  delivered: deliveredIcon,
	  deviation: deviationIcon
	};
	
	function Style() {
	  this.iconCache = {};
	  this.textCache = {};
	}
	
	Style.prototype.circleStyle = function(coordinates, resolution, radius, color, highlight) {
	  var stroke = null;
	
	  if(highlight){
	    stroke = new ol.style.Stroke({
	      color: 'white',
	      width: 5
	    });
	  }
	
	  return new ol.style.Style({
	    geometry: new ol.geom.Circle(coordinates, resolution * radius),
	    fill: new ol.style.Fill({
	      color: color
	    }),
	    stroke: stroke
	  });
	};
	
	Style.prototype.iconStyle = function(icon, scale) {
	  if (! this.iconCache[icon]) {
	    this.iconCache[icon] = new ol.style.Style({
	      image: new ol.style.Icon({
	        scale: scale || 1,
	        src: 'data:image/svg+xml;charset=UTF-8;base64,' + window.btoa([icons[icon]])
	      })
	    });
	  }
	
	  return this.iconCache[icon];
	};
	
	Style.prototype.textStyle = function(text) {
	  if (! this.textCache[text]) {
	    this.textCache[text] = new ol.style.Style({
	      text: new ol.style.Text({
	        text: text,
	        font: '12px DIN-Regular',
	        offsetY: 1,
	        fill: new ol.style.Fill({
	          color: 'white'
	        })
	      })
	    });
	  }
	
	  return this.textCache[text];
	};
	
	// options.radius [required]
	// options.color [required]
	// options.delivered [boolean]
	// options.deviation [boolean
	// options.text
	Style.prototype.circle = function(options, feature, resolution) {
	  if (feature && feature.getGeometry()) {
	    var coordinates = feature.getGeometry().getCoordinates();
	    var circle = this.circleStyle(coordinates, resolution, options.radius, options.color, options.highlight);
	    var icon;
	    var text;
	
	    if (options.deviation) {
	      icon = this.iconStyle('deviation');
	    } else if (options.delivered) {
	      icon = this.iconStyle('delivered');
	    } else if (options.text) {
	      text = this.textStyle(options.text);
	      if (/^\d+$/.test(options.text)) {
	        circle.setZIndex(options.text);
	        text.setZIndex(options.text);
	      }
	    }
	
	    if (icon) return [circle, icon];
	    if (text) return [circle, text];
	    return circle;
	  } else {
	    console.log('circle - Missing important args', options, feature, resolution);
	  }
	};
	
	var style = new Style();
	
	module.exports = style.circle.bind(style);


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var angular = __webpack_require__(2);
	
	module.exports.coordinate = function(location) {
	  var coordinate = [location.longitude, location.latitude];
	
	  return ol.proj.transform(coordinate, 'EPSG:4326', 'EPSG:3857');
	};
	
	module.exports.point = function(location) {
	  return new ol.geom.Point(module.exports.coordinate(location));
	};
	
	module.exports.equalCoordinates = function(coordinate1, coordinate2) {
	  return angular.equals(coordinate1 || null, coordinate2 || null);
	};


/***/ },
/* 15 */
/***/ function(module, exports) {

	function StopLocation(customer, route) {
	  this.id = customer.stopLocationId;
	  this.routeSequence = customer.routeSequence;
	  this.address = customer.fullAddress;
	  this.latitude = customer.latitude;
	  this.longitude = customer.longitude;
	  this.customers = [customer];
	  this.route = route;
	}
	
	StopLocation.prototype.addCustomer = function(customer) {
	  this.customers.push(customer);
	};
	
	StopLocation.prototype.deliveries = function() {
	  return this.customers.reduce(function(deliveries, customer) {
	    return deliveries.concat(customer.deliveries);
	  }, []);
	};
	
	StopLocation.prototype.deliveryCount = function() {
	  return this.customers.reduce(function(count, customer) {
	    return count + customer.deliveries.length;
	  }, 0);
	};
	
	StopLocation.prototype.customerNotCancelledCount = function() {
	  return this.customers.reduce(function(count, customer) {
	    return count + customer.notCancelled();
	  }, 0);
	};
	
	StopLocation.prototype.notCancelled = function() {
	  return this.customers.some(function(customer) {
	    return customer.notCancelled();
	  });
	};
	
	StopLocation.prototype.allDelivered = function() {
	  if (! this.notCancelled()) return false; // All cancelled - none have been handled by driver
	
	  return this.customers.every(function(customer) {
	    return customer.allDelivered() || ! customer.notCancelled();
	  });
	};
	
	StopLocation.prototype.anyDeviations = function() {
	  return this.customers.some(function(customer) {
	    return customer.anyDeviations();
	  });
	};
	
	StopLocation.prototype.anyComingNotifications = function() {
	  return this.customers.some(function(customer) {
	    return customer.hasReceivedComingSms();
	  });
	};
	
	StopLocation.prototype.anyUnAccountedDeliveries = function() {
	  return this.customers.some(function(customer) {
	    return customer.anyUnAccountedDeliveries();
	  });
	};
	
	StopLocation.prototype.updateRouteSequence = function(data) {
	  this.routeSequence = data.routeSequence;
	};
	
	
	module.exports = StopLocation;


/***/ },
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <distribution-header></distribution-header>\n</page>\n<main>\n  <table>\n    <thead>\n      <tr>\n        <th class=\"stopno\">{{ t('fleetDelStop') }}</th>\n        <th class=\"product\">{{ t('cProduct') }}</th>\n        <th></th>\n        <th>{{ t('customerOrder') }}</th>\n        <th>{{ t('cCustomer') }}</th>\n        <th></th>\n        <th>{{ t('customerPhone1') }}</th>\n        <th>{{ t('cRoute') }}</th>\n        <th ng-show=\"page !== 'distribution-deviations'\" class=\"estimate\">{{ t('fleetDelArrival') }}</th>\n        <th ng-show=\"page === 'distribution-deviations'\" sortable=\"deliveryStatusTimestamp\" function reverse default class=\"estimate\">{{ t('fleetDelArrival') }}</th>\n        <th ng-show=\"auth.roles.clientPlus\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"customer in customers | orderBy:orderBy.property:orderBy.reverse\" class=\"{{ customer.notCancelled() ? 'notCancelled' : 'cancelledCustomer' }}\">\n        <td class=\"stopno\"><span class=\"circle color-{{ customer.route.color }}\">{{ customer.routeSequence }}</span></td>\n        <td class=\"product\">\n          <status-deliveries customer=\"customer\"></status-deliveries>\n        </td>\n        <td>{{ customerSystems[customer.customerSystemId].shortName }}</td>\n        <td>{{ customer.orderId }}</td>\n        <td><span tooltip=\"deliveryInfoTooltipTemplate\" class=\"delivery-info\"><span>{{ customer.name }}</span></span>\n          <div class=\"address\">{{ customer.fullAddress() }}</div>\n        </td>\n        <td><span ng-show=\"customer.notifications.length\" tooltip=\"notificationsTooltipTemplate\" class=\"notifications\"></span>\n          <image-modal customer=\"customer\" ng-if=\"customer.imageUrl\"></image-modal>\n        </td>\n        <td><span ng-show=\"customer.callLogs.length &gt; 0\" tooltip=\"customerCallLogTooltipTemplate\" class=\"callLog\"><span class=\"phone\">{{ formatPhone(customer.phone1) }}</span><br><span ng-if=\"customer.phone2\" class=\"phone\">{{ formatPhone(customer.phone2) }}</span></span><span ng-show=\"customer.callLogs.length === 0\"><span class=\"phone\">{{ formatPhone(customer.phone1) }}</span><br><span ng-if=\"customer.phone2\" class=\"phone\">{{ formatPhone(customer.phone2) }}</span></span></td>\n        <td><span tooltip=\"routeInfoTooltipTemplate\" class=\"route-info\"><span>{{ customer.route.name }}</span></span></td>\n        <td class=\"estimate\"><span tooltip=\"customerTimestampTooltipTemplate\" ng-class=\"{ delayed: customer.delayed(), visited: customer.deliveryStatusTimestamp() }\" class=\"customer-timestamp\"><span>{{ (customer.deliveryStatusTimestamp() ? customer.estimatedTimestampDone : estimatedTimeAdjustedByRoute(customer.estimatedTimestampDone, customer.routeId)) | moment: 'LT' }}</span><span>{{ customer.deliveryStatusTimestamp() | moment: 'LT' }}</span></span></td>\n        <td ng-show=\"auth.roles.clientPlus\">\n          <div ng-if=\"!customer.routeId\"><a href=\"{{ router.link('plan/customers', customer.routePlanId) }}\" class=\"link\">{{ t('distributionShowCustomers') }}</a></div>\n          <div ng-if=\"customer.routeId\" class=\"vertical-links\"><a href=\"{{ router.link('fleet/dashboard/map', customer.routePlanId) }}?routeId={{customer.routeId}}&amp;routeSequence={{customer.routeSequence}}\" class=\"link\">{{ t('distributionShowRouteMap') }}</a><a href=\"{{ router.link('fleet/deliveries', customer.routePlanId) }}/{{customer.routeId}}//{{customer.orderId}}\" class=\"link\">{{ t('distributionShowRouteCustomer') }}</a></div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</main>");;return buf.join("");
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page class=\"plan-routes\">\n  <page-header>\n    <page-title></page-title>\n  </page-header>\n  <plan-routes-stats></plan-routes-stats>\n  <main>\n    <h3 ng-show=\"routePlan.unlinkedCustomers().length\">Avvik ({{ routePlan.unlinkedCustomers().length }})</h3>\n    <table ng-show=\"routePlan.unlinkedCustomers().length\" class=\"deviation\">\n      <thead>\n        <tr>\n          <th>{{ t('cAddress') }}</th>\n          <th>{{ t('cCustomer') }}</th>\n          <th>{{ t('customerDeadline') }}</th>\n          <th>{{ t('cSupplier') }}</th>\n          <th>{{ t('customerParcels') }}</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"customer in routePlan.unlinkedCustomers() | orderBy: 'stopLocationId'\" ng-class-odd=\"'odd'\">\n          <td class=\"address\">{{ customer.fullAddress }}</td>\n          <td class=\"name\">{{ customer.name }}</td>\n          <td class=\"time\">{{ customer.deliveryWindow() }}</td>\n          <td>{{ customerSystems[customer.customerSystemId].shortName }}</td>\n          <td>\n            <delivery-count customer=\"customer\"></delivery-count>\n          </td>\n          <td class=\"right\">\n            <button ng-click=\"openMoveStopLocation(toStopLocation(customer))\" href=\"#\" ng-disabled=\"! auth.roles.planner\" class=\"link\">{{ t('moveModalMoveToRoute') }}</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <h3 ng-show=\"! reserveRoutes\">{{ t('planRoutesHeader') }}</h3>\n    <h3 ng-show=\"reserveRoutes\">{{ t('planRoutesReserveHeader') }}<span class=\"subtitle\">{{ t('planRoutesReserveSubTitle') }}</span></h3>\n    <table ng-show=\"filteredRoutes.length\" class=\"routes\">\n      <thead>\n        <tr>\n          <th>{{ t('cRoute') }}</th>\n          <th></th>\n          <th>{{ t('planRoutesAssigned') }}</th>\n          <th>{{ t('planRoutesStop') }}</th>\n          <th>{{ t('planRoutesWeight') }}</th>\n          <th>{{ t('planRoutesLength') }}</th>\n          <th>{{ t('planRoutesStartDone') }}</th>\n          <th>{{ t('planRoutesDrivingDuration') }}</th>\n          <th>{{ t('planRoutesTotalDuration') }}</th>\n          <th><span tooltip=\"customersPerHourTooltipTemplate\" class=\"cph-info\">{{ t('planRoutesCustomersPerHour') }}</span></th>\n          <th style=\"padding-left: 0\">\n            <button ng-if=\"routePlan.routesThatNeedOptimization().length &gt; 0 &amp;&amp; ! reserveRoutes\" ng-disabled=\"! auth.roles.planner\" ng-click=\"optimizeAllNeededRoutes(routePlan)\" class=\"action\">{{ t('planRoutesOptimizeAllBtn') }}</button>\n          </th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat-start=\"route in filteredRoutes = (routePlan.routes | fleetRoutes: routeFilter | orderBy: 'name') track by route.id\" ng-class-odd=\"'odd'\" class=\"{{ expandedRoutes[route.id] ? 'expanded' : 'collapsed' }}\">\n          <td class=\"route\"><a href=\"{{ router.link('plan/routes/map', routePlan.id) }}?routeId={{route.id}}\">\n              <route-name></route-name></a></td>\n          <td class=\"edit\"><a ng-if=\"canEditRouteInfo(routePlan)\" ng-click=\"openEditRoute($event, route)\" href=\"#\"></a></td>\n          <td>\n            <div class=\"driverWrapperPlan\"><span ng-if=\"route.driverUsername\" class=\"driverIcon\"></span><span ng-if=\"route.autoAssignedDriver\" class=\"driverIconAutoAssigned\">{{ t('taggedAutoAssignedPlan') }}</span><span ng-if=\"route.driverUsername\" class=\"driverNamePlan\">\n                {{ drivers[route.driverUsername].firstName.trim() }}\n                {{ drivers[route.driverUsername].phone }}</span><a ng-if=\"canEditRouteInfo(routePlan)\" ng-click=\"openEditRoute($event, route)\" href=\"#\" class=\"assign\"><span ng-if=\"! route.driverUsername\">{{ t('fleetDashAssign') }}</span></a></div>\n          </td>\n          <td>{{ route.stopLocations.length }}</td>\n          <td>{{ route.weight | weightInKg }}</td>\n          <td ng-if=\"! route.durationTotal\" colspan=\"5\" class=\"waiting-for-meta-data\">\n            <spinner ng-show=\"route.stopLocations.length &gt; 0\"></spinner>\n          </td>\n          <td ng-if=\"route.durationTotal\">{{ (route.length ? route.length : '< 1') + ' km' }}</td>\n          <td ng-if=\"route.durationTotal\" ng-class=\"{ deviation: route.estimateOutsideDeliveryWindow() }\">{{ route.estimatedTimestampStart && (route.estimatedTimestampStart | moment: 'LT') + '-' + (route.estimatedTimestampStop | moment: 'LT') }}</td>\n          <td ng-if=\"route.durationTotal\">{{ route.durationDriving | duration }}</td>\n          <td ng-if=\"route.durationTotal\">{{ route.durationTotal | duration }}</td>\n          <td ng-if=\"route.durationTotal\">{{ route.durationTotal ? ((60 * route.customerCount / route.durationTotal) | number : 1) : '' }}</td>\n          <td class=\"optimize\">\n            <div ng-if=\"route.optimizationStatus !== 5 &amp;&amp; route.stopLocations.length &gt; 2\" class=\"button-group\">\n              <button ng-click=\"optimizeRoute(route)\" ng-disabled=\"route.optimizationStatus !== -1 || ! canMoveStops(routePlan)\" ng-class=\"{ failed: route.optimizationStatus === 5 }\" class=\"action\"><span ng-if=\"route.optimizationStatus === 0 || route.optimizationStatus === -1\">{{ t('planRoutesOptimizeBtn') }}</span><span ng-if=\"route.optimizationStatus &gt;= 1 &amp;&amp; route.optimizationStatus &lt;= 4\">{{ t('routeOptimStatus' + route.optimizationStatus) }}</span></button>\n              <button ng-if=\"route.optimizationStatus === 0 || route.optimizationStatus === -1\" ng-click=\"openOptimizeRouteWithOptions(route)\" ng-disabled=\"! canMoveStops(routePlan)\" class=\"action\"><span>{{ (route.forcedFirstStopLocationId || route.forcedLastStopLocationId) ? '&#10003;' : '+' }}</span></button>\n            </div>\n            <button ng-if=\"route.optimizationStatus === 5\" ng-click=\"toggleFailedInfo(route)\" class=\"action failed\"><span>{{ t('routeOptimTooManyCustomers') }}</span></button>\n          </td>\n          <td><a ng-click=\"toggleExpandRoute($event, route)\" href=\"#\"></a></td>\n        </tr>\n        <tr ng-show=\"showFailedInfoRoutes[route.id] &amp;&amp; route.optimizationStatus === 5\">\n          <td colspan=\"10\">\n            <div ng-show=\"route.customerTimeWindows.length === 1\" ng-bind-html=\"t('planRoutesOptimizeWithTimeWindowFailedSameInterval', route.customerTimeWindows[0])\" class=\"failed-info\"></div>\n            <div ng-show=\"route.customerTimeWindows.length &gt; 1\" ng-bind-html=\"t('planRoutesOptimizeWithTimeWindowFailedMultipleIntervals')\" class=\"failed-info\"></div>\n          </td>\n          <td colspan=\"2\" class=\"optimize\">\n            <button ng-click=\"clearTimeWindowsAndOptimizeRoute(route)\" ng-disabled=\"route.customerTimeWindows.length &gt; 1\" class=\"action\">{{ t('planRoutesOptimizeWithoutTimeWindow') }}</button>\n          </td>\n        </tr>\n        <tr ng-repeat-end ng-if=\"expandedRoutes[route.id]\">\n          <td colspan=\"12\">\n            <table class=\"stop-locations\">\n              <tbody move-stop-location=\"moveStopLocation\" data-route-id=\"{{ route.id }}\">\n                <tr ng-if=\"route.stopLocations.length\" class=\"move-all\">\n                  <td></td>\n                  <td class=\"checkbox\">\n                    <label>\n                      <input type=\"checkbox\" ng-checked=\"allStopsSelected(route)\" ng-click=\"selectAllStops($event, route)\">\n                    </label>\n                  </td>\n                  <td colspan=\"7\" class=\"optimize\">\n                    <button ng-click=\"openMoveStopLocations(route)\" ng-disabled=\"! canMoveStops(routePlan) || ! countStopsSelected(route)\" class=\"action\">{{ countStopsSelected(route) > 1 ? t('planRoutesMoveStops', countStopsSelected(route)) : t('planRoutesMoveStop') }}</button>\n                  </td>\n                </tr>\n                <tr ng-repeat=\"stop in route.stopLocations | orderBy: 'routeSequence'\" data-stop-location-id=\"{{ stop.id }}\" ng-class=\"{ cancelled: ! stop.notCancelled() }\" class=\"stop-location\">\n                  <td ng-class=\"{ 'move': canMoveStops(routePlan) &amp;&amp; stop.anyUnAccountedDeliveries(), 'drag': canMoveStops(routePlan) &amp;&amp; stop.anyUnAccountedDeliveries() }\"></td>\n                  <td ng-class=\"{ 'hide': ! stop.anyUnAccountedDeliveries() }\" class=\"checkbox\">\n                    <label>\n                      <input type=\"checkbox\" ng-checked=\"selectedStops[route.id][stop.id]\" ng-click=\"selectStop($event, stop)\">\n                    </label>\n                  </td>\n                  <td style=\"padding-right:0\">{{ stop.routeSequence }}.</td>\n                  <td class=\"address\">{{ stop.address }}</td>\n                  <td class=\"name\">\n                    <div ng-repeat=\"customer in stop.customers | orderBy: 'id'\" ng-class=\"{ cancelled: ! customer.notCancelled() }\">{{ customer.name }}</div>\n                  </td>\n                  <td ng-if=\"route.durationTotal\" class=\"time\">\n                    <div ng-repeat=\"customer in stop.customers | orderBy: 'id'\"><span ng-class=\"{ deviation: customer.estimateOutsideDeliveryWindow() }\">{{ customer.estimatedTimestampDone | moment: 'LT' }}</span></div>\n                  </td>\n                  <td class=\"time\">\n                    <div ng-repeat=\"customer in stop.customers | orderBy: 'id'\">{{ customer.deliveryWindow() }}</div>\n                  </td>\n                  <td>\n                    <div ng-repeat=\"customer in stop.customers | orderBy: 'id'\">{{ customerSystems[customer.customerSystemId].shortName }}</div>\n                  </td>\n                  <td>\n                    <div ng-repeat=\"customer in stop.customers | orderBy: 'id'\">\n                      <delivery-count customer=\"customer\"></delivery-count>\n                    </div>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <div ng-if=\"! reserveRoutes\" class=\"buttons\">\n      <button type=\"button\" ng-click=\"deleteRoutes(routePlan)\" ng-disabled=\"! auth.roles.planner\" class=\"link\">{{ t('planRoutesDeleteAllRoutes') }}</button>\n      <button type=\"button\" ng-click=\"addRoute($event, routePlan)\" ng-disabled=\"! auth.roles.planner\" class=\"action\">{{ t('planRoutesNewRouteBtn') }}</button>\n    </div>\n    <div ng-if=\"reserveRoutes\" class=\"buttons\"><a href=\"{{ router.link('fleet/dashboard/list', routePlan.id) }}\" class=\"link\">{{ t('planRoutesBackToDashboardBtn') }}</a>\n      <button type=\"button\" ng-click=\"addReserveRoute($event, routePlan)\" ng-disabled=\"! (auth.roles.fleetManager || auth.roles.clientPlus)\" class=\"action\">{{ t('planRoutesNewReserveRouteBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"cell\"><span class=\"label\">{{ t('fleetDelCallLog') }}</span>\n    <div ng-repeat=\"callLog in customer.callLogs\"><span>{{ callLog.timestampCalled | moment: 'LT' }}</span></div>\n  </div>\n  <div ng-if=\"drivers\" class=\"cell\"><span class=\"label\">{{ t('fleetDelCallLogDriver') }}</span>\n    <div ng-repeat=\"callLog in customer.callLogs\"><span>{{ driverName(callLog.driverUsername, drivers) }}</span></div>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-hide=\"customer.deliveryStatusTimestamp()\">\n  <div ng-hide=\"routeDelayByRouteId(customer.routeId)\">\n    <div class=\"planned full\"><span class=\"label\">{{ t('fleetDelTimePlanned') }}</span><span>{{ customer.estimatedTimestampDone | moment: 'LT' }}</span></div>\n  </div>\n  <div ng-show=\"routeDelayByRouteId(customer.routeId)\">\n    <div class=\"planned\"><span class=\"label\">{{ t('fleetDelTimePlanned') }}</span><span>{{ customer.estimatedTimestampDone | moment: 'LT' }}</span></div>\n    <div class=\"delayedRoute\"><span class=\"label\">{{ t('fleetDelTimeRouteDelay') }}</span><span>&nbsp; {{ routeDelayByRouteId(customer.routeId) }}</span></div>\n    <div class=\"recalculated\"><span class=\"label\">{{ t('fleetDelTimeCalculated') }}</span><span>{{ estimatedTimeAdjustedByRoute(customer.estimatedTimestampDone, customer.routeId) | moment: 'LT' }}</span></div>\n  </div>\n</div>\n<div ng-show=\"customer.deliveryStatusTimestamp()\">\n  <div class=\"planned\"><span class=\"label\">{{ t('fleetDelTimePlanned') }}</span><span>{{ customer.estimatedTimestampDone | moment: 'LT' }}</span></div>\n  <div class=\"delayedRoute\"><span class=\"label\">{{ t('fleetDelTimeRouteDelay') }}</span><span>{{ delayedCustomer(customer.clientSideTimestampDone, customer.estimatedTimestampDone) }} &nbsp;</span></div>\n  <div></div>\n  <div ng-if=\"customer.clientSideTimestampDone\" class=\"clientSide\"><span class=\"label\">{{ t('fleetDelTimeDeliveredClientSide') }}</span><span>{{ customer.clientSideTimestampDone | moment: 'LT' }}</span></div>\n  <div class=\"serverSide\"><span class=\"label\">{{ t('fleetDelTimeDeliveredServerSide') }}</span><span>{{ customer.deliveryStatusTimestamp() | moment: 'LT' }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div ng-if=\"customer.deliveryWindow()\" class=\"cell\"><span class=\"label\">{{ t('customerDeadline') }}</span><span>{{ customer.deliveryWindow() }}</span></div>\n</div>\n<div ng-if=\"customer.description\" class=\"description\">\n  <div class=\"label\">{{ t('customerDirective') }}</div>\n  <div>{{ customer.description }}</div>\n</div>");;return buf.join("");
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div ng-class=\"{ border: delivery.parcelNumber || delivery.orderLineId || delivery.showStatus() }\" class=\"status\"><span class=\"{{ delivery.status }} delivery-status\"></span><span>{{ t('delStatus' + delivery.deliveryStatus) }}</span></div>\n  <div ng-if=\"delivery.showStatus()\" class=\"cell\"><span class=\"label\">{{ t('fleetDelAcknowledged') }}</span><span>{{ delivery.showStatus() ? (delivery.statusTimestamp | moment: 'LT') : '&nbsp;' }}</span></div>\n  <div ng-if=\"delivery.parcelNumber\" class=\"cell\"><span class=\"label\">{{ t('fleetDelParcelNumber') }}</span><span>{{ delivery.parcelNumber || '&nbsp;' }}</span></div>\n  <div ng-if=\"delivery.orderLineId\" class=\"cell\"><span class=\"label\">{{ t('fleetDelOrderLine') }}</span><span>{{ delivery.orderLineId || '&nbsp;' }}</span></div>\n</div>\n<div ng-if=\"delivery.comment\" class=\"description\">\n  <div class=\"label\">{{ t('fleetDelDriverComment') }}</div>\n  <div>{{ delivery.comment }}</div>\n</div>");;return buf.join("");
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form id=\"{{ move.close ? 'moveStopLocation' : '' }}\" ng-submit=\"moveStopLocation(move.stop, move.oldIndex, +move.newIndex, move.route.id)\" name=\"form\">\n  <button type=\"button\" ng-if=\"move.close\" ng-click=\"move.close()\" class=\"close\"></button>\n  <div>\n    <div ng-if=\"move.stop.route\" class=\"route-name color-{{ move.stop.route.color % routeColors.length }}\">{{ move.stop.route.name }}</div>\n    <div ng-if=\"! move.stop.notCancelled()\" class=\"cancelled-notice\">{{ t('moveModalCancelled') }}</div>\n    <div ng-class=\"{ cancelled: ! move.stop.notCancelled() }\" class=\"address\"><span ng-if=\"move.stop.routeSequence\">{{ move.stop.routeSequence }}. &nbsp;</span>{{ move.stop.address }}</div>\n    <div ng-repeat=\"customer in move.stop.customers\" ng-class=\"{ cancelled: ! customer.notCancelled() }\" class=\"customer\"><span>{{ customer.deliveryWindow() }}</span><span>{{ customerSystems[customer.customerSystemId].shortName }}</span><span>{{ customer.deliveries.length }}</span><span>{{ customer.name }}</span></div>\n  </div>\n  <div class=\"select-route\">\n    <label>{{ t('moveModalMoveToRoute') }}</label>\n    <div class=\"select\">\n      <select ng-options=\"route as route.nameAndDriver(drivers, true) for route in routePlan.routes | filter: move.routeFilter | orderBy: 'name'\" ng-model=\"move.route\" ng-change=\"move.routeSelected(move.route)\">\n        <option value=\"\">{{ t('moveModalMoveToRouteChoose') }}</option>\n      </select>\n    </div>\n    <label>{{ t('moveModalPlaceAfter') }}</label>\n    <div class=\"select\">\n      <select ng-model=\"move.newIndex\" ng-disabled=\"! move.route\" required>\n        <option ng-if=\"! move.route\" value=\"\">{{ t('moveModalPlaceAfterChoose') }}</option>\n        <option value=\"0\">0. {{ t('moveModalPlaceAfterStart') }}</option>\n        <option ng-repeat=\"stop in move.route.stopLocations | orderBy:'routeSequence'\" value=\"{{ $index + 1 }}\">\n           \n          {{ stop.routeSequence }}. \n          {{ ! stop.notCancelled() ? t('moveModalPlaceAfterCancelled') : '' }}\n          {{ stop.address }}\n          {{ $last ? t('moveModalLastStop') : '' }}\n        </option>\n      </select>\n    </div>\n  </div>\n  <div class=\"multi-move-tip\"><b>{{ t('moveModalMultiTipTitle') }}</b><span>{{ t('moveModalMultiTipDescription', ctrlKey) }}</span></div>\n  <div>\n    <button type=\"button\" ng-if=\"move.map &amp;&amp; ! move.next &amp;&amp; canEditRouteInfo(routePlan)\" ng-click=\"openEditRoute($event, move.stop.route)\" class=\"link\">{{ t('moveModalEditRoute') }}</button>\n    <button type=\"button\" ng-if=\"move.next\" ng-click=\"move.next()\" class=\"link\">{{ t('moveModalNextStop') }}</button>\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('cSave') }}</button>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form id=\"moveStopLocations\" ng-submit=\"moveStopLocations(multiMove.stops, multiMove.route.id)\" name=\"form\">\n  <button type=\"button\" ng-if=\"multiMove.close\" ng-click=\"multiMove.close()\" class=\"close\"></button>\n  <div ng-if=\"multiMove.oldRoute\" class=\"route-name color-{{ multiMove.oldRoute.color % routeColors.length }}\">{{ multiMove.oldRoute.name }}</div>\n  <div>{{ t('moveModalCustomersSelected', multiMove.customerCount()) }}</div>\n  <div class=\"select-route\">\n    <label>{{ t('moveModalMoveToRoute') }}</label>\n    <div class=\"select\">\n      <select ng-options=\"route as route.nameAndDriver(drivers, true) for route in routePlan.routes | filter: multiMove.routeFilter | orderBy: 'name'\" ng-model=\"multiMove.route\" ng-required=\"true\">\n        <option value=\"\">{{ t('moveModalMoveToRouteChoose') }}</option>\n      </select>\n    </div>\n  </div>\n  <div>\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('cSave') }}</button>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-repeat=\"notification in customer.notifications\">\n  <div class=\"cell\"><span class=\"label\">{{ t('notificationSent') }}</span><span>{{ notification.timestampSent | moment: 'LT' }}</span></div>\n  <div class=\"cell\"><span ng-if=\"!notification.simulation\" class=\"label\">{{ t('notificationMsg') }}</span><span ng-if=\"notification.simulation\" class=\"label\">{{ t('notificationMsgSimulation') }}</span><span class=\"msg\">{{ notification.templateName }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"status\"><span class=\"{{ routeStatusClass(route) || route.status() }}\"></span><span class=\"no-gps-text\">Ingen GPS</span><span>{{ t(route.timestampStart ? (route.timestampStop ? 'statusDone' : 'statusStarted') : 'statusNotStarted') }}</span></div>\n<div class=\"started\"><span class=\"label\">{{ t((route.timestampStart || (auth.roles.client && ! auth.roles.clientPlus)) ? 'statusStarted' : 'statusEstimatedStart') }}</span><span class=\"estimate\">{{ route.estimatedTimestampStart | moment:'LT' }}</span><span ng-if=\"route.timestampStart\" ng-class=\"{ delayed: route.timestampStart &gt; route.estimatedTimestampStart }\">{{ route.timestampStart | moment:'LT' }}</span><span ng-if=\"(auth.roles.client &amp;&amp; ! auth.roles.clientPlus) &amp;&amp; ! route.timestampStart\">&nbsp;</span></div>\n<div class=\"finished\"><span class=\"label\">{{ t((route.timestampStop || (auth.roles.client && ! auth.roles.clientPlus)) ? 'statusDone' : 'statusEstimatedDone') }}</span><span class=\"estimate\">{{ route.estimatedTimestampStop | moment:'LT' }}</span><span ng-if=\"route.timestampStop\" ng-class=\"{ delayed: route.timestampStop &gt; route.estimatedTimestampStop }\">{{ route.timestampStop | moment:'LT' }}</span><span ng-if=\"(auth.roles.client &amp;&amp; ! auth.roles.clientPlus) &amp;&amp; ! route.timestampStop\">&nbsp;</span></div>");;return buf.join("");
	}

/***/ },
/* 27 */,
/* 28 */,
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Angular.js plugin
	 *
	 * Provides an $exceptionHandler for Angular.js
	 */
	var wrappedCallback = __webpack_require__(8).wrappedCallback;
	
	// See https://github.com/angular/angular.js/blob/v1.4.7/src/minErr.js
	var angularPattern = /^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/;
	var moduleName = 'ngRaven';
	
	function angularPlugin(Raven, angular) {
	  angular = angular || window.angular;
	
	  if (!angular) return;
	
	  function RavenProvider() {
	    this.$get = [
	      '$window',
	      function($window) {
	        return Raven;
	      }
	    ];
	  }
	
	  function ExceptionHandlerProvider($provide) {
	    $provide.decorator('$exceptionHandler', ['Raven', '$delegate', exceptionHandler]);
	  }
	
	  function exceptionHandler(R, $delegate) {
	    return function(ex, cause) {
	      R.captureException(ex, {
	        extra: {cause: cause}
	      });
	      $delegate(ex, cause);
	    };
	  }
	
	  angular
	    .module(moduleName, [])
	    .provider('Raven', RavenProvider)
	    .config(['$provide', ExceptionHandlerProvider]);
	
	  Raven.setDataCallback(
	    wrappedCallback(function(data) {
	      return angularPlugin._normalizeData(data);
	    })
	  );
	}
	
	angularPlugin._normalizeData = function(data) {
	  // We only care about mutating an exception
	  var exception = data.exception;
	  if (exception) {
	    exception = exception.values[0];
	    var matches = angularPattern.exec(exception.value);
	
	    if (matches) {
	      // This type now becomes something like: $rootScope:inprog
	      exception.type = matches[1];
	      exception.value = matches[2];
	
	      data.message = exception.type + ': ' + exception.value;
	      // auto set a new tag specifically for the angular error url
	      data.extra.angularDocs = matches[3].substr(0, 250);
	    }
	  }
	
	  return data;
	};
	
	angularPlugin.moduleName = moduleName;
	
	module.exports = angularPlugin;


/***/ },
/* 30 */
/***/ function(module, exports) {

	/*
	 json-stringify-safe
	 Like JSON.stringify, but doesn't throw on circular references.
	
	 Originally forked from https://github.com/isaacs/json-stringify-safe
	 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
	 and IE8 compatibility. Tests for this are in test/vendor.
	
	 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
	*/
	
	exports = module.exports = stringify;
	exports.getSerialize = serializer;
	
	function indexOf(haystack, needle) {
	  for (var i = 0; i < haystack.length; ++i) {
	    if (haystack[i] === needle) return i;
	  }
	  return -1;
	}
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
	}
	
	// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
	function stringifyError(value) {
	  var err = {
	    // These properties are implemented as magical getters and don't show up in for in
	    stack: value.stack,
	    message: value.message,
	    name: value.name
	  };
	
	  for (var i in value) {
	    if (Object.prototype.hasOwnProperty.call(value, i)) {
	      err[i] = value[i];
	    }
	  }
	
	  return err;
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [];
	  var keys = [];
	
	  if (cycleReplacer == null) {
	    cycleReplacer = function(key, value) {
	      if (stack[0] === value) {
	        return '[Circular ~]';
	      }
	      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
	    };
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = indexOf(stack, this);
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
	
	      if (~indexOf(stack, value)) {
	        value = cycleReplacer.call(this, key, value);
	      }
	    } else {
	      stack.push(value);
	    }
	
	    return replacer == null
	      ? value instanceof Error ? stringifyError(value) : value
	      : replacer.call(this, key, value);
	  };
	}


/***/ },
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	var moment = __webpack_require__(5);
	
	var StopLocation = __webpack_require__(15);
	var Count = __webpack_require__(11);
	var toDate = __webpack_require__(3).toDate;
	var formatPhone = __webpack_require__(3).formatPhone;
	var delayMinutes = __webpack_require__(3).delayInMinutes;
	var delayHuman = __webpack_require__(3).delayForHumans;
	var aggregateProducts = __webpack_require__(3).aggregateProductsForCustomers;
	
	function Route(route, customers) {
	  angular.extend(this, route);
	  if (this.estimatedTimestampStart === this.estimatedTimestampStop) {
	    this.estimatedTimestampStart = toDate(this.estimatedTimestampStart);
	    this.estimatedTimestampStop = null;
	  } else {
	    this.estimatedTimestampStart = toDate(this.estimatedTimestampStart);
	    this.estimatedTimestampStop = toDate(this.estimatedTimestampStop);
	  }
	  this.timestampStart = toDate(this.timestampStart);
	  this.timestampStop = toDate(this.timestampStop);
	  this.timestampLoadConfirmed = toDate(this.timestampLoadConfirmed);
	  this.reserved = this.type === 1;
	  this.stopLocations = getStopLocations(this, customers);
	  this.updateCustomersRouteNameAndColor();
	  angular.extend(this, new Count(this.stopLocations));
	  if (customers && customers.length > 0) {
	    this.customerTimeWindows = findCustomerTimeWindows(customers);
	    this.customerCount = this.countCustomersNotCancelled();
	    this.products = aggregateProducts(customers);
	  } else {
	    this.customerTimeWindows = route.customerTimeWindows || [];
	    this.products = {};
	  }
	}
	
	var getStopLocations = function(route, customers) {
	  var stops = {};
	
	  customers.forEach(function(customer) {
	    if (stops[customer.stopLocationId]) {
	      stops[customer.stopLocationId].addCustomer(customer);
	    } else {
	      stops[customer.stopLocationId] = new StopLocation(customer, route);
	    }
	  });
	
	  return Object.keys(stops)
	    .map(function(id) {
	      return stops[id];
	    })
	    .sort(function(stop1, stop2) {
	      return stop1.routeSequence - stop2.routeSequence;
	    });
	};
	
	var findCustomerTimeWindows = function(customers) {
	  var timeWindows = {};
	
	  customers.forEach(function(customer) {
	    var deliveryWindow = customer.deliveryWindow();
	    if (deliveryWindow) {
	      timeWindows[deliveryWindow] = deliveryWindow;
	    }
	  });
	
	  return Object.keys(timeWindows);
	};
	
	Route.prototype.customers = function() {
	  return this.stopLocations.reduce(function(customers, stopLocation) {
	    return customers.concat(stopLocation.customers);
	  }, []);
	};
	
	Route.prototype.deliveries = function() {
	  return this.customers().reduce(function(deliveries, customer) {
	    return deliveries.concat(customer.deliveries);
	  }, []);
	};
	
	Route.prototype.updateCustomersRouteNameAndColor = function() {
	  this.customers().forEach(function(customer) {
	    customer.routeName = this.name;
	    customer.routeColor = this.color;
	  }, this);
	};
	
	Route.prototype.findStopLocation = function(stopLocationId) {
	  return this.stopLocations.filter(function(stopLocation) {
	    return stopLocation.id === stopLocationId;
	  })[0];
	};
	
	Route.prototype.sortStopLocations = function() {
	  return this.stopLocations.sort(function(stop1, stop2) {
	    return stop1.routeSequence - stop2.routeSequence;
	  });
	};
	
	Route.prototype.updateRouteOptimizationStatus = function(statusId) {
	  this.optimizationStatus = statusId;
	};
	
	Route.prototype.countDeliveries = function(status) {
	  return this.customers().reduce(function(count, customer) {
	    return count + (status ? customer.findDeliveries(status) : customer.deliveries).length;
	  }, 0);
	};
	
	Route.prototype.resetStats = function() {
	  this.length = 0;
	  this.durationDriving = 0;
	  this.durationTotal = 0;
	  this.estimatedTimestampStart = null;
	  this.estimatedTimestampStop = null;
	};
	
	Route.prototype.validStats = function() {
	  return this.durationTotal || ! this.stopLocations.length;
	};
	
	Route.prototype.updateDriverPosition = function(latitude, longitude) {
	  this.driverPositionLatitude = latitude;
	  this.driverPositionLongitude = longitude;
	  this.driverPositionTimestamp = new Date();
	};
	
	Route.prototype.noGPS = function(mapContext) {
	  // Check if route started long time ago - driver did not finish the route and we don't expect GPS/device to still be on
	  var startedLongTimeAgo = moment().isAfter(moment(this.timestampStart).add(12, 'h'));
	
	  var ts = this.driverPositionTimestamp;
	  return ! ts || (moment(ts).isBefore(moment().subtract(5, 'minutes')) && (mapContext || ! startedLongTimeAgo));
	};
	
	Route.prototype.driverPositionIsRecent = function() {
	  return ! this.noGPS(true);
	};
	
	Route.prototype.estimateOutsideDeliveryWindow = function() {
	  return this.customers().some(function(customer) {
	    return customer.estimateOutsideDeliveryWindow();
	  });
	};
	
	Route.prototype.delayInMinutes = function() {
	  var lastCustomer;
	  var lastRouteSequence = 0;
	
	  if (! this.timestampStart) {
	    return delayMinutes(new Date(), this.estimatedTimestampStart);
	  }
	
	  if (this.timestampStop) {
	    return delayMinutes(this.timestampStop, this.estimatedTimestampStop);
	  }
	
	  this.stopLocations.forEach(function(stop) {
	    stop.customers.forEach(function(customer) {
	      if (customer.routeSequence > lastRouteSequence && customer.deliveryStatusTimestamp()) {
	        lastCustomer = customer;
	        lastRouteSequence = customer.routeSequence;
	      }
	    });
	  });
	
	  if (lastCustomer) {
	    return delayMinutes(lastCustomer.deliveryStatusTimestamp(), lastCustomer.estimatedTimestampDone);
	  } else if (this.timestampStart) {
	    return delayMinutes(this.timestampStart, this.estimatedTimestampStart);
	  }
	};
	
	Route.prototype.delayForHumans = function() {
	  return delayHuman(this.delayInMinutes());
	};
	
	Route.prototype.nameAndDriver = function(drivers, noPhone) {
	  var driverName = this.driverName(drivers, noPhone);
	  return driverName ? this.name + ' - ' + driverName : this.name;
	};
	
	Route.prototype.driverName = function(drivers, noPhone) {
	  var driver = drivers[this.driverUsername];
	
	  if (! driver) return '';
	
	  var driverShortName = (driver.firstName ? driver.firstName : driver.name);
	
	  if (! driver.phone || noPhone) return driverShortName;
	
	  return driverShortName + ' (' + formatPhone(driver.phone) + ')';
	};
	
	module.exports = Route;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	var moment = __webpack_require__(5);
	
	var t = __webpack_require__(4).t;
	var Customer = __webpack_require__(9);
	var Route = __webpack_require__(32);
	var Count = __webpack_require__(11);
	var SuggestedRoute = __webpack_require__(193);
	var File = __webpack_require__(7);
	var util = __webpack_require__(3);
	
	function RoutePlan(routePlan, light) {
	  angular.extend(this, routePlan);
	  if(this.date) {
	    this.date = this.date.slice(0, 10); // YYYY-MM-DD
	  }
	  if (! light) {
	    this.customers = (this.customers || []).map(function(customer) {
	      return new Customer(customer);
	    });
	
	    this.routes = (this.routes || []).map(function(route) {
	      return new Route(route, this.customers.filter(function(customer) {
	        return customer.routeId === route.id;
	      }));
	    }, this);
	
	    this.suggestedRoutes = (this.suggestedRoutes || []).sort(function(r1, r2) {
	      return r1.name.localeCompare(r2.name);
	    }).map(function(suggestedRoute) {
	      return new SuggestedRoute(suggestedRoute);
	    });
	
	    this.files = (this.files || []).map(function(file) {
	      return new File(file);
	    }).sort(function(a, b) {
	      return a.id - b.id;
	    });
	  }
	}
	
	RoutePlan.prototype.hasAccessToAllCustomerSystems = function(customerSystemIds) {
	  return this.customerSystems.every(function(customerSystemId) {
	    // Check if every CS for the plan is available in the given list
	    return customerSystemIds.some(function(csId) {
	      return csId === customerSystemId;
	    });
	  });
	};
	
	RoutePlan.prototype.hasRoutes = function() {
	  return this.routes && this.routes.length !== 0;
	};
	
	RoutePlan.prototype.suggestedRoutesCount = function() {
	  return this.suggestedRoutes.length;
	};
	
	RoutePlan.prototype.suggestedRoutesCoverage = function() {
	  var totalCount = this.suggestedRoutesTotalCount();
	  return 100 * (totalCount - this.suggestedRoutesUnplaced()) / totalCount;
	};
	
	RoutePlan.prototype.suggestedRoutesUnplaced = function() {
	  return this.suggestedRoutes.reduce(function(count, sugRoute) {
	    return count + (sugRoute.name.trim() === '' ? sugRoute.customerCount : 0);
	  }, 0);
	};
	
	RoutePlan.prototype.suggestedRoutesTotalCount = function() {
	  return this.suggestedRoutes.reduce(function(count, sugRoute) {
	    return count + sugRoute.customerCount;
	  }, 0);
	};
	
	RoutePlan.prototype.unlinkedCustomers = function() {
	  return this.customers.filter(function(customer) {
	    return ! customer.routeId;
	  });
	};
	
	RoutePlan.prototype.validStats = function() {
	  return this.routes.every(function(route) {
	    return route.validStats();
	  });
	};
	
	RoutePlan.prototype.noRoutesAreOptimizing = function() {
	  return this.routes.every(function(route) {
	    return (route.optimizationStatus === -1 || route.optimizationStatus === 0); // Dirty or OK
	  });
	};
	
	RoutePlan.prototype.noRoutesAreLoadedOrStarted = function() {
	  return this.routes.every(function(route) {
	    return (route.timestampLoadConfirmed === null && route.timestampStart === null);
	  });
	};
	
	RoutePlan.prototype.allRoutesAreAssigned = function() {
	  return this.routes.every(function(route) {
	    var count = route.countCustomersNotCancelled();
	    return !! route.driverUsername || route.countCustomersNotCancelled() === 0; // Has driver (or empty)
	  });
	};
	
	RoutePlan.prototype.length = function() {
	  return routeStats(this.routes, 'length');
	};
	
	RoutePlan.prototype.durationDriving = function() {
	  return routeStats(this.routes, 'durationDriving');
	};
	
	RoutePlan.prototype.durationTotal = function() {
	  return routeStats(this.routes, 'durationTotal');
	};
	
	var routeStats = function(routes, property) {
	  return routes.reduce(function(sum, route) {
	    return sum + route[property];
	  }, 0);
	};
	
	RoutePlan.prototype.countStopLocationsNotCancelled = function() {
	  return countAggregated(this.routes, 'countStopLocationsNotCancelled');
	};
	
	RoutePlan.prototype.countCustomers = function() {
	  return countAggregated(this.routes, 'countCustomers');
	};
	
	RoutePlan.prototype.countCustomersDelivered = function() {
	  return countAggregated(this.routes, 'countCustomersDelivered');
	};
	
	RoutePlan.prototype.countCustomersCancelled = function() {
	  return countAggregated(this.routes, 'countCustomersCancelled');
	};
	
	RoutePlan.prototype.countCustomersDeviation = function() {
	  return countAggregated(this.routes, 'countCustomersDeviation');
	};
	
	RoutePlan.prototype.countCustomersNotCancelled = function() {
	  return countAggregated(this.routes, 'countCustomersNotCancelled');
	};
	
	RoutePlan.prototype.countDeliveries = function() {
	  return countAggregated(this.routes, 'countDeliveries');
	};
	
	RoutePlan.prototype.countDeliveriesNotCancelled = function() {
	  return countAggregated(this.routes, 'countDeliveriesNotCancelled');
	};
	
	RoutePlan.prototype.countStopLocationsDone = function() {
	  return countAggregated(this.routes, 'countStopLocationsDone');
	};
	
	RoutePlan.prototype.countCustomersDone = function() {
	  return countAggregated(this.routes, 'countCustomersDone');
	};
	
	RoutePlan.prototype.countDeliveriesDone = function() {
	  return countAggregated(this.routes, 'countDeliveriesDone');
	};
	
	var countAggregated = function(routes, func) {
	  return routes.reduce(function(count, route) {
	    return count + route[func]();
	  }, 0);
	};
	
	RoutePlan.prototype.countDeliveries = function(status) {
	  return this.routes.reduce(function(count, route) {
	    return count + route.countDeliveries(status);
	  }, 0);
	};
	
	RoutePlan.prototype.countDelayedUnfinishedRoutes = function() {
	  return this.routes.reduce(function(count, route) {
	    return count + ((route.delayForHumans() && ! route.timestampStop && !! route.driverUsername) ? 1 : 0);
	  }, 0);
	};
	
	RoutePlan.prototype.updateDelivery = function(newDelivery) {
	  var oldDelivery = this.findDelivery(newDelivery.customerId, newDelivery.id);
	  if (oldDelivery) {
	    angular.extend(oldDelivery, newDelivery);
	  } else {
	    // Could not find delivery in cache, let's add it to the customer
	    var customer = this.findCustomer(newDelivery.customerId);
	    if (customer) {
	      customer.deliveries.push(newDelivery);
	    }
	  }
	};
	
	RoutePlan.prototype.deleteDelivery = function(deliveryId, customerId) {
	  var customer = this.findCustomer(customerId);
	  if (customer) {
	    customer.deliveries = customer.deliveries.filter(function(delivery) {
	      return delivery.id !== deliveryId;
	    });
	  }
	};
	
	RoutePlan.prototype.updateDeliveryEstimates = function(estimates) {
	  estimates.forEach(function(estimate) {
	    var customer = this.findCustomer(estimate.id);
	    customer && customer.updateDeliveryEstimate(estimate);
	  }, this);
	};
	
	RoutePlan.prototype.updateCustomerSequence = function(routeId, customerSequences) {
	  var route = this.findRoute(routeId);
	  customerSequences.forEach(function(custSeq) {
	    var customer = this.findCustomer(custSeq.id);
	    customer && customer.updateRouteSequence(custSeq);
	
	    var stopLocation = route.findStopLocation(custSeq.stopLocationId);
	    stopLocation && stopLocation.updateRouteSequence(custSeq);
	
	  }, this);
	  route.sortStopLocations();
	};
	
	RoutePlan.prototype.updateNotification = function(newNotification) {
	  var customer = this.findCustomer(newNotification.customerId);
	  if (customer) {
	    customer.notifications.push(newNotification);
	  }
	};
	
	RoutePlan.prototype.updateCustomerImage = function(customerId, imageUrl) {
	  var customer = this.findCustomer(customerId);
	  if (customer) {
	    customer.imageUrl = imageUrl;
	  }
	};
	
	RoutePlan.prototype.updateCustomerClientTime = function(customerId, clientSideTimestampDone) {
	  var customer = this.findCustomer(customerId);
	  if (customer) {
	    customer.clientSideTimestampDone = clientSideTimestampDone;
	  }
	};
	
	RoutePlan.prototype.updateCustomerCallLog = function(customerId, driverUsername, timestampCalled) {
	  var customer = this.findCustomer(customerId);
	  if (customer) {
	    customer.callLogs.push({ driverUsername: driverUsername, timestampCalled: timestampCalled });
	  }
	};
	
	RoutePlan.prototype.updateRoute = function(newRoute) {
	  var oldRoute = this.findRoute(newRoute.id);
	  if (oldRoute) {
	    angular.extend(oldRoute, newRoute, { stopLocations: oldRoute.stopLocations });
	    angular.extend(oldRoute, new Count(oldRoute.stopLocations));
	    oldRoute.updateCustomersRouteNameAndColor();
	  }
	};
	
	RoutePlan.prototype.findDelivery = function(customerId, deliveryId) {
	  var customer = this.findCustomer(customerId);
	  return customer && customer.findDelivery(deliveryId);
	};
	
	RoutePlan.prototype.findCustomer = function(customerId) {
	  return this.customers.filter(function(customer) {
	    return customer.id === customerId;
	  })[0];
	};
	
	RoutePlan.prototype.findStopLocation = function(routeId, stopLocationId) {
	  var route = this.findRoute(routeId);
	  return route && route.stopLocations.filter(function(stopLocation) {
	    return stopLocation.id === stopLocationId;
	  })[0];
	};
	
	RoutePlan.prototype.findRoute = function(routeId) {
	  return this.routes.filter(function(route) {
	    return route.id === routeId;
	  })[0];
	};
	
	RoutePlan.prototype.findFile = function(fileId) {
	  return this.files.filter(function(file) {
	    return file.id === fileId;
	  })[0];
	};
	
	RoutePlan.prototype.pianoFile = function() {
	  if (this.files[0] && this.files[0].format === 'PIANO') {
	    return this.files[0];
	  }
	};
	
	RoutePlan.prototype.pickupLocationAddress = function(pickupLocation) {
	  return pickupLocation.address + ', ' +
	         util.formatZip(pickupLocation.zip, pickupLocation.country) + ' ' +
	         pickupLocation.city;
	};
	
	RoutePlan.prototype.status = function() {
	  switch (this.statusId) {
	  case 0:
	    return this.deliveryCount ? 'imported' : 'created';
	  case 8:
	    return 'importing';
	  case 1:
	    return 'queued';
	  case 2:
	  case 3:
	    return 'optimizing';
	  case 4:
	    return 'generating';
	  case 7:
	    return 'failed';
	  case 6:
	    return 'deleted';
	  case 9:
	    return 'routesimportqueued';
	  case 10:
	    return 'routesimporting';
	  case 11:
	    return this.published ? 'published' : (this.readyForDriverInput ? 'readyfordriverinput' : 'routesimported');
	  default:
	    return this.published ? 'published' : (this.readyForDriverInput ? 'readyfordriverinput' : 'optimized');
	  }
	};
	
	RoutePlan.prototype.editable = function() {
	  var status = this.status();
	
	  return status === 'created' ||
	         status === 'imported' ||
	         status === 'importing' ||
	         status === 'failed';
	};
	
	RoutePlan.prototype.canCustomerBeEdited = function() {
	  var status = this.status();
	
	  return status === 'created' ||
	         status === 'imported' ||
	         status === 'importing' ||
	         status === 'routesimported' ||
	         status === 'readyfordriverinput' ||
	         status === 'published' ||
	         status === 'optimized' ||
	         status === 'failed';
	};
	
	RoutePlan.prototype.canCustomerBeAdded = function(routeId) {
	    var route = this.findRoute(routeId);
	
	    return (!! route && !! route.estimatedTimestampStart) && moment(route.estimatedTimestampStart).subtract(120, 'minutes').isAfter(moment());
	};
	
	RoutePlan.prototype.correctable = function(routeId, deliveries) {
	  var route = this.findRoute(routeId);
	  var status = this.status();
	
	  if (! route)
	    return true; // If we can't find the route (on this plan), then it should be ok to correct any problems
	
	  // Matching logic in App : can't show loading list untill it's only TWO HOURS left to estimated start
	  var moreThanTwoHourBeforeEstimatedStart = (!! route && !! route.estimatedTimestampStart) && moment(route.estimatedTimestampStart).subtract(120, 'minutes').isAfter(moment());
	
	  //console.log('correctable', routeId, status, route.timestampLoadConfirmed, moreThanTwoHourBeforeEstimatedStart);
	
	  return status === 'optimized' || status === 'routesimported' || status === 'readyfordriverinput' ||
	    (status === 'published' && (route && ! route.timestampLoadConfirmed && ! route.timestampStart && moreThanTwoHourBeforeEstimatedStart)) ||
	    (status === 'published' && deliveries.every(function(delivery) {
	          return (delivery.status !== 'delivered' && delivery.status !== "deviation");
	      }));
	};
	
	RoutePlan.prototype.routesThatNeedOptimization = function() {
	  return (this.routes || []).filter(function(route) {
	    return route.optimizationStatus === -1;
	  });
	};
	
	RoutePlan.prototype.deletable = function() {
	  var status = this.status();
	
	  return status === 'created' ||
	         status === 'imported' ||
	         status === 'queued' ||
	         status === 'failed' ||
	         status === 'optimized' ||
	         status === 'routesimported' ||
	         status === 'readyfordriverinput';
	};
	
	RoutePlan.prototype.sumPrints = function(prints) {
	  var totalPrints = 0;
	  prints.forEach(function(print) {
	    totalPrints += print.numberOfPrints;
	  });
	  return totalPrints;
	};
	
	RoutePlan.prototype.boundaryBoxUrl = function(boundaryBox) {
	  if (boundaryBox && boundaryBox.minX) {
	    return 'http://bboxfinder.com/#' + boundaryBox.minY + ',' + boundaryBox.minX + ',' + boundaryBox.maxY + ',' + boundaryBox.maxX;
	  }
	  return '';
	};
	
	RoutePlan.prototype.errorMessage = function(key, boundaryBox) {
	  if (key === 'company.boundarybox.missing') {
	    return {
	      title: 'planCustomersBoundaryBoxMissingErrorHeader',
	      message: t('planCustomersBoundaryBoxMissingError')
	    };
	  } else if (key === 'company.boundarybox.outside') {
	    return {
	      title: 'planCustomersBoundaryBoxOutsideErrorHeader',
	      message: t('planCustomersBoundaryBoxOutsideError'),
	      link: '<a href="' + this.boundaryBoxUrl(boundaryBox) + '" target="_blank">' + t('settingsCompanyBoundaryBoxLink') + '</a>'
	    };
	  } else if (key === 'optimize.relocate.products.unbalanced') {
	    return {
	      title: 'planCustomersRelocateUnbalancedErrorHeader',
	      message: t('planCustomersRelocateUnbalancedError')
	    };
	  }
	  return { title: '', message: '' };
	};
	
	module.exports = RoutePlan;


/***/ },
/* 34 */
/***/ function(module, exports) {

	;(function(angular){
	  'use strict';
	  var indexOf = [].indexOf || function(item) {
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (i in this && this[i] === item) return i;
	    }
	    return -1;
	  };
	
	  function map(items, property) {
	    var mappedArray = [];
	    angular.forEach(items, function(item) {
	      mappedArray.push(angular.isFunction(property) ? property(item) : item[property]);
	    });
	    return mappedArray;
	  }
	
	  angular.module('pickadate', [])
	
	    .provider('pickadateI18n', function() {
	      var defaults = {
	        'prev': 'prev',
	        'next': 'next'
	      };
	
	      this.translations = {};
	
	      this.$get = function() {
	        var translations = this.translations;
	
	        return {
	          t: function(key) {
	            return translations[key] || defaults[key];
	          }
	        };
	      };
	    })
	
	    .factory('pickadateModalBindings', ['$window', '$document', function($window, $document) {
	      var supportPageOffset = $window.pageXOffset !== undefined,
	          isCSS1Compat = (($document.compatMode || "") === "CSS1Compat");
	
	      var computeStyles = function(element) {
	        var scrollX = supportPageOffset ? $window.pageXOffset : isCSS1Compat ? $document.documentElement.scrollLeft : $document.body.scrollLeft,
	            scrollY = supportPageOffset ? $window.pageYOffset : isCSS1Compat ? $document.documentElement.scrollTop : $document.body.scrollTop,
	            innerWidth = $window.innerWidth || $document.documentElement.clientWidth || $document.body.clientWidth,
	            styles = { top: scrollY + element.getBoundingClientRect().bottom + 'px' };
	
	        if ((innerWidth - element.getBoundingClientRect().left ) >= 300) {
	          styles.left = scrollX + element.getBoundingClientRect().left  + 'px';
	        } else {
	          styles.right = innerWidth - element.getBoundingClientRect().right - scrollX + 'px';
	        }
	
	        return styles;
	      };
	
	      var isDescendant = function(parent, child) {
	        var node = child.parentNode;
	        while (node !== null) {
	          if (node === parent) return true;
	          node = node.parentNode;
	        }
	        return false;
	      };
	
	      return function(scope, element, rootNode) {
	        var togglePicker = function(toggle) {
	          scope.displayPicker = toggle;
	          scope.$apply();
	        };
	
	        element.on('focus', function() {
	          scope.modalStyles = computeStyles(element[0]);
	          togglePicker(true);
	        });
	
	        element.on('keydown', function(e) {
	          if (indexOf.call([9, 13, 27], e.keyCode) >= 0) togglePicker(false);
	        });
	
	        $document.on('click', function(e) {
	          if (isDescendant(rootNode, e.target) || e.target === element[0]) return;
	          togglePicker(false);
	        });
	      };
	
	    }])
	
	    .factory('pickadateDateHelper', ['$locale', 'dateFilter', function($locale, dateFilter) {
	
	      function getPartName(part) {
	        switch (part) {
	          case 'dd':   return 'day';
	          case 'MM':   return 'month';
	          case 'yyyy': return 'year';
	        }
	      }
	
	      return function(format, options) {
	        var minDate, maxDate, disabledDates, currentDate, weekStartsOn, noExtraRows;
	
	        options       = options || {};
	        format        = format  || 'yyyy-MM-dd';
	        weekStartsOn  = options.weekStartsOn;
	        noExtraRows   = options.noExtraRows;
	        disabledDates = options.disabledDates || angular.noop;
	
	        if (!angular.isNumber(weekStartsOn) || weekStartsOn < 0 || weekStartsOn > 6) weekStartsOn = 0;
	
	        return {
	
	          parseDate: function(dateString) {
	            if (!dateString) return;
	            if (angular.isDate(dateString)) return new Date(dateString);
	
	            var formatRegex = '(dd|MM|yyyy)',
	                separator   = format.match(/[-|/]/)[0],
	                dateParts   = dateString.split(separator),
	                regexp      = new RegExp([formatRegex, formatRegex, formatRegex].join(separator)),
	                formatParts = format.match(regexp),
	                dateObj     = {};
	
	            formatParts.shift();
	
	            angular.forEach(formatParts, function(part, i) {
	              dateObj[getPartName(part)] = parseInt(dateParts[i], 10);
	            });
	
	            if (isNaN(dateObj.year) || isNaN(dateObj.month) || isNaN(dateObj.day)) return;
	
	            return new Date(dateObj.year, dateObj.month - 1, dateObj.day, 3);
	          },
	
	          setRestrictions: function(restrictions) {
	            minDate       = this.parseDate(restrictions.minDate) || new Date(0);
	            maxDate       = this.parseDate(restrictions.maxDate) || new Date(99999999999999);
	            currentDate   = restrictions.currentDate;
	          },
	
	          allowPrevMonth: function() {
	            return currentDate > minDate;
	          },
	
	          allowNextMonth: function() {
	            var nextMonth = angular.copy(currentDate);
	            nextMonth.setMonth(nextMonth.getMonth() + 1);
	            return nextMonth <= maxDate;
	          },
	
	          buildDateObject: function(date) {
	            var localDate     = angular.copy(date),
	                formattedDate = dateFilter(localDate, format),
	                disabled      = disabledDates({date: localDate, formattedDate: formattedDate}),
	                monthOffset   = this.getMonthOffset(localDate, currentDate),
	                outOfMinRange = localDate < minDate,
	                outOfMaxRange = localDate > maxDate,
	                outOfMonth    = (monthOffset === -1 && !options.previousMonthSelectable) ||
	                                (monthOffset === 1 && !options.nextMonthSelectable);
	
	            return {
	              date: localDate,
	              formattedDate: formattedDate,
	              today: formattedDate === dateFilter(new Date(), format),
	              disabled: disabled,
	              outOfMinRange: outOfMinRange,
	              outOfMaxRange: outOfMaxRange,
	              monthOffset: monthOffset,
	              outOfMonth: outOfMonth,
	              enabled: !(disabled || outOfMinRange || outOfMaxRange || outOfMonth)
	            };
	          },
	
	          buildDates: function(year, month, options) {
	            var dates      = [],
	                date       = new Date(year, month, 1, 3),
	                lastDate   = new Date(year, month + 1, 0, 3);
	
	            options        = options || {};
	            currentDate    = angular.copy(date);
	
	            while (date.getDay() !== weekStartsOn) date.setDate(date.getDate() - 1);
	
	            for (var i = 0; i < 42; i++) {  // 42 == 6 rows of dates
	              if (noExtraRows && date.getDay() === weekStartsOn && date > lastDate) break;
	
	              dates.push(this.buildDateObject(date));
	              date.setDate(date.getDate() + 1);
	            }
	
	            return dates;
	          },
	
	          buildDayNames: function() {
	            var dayNames = $locale.DATETIME_FORMATS.SHORTDAY;
	
	            if (weekStartsOn) {
	              dayNames = dayNames.slice(0);
	              for (var i = 0; i < weekStartsOn; i++) dayNames.push(dayNames.shift());
	            }
	            return dayNames;
	          },
	
	          getMonthOffset: function(date1, date2) {
	            return date1.getMonth() - date2.getMonth() + (12 * (date1.getFullYear() - date2.getFullYear()));
	          }
	        };
	      };
	
	    }])
	
	    .directive('pickadate', ['$locale', '$sce', '$compile', '$document', '$window', 'pickadateDateHelper',
	      'pickadateI18n', 'pickadateModalBindings', 'filterFilter', function($locale, $sce, $compile, $document, $window,
	                                                                          dateHelperFactory, i18n, modalBindings, filter) {
	
	      var TEMPLATE =
	        '<div class="pickadate" ng-show="displayPicker" ng-style="modalStyles">' +
	          '<div class="pickadate-header">' +
	            '<div class="pickadate-controls">' +
	              '<a href="" class="pickadate-prev" ng-click="changeMonth(-1)" ng-show="allowPrevMonth">' +
	                $sce.trustAsHtml(i18n.t('prev')) +
	              '</a>' +
	              '<a href="" class="pickadate-next" ng-click="changeMonth(1)" ng-show="allowNextMonth">' +
	                $sce.trustAsHtml(i18n.t('next')) +
	              '</a>' +
	            '</div>'+
	            '<h3 class="pickadate-centered-heading">' +
	              '{{currentDate | date:"MMMM yyyy"}}' +
	            '</h3>' +
	          '</div>' +
	          '<div class="pickadate-body">' +
	            '<div class="pickadate-main">' +
	              '<ul class="pickadate-cell">' +
	                '<li class="pickadate-head" ng-repeat="dayName in dayNames">' +
	                  '{{dayName}}' +
	                '</li>' +
	              '</ul>' +
	              '<ul class="pickadate-cell">' +
	                '<li ng-repeat="dateObj in dates" ng-click="setDate(dateObj)" ng-class="classesFor(dateObj)">' +
	                  '{{dateObj.date | date:"d"}}' +
	                '</li>' +
	              '</ul>' +
	            '</div>' +
	          '</div>' +
	        '</div>';
	
	      return {
	        require: 'ngModel',
	        scope: {
	          defaultDate: '=',
	          minDate: '=',
	          maxDate: '=',
	          disabledDates: '&',
	          weekStartsOn: '='
	        },
	
	        link: function(scope, element, attrs, ngModel)  {
	          var allowMultiple           = attrs.hasOwnProperty('multiple'),
	              allowBlank              = attrs.hasOwnProperty('allowBlankDate'),
	              selectedDates           = [],
	              wantsModal              = element[0] instanceof HTMLInputElement,
	              compiledHtml            = $compile(TEMPLATE)(scope),
	              format                  = (attrs.format || 'yyyy-MM-dd').replace(/m/g, 'M'),
	              dateHelper              = dateHelperFactory(format, {
	                previousMonthSelectable: /^(previous|both)$/.test(attrs.selectOtherMonths),
	                nextMonthSelectable:     /^(next|both)$/.test(attrs.selectOtherMonths),
	                weekStartsOn: scope.weekStartsOn,
	                noExtraRows: attrs.hasOwnProperty('noExtraRows'),
	                disabledDates: scope.disabledDates
	              });
	
	          scope.displayPicker = !wantsModal;
	
	          scope.setDate = function(dateObj) {
	            if (!dateObj.enabled) return;
	
	            selectedDates = toggleDate(dateObj, selectedDates);
	
	            setViewValue(selectedDates);
	
	            scope.changeMonth(dateObj.monthOffset);
	            scope.displayPicker = !wantsModal;
	          };
	
	          var $render = ngModel.$render = function(options) {
	            if (angular.isArray(ngModel.$viewValue)) {
	              selectedDates = ngModel.$viewValue;
	            } else if (ngModel.$viewValue) {
	              selectedDates = [ngModel.$viewValue];
	            }
	
	            scope.currentDate = dateHelper.parseDate(scope.defaultDate || selectedDates[0]) || new Date();
	
	            dateHelper.setRestrictions(scope);
	
	            selectedDates = map(selectedDates, function(date) {
	              return dateHelper.buildDateObject(dateHelper.parseDate(date));
	            });
	
	            selectedDates = filter(selectedDates, { enabled: true });
	
	            setViewValue(selectedDates, options);
	            render();
	          };
	
	          scope.classesFor = function(date) {
	            var formattedDates = map(selectedDates, 'formattedDate'),
	                classes        = indexOf.call(formattedDates, date.formattedDate) >= 0 ? 'pickadate-active' : null;
	            return date.classNames.concat(classes);
	          };
	
	          scope.changeMonth = function(offset) {
	            if (!offset) return;
	            // If the current date is January 31th, setting the month to date.getMonth() + 1
	            // sets the date to March the 3rd, since the date object adds 30 days to the current
	            // date. Settings the date to the 2nd day of the month is a workaround to prevent this
	            // behaviour
	            scope.currentDate.setDate(1);
	            scope.currentDate.setMonth(scope.currentDate.getMonth() + offset);
	            render();
	          };
	
	          // Workaround to watch multiple properties. XXX use $scope.$watchGroup in angular 1.3
	          scope.$watch(function() {
	            return angular.toJson([scope.minDate, scope.maxDate]);
	          }, $render);
	
	          // Insert datepicker into DOM
	          if (wantsModal) {
	            modalBindings(scope, element, compiledHtml[0]);
	
	            // if the user types a date, update the picker and set validity
	            scope.$watch(function() {
	              return ngModel.$viewValue;
	            }, function(val) {
	              var isValidDate = dateHelper.parseDate(val);
	
	              if (isValidDate) $render({ skipRenderInput: true });
	              ngModel.$setValidity('date', !!isValidDate);
	            });
	
	            // if the input element has a value, set it as the ng-model
	            scope.$$postDigest(function() {
	              if (attrs.value) { ngModel.$viewValue = attrs.value; $render(); }
	            });
	
	            element.after(compiledHtml.addClass('pickadate-modal'));
	          } else {
	            element.append(compiledHtml);
	          }
	
	          function render() {
	            var dates = dateHelper.buildDates(scope.currentDate.getFullYear(), scope.currentDate.getMonth());
	
	            scope.allowPrevMonth = dateHelper.allowPrevMonth();
	            scope.allowNextMonth = dateHelper.allowNextMonth();
	            scope.dayNames       = dateHelper.buildDayNames();
	
	            scope.dates = map(dates, function(date) {
	              date.classNames = [date.enabled ? 'pickadate-enabled' : 'pickadate-disabled'];
	
	              if (date.monthOffset !== 0) date.classNames.push('pickadate-out-of-month');
	
	              if (date.today)    date.classNames.push('pickadate-today');
	              if (date.disabled) date.classNames.push('pickadate-unavailable');
	
	              return date;
	            });
	          }
	
	          function setViewValue(value, options) {
	            options = options || {};
	
	            if (allowMultiple) {
	              ngModel.$setViewValue(map(value, 'formattedDate'));
	            } else {
	              ngModel.$setViewValue(value[0] && value[0].formattedDate);
	            }
	
	            if (!options.skipRenderInput) element.val(ngModel.$viewValue);
	          }
	
	          function toggleDate(dateObj, dateArray) {
	            var index = indexOf.call(map(dateArray, 'formattedDate'), dateObj.formattedDate);
	            if (index === -1) {
	              dateArray = addDate(dateObj, dateArray);
	            } else if (allowBlank || (dateArray.length > 1)) {
	              dateArray.splice(index, 1);
	            }
	            return dateArray;
	          }
	
	          function addDate(dateObj, dateArray){
	            if (allowMultiple) {
	              dateArray.push(dateObj);
	            } else {
	              dateArray = [dateObj];
	            }
	
	            return dateArray;
	          }
	        }
	      };
	    }]);
	})(window.angular);


/***/ },
/* 35 */,
/* 36 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.1
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isDefined;
	var lowercase;
	var noop;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isDefined = angular.isDefined;
	  lowercase = angular.lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = toMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function(window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument('inert');
	    } else {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = node.nextSibling;
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = node.parentNode;
	            if (node === inertBodyElement) break;
	            nextNode = node.nextSibling;
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = node.nextSibling;
	    }
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36);
	module.exports = 'ngSanitize';


/***/ },
/* 38 */,
/* 39 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.ico";

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <distribution-header></distribution-header>\n  <div class=\"stats\">\n    <div>\n      <div class=\"stat\">{{ distribution.routePlans.length }}\n        <div class=\"label\">{{ t('distributionPlans') }}</div>\n      </div>\n      <div class=\"stat\">{{ distribution.routes.length }}\n        <div class=\"label\">{{ t('cRoutes') }}</div>\n      </div>\n      <div class=\"stat\"><a href=\"{{ router.link('distribution', null, distribution) }}/routes\">{{ distribution.delayedUnfinishedRoutes().length }}</a>\n        <div class=\"label\">{{ t('fleetDashDelayed') }}</div>\n      </div>\n      <div class=\"stat\"><span tooltip=\"distributionProgressTooltipTemplate\" class=\"route-progress-info tooltip-right biginfo\">\n          <progress-bar max=\"distribution.sum('customerCount')\" cancelled=\"distribution.sum('customerCancelledCount')\" delivered=\"distribution.sum('customerDeliveredCount')\" deviation=\"distribution.sum('customerDeviationCount')\"></progress-bar></span>\n        <div class=\"label\">{{ t('fleetDashHandledCustomers') }}</div>\n      </div>\n      <div class=\"stat\">{{ distribution.sum('customerRemainingCount') }}\n        <div class=\"label\">{{ t('fleetDashRemaining') }}</div>\n      </div>\n      <div class=\"stat\"><a href=\"{{ router.link('distribution', null, distribution) }}/deviations\">{{ distribution.sum('deviationCount') }}</a>\n        <div class=\"label\">{{ t('fleetDashDeviation') }}</div>\n      </div>\n    </div>\n  </div>\n  <main>\n    <h3>{{ t('distributionPlans') }}</h3>\n    <table class=\"route-plans\">\n      <thead>\n        <tr sortable-key=\"plans\">\n          <th sortable=\"companyName name\" default>{{ t('distributionCompany') }}</th>\n          <th>{{ t('distributionPlanName') }}</th>\n          <th></th>\n          <th>{{ t('cRoutes') }}</th>\n          <th sortable=\"delayedRoutes\" function reverse>{{ t('fleetDashDelayed') }}</th>\n          <th sortable=\"percentageHandled\" function>{{ t('fleetDashHandledCustomers') }}</th>\n          <th sortable=\"customerRemainingCount\" function reverse>{{ t('fleetDashRemaining') }}</th>\n          <th sortable=\"deviationCount\" function reverse>{{ t('fleetDashDeviation') }}</th>\n          <th ng-show=\"auth.roles.clientPlus\"></th>\n          <th ng-show=\"auth.roles.clientPlus\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"routePlan in distribution.routePlans | orderBy:orderBy.plans.property:orderBy.plans.reverse\">\n          <td>{{ routePlan.companyName }}</td>\n          <td>{{ routePlan.name }}</td>\n          <td><span ng-show=\"routePlan.countOutdatedApps() &gt; 0\" tooltip=\"distributionOutdatedAppTooltipTemplate\" class=\"outdated-app tooltip-below\"> </span></td>\n          <td>{{ routePlan.routeCount }}</td>\n          <td><span ng-show=\"routePlan.published &amp;&amp; routePlan.delayedUnfinishedRoutes().length\">{{ routePlan.delayedUnfinishedRoutes().length }}</span></td>\n          <td><span tooltip=\"distributionRoutePlanProgressTooltipTemplate\" ng-show=\"routePlan.published\" class=\"route-progress-info tooltip-left\">\n              <progress-bar max=\"routePlan.customerCount\" cancelled=\"routePlan.customerCancelledCount()\" delivered=\"routePlan.customerDeliveredCount()\" deviation=\"routePlan.customerDeviationCount()\"></progress-bar></span></td>\n          <td>{{ routePlan.customerRemainingCount() }}</td>\n          <td><span ng-show=\"routePlan.published\">{{ routePlan.deviationCount() }}</span></td>\n          <td ng-show=\"auth.roles.clientPlus\"><a href=\"{{ router.link(router.nextPage(routePlan), routePlan.id) }}\" class=\"link\">{{ t('distributionShowPlan') }}</a></td>\n          <td ng-show=\"auth.roles.clientPlus\">\n            <button ng-click=\"deleteRoutePlan(routePlan)\" ng-if=\"! routePlan.published\" class=\"link dangerous\">{{ t('distributionDeletePlan') }}</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <div ng-show=\"auth.roles.clientPlus\" class=\"buttons\">\n      <button type=\"button\" ng-click=\"openEditRoutePlan(null, false, routePlans)\" class=\"action\">{{ t('plansNewPlanBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <distribution-header></distribution-header>\n</page>\n<main>\n  <h3 ng-show=\"distribution.delayedUnfinishedRoutes().length\">{{ t('distributionDelayedRoutes') }}\n    <input type=\"text\" ng-model=\"search.delayed\" placeholder=\"{{ t('distributionRouteFilter') }}\" class=\"search\">\n  </h3>\n  <table ng-show=\"distribution.delayedUnfinishedRoutes().length\">\n    <thead ng-hide=\"! filteredDelayedRoutes.length\">\n      <tr sortable-key=\"delayed\">\n        <th sortable=\"companyName name\">{{ t('distributionCompany') }}</th>\n        <th sortable=\"name\">{{ t('cRoute') }}</th>\n        <th sortable=\"driver.name\">{{ t('fleetDashDriver') }}</th>\n        <th sortable=\"percentageHandled\" function>{{ t('fleetDashHandledCustomers') }}</th>\n        <th sortable=\"customerRemainingCount\" reverse>{{ t('fleetDashRemaining') }}</th>\n        <th sortable=\"sortableDelay\" function reverse default>{{ t('fleetDashStatus') }}</th>\n        <th ng-show=\"auth.roles.clientPlus\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-hide=\"filteredDelayedRoutes.length\">\n        <td colspan=\"6\" class=\"empty-route-filter-result\">{{ t('distributionNoRoutesFound', search.delayed) }}</td>\n      </tr>\n      <tr ng-repeat=\"route in filteredDelayedRoutes = (distribution.delayedUnfinishedRoutes() | filter: search.delayed | orderBy:orderBy.delayed.property:orderBy.delayed.reverse)\">\n        <td>{{ route.companyName }}</td>\n        <td>{{ route.name }}</td>\n        <td>{{ route.driver.name }} {{route.driverPhone()}}</td>\n        <td><span tooltip=\"distributionRoutesProgressTooltipTemplate\" class=\"route-progress-info tooltip-left\">\n            <progress-bar max=\"route.customerCount\" cancelled=\"route.customerCancelledCount\" delivered=\"route.customerDeliveredCount\" deviation=\"route.customerDeviationCount\"></progress-bar></span></td>\n        <td>{{ route.customerRemainingCount }}</td>\n        <td class=\"status\"><span tooltip=\"routeStatusTooltipTemplate\" class=\"{{ route.status() }} route-status tooltip-below\"></span><span class=\"delay\">{{ route.delayForHumans() }}</span></td>\n        <td ng-show=\"auth.roles.clientPlus\">\n          <div class=\"vertical-links\"><a href=\"{{ router.link('fleet/dashboard/map', route.routePlanId) }}?routeId={{route.id}}\" class=\"link\">{{ t('distributionShowRouteMap') }}</a><a href=\"{{ router.link('fleet/deliveries', route.routePlanId) }}/{{route.id}}\" class=\"link\">{{ t('distributionShowRouteCustomers') }}</a></div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</main>");;return buf.join("");
	}

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <nav><a href=\"{{ router.link('distributions') }}\" ng-class=\"{ active: ! archive }\">{{ t('distributionsActive') }}\n        <div class=\"badge\">{{ (distributions | activeRoutePlans:false).length }}</div></a><a href=\"{{ router.link('distributions') }}#archive\" ng-class=\"{ active: archive }\">{{ t('distributionsHistoric') }}\n        <div class=\"badge\">{{ (distributions | activeRoutePlans:true).length }}</div></a></nav>\n  </page-header>\n  <main>\n    <div ng-repeat=\"distribution in distributions | activeRoutePlans:archive | orderBy: ['-date']\" class=\"distribution\">\n      <div ng-if=\"distribution.status() === 'published'\" class=\"status all-published\"><span>{{ t('distributionAllPublished', distribution.routePlans.length) }}</span></div>\n      <div ng-if=\"distribution.status() !== 'published'\" class=\"status\"><span>{{ t('distributionCountPublished', distribution.publishedRoutePlans().length, distribution.routePlans.length) }}</span></div>\n      <div class=\"content\">\n        <div class=\"date\"><span class=\"weekday\">{{ distribution.date | moment:'llll' }}</span></div>\n        <div ng-repeat=\"distrNo in distribution.distrNos\" class=\"distribution-no\"><a href=\"{{ router.link('distribution', null, { date: distribution.date, distrNo: distrNo }) }}\" class=\"link\">{{ t('distrNo' + distrNo) }}</a></div>\n      </div>\n      <div class=\"footer\">\n        <div class=\"route-plans\">{{ distribution.routePlans.length }}</div>\n        <div class=\"routes\">{{ distribution.sum('routeCount') }}</div>\n        <div class=\"customers\">{{ distribution.sum('customerCount') }}</div>\n        <div class=\"deliveries\">{{ distribution.sum('deliveryCount') }}</div>\n        <div class=\"flex-padding\"></div>\n      </div>\n    </div>\n    <div ng-if=\"! archive &amp;&amp; auth.roles.clientPlus\" class=\"route-plan dummy\">\n      <button type=\"button\" ng-click=\"openEditRoutePlan(undefined, true)\" class=\"action\">+ {{ t('distributionNewDistributionBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page ng-class=\"{ 'client-view': auth.roles.client &amp;&amp; ! auth.roles.clientPlus }\" class=\"fleet-dashboard\">\n  <page-header>\n    <page-title></page-title>\n  </page-header>\n  <fleet-dashboard-stats></fleet-dashboard-stats>\n  <div class=\"page-header route-filter\">\n    <div>\n      <nav><a href=\"#\" ng-click=\"setRouteFilter($event)\" ng-class=\"{ active: ! routeFilter.status }\">{{ t('fleetDashFilterAll') }}\n          <div class=\"badge\">{{ routePlan.routes.length }}</div></a><a href=\"#\" ng-click=\"setRouteFilter($event, 'notStarted')\" ng-class=\"{ active: routeFilter.status==='notStarted' }\">{{ t('fleetDashFilterNotStarted') }}\n          <div class=\"badge\">{{ countRouteFilter('notStarted') }}</div></a><a href=\"#\" ng-click=\"setRouteFilter($event, 'unfinished')\" ng-class=\"{ active: routeFilter.status==='unfinished' }\">{{ t('fleetDashFilterOngoing') }}\n          <div class=\"badge\">{{ countRouteFilter('unfinished') }}</div></a><a href=\"#\" ng-click=\"setRouteFilter($event, 'delayed')\" ng-class=\"{ active: routeFilter.status==='delayed' }\">{{ t('fleetDashFilterDelayed') }}\n          <div class=\"badge\">{{ countRouteFilter('delayed') }}</div></a><a href=\"#\" ng-click=\"setRouteFilter($event, 'reserved')\" ng-class=\"{ active: routeFilter.status==='reserved' }\">{{ t('fleetDashFilterReserve') }}\n          <div class=\"badge\">{{ countRouteFilter('reserved') }}</div></a></nav>\n      <div class=\"filters\"><a href=\"{{ router.link('plan/reserveroutes', routePlan.id) }}\" ng-if=\"auth.roles.fleetManager || auth.roles.clientPlus\" class=\"action\">{{ t('fleetDashEditReserve') }}</a></div>\n    </div>\n  </div>\n  <main>\n    <table>\n      <thead>\n        <tr>\n          <th>{{ t('cRoute') }}</th>\n          <th class=\"driver\"></th>\n          <th class=\"driver\">{{ t('fleetDashDriver') }}</th>\n          <th>{{ t('fleetDashWeight') }}</th>\n          <th>{{ t('fleetDashHandledCustomers') }}</th>\n          <th>{{ t('fleetDashRemaining') }}</th>\n          <th>{{ t('fleetDashDeviation') }}</th>\n          <th>{{ t('fleetDashStatus') }}</th>\n          <th></th>\n          <th></th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"route in routePlan.routes | fleetRoutes: routeFilter | orderBy: 'name'\">\n          <td><a href=\"{{ router.link('fleet/dashboard/map', routePlan.id) }}?routeId={{route.id}}\">\n              <route-name></route-name></a></td>\n          <td class=\"edit driver\"><a ng-click=\"openEditRoute($event, route)\" ng-if=\"canEditRouteInfo(routePlan)\" href=\"#\"></a></td>\n          <td class=\"driver\">\n            <div class=\"driverWrapper\">\n              <initials ng-if=\"! canEditRouteInfo(routePlan) &amp;&amp; route.driverUsername\" name=\"{{ drivers[route.driverUsername].name }}\"></initials><a ng-click=\"openEditRoute($event, route)\" ng-if=\"canEditRouteInfo(routePlan)\" href=\"#\" class=\"assign\">\n                <initials ng-if=\"route.driverUsername\" name=\"{{ drivers[route.driverUsername].name }}\"></initials><span ng-if=\"! route.driverUsername\">{{ t('fleetDashAssign') }}</span></a><span tooltip=\"driverInfoTooltipTemplate\" class=\"driver-info\"><span ng-if=\"drivers[route.driverUsername].shouldUpgradeApp\" class=\"outdated-app\"></span>{{ drivers[route.driverUsername].name }}</span><span ng-if=\"route.autoAssignedDriver\" class=\"tag autoassigned\">{{ t('taggedAutoAssigned') }}</span>\n            </div>\n          </td>\n          <td>{{ route.weight | weightInKg }}</td>\n          <td><span tooltip=\"routeProgressTooltipTemplate\" class=\"route-progress-info tooltip-left biginfo\">\n              <progress-bar max=\"route.countCustomers()\" cancelled=\"route.countCustomersCancelled()\" delivered=\"route.countCustomersDelivered()\" deviation=\"route.countCustomersDeviation()\"></progress-bar></span></td>\n          <td>{{ (route.customerCount - route.countCustomersDone()) || '' }}</td>\n          <td>{{ route.countDeliveries('deviation') || '' }}</td>\n          <td class=\"status\"><span tooltip=\"routeStatusTooltipTemplate\" class=\"{{ routeStatusClass(route) }} route-status tooltip-below\"></span><span class=\"delay\">{{ route.delayForHumans() }}</span></td>\n          <td><span ng-if=\"! route.permitDriverComingSMS\" class=\"disabledNotification\"></span></td>\n          <td><span ng-if=\"! route.orderMaintained\" class=\"wrongOrder\"></span></td>\n          <td><a href=\"{{ router.link('fleet/deliveries', routePlan.id) }}/{{ route.id }}\" class=\"link\">{{ t('cCustomers') }}</a></td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page ng-class=\"{ 'client-view': auth.roles.client &amp;&amp; ! auth.roles.clientPlus }\" class=\"fleet-dashboard\">\n  <page-header>\n    <page-title></page-title>\n    <div class=\"filters\">\n      <select ng-options=\"route as route.nameAndDriver(drivers) for route in routePlan.routes | orderBy: 'name'\" ng-model=\"map.route\" ng-change=\"map.selectRoute(map.route)\">\n        <option value=\"\">{{ t('fleetDashShowAllRoutes') }}</option>\n      </select>\n    </div>\n  </page-header><map></map>\n  <fleet-dashboard-stats></fleet-dashboard-stats>\n</page>");;return buf.join("");
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page ng-class=\"{ 'client-view': auth.roles.client &amp;&amp; ! auth.roles.clientPlus }\">\n  <page-header>\n    <page-title></page-title>\n    <div class=\"actions\">\n      <input type=\"text\" ng-model=\"search.text\" placeholder=\"{{ t('fleetDashFilter') }}\" class=\"search\">\n    </div>\n    <div class=\"reports\"><a href=\"{{ router.link('fleet/print', routePlan.id) }}/{{ filter.routeId || '' }}\" target=\"_blank\" ng-click=\"addPrint(route.routeId)\" class=\"action print stroked\">{{ t('fleetDelPrintBtn') }}\n        <div ng-show=\"routePlan.sumPrints(routePlan.prints)\" tooltip=\"routePrintedTooltipTemplate\" class=\"badge-printed\">{{routePlan.sumPrints(routePlan.prints)}}</div></a><a href=\"{{ exportDeliveryMetaUrl() }}\" target=\"_self\" class=\"action export stroked\">{{ t('fleetDelAcknowledgementsBtn') }}</a><a href=\"{{ exportDeviationMetaUrl() }}\" target=\"_self\" class=\"action export stroked\">{{ t('fleetDelDeviationsBtn') }}</a></div>\n    <nav><a href=\"#\" ng-click=\"setStatus($event)\" ng-class=\"{ active: ! filter.status &amp;&amp; ! filter.delayed }\">{{ t('fleetDelFilterAll') }}\n        <div class=\"badge\">{{ countStatus() }}</div></a><a href=\"#\" ng-click=\"setStatus($event, 'notDelivered')\" ng-class=\"{ active: filter.status === 'notDelivered' }\">{{ t('fleetDelFilterRemaining') }}\n        <div class=\"badge\">{{ countStatus('notDelivered') }}</div></a><a href=\"#\" ng-if=\"! auth.roles.client\" ng-click=\"setStatus($event, undefined, true)\" ng-class=\"{ active: filter.delayed }\">{{ t('fleetDelFilterDelayed') }}\n        <div class=\"badge\">{{ countStatus(undefined, true) }}</div></a><a href=\"#\" ng-click=\"setStatus($event, 'deviation')\" ng-class=\"{ active: filter.status === 'deviation' }\">{{ t('fleetDelFilterDeviations') }}\n        <div class=\"badge\">{{ countStatus('deviation') }}</div></a><a href=\"#\" ng-click=\"setStatus($event, 'partiallyDelivered')\" ng-class=\"{ active: filter.status === 'partiallyDelivered' }\">{{ t('fleetDelFilterPartiallyDelivered') }}\n        <div class=\"badge\">{{ countStatus('partiallyDelivered') }}</div></a><a href=\"#\" ng-click=\"setStatus($event, 'cancelled')\" ng-class=\"{ active: filter.status === 'cancelled' }\">{{ t('fleetDelFilterCancelled') }}\n        <div class=\"badge\">{{ countStatus('cancelled') }}</div></a></nav>\n    <div class=\"filters\">\n      <select ng-model=\"filter.routeId\">\n        <option value=\"\">{{ t('fleetDelAllRoutes') }}</option>\n        <option ng-repeat=\"route in routePlan.routes | orderBy:'name'\" value=\"{{ route.id }}\">{{ route.nameAndDriver(drivers) }}</option>\n      </select>\n    </div>\n  </page-header>\n  <main>\n    <table>\n      <thead>\n        <tr>\n          <th>{{ t('fleetDelStop') }}</th>\n          <th class=\"product\">{{ t('cProduct') }}</th>\n          <th class=\"customer-system\"></th>\n          <th>{{ t('customerOrder') }}</th>\n          <th></th>\n          <th>{{ t('cCustomer') }}</th>\n          <th></th>\n          <th>{{ t('customerPhone1') }}</th>\n          <th>{{ t('cRoute') }}</th>\n          <th class=\"estimate\">{{ t('fleetDelArrival') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"customer in routePlan.customers |                       fleetCustomers: filter | filter: search.text |                       orderBy: ['routeName', 'routeSequence', 'id']                       track by customer.id\" class=\"{{ customer.notCancelled() ? 'notCancelled' : 'cancelledCustomer' }}\">\n          <td class=\"stopno\"><span class=\"circle color-{{ customer.routeColor }}\">{{ customer.routeSequence }}</span></td>\n          <td class=\"product\">\n            <status-deliveries customer=\"customer\"></status-deliveries>\n          </td>\n          <td class=\"customer-system\">{{ customer.customerSystem.shortName }}</td>\n          <td>{{ customer.orderId }}</td>\n          <td class=\"edit\">\n            <button type=\"button\" ng-click=\"openEditCustomer(customer, ! customer.notCancelled(), customer.routeId)\" ng-if=\"routePlan.correctable(customer.routeId, customer.deliveries)\"></button>\n          </td>\n          <td><span tooltip=\"deliveryInfoTooltipTemplate\" class=\"delivery-info\"><span>{{ customer.name }}</span></span>\n            <div class=\"address\">{{ customer.fullAddress }}</div>\n          </td>\n          <td><span ng-show=\"customer.notifications.length\" tooltip=\"notificationsTooltipTemplate\" class=\"notifications\"></span>\n            <image-modal customer=\"customer\" ng-if=\"customer.imageUrl\"></image-modal>\n          </td>\n          <td><span ng-show=\"customer.callLogs.length &gt; 0\" tooltip=\"customerCallLogTooltipTemplate\" class=\"callLog\"><span class=\"phone\">{{ formatPhone(customer.phone1) }}</span><br><span ng-if=\"customer.phone2\" class=\"phone\">{{ formatPhone(customer.phone2) }}</span></span><span ng-show=\"customer.callLogs.length === 0\"><span class=\"phone\">{{ formatPhone(customer.phone1) }}</span><br><span ng-if=\"customer.phone2\" class=\"phone\">{{ formatPhone(customer.phone2) }}</span></span></td>\n          <td><a href=\"{{ router.link('fleet/dashboard/map', routePlan.id) }}?routeId={{customer.routeId}}&amp;routeSequence={{ customer.routeSequence }}\" class=\"link\">{{ customer.routeName }}</a></td>\n          <td class=\"estimate\"><span tooltip=\"customerTimestampTooltipTemplate\" ng-class=\"{ delayed: customer.delayed(), visited: customer.deliveryStatusTimestamp() }\" ng-show=\"customer.estimatedTimestampDone || customer.deliveryStatusTimestamp()\" class=\"customer-timestamp\"><span>{{ (customer.deliveryStatusTimestamp() ? customer.estimatedTimestampDone : estimatedTimeAdjustedByRoute(customer.estimatedTimestampDone, customer.routeId)) | moment: 'LT' }}</span><span>{{ customer.deliveryStatusTimestamp() | moment: 'LT' }}</span></span></td>\n        </tr>\n      </tbody>\n    </table>\n    <div class=\"buttons\">\n      <button type=\"button\" ng-if=\"routePlan.canCustomerBeAdded(routePlan.customers[0].routeId)\" ng-click=\"openEditCustomer(null, false, null)\" ng-disabled=\"routePlan.status() === 'importing' || !(auth.roles.plannerPlus || auth.roles.clientPlus)\" class=\"action\">{{ t('planFilesNewCustomerBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-if=\"dataLoaded()\" ng-repeat=\"route in routePlan.routes | filter: { id: filter.routeId } | orderBy: 'name'\" ng-class=\"{ 'page-break': $index, 'single-customer-system': routePlan.customerSystems.length &lt; 2 }\" class=\"print-page\">\n  <page-header>\n    <h1>\n      <div class=\"printer-name\">{{ t('fleetPrinterName', username) }}</div>\n      <div class=\"date\">{{ routePlan.date | moment:'LL' }}</div>\n      <div class=\"name\">{{ routePlan.name }}</div>\n      <div ng-repeat=\"name in customerSystemNames(routePlan.customerSystems)\" class=\"customer-system\">{{ name }}</div>\n    </h1>\n    <div class=\"actions\">\n      <h1>\n        <div class=\"routeName\">{{ route.name }}</div>\n        <div class=\"driverName\">{{ route.driverName(drivers) }}</div>\n      </h1>\n    </div>\n  </page-header>\n  <main>\n    <div class=\"document-instructions\">{{ t('fleetPrinterInstructions') }}</div>\n    <table class=\"product-summary\">\n      <thead>\n        <tr>\n          <th>{{ t('cProduct') }}</th>\n          <th>{{ t('fleetPrintCount') }}</th>\n        </tr>\n        <tr ng-repeat=\"product in values(route.products) | orderBy: 'name'\">\n          <td>{{ product.name }}</td>\n          <td>{{ product.count }}</td>\n        </tr>\n      </thead>\n    </table>\n    <div class=\"clear\"></div>\n    <table class=\"page-break\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>{{ t('cAddress') }}</th>\n          <th>{{ t('cCustomer') }}</th>\n          <th>{{ t('customerPhone1') }}</th>\n          <th class=\"customer-system\"></th>\n          <th>{{ t('customerOrder') }}</th>\n          <th>{{ t('cProduct') }}</th>\n        </tr>\n        <tbody>\n          <tr ng-repeat=\"customer in routePlan.customers |                        filter: { routeId: route.id } |                        orderBy: ['routeSequence', 'name']\" ng-if=\"customer.notCancelled()\">\n            <td>{{ customer.routeSequence }}.</td>\n            <td class=\"address\">\n              <div>{{ customer.address }}</div>\n              <div>{{ customer.zipAndCity() }}</div>\n            </td>\n            <td>{{ customer.name }}<br>\n              <div class=\"directive\">{{ customer.description }}</div>\n            </td>\n            <td class=\"nowrap\">\n              <div>{{ formatPhone(customer.phone1) }}</div>\n              <div>{{ formatPhone(customer.phone2) }}</div>\n            </td>\n            <td class=\"nowrap customer-system\">{{ customer.customerSystem.shortName }}</td>\n            <td>{{ customer.orderId }}</td>\n            <td class=\"nowrap\">\n              <div ng-repeat=\"delivery in customer.deliveries\" ng-if=\"delivery.notCancelled()\"><span ng-if=\"delivery.productCount &gt; 1\">{{ delivery.productCount }}&nbsp;</span>{{ delivery.product }}</div>\n            </td>\n          </tr>\n        </tbody>\n      </thead>\n    </table>\n  </main>\n</div>\n<print></print>");;return buf.join("");
	}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<header>\n  <downtime-warnings></downtime-warnings>\n</header>\n<main>\n  <div class=\"logo\">Plan & Go</div>\n  <form ng-submit=\"login(username, password)\" name=\"form\">\n    <label>{{ t('loginUsername') }}</label>\n    <input type=\"text\" ng-model=\"username\" required>\n    <label>{{ t('loginPassword') }}</label>\n    <input type=\"password\" ng-model=\"password\" required>\n    <label>{{ t('loginLanguage') }}</label>\n    <div ng-if=\"languages\" class=\"select\">\n      <select ng-required=\"true\" ng-model=\"languageId\" ng-options=\"language.id as language.name for language in languages | orderBy:'name'\" ng-change=\"changeLanguage(languageId)\"></select>\n    </div>\n    <div ng-show=\"errorMsg\" ng-bind-html=\"errorMsg\" class=\"error\"></div>\n    <div class=\"actions\"><a ng-href=\"{{ forgotPasswordURL() }}\">{{ t('loginForgot') }}</a>\n      <div class=\"flex-padding\"></div>\n      <button type=\"submit\" ng-if=\"! isLoading\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('loginLoginBtn') }}</button>\n      <spinner ng-if=\"isLoading\"></spinner>\n    </div>\n  </form>\n  <div class=\"downloadAppWrapper\"><a href=\"https://appsto.re/no/jYvtfb.i\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"135\" height=\"40\" viewBox=\"0 0 135 40\" class=\"appstore-badge apple\">\n  <path class=\"background\" d=\"M130.197 40H4.729A4.74 4.74 0 0 1 0 35.267V4.726A4.733 4.733 0 0 1 4.729 0h125.468C132.803 0 135 2.12 135 4.726v30.541c0 2.605-2.197 4.733-4.803 4.733z\"/>\n  <g class=\"logo\">\n    <path class=\"fill\" d=\"M30.128 19.784c-.029-3.223 2.639-4.791 2.761-4.864-1.511-2.203-3.853-2.504-4.676-2.528-1.967-.207-3.875 1.177-4.877 1.177-1.022 0-2.565-1.157-4.228-1.123-2.14.033-4.142 1.272-5.24 3.196-2.266 3.923-.576 9.688 1.595 12.859 1.086 1.553 2.355 3.287 4.016 3.226 1.625-.067 2.232-1.036 4.193-1.036 1.943 0 2.513 1.036 4.207.997 1.744-.028 2.842-1.56 3.89-3.127 1.255-1.78 1.759-3.533 1.779-3.623-.041-.014-3.387-1.291-3.42-5.154zM26.928 10.306c.874-1.093 1.472-2.58 1.306-4.089-1.265.056-2.847.875-3.758 1.944-.806.942-1.526 2.486-1.34 3.938 1.421.106 2.88-.717 3.792-1.793z\"/>\n  </g>\n  <g class=\"fontBig\">\n    <path class=\"fill\" d=\"M53.645 31.504h-2.271l-1.244-3.909h-4.324l-1.185 3.909H42.41l4.284-13.308h2.646l4.305 13.308zm-3.89-5.549L48.63 22.48c-.119-.355-.342-1.191-.671-2.507h-.04a96.75 96.75 0 0 1-.632 2.507l-1.105 3.475h3.573zM64.662 26.588c0 1.632-.441 2.922-1.323 3.869-.79.843-1.771 1.264-2.942 1.264-1.264 0-2.172-.454-2.725-1.362h-.04v5.055H55.5V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.711-1.146 1.79-1.718 3.238-1.718 1.132 0 2.077.447 2.833 1.342.758.896 1.136 2.074 1.136 3.535zm-2.172.078c0-.934-.21-1.704-.632-2.31-.461-.632-1.08-.948-1.856-.948-.526 0-1.004.176-1.431.523-.428.35-.708.807-.839 1.373-.066.264-.099.48-.099.65v1.6c0 .698.214 1.287.642 1.768s.984.721 1.668.721c.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM75.699 26.588c0 1.632-.441 2.922-1.324 3.869-.789.843-1.77 1.264-2.941 1.264-1.264 0-2.172-.454-2.724-1.362h-.04v5.055h-2.132V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.71-1.146 1.789-1.718 3.238-1.718 1.131 0 2.076.447 2.834 1.342.755.896 1.134 2.074 1.134 3.535zm-2.172.078c0-.934-.211-1.704-.633-2.31-.461-.632-1.078-.948-1.855-.948a2.22 2.22 0 0 0-1.432.523c-.428.35-.707.807-.838 1.373-.065.264-.099.48-.099.65v1.6c0 .698.214 1.287.64 1.768.428.48.984.721 1.67.721.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM88.039 27.772c0 1.132-.393 2.053-1.182 2.764-.867.777-2.074 1.165-3.625 1.165-1.432 0-2.58-.276-3.449-.829l.494-1.777c.936.566 1.963.85 3.082.85.803 0 1.428-.182 1.877-.544.447-.362.67-.848.67-1.454 0-.54-.184-.995-.553-1.364-.367-.369-.98-.712-1.836-1.029-2.33-.869-3.494-2.142-3.494-3.816 0-1.094.408-1.991 1.225-2.689.814-.699 1.9-1.048 3.258-1.048 1.211 0 2.217.211 3.02.632l-.533 1.738c-.75-.408-1.598-.612-2.547-.612-.75 0-1.336.185-1.756.553a1.58 1.58 0 0 0-.533 1.205c0 .526.203.961.611 1.303.355.316 1 .658 1.936 1.027 1.145.461 1.986 1 2.527 1.618.539.616.808 1.387.808 2.307zM95.088 23.508h-2.35v4.659c0 1.185.414 1.777 1.244 1.777.381 0 .697-.033.947-.099l.059 1.619c-.42.157-.973.236-1.658.236-.842 0-1.5-.257-1.975-.77-.473-.514-.711-1.376-.711-2.587v-4.837h-1.4v-1.6h1.4v-1.757l2.094-.632v2.389h2.35v1.602zM105.691 26.627c0 1.475-.422 2.686-1.264 3.633-.883.975-2.055 1.461-3.516 1.461-1.408 0-2.529-.467-3.365-1.401s-1.254-2.113-1.254-3.534c0-1.487.43-2.705 1.293-3.652.861-.948 2.023-1.422 3.484-1.422 1.408 0 2.541.467 3.396 1.402.818.907 1.226 2.078 1.226 3.513zm-2.212.069c0-.885-.189-1.644-.572-2.277-.447-.766-1.086-1.148-1.914-1.148-.857 0-1.508.383-1.955 1.148-.383.634-.572 1.405-.572 2.317 0 .885.189 1.644.572 2.276.461.766 1.105 1.148 1.936 1.148.814 0 1.453-.39 1.914-1.168.393-.645.591-1.412.591-2.296zM112.621 23.783a3.702 3.702 0 0 0-.672-.059c-.75 0-1.33.283-1.738.85-.355.5-.533 1.132-.533 1.895v5.035h-2.131l.02-6.574c0-1.106-.027-2.113-.08-3.021h1.857l.078 1.836h.059c.225-.631.58-1.139 1.066-1.52a2.578 2.578 0 0 1 1.541-.514c.197 0 .375.014.533.039v2.033zM122.156 26.252a5 5 0 0 1-.078.967h-6.396c.025.948.334 1.673.928 2.173.539.447 1.236.671 2.092.671.947 0 1.811-.151 2.588-.454l.334 1.48c-.908.396-1.98.593-3.217.593-1.488 0-2.656-.438-3.506-1.313-.848-.875-1.273-2.05-1.273-3.524 0-1.447.395-2.652 1.186-3.613.828-1.026 1.947-1.539 3.355-1.539 1.383 0 2.43.513 3.141 1.539.563.815.846 1.823.846 3.02zm-2.033-.553c.014-.632-.125-1.178-.414-1.639-.369-.593-.936-.889-1.699-.889-.697 0-1.264.289-1.697.869-.355.461-.566 1.014-.631 1.658h4.441z\"/>\n  </g>\n  <g class=\"fontSmall\">\n    <path class=\"fill\" d=\"M49.05 10.009c0 1.177-.353 2.063-1.058 2.658-.653.549-1.581.824-2.783.824-.596 0-1.106-.026-1.533-.078V6.982c.557-.09 1.157-.136 1.805-.136 1.145 0 2.008.249 2.59.747.652.563.979 1.368.979 2.416zm-1.105.029c0-.763-.202-1.348-.606-1.756-.404-.407-.994-.611-1.771-.611-.33 0-.611.022-.844.068v4.889c.129.02.365.029.708.029.802 0 1.421-.223 1.857-.669s.656-1.096.656-1.95zM54.909 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.009.718-1.727.718-.692 0-1.243-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.712-.698c.692 0 1.248.229 1.669.688.4.446.601 1.022.601 1.726zm-1.087.034c0-.435-.094-.808-.281-1.119-.22-.376-.533-.564-.94-.564-.421 0-.741.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .714-.191.94-.574.194-.317.291-.693.291-1.128zM62.765 8.719l-1.475 4.714h-.96l-.611-2.047a15.32 15.32 0 0 1-.379-1.523h-.019a11.15 11.15 0 0 1-.379 1.523l-.649 2.047h-.971l-1.387-4.714h1.077l.533 2.241c.129.53.235 1.035.32 1.513h.019c.078-.394.207-.896.389-1.503l.669-2.25h.854l.641 2.202c.155.537.281 1.054.378 1.552h.029c.071-.485.178-1.002.32-1.552l.572-2.202h1.029zM68.198 13.433H67.15v-2.7c0-.832-.316-1.248-.95-1.248a.946.946 0 0 0-.757.343 1.217 1.217 0 0 0-.291.808v2.796h-1.048v-3.366c0-.414-.013-.863-.038-1.349h.921l.049.737h.029c.122-.229.304-.418.543-.569.284-.176.602-.265.95-.265.44 0 .806.142 1.097.427.362.349.543.87.543 1.562v2.824zM71.088 13.433h-1.047V6.556h1.047v6.877zM77.258 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.01.718-1.727.718-.693 0-1.244-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.711-.698c.693 0 1.248.229 1.67.688.4.446.601 1.022.601 1.726zm-1.088.034c0-.435-.094-.808-.281-1.119-.219-.376-.533-.564-.939-.564-.422 0-.742.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .713-.191.939-.574.195-.317.291-.693.291-1.128zM82.33 13.433h-.941l-.078-.543h-.029c-.322.433-.781.65-1.377.65-.445 0-.805-.143-1.076-.427a1.339 1.339 0 0 1-.369-.96c0-.576.24-1.015.723-1.319.482-.304 1.16-.453 2.033-.446V10.3c0-.621-.326-.931-.979-.931-.465 0-.875.117-1.229.349l-.213-.688c.438-.271.979-.407 1.617-.407 1.232 0 1.85.65 1.85 1.95v1.736c0 .471.023.846.068 1.124zm-1.088-1.62v-.727c-1.156-.02-1.734.297-1.734.95 0 .246.066.43.201.553a.733.733 0 0 0 .512.184c.23 0 .445-.073.641-.218a.893.893 0 0 0 .38-.742zM88.285 13.433h-.93l-.049-.757h-.029c-.297.576-.803.864-1.514.864-.568 0-1.041-.223-1.416-.669s-.562-1.025-.562-1.736c0-.763.203-1.381.611-1.853.395-.44.879-.66 1.455-.66.633 0 1.076.213 1.328.64h.02V6.556h1.049v5.607c0 .459.012.882.037 1.27zm-1.086-1.988v-.786a1.194 1.194 0 0 0-.408-.965 1.03 1.03 0 0 0-.701-.257c-.391 0-.697.155-.922.466-.223.311-.336.708-.336 1.193 0 .466.107.844.322 1.135.227.31.533.465.916.465.344 0 .619-.129.828-.388.202-.239.301-.527.301-.863zM97.248 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.008.718-1.727.718-.691 0-1.242-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.713-.698c.691 0 1.248.229 1.668.688.4.446.601 1.022.601 1.726zm-1.086.034c0-.435-.094-.808-.281-1.119-.221-.376-.533-.564-.941-.564-.42 0-.74.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .715-.191.941-.574.193-.317.291-.693.291-1.128zM102.883 13.433h-1.047v-2.7c0-.832-.316-1.248-.951-1.248-.311 0-.562.114-.756.343s-.291.499-.291.808v2.796h-1.049v-3.366c0-.414-.012-.863-.037-1.349h.92l.049.737h.029a1.53 1.53 0 0 1 .543-.569c.285-.176.602-.265.951-.265.439 0 .805.142 1.096.427.363.349.543.87.543 1.562v2.824zM109.936 9.504h-1.154v2.29c0 .582.205.873.611.873.188 0 .344-.016.467-.049l.027.795c-.207.078-.479.117-.814.117-.414 0-.736-.126-.969-.378-.234-.252-.35-.676-.35-1.271V9.504h-.689v-.785h.689v-.864l1.027-.31v1.173h1.154v.786zM115.484 13.433h-1.049v-2.68c0-.845-.316-1.268-.949-1.268-.486 0-.818.245-1 .735a1.317 1.317 0 0 0-.049.377v2.835h-1.047V6.556h1.047v2.841h.02c.33-.517.803-.775 1.416-.775.434 0 .793.142 1.078.427.355.355.533.883.533 1.581v2.803zM121.207 10.853c0 .188-.014.346-.039.475h-3.143c.014.466.164.821.455 1.067.266.22.609.33 1.029.33.465 0 .889-.074 1.271-.223l.164.728c-.447.194-.973.291-1.582.291-.73 0-1.305-.215-1.721-.645-.418-.43-.625-1.007-.625-1.731 0-.711.193-1.303.582-1.775.406-.504.955-.756 1.648-.756.678 0 1.193.252 1.541.756.281.4.42.895.42 1.483zm-1-.271a1.411 1.411 0 0 0-.203-.805c-.182-.291-.459-.437-.834-.437a.995.995 0 0 0-.834.427 1.586 1.586 0 0 0-.311.815h2.182z\"/>\n  </g>\n</svg></a><a href=\"https://play.google.com/store/apps/details?id=no.di.planandgo\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 135.17 40.13\" class=\"appstore-badge googleplay\">\n  <defs>\n    <style>\n      .cls-9{opacity:0.2;}\n      .cls-10,.cls-11,.cls-9{isolation:isolate;}\n      .cls-10{opacity:0.12;}\n      .cls-11{opacity:0.25;}\n    </style>\n  </defs>\n  <rect class=\"fill\" x=\"0.13\" width=\"135\" height=\"40\" rx=\"5\" ry=\"5\"/>\n  <path class=\"fill\" d=\"M130.13.8a4.2,4.2,0,0,1,4.2,4.2V35a4.2,4.2,0,0,1-4.2,4.2H5.13A4.2,4.2,0,0,1,.93,35V5A4.2,4.2,0,0,1,5.13.8h125m0-.8H5.13a5,5,0,0,0-5,5V35a5,5,0,0,0,5,5h125a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z\"/>\n  <g class=\"font1\">\n    <path d=\"M47.54,10.24a2.71,2.71,0,0,1-.75,2,2.91,2.91,0,0,1-2.2.89A3.09,3.09,0,0,1,41.48,10a3.09,3.09,0,0,1,3.12-3.13,3.1,3.1,0,0,1,1.23.25,2.47,2.47,0,0,1,.94.67l-.53.53a2,2,0,0,0-1.64-.71A2.32,2.32,0,0,0,42.26,10a2.36,2.36,0,0,0,4,1.73,1.89,1.89,0,0,0,.5-1.22H44.59V9.79H47.5A2.54,2.54,0,0,1,47.54,10.24Z\"/>\n    <path d=\"M52.15,7.74H49.42v1.9h2.46v.72H49.42v1.9h2.73V13h-3.5V7h3.5Z\"/>\n    <path d=\"M55.4,13h-.77V7.74H53V7h4.12v.74H55.4Z\"/>\n    <path d=\"M60.06,13V7h.77v6Z\"/>\n    <path d=\"M64.25,13h-.77V7.74H61.81V7h4.12v.74H64.25Z\"/>\n    <path d=\"M73.73,12.22a3.12,3.12,0,0,1-4.4,0A3.07,3.07,0,0,1,68.45,10a3.07,3.07,0,0,1,.88-2.22,3.1,3.1,0,0,1,4.4,0A3.07,3.07,0,0,1,74.62,10,3.07,3.07,0,0,1,73.73,12.22Zm-3.83-.5a2.31,2.31,0,0,0,3.26,0A2.35,2.35,0,0,0,73.83,10a2.35,2.35,0,0,0-.67-1.72,2.31,2.31,0,0,0-3.26,0A2.35,2.35,0,0,0,69.24,10,2.35,2.35,0,0,0,69.9,11.72Z\"/>\n    <path d=\"M75.7,13V7h.94l2.92,4.67h0l0-1.16V7h.77v6h-.8L76.47,8.11h0l0,1.16V13Z\"/>\n  </g>\n  <path class=\"font\" d=\"M68.26,21.75A4.25,4.25,0,1,0,72.53,26,4.19,4.19,0,0,0,68.26,21.75Zm0,6.83A2.58,2.58,0,1,1,70.66,26,2.46,2.46,0,0,1,68.26,28.58Zm-9.31-6.83A4.25,4.25,0,1,0,63.22,26,4.19,4.19,0,0,0,58.95,21.75Zm0,6.83A2.58,2.58,0,1,1,61.35,26,2.46,2.46,0,0,1,58.95,28.58ZM47.87,23.06v1.8h4.32a3.77,3.77,0,0,1-1,2.27,4.42,4.42,0,0,1-3.33,1.32,4.8,4.8,0,0,1,0-9.6,4.6,4.6,0,0,1,3.25,1.29l1.27-1.27A6.29,6.29,0,0,0,47.87,17a6.61,6.61,0,1,0,0,13.21,6,6,0,0,0,4.61-1.85A6,6,0,0,0,54,24.18a5.87,5.87,0,0,0-.1-1.13Zm45.31,1.4a4,4,0,0,0-3.64-2.71,4,4,0,0,0-4,4.25,4.16,4.16,0,0,0,4.22,4.25,4.23,4.23,0,0,0,3.54-1.88l-1.45-1a2.43,2.43,0,0,1-2.09,1.18,2.16,2.16,0,0,1-2.06-1.29l5.69-2.35Zm-5.8,1.42a2.33,2.33,0,0,1,2.22-2.48,1.65,1.65,0,0,1,1.58.9ZM82.75,30h1.87V17.5H82.75Zm-3.06-7.3h-.06a3,3,0,0,0-2.24-1,4.26,4.26,0,0,0,0,8.51,2.9,2.9,0,0,0,2.24-1h.06v.61c0,1.63-.87,2.5-2.27,2.5a2.35,2.35,0,0,1-2.14-1.51l-1.63.68a4.05,4.05,0,0,0,3.77,2.51c2.19,0,4-1.29,4-4.43V22H79.69Zm-2.14,5.88a2.59,2.59,0,0,1,0-5.16A2.4,2.4,0,0,1,79.82,26,2.38,2.38,0,0,1,77.55,28.58ZM101.93,17.5H97.46V30h1.87V25.26h2.61a3.89,3.89,0,1,0,0-7.76Zm0,6H99.33V19.24H102a2.14,2.14,0,1,1,0,4.29Zm11.53-1.8a3.5,3.5,0,0,0-3.33,1.91l1.66.69a1.77,1.77,0,0,1,1.7-.92,1.8,1.8,0,0,1,2,1.61v.13a4.13,4.13,0,0,0-1.95-.48c-1.79,0-3.6,1-3.6,2.81a2.89,2.89,0,0,0,3.1,2.75A2.63,2.63,0,0,0,115.44,29h.06v1h1.8V25.19C117.31,23,115.65,21.73,113.51,21.73Zm-.23,6.85c-.61,0-1.46-.31-1.46-1.06,0-1,1.06-1.33,2-1.33a3.32,3.32,0,0,1,1.7.42A2.26,2.26,0,0,1,113.29,28.58ZM123.87,22l-2.14,5.42h-.06L119.45,22h-2l3.33,7.58-1.9,4.21h1.95L125.94,22Zm-16.81,8h1.87V17.5h-1.87Z\"/>\n  <path class=\"blue\" d=\"M10.56,7.54a2,2,0,0,0-.46,1.4V31.06a2,2,0,0,0,.46,1.4l.07.07L23,20.15v-.29L10.63,7.47Z\"/>\n  <path class=\"yellow\" d=\"M27.15,24.28,23,20.15v-.29l4.13-4.13.09.05,4.89,2.78c1.4.79,1.4,2.09,0,2.89l-4.89,2.78Z\"/>\n  <path class=\"red\" d=\"M27.25,24.22,23,20,10.56,32.46a1.63,1.63,0,0,0,2.08.06l14.61-8.3\"/>\n  <path class=\"green\" d=\"M27.25,15.78,12.64,7.48a1.63,1.63,0,0,0-2.08.06L23,20Z\"/>\n  <path class=\"cls-9\" d=\"M27.15,24.13,12.64,32.38a1.67,1.67,0,0,1-2,0h0l-.07.07h0l.07.07h0a1.66,1.66,0,0,0,2,0l14.61-8.3Z\"/>\n  <path class=\"cls-10\" d=\"M10.56,32.32a2,2,0,0,1-.46-1.4v.15a2,2,0,0,0,.46,1.4l.07-.07Z\"/>\n  <path class=\"cls-10\" d=\"M32.14,21.3l-5,2.83.09.09,4.89-2.78a1.75,1.75,0,0,0,1-1.44h0A1.86,1.86,0,0,1,32.14,21.3Z\"/>\n  <path class=\"cls-11\" d=\"M12.64,7.62,32.14,18.7a1.86,1.86,0,0,1,1,1.3h0a1.75,1.75,0,0,0-1-1.44L12.64,7.48c-1.4-.79-2.54-.13-2.54,1.47v.15C10.1,7.49,11.24,6.83,12.64,7.62Z\"/>\n</svg></a></div>\n</main>");;return buf.join("");
	}

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <plan-customers-tabs></plan-customers-tabs>\n  <main>\n    <table>\n      <thead>\n        <tr>\n          <th></th>\n          <th>{{ t('cAddress') }}</th>\n          <th>{{ t('cCustomer') }}</th>\n          <th>{{ t('customerDeadline') }}</th>\n          <th>{{ t('cSupplier') }}</th>\n          <th>{{ t('customerOrder') }}</th>\n          <th>{{ t('customerParcels') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"customer in routePlan.customers | filter: filter | filter: search.text\" ng-class=\"{ deviation: ! customer.latitude, active: customer.id === activeCustomerId, cancelled: ! customer.anyDeliveries() }\">\n          <td class=\"edit\">\n            <button ng-if=\"routePlan.canCustomerBeEdited()\" type=\"button\" ng-click=\"openEditCustomer(customer, ! customer.anyDeliveries(), customer.routeId)\"></button>\n          </td>\n          <td class=\"address\">{{ customer.fullAddress }}</td>\n          <td class=\"name\">{{ customer.name }}</td>\n          <td class=\"time\">{{ customer.deliveryWindow() }}</td>\n          <td>{{ customerSystems[customer.customerSystemId].shortName }}</td>\n          <td>{{ customer.orderId }}</td>\n          <td>\n            <delivery-count customer=\"customer\"></delivery-count>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <div class=\"buttons\">\n      <button type=\"button\" ng-if=\"routePlan.canCustomerBeEdited()\" ng-click=\"openEditCustomer(null, false, null)\" ng-disabled=\"routePlan.status() === 'importing' || !(auth.roles.plannerPlus || auth.roles.clientPlus)\" class=\"action\">{{ t('planFilesNewCustomerBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <plan-customers-tabs></plan-customers-tabs>\n  <main>\n    <div ng-repeat=\"file in allFiles() track by file.id\" class=\"file\">\n      <div class=\"status {{ file.statusClass() }}\"><span>{{ t('fileStatus_' + file.statusClass()) }} &nbsp;</span>\n        <spinner ng-if=\"file.statusClass() === 'linking' || file.statusClass() === 'uploading'\"></spinner>\n        <button type=\"button\" ng-if=\"(file.statusClass() === 'done' || file.statusClass() === 'error') &amp;&amp; canDeleteFiles(routePlan)\" ng-click=\"deleteFile(file)\" class=\"delete\"></button>\n      </div>\n      <div class=\"content\">\n        <div class=\"file-name\">{{ file.name }}</div>\n        <div class=\"customer-systems\">\n          <div ng-repeat=\"name in customerSystemNames(file.customerSystemIds(routePlan.customers))\">{{ name }}</div>\n        </div>\n        <div class=\"flex-padding\"></div>\n      </div>\n      <div class=\"footer\">\n        <div ng-if=\"file.statusClass() === 'linking' &amp;&amp; file.progress != null\" class=\"progress\">{{ file.progress }}% ferdig</div>\n        <div class=\"customers\">{{ customersInFile(file).length || '' }}</div>\n        <div class=\"deviations\">{{ ( customersInFile(file) | filter: { latitude: null } ).length || '' }}</div>\n        <div class=\"flex-padding\"></div>\n        <button ng-if=\"file.statusClass() === 'done' || file.statusClass() === 'manual'\" ng-click=\"openProducts(routePlan, file)\" class=\"link\">{{ t('planFilesCardShowProducts') }}</button>\n        <div class=\"flex-padding\"></div><a ng-if=\"file.statusClass() === 'done' || file.statusClass() === 'manual'\" href=\"{{ router.link('plan/customers', routePlan.id) }}/{{ file.id }}\" class=\"link\">{{ t('planFilesCardShowCustomers') }}</a>\n      </div>\n    </div>\n    <div ng-if=\"routePlan.editable() &amp;&amp; ! routePlan.pianoFile() &amp;&amp; (auth.roles.plannerPlus || auth.roles.clientPlus)\" class=\"file dummy\">\n      <button type=\"button\" ng-click=\"openFileUpload()\" class=\"action\">+ {{ t('planFilesNewFileBtn') }}</button>\n      <button type=\"button\" ng-click=\"openEditCustomer(null, false, null)\" class=\"action\">+ {{ t('planFilesNewCustomerBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page class=\"plan-routes\">\n  <page-header>\n    <page-title></page-title>\n    <div class=\"filters\">\n      <select ng-options=\"route as route.nameAndDriver(drivers) for route in routePlan.routes | orderBy: 'name'\" ng-model=\"map.route\" ng-change=\"map.selectRoute(map.route)\">\n        <option value=\"\">{{ t('fleetDashShowAllRoutes') }}</option>\n      </select>\n    </div>\n  </page-header><map> </map>\n  <plan-routes-stats></plan-routes-stats>\n</page>");;return buf.join("");
	}

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <nav><a href=\"{{ router.link('plans') }}\" ng-class=\"{ active: ! archive }\">{{ t('plansActivePlans') }}\n        <div class=\"badge\">{{ (routePlans | activeRoutePlans:false).length }}</div></a><a href=\"{{ router.link('plans') }}#archive\" ng-class=\"{ active: archive }\">{{ t('plansHistoricPlans') }}\n        <div class=\"badge\">{{ (routePlans | activeRoutePlans:true).length }}</div></a></nav>\n    <div class=\"filters\"><a ng-if=\"auth.roles.planner &amp;&amp; settings.geoFencing\" href=\"{{ exportGeoFenceMetaUrl() }}\" target=\"_self\" class=\"action export stroked\">{{ t('plansGeoFencingBtn') }}</a><a ng-if=\"auth.roles.planner\" href=\"{{ exportCompanyDeliveriesDataUrl() }}\" target=\"_self\" class=\"action export stroked\">{{ t('plansCompanyDeliveriesDataBtn') }}</a><a ng-if=\"auth.roles.di\" href=\"{{ exportInvoiceDataAllPlansUrl() }}\" target=\"_self\" class=\"action export stroked\">{{ t('plansInvoiceDataBtn') }}</a></div>\n  </page-header>\n  <main>\n    <div ng-repeat=\"routePlan in routePlans | activeRoutePlans:archive | orderBy: ['-date', '-id']\" class=\"route-plan\">\n      <div class=\"status {{ routePlan.status() }}\"><span class=\"circles\"><span ng-repeat=\"n in [1, 2, 3, 4, 5]\"></span></span><span>{{ t('planStatus_' + routePlan.status(), routePlan.placeInOptimizeQueue) }}</span>\n        <button href=\"#\" ng-click=\"deleteRoutePlan(routePlan)\" ng-if=\"routePlan.deletable() &amp;&amp; auth.roles.plannerPlus\" class=\"delete\"></button>\n      </div>\n      <div class=\"content\">\n        <div class=\"name\"><span class=\"time-of-day\">{{ t('distrNo'+routePlan.distrNo) }}</span>{{ routePlan.name }}</div>\n        <div class=\"date\"><span class=\"weekday\">{{ routePlan.date | moment:'llll' }}</span></div>\n        <div class=\"customer-systems\">\n          <div ng-repeat=\"name in customerSystemNames(routePlan.customerSystems)\">{{ name }}</div>\n        </div>\n      </div>\n      <div class=\"footer\">\n        <div class=\"routes\">{{ routePlan.routeCount || '' }}</div>\n        <div class=\"stops\">{{ routePlan.stopLocationCount || '' }}</div>\n        <div class=\"customers\">{{ routePlan.customerCount || '' }}</div>\n        <div class=\"deliveries\">{{ routePlan.deliveryCount || '' }}</div>\n        <div class=\"flex-padding\"></div><a href=\"{{ router.link(router.nextPage(routePlan), routePlan.id) }}\" ng-if=\"routePlan.status() !== 'generating'\" class=\"link\">{{ t('plansCardOpen') }}</a>\n      </div>\n    </div>\n    <div ng-if=\"! archive &amp;&amp; auth.roles.plannerPlus\" class=\"route-plan dummy\">\n      <button type=\"button\" ng-click=\"openEditRoutePlan()\" class=\"action\">+ {{ t('plansNewPlanBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon delivered\"></span>{{ t('settingsAcknowledgementsForTitle', settings.companyName) }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <div ng-if=\"settings.customerSystemSettings.length == 0\" class=\"settingMissing\">{{ t('settingsCompanyMissingCustomerSystems') }}</div>\n    <div ng-if=\"settings.customerSystemSettings.length &gt; 0\" style=\"margin-top: 20px;margin-bottom: 20px\" class=\"flex\">\n      <div></div>\n      <div>\n        <h2><span class=\"header-icon delivered\"></span>{{ t('settingsActionsTitle') }}</h2>\n        <p>{{ t('settingsActionsDescription') }}</p>\n      </div>\n      <div>\n        <h2><span class=\"header-icon deviation\"></span>{{ t('settingsCustomerDeviationsTitle') }}</h2>\n        <p>{{ t('settingsCustomerDeviationsDescription') }}</p>\n      </div>\n      <div>\n        <h2><span class=\"header-icon deviation\"></span>{{ t('settingsProductDeviationsTitle') }}</h2>\n        <p>{{ t('settingsProductDeviationsDescription') }}</p>\n      </div>\n    </div>\n    <div ng-repeat=\"customerSystemSettings in settings.customerSystemSettings\" class=\"customerSystemsSection\">\n      <div class=\"flex\">\n        <div class=\"verticallyAligned\">\n          <h2>{{ customerSystemSettings.customerSystemName }}</h2>\n        </div>\n        <div>\n          <div ng-if=\"customerSystemSettings.quickActions.length == 0\" class=\"settingMissing\">{{ t('settingsMissingActions') }}</div>\n          <table ng-if=\"customerSystemSettings.quickActions.length &gt; 0\">\n            <tbody>\n              <tr ng-repeat=\"quickAction in customerSystemSettings.quickActions\">\n                <td>{{ t('delStatus'+quickAction.deliveryStatusId) }}\n                  <div ng-if=\"quickAction.pictureProof\" class=\"ackSetting\">{{ t('settingsPictureProof') }}</div>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div>\n          <div ng-if=\"customerSystemSettings.customerDeviationActions.length == 0\" class=\"settingMissing\">{{ t('settingsMissingCustomerDeviations') }}</div>\n          <table ng-if=\"customerSystemSettings.customerDeviationActions.length &gt; 0\">\n            <tbody>\n              <tr ng-repeat=\"deviationAction in customerSystemSettings.customerDeviationActions\">\n                <td>{{ t('delStatus'+deviationAction.deliveryStatusId) }}\n                  <div ng-if=\"deviationAction.canComment\" class=\"ackSetting\">{{ t('settingsCanComment') }}</div>\n                  <div ng-if=\"deviationAction.pictureProof\" class=\"ackSetting\">{{ t('settingsPictureProof') }}</div>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div>\n          <div ng-if=\"customerSystemSettings.productDeviationActions.length == 0\" class=\"settingMissing\">{{ t('settingsMissingProductDeviations') }}</div>\n          <table ng-if=\"customerSystemSettings.productDeviationActions.length &gt; 0\">\n            <tbody>\n              <tr ng-repeat=\"deviationAction in customerSystemSettings.productDeviationActions\">\n                <td>{{ t('delStatus'+deviationAction.deliveryStatusId) }}\n                  <div ng-if=\"deviationAction.canComment\" class=\"ackSetting\">{{ t('settingsCanComment') }}</div>\n                  <div ng-if=\"deviationAction.pictureProof\" class=\"ackSetting\">{{ t('settingsPictureProof') }}</div>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon deliverytimes\"></span>{{ t('settingsCompanyZipIntervalsTitle', settings.companyName) }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <p style=\"margin: 30px 0 40px\">{{ t('settingsCompanyZipIntervalsDescription') }}</p>\n    <div ng-if=\"settings.zipIntervals.length == 0\" class=\"settingMissing\">{{ t('settingsMissingZipIntervals') }}</div>\n    <table ng-if=\"settings.zipIntervals.length &gt; 0\">\n      <thead>\n        <tr>\n          <th colspan=\"2\">{{ t('settingsZipIntervalsColInterval') }}</th>\n          <th>{{ t('settingsZipIntervalsColCustomerSystem') }}</th>\n          <th>{{ t('settingsZipIntervalsColTime') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"zipInterval in settings.zipIntervals\">\n          <td>{{ zipInterval.zipFrom }}</td>\n          <td>{{ zipInterval.zipTo }}</td>\n          <td>{{ zipInterval.customerSystemName }}</td>\n          <td>{{ zipInterval.seconds | durationSeconds }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon generalSettings\"></span>{{ t('settingsCompanyGeneralTitle') }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <p style=\"margin: 30px 0 40px\">{{ t('settingsCompanyGeneralDescription') }}</p>\n    <h2>{{ t('settingsCompanyGeneralCompanySectionTitle') }}</h2>\n    <div style=\"margin-bottom: 120px\" class=\"customerSystemsSection\">\n      <div class=\"flex\">\n        <div class=\"verticallyAligned\">\n          <h3>{{ settings.companyName }}</h3>\n        </div>\n        <div class=\"settingsWrapper\">\n          <div>\n            <input type=\"checkbox\" ng-model=\"settings.autoAssignDrivers\" disabled>&nbsp; {{ t('settingsAutoAssignDrivers') }}\n          </div>\n          <div><span ng-if=\"! settings.boundaryBox.minY\" class=\"boundaryBoxMissing\">{{ t('settingsCompanyBoundaryBoxMissing') }}</span><a ng-if=\"settings.boundaryBox.minY\" ng-href=\"http://bboxfinder.com/#{{settings.boundaryBox.minY}},{{settings.boundaryBox.minX}},{{settings.boundaryBox.maxY}},{{settings.boundaryBox.maxX}}\" target=\"_blank\" class=\"boundaryBox\">{{ t('settingsCompanyBoundaryBoxLink') }}</a></div>\n        </div>\n        <div class=\"settingsWrapper\"></div>\n      </div>\n    </div>\n    <h2>{{ t('settingsCompanyGeneralCustomerSystemsSectionTitle') }}</h2>\n    <div ng-repeat=\"customerSystemSettings in settings.customerSystemSettings\" class=\"customerSystemsSection\">\n      <div class=\"flex\">\n        <div class=\"verticallyAligned\">\n          <h3>{{ customerSystemSettings.customerSystemName }}</h3>\n        </div>\n        <div class=\"settingsWrapper\">\n          <div>{{ t('settingsPermitLoadingMinutesBefore', customerSystemSettings.permitLoadingBeforeEstimatedStartInMinutes) }}</div>\n          <div>{{ t('settingsPermitStartingMinutesBefore', customerSystemSettings.permitStartingBeforeEstimatedStartInMinutes) }}</div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.showProductCount\" disabled>&nbsp; {{ t('settingsShowProductCount') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.scanBeforeLoading\" disabled>&nbsp; {{ t('settingsScanBeforeLoading') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.scanBeforeDelivery\" disabled>&nbsp; {{ t('settingsScanBeforeDelivery') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.askForDriverInput\" disabled>&nbsp; {{ t('settingsAskForDriverInput') }}\n          </div>\n        </div>\n        <div class=\"settingsWrapper\">\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.sendEventsToFlow\" disabled>&nbsp; {{ t('settingsSendEventsToFlow') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.sendEventsToTransport\" disabled>&nbsp; {{ t('settingsSendEventsToTransport') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.showTraveller\" disabled>&nbsp; {{ t('settingsShowTraveller') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.autoConfirmOnExit\" disabled>&nbsp; {{ t('settingsAutoConfirmOnExit') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.handleDevatiations\" disabled>&nbsp; {{ t('settingsHandleDeviations') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-checked=\"customerSystemSettings.adhocProducts.length &gt; 0\" disabled>&nbsp; {{ t('settingsAdhocProducts') }}\n            <ul style=\"margin-left: 30px\">\n              <li ng-repeat=\"adhocProduct in customerSystemSettings.adhocProducts\">{{ adhocProduct }}</li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon notifications\"></span>{{ t('settingsCompanyNotificationsTitle') }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <p style=\"margin: 30px 0 40px\">{{ t('settingsCompanyNotificationsDescription') }}</p>\n    <div ng-if=\"settings.notificationTypes.length == 0\" class=\"settingMissing\">{{ t('settingsMissingNotificationTypes') }}</div>\n    <table ng-if=\"settings.notificationTypes.length &gt; 0\">\n      <thead>\n        <tr>\n          <th class=\"nowrap\">{{ t('settingsCompanyNotificationsCol1') }}</th>\n          <th class=\"nowrap\">{{ t('settingsNotificationsColEvent') }}</th>\n          <th>{{ t('settingsNotificationsCol4') }}</th>\n          <th class=\"nowrap\">{{ t('settingsNotificationsCol5') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"notificationType in settings.notificationTypes | orderBy:['customerSystemName', 'minutesBeforeArrival']\" ng-class=\"{ simulate: notificationType.companies[0].simulate }\">\n          <td class=\"nowrap\">{{ notificationType.customerSystemName }}</td>\n          <td><span ng-if=\"notificationType.deliveryStatusId\" class=\"nowrap\">{{ t('delStatus'+notificationType.deliveryStatusId) }}</span><span ng-if=\"notificationType.minutesBeforeArrival\" class=\"nowrap\">{{ t('settingsNotificationsMinutesBefore', notificationType.minutesBeforeArrival) }}</span></td>\n          <td>{{ notificationType.templateName }}</td>\n          <td class=\"nowrap\">{{ notificationType.companies[0].simulate ? t('settingsNotificationsSimulate') : t('settingsNotificationsActive') }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon delivered\"></span>{{ t('settingsAcknowledgementsTitle') }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <div style=\"margin-top: 20px;margin-bottom: 20px\" class=\"flex\">\n      <div></div>\n      <div>\n        <h2>{{ t('settingsMiscTitle') }}</h2>\n        <p>{{ t('settingsMiscDescription') }}</p>\n      </div>\n      <div>\n        <h2><span class=\"header-icon delivered\"></span>{{ t('settingsActionsTitle') }}</h2>\n        <p>{{ t('settingsActionsDescription') }}</p>\n      </div>\n      <div>\n        <h2><span class=\"header-icon deviation\"></span>{{ t('settingsCustomerDeviationsTitle') }}</h2>\n        <p>{{ t('settingsCustomerDeviationsDescription') }}</p>\n      </div>\n      <div>\n        <h2><span class=\"header-icon deviation\"></span>{{ t('settingsProductDeviationsTitle') }}</h2>\n        <p>{{ t('settingsProductDeviationsDescription') }}</p>\n      </div>\n    </div>\n    <div ng-repeat=\"customerSystemSettings in settings.customerSystemSettings\" class=\"customerSystemsSection\">\n      <div class=\"flex\">\n        <div class=\"verticallyAligned\">\n          <h2>{{ customerSystemSettings.customerSystemName }}</h2>\n        </div>\n        <div>\n          <table>\n            <tbody>\n              <tr>\n                <td>{{ t('settingsPermitLoadingMinutesBefore', customerSystemSettings.permitLoadingBeforeEstimatedStartInMinutes) }}</td>\n              </tr>\n              <tr>\n                <td>{{ t('settingsPermitStartingMinutesBefore', customerSystemSettings.permitStartingBeforeEstimatedStartInMinutes) }}</td>\n              </tr>\n              <tr ng-if=\"customerSystemSettings.showProductCount\">\n                <td>{{ t('settingsShowProductCount') }}</td>\n              </tr>\n              <tr ng-if=\"customerSystemSettings.scanBeforeLoading\">\n                <td>{{ t('settingsScanBeforeLoading') }}</td>\n              </tr>\n              <tr ng-if=\"customerSystemSettings.scanBeforeDelivery\">\n                <td>{{ t('settingsScanBeforeDelivery') }}</td>\n              </tr>\n              <tr ng-if=\"customerSystemSettings.askForDriverInput\">\n                <td>{{ t('settingsAskForDriverInput') }}</td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div>\n          <div ng-if=\"customerSystemSettings.quickActions.length == 0\" class=\"settingMissing\">{{ t('settingsMissingActions') }}</div>\n          <table ng-if=\"customerSystemSettings.quickActions.length &gt; 0\">\n            <tbody>\n              <tr ng-repeat=\"quickAction in customerSystemSettings.quickActions\">\n                <td>{{ t('delStatus'+quickAction.deliveryStatusId) }}\n                  <div ng-if=\"quickAction.pictureProof\" class=\"ackSetting\">{{ t('settingsPictureProof') }}</div>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div>\n          <div ng-if=\"customerSystemSettings.customerDeviationActions.length == 0\" class=\"settingMissing\">{{ t('settingsMissingCustomerDeviations') }}</div>\n          <table ng-if=\"customerSystemSettings.customerDeviationActions.length &gt; 0\">\n            <tbody>\n              <tr ng-repeat=\"deviationAction in customerSystemSettings.customerDeviationActions\">\n                <td>{{ t('delStatus'+deviationAction.deliveryStatusId) }}\n                  <div ng-if=\"deviationAction.canComment\" class=\"ackSetting\">{{ t('settingsCanComment') }}</div>\n                  <div ng-if=\"deviationAction.pictureProof\" class=\"ackSetting\">{{ t('settingsPictureProof') }}</div>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div>\n          <div ng-if=\"customerSystemSettings.productDeviationActions.length == 0\" class=\"settingMissing\">{{ t('settingsMissingProductDeviations') }}</div>\n          <table ng-if=\"customerSystemSettings.productDeviationActions.length &gt; 0\">\n            <tbody>\n              <tr ng-repeat=\"deviationAction in customerSystemSettings.productDeviationActions\">\n                <td>{{ t('delStatus'+deviationAction.deliveryStatusId) }}\n                  <div ng-if=\"deviationAction.canComment\" class=\"ackSetting\">{{ t('settingsCanComment') }}</div>\n                  <div ng-if=\"deviationAction.pictureProof\" class=\"ackSetting\">{{ t('settingsPictureProof') }}</div>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon deliverytimes\"></span>{{ t('settingsCustSysZipIntervalsTitle') }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <p style=\"margin: 30px 0 40px\">{{ t('settingsCustSysZipIntervalsDescription') }}</p>\n    <div ng-if=\"settings.zipIntervals.length == 0\" class=\"settingMissing\">{{ t('settingsMissingZipIntervals') }}</div>\n    <table ng-if=\"settings.zipIntervals.length &gt; 0\">\n      <thead>\n        <tr>\n          <th>{{ t('settingsZipIntervalsColCompany') }}</th>\n          <th colspan=\"2\">{{ t('settingsZipIntervalsColInterval') }}</th>\n          <th>{{ t('settingsZipIntervalsColCustomerSystem') }}</th>\n          <th>{{ t('settingsZipIntervalsColTime') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"zipInterval in settings.zipIntervals\">\n          <td>{{ zipInterval.companyName }}</td>\n          <td>{{ zipInterval.zipFrom }}</td>\n          <td>{{ zipInterval.zipTo }}</td>\n          <td>{{ zipInterval.customerSystemName }}</td>\n          <td>{{ zipInterval.seconds }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon generalSettings\"></span>{{ t('settingsCustSysGeneralTitle') }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <div ng-repeat=\"customerSystemSettings in settings.customerSystemSettings\" class=\"customerSystemsSection\">\n      <div class=\"flex\">\n        <div class=\"verticallyAligned\">\n          <h3>{{ customerSystemSettings.customerSystemName }}</h3>\n        </div>\n        <div class=\"settingsWrapper\">\n          <div>{{ t('settingsPermitLoadingMinutesBefore', customerSystemSettings.permitLoadingBeforeEstimatedStartInMinutes) }}</div>\n          <div>{{ t('settingsPermitStartingMinutesBefore', customerSystemSettings.permitStartingBeforeEstimatedStartInMinutes) }}</div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.showProductCount\" disabled>&nbsp; {{ t('settingsShowProductCount') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.scanBeforeLoading\" disabled>&nbsp; {{ t('settingsScanBeforeLoading') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.scanBeforeDelivery\" disabled>&nbsp; {{ t('settingsScanBeforeDelivery') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.askForDriverInput\" disabled>&nbsp; {{ t('settingsAskForDriverInput') }}\n          </div>\n        </div>\n        <div class=\"settingsWrapper\">\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.sendEventsToFlow\" disabled>&nbsp; {{ t('settingsSendEventsToFlow') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.sendEventsToTransport\" disabled>&nbsp; {{ t('settingsSendEventsToTransport') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.showTraveller\" disabled>&nbsp; {{ t('settingsShowTraveller') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-model=\"customerSystemSettings.autoConfirmOnExit\" disabled>&nbsp; {{ t('settingsAutoConfirmOnExit') }}\n          </div>\n          <div>\n            <input type=\"checkbox\" ng-checked=\"customerSystemSettings.adhocProducts.length &gt; 0\" disabled>&nbsp; {{ t('settingsAdhocProducts') }}\n            <ul style=\"margin-left: 30px\">\n              <li ng-repeat=\"adhocProduct in customerSystemSettings.adhocProducts\">{{ adhocProduct }}</li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon notifications\"></span>{{ t('settingsCustSysNotificationsTitle') }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <p style=\"margin: 30px 0 40px\">{{ t('settingsCustSysNotificationsDescription') }}</p>\n    <div ng-repeat=\"customerSystemSettings in settings.customerSystemSettings\" class=\"customerSystemsSection\">\n      <h2>{{ customerSystemSettings.customerSystemName }}</h2>\n      <div ng-if=\"customerSystemSettings.notificationTypes.length == 0\" class=\"settingMissing\">{{ t('settingsMissingNotificationTypes') }}</div>\n      <table ng-if=\"customerSystemSettings.notificationTypes.length &gt; 0\">\n        <thead>\n          <tr>\n            <th class=\"nowrap companies\">{{ t('settingsCustSysNotificationsCol1') }}</th>\n            <th class=\"nowrap\">{{ t('settingsNotificationsColEvent') }}</th>\n            <th>{{ t('settingsNotificationsCol4') }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"notificationType in customerSystemSettings.notificationTypes | orderBy:['minutesBeforeArrival']\">\n            <td>\n              <div ng-show=\"notificationType.companies.length &gt; 10\" class=\"expander\">{{ notificationType.companies.length }} transportselskaper<a ng-click=\"showAllCompanies = ! showAllCompanies\" ng-class=\"{ expanded: showAllCompanies }\" href></a></div>\n              <ul ng-show=\"notificationType.companies.length &lt;= 10 || showAllCompanies\">\n                <li ng-repeat=\"company in notificationType.companies | orderBy:['companyName', 'simulate']\" ng-class=\"{ simulate: company.simulate }\" class=\"nowrap\">{{ company.companyName }} {{ company.simulate ? ' (' + t('settingsNotificationsSimulate') + ')' : '' }}</li>\n              </ul>\n            </td>\n            <td><span ng-if=\"notificationType.deliveryStatusId\" class=\"nowrap\">{{ t('delStatus'+notificationType.deliveryStatusId) }}</span><span ng-if=\"notificationType.minutesBeforeArrival\" class=\"nowrap\">{{ t('settingsNotificationsMinutesBefore', notificationType.minutesBeforeArrival) }}</span></td>\n            <td>{{ notificationType.templateName }}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon systemwarnings\"></span>{{ t('settingsDISysWarningTitle') }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <p style=\"margin: 30px 0 40px\">{{ t('settingsDISysWarningDescription') }}</p>\n    <div class=\"systemWarnings\">\n      <form ng-submit=\"createSystemWarning(downtime)\" name=\"form\" role=\"form\" novalidate>\n        <input type=\"checkbox\" ng-init=\"downtime.generalEnabled = !!downtime.problemsTimestamp\" ng-model=\"downtime.generalEnabled\">\n        <label>{{ t('settingsDISysWarningGeneral') }}</label><br>\n        <input type=\"checkbox\" ng-init=\"downtime.downtimeEnabled = !!downtime.serverDownTimestamp\" ng-model=\"downtime.downtimeEnabled\" class=\"downtime\">\n        <label>{{ t('settingsDISysWarningDowntime')}}</label><br>\n        <div ng-if=\"downtime.downtimeEnabled\" class=\"systemWarningDateTimePickers\">\n          <calendar date=\"downtime.date\" ng-init=\"downtime.date = downtime.getServerDownDate()\"></calendar>\n          <input type=\"text\" ng-pattern=\"timePattern\" ng-required=\"true\" placeholder=\"HH:mm\" ng-model=\"downtime.time\" ng-init=\"downtime.time = downtime.getServerDownTime()\">\n          <input type=\"text\" ng-pattern=\"durationPattern\" ng-required=\"true\" placeholder=\"{{ t('settingsDISysDowntimeDuration') }}\" ng-model=\"downtime.estimatedDownTimeMinutes\">\n        </div>\n        <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{t('settingsDISaveSysWarning')}}</button>\n      </form>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\">{{ t('driverUserHeader') }}</div>\n    </h1>\n    <div class=\"actions\">\n      <input type=\"text\" ng-model=\"search.text\" placeholder=\"{{ t('cSearch') }}\" class=\"search\">\n    </div>\n    <nav><a href=\"#\" ng-click=\"setStatus($event, true)\" ng-class=\"{ active: filter.active }\">{{ t('driverUsersFilterActive') }}\n        <div class=\"badge\">{{ countStatus(true) }}</div></a><a href=\"#\" ng-click=\"setStatus($event, false)\" ng-class=\"{ active: ! filter.active }\">{{ t('driverUsersFilterInactive') }}\n        <div class=\"badge\">{{ countStatus(false) }}</div></a></nav>\n  </page-header>\n  <main>\n    <table>\n      <thead>\n        <tr>\n          <th></th>\n          <th>{{ t('cUserName') }}</th>\n          <th>{{ t('cFirstName') }}</th>\n          <th>{{ t('cLastName') }}</th>\n          <th>{{ t('driverUsersMobile') }}</th>\n          <th>{{ t('cEmail') }}</th>\n          <th>{{ t('driverUsersLastLoggedIn') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"user in driverUsers | filter:filter.active | filter: search.text\">\n          <td class=\"edit\">\n            <button type=\"button\" ng-click=\"openEditUser(user)\"></button>\n          </td>\n          <td><span ng-show=\"!user.active\" class=\"inactive tag\">Inaktiv</span><span>{{ user.userName }}</span></td>\n          <td>{{ user.firstName }}</td>\n          <td>{{ user.lastName }}</td>\n          <td>{{ formatPhone(user.phone) }}</td>\n          <td>{{ user.email }}</td>\n          <td>{{ user.lastLoggedIn | moment:'L' }}</td>\n        </tr>\n      </tbody>\n    </table>\n    <div class=\"buttons\">\n      <button type=\"button\" ng-click=\"openEditUser()\" class=\"action\">{{ t('driverUsersNewDriverBtn') }}</button>\n    </div>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\">{{ t('userHeader') }}</div>\n    </h1>\n    <div class=\"actions\">\n      <input type=\"text\" ng-model=\"search.text\" placeholder=\"{{ t('cSearch') }}\" class=\"search\">\n    </div>\n    <nav><a href=\"#\" ng-click=\"setStatus($event, true)\" ng-class=\"{ active: filter.active }\">{{ t('driverUsersFilterActive') }}\n        <div class=\"badge\">{{ countStatus(true) }}</div></a><a href=\"#\" ng-click=\"setStatus($event, false)\" ng-class=\"{ active: ! filter.active }\">{{ t('driverUsersFilterInactive') }}\n        <div class=\"badge\">{{ countStatus(false) }}</div></a></nav>\n  </page-header>\n  <main>\n    <table>\n      <thead>\n        <tr>\n          <th>{{ t('cUserName') }}</th>\n          <th>{{ t('cFirstName') }}</th>\n          <th>{{ t('cLastName') }}</th>\n          <th>{{ t('driverUsersMobile') }}</th>\n          <th>{{ t('cEmail') }}</th>\n          <th>{{ t('driverUsersLastLoggedIn') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"user in users | filter:filter.active | filter: search.text\">\n          <td><span ng-show=\"!user.active\" class=\"inactive tag\">Inaktiv</span><span>{{ user.userName }}</span></td>\n          <td>{{ user.firstName }}</td>\n          <td>{{ user.lastName }}</td>\n          <td>{{ formatPhone(user.phone) }}</td>\n          <td>{{ user.email }}</td>\n          <td>{{ user.lastLoggedIn | moment:'L' }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n</page>");;return buf.join("");
	}

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div id=\"address-helper\">\n  <input type=\"hidden\" class=\"selectionCache\">\n  <div class=\"street\">\n    <div ng-bind-html=\"t('addressHelperHint')\" class=\"streetInputHint\"></div>\n    <input type=\"text\" placeholder=\"{{ t('addressHelperStreetName') }}\" class=\"streetInput\">\n    <div class=\"streetContainer\"></div>\n  </div>\n  <div class=\"streetNumber\">\n    <input type=\"text\" placeholder=\"{{ t('addressHelperStreetNo') }}\" class=\"streetNumberInput\">\n    <div class=\"streetNumberContainer\"></div>\n  </div>\n  <div class=\"zip\">\n    <input type=\"text\" placeholder=\"{{ t('addressHelperZip') }}\" tabindex=\"-1\" readonly class=\"zipLabel\">\n  </div>\n  <div class=\"city\">\n    <input type=\"text\" placeholder=\"{{ t('addressHelperCity') }}\" tabindex=\"-1\" readonly class=\"cityLabel\">\n  </div>\n  <div class=\"error\">{{ t('addressHelperNoCoords') }}</div>\n</div>");;return buf.join("");
	}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div pickadate ng-model=\"dateString\" min-date=\"today\" week-starts-on=\"1\" no-extra-rows class=\"calendar\"></div>");;return buf.join("");
	}

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-click=\"_modal.close($event)\" class=\"modal\">\n  <div ng-click=\"_modal.close($event)\" class=\"modal-center\">\n    <div class=\"modal-window confirm\">\n      <div class=\"modal-body\">\n        <h3>{{ title }}</h3>\n        <p>{{ body }}</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" ng-click=\"_modal.close()\" class=\"cancel\">{{ t('cCancel') }}</button>\n        <button type=\"submit\" ng-click=\"_modal.onConfirm()\" autofocus class=\"action\">{{ title }}</button>\n      </div>\n    </div>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>{{ t('planRoutesCustomersPerHourDescription') }}</div>");;return buf.join("");
	}

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("<span tooltip=\"deliveryCountTooltipTemplate\" class=\"delivery-count\">{{ customer.deliveryCount() }}</span>");;return buf.join("");
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-repeat=\"delivery in customer.deliveries\" ng-class=\"{ cancelled: ! delivery.notCancelled() }\">{{ delivery.product }}{{ ((delivery.productCount || 0) <= 1) ? '' : ' (' + delivery.productCount + ')' }}</div>");;return buf.join("");
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div> \n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"weekday\">{{ distribution.date | moment:'llll' }}</span></div>\n      <div class=\"distr-no\">{{ t('distrNo' + distribution.distrNo) }}</div>\n      <div ng-repeat=\"name in customerSystemNames(distribution.routePlans)\" class=\"customer-system\">{{ name }}</div>\n    </h1>\n    <form ng-submit=\"searchForm.$valid &amp;&amp; goToSearch()\" name=\"searchForm\" class=\"actions\">\n      <input type=\"text\" ng-model=\"search.customer\" placeholder=\"{{ t('distributionCustomerSearch') }}\" ng-minlength=\"3\" required class=\"search\">\n      <button type=\"submit\" ng-disabled=\"searchForm.$invalid\" class=\"action\">{{ t('cSearch') }}</button>\n    </form>\n  </page-header>\n</div>");;return buf.join("");
	}

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div><span>{{ t('fleetDashOutdatedApp', routePlan.countOutdatedApps()) }}</span></div>");;return buf.join("");
	}

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"cell\"><span class=\"label\">&nbsp;</span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCustomers') }}</span></div>\n</div>\n<div ng-show=\"distribution.sum('customerCancelledCount');\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCancelled') }}</span></div>\n  <div class=\"cell count\"><span class=\"cancelled\">{{ distribution.sum('customerCancelledCount'); }}</span></div>\n</div>\n<div ng-show=\"distribution.sum('customerDeliveredCount'); \" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDelivered') }}</span></div>\n  <div class=\"cell count\"><span class=\"delivered\">{{ distribution.sum('customerDeliveredCount'); }}</span></div>\n</div>\n<div ng-show=\"distribution.sum('customerDeviationCount');\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDeviation') }}</span></div>\n  <div class=\"cell count\"><span class=\"deviation\">{{ distribution.sum('customerDeviationCount'); }}</span></div>\n</div>\n<div ng-show=\"distribution.sum('customerRemainingCount');\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressRemaining') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ distribution.sum('customerRemainingCount'); }}</span></div>\n</div>\n<div class=\"top-border-thick\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressTotal') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ distribution.sum('customerCount') }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"cell\"><span class=\"label\">&nbsp;</span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCustomers') }}</span></div>\n</div>\n<div ng-show=\"routePlan.customerCancelledCount();\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCancelled') }}</span></div>\n  <div class=\"cell count\"><span class=\"cancelled\">{{ routePlan.customerCancelledCount(); }}</span></div>\n</div>\n<div ng-show=\"routePlan.customerDeliveredCount(); \" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDelivered') }}</span></div>\n  <div class=\"cell count\"><span class=\"delivered\">{{ routePlan.customerDeliveredCount(); }}</span></div>\n</div>\n<div ng-show=\"routePlan.customerDeviationCount();\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDeviation') }}</span></div>\n  <div class=\"cell count\"><span class=\"deviation\">{{ routePlan.customerDeviationCount(); }}</span></div>\n</div>\n<div ng-show=\"routePlan.customerRemainingCount();\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressRemaining') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ routePlan.customerRemainingCount(); }}</span></div>\n</div>\n<div class=\"top-border-thick\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressTotal') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ routePlan.customerCount }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"cell\"><span class=\"label\">&nbsp;</span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCustomers') }}</span></div>\n</div>\n<div ng-show=\"route.customerCancelledCount;\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCancelled') }}</span></div>\n  <div class=\"cell count\"><span class=\"cancelled\">{{ route.customerCancelledCount; }}</span></div>\n</div>\n<div ng-show=\"route.customerDeliveredCount; \" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDelivered') }}</span></div>\n  <div class=\"cell count\"><span class=\"delivered\">{{ route.customerDeliveredCount; }}</span></div>\n</div>\n<div ng-show=\"route.customerDeviationCount;\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDeviation') }}</span></div>\n  <div class=\"cell count\"><span class=\"deviation\">{{ route.customerDeviationCount; }}</span></div>\n</div>\n<div ng-show=\"route.customerRemainingCount;\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressRemaining') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ route.customerRemainingCount; }}</span></div>\n</div>\n<div class=\"top-border-thick\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressTotal') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ route.customerCount }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"downtimeWarnings\">\n  <div ng-if=\"downtime.display('first')\" class=\"warning first\"><span>{{ t('pageDowntimePlanned', downtime.localDowntime(), downtime.estimatedDownTimeMinutes) }}</span><a ng-click=\"downtime.hide('first')\" class=\"close\"></a></div>\n  <div ng-if=\"downtime.display('final')\" class=\"warning final\"><span>{{ t('pageDowntimePlanned', downtime.formatDowntime(), downtime.estimatedDownTimeMinutes) }}</span><a ng-click=\"downtime.hide('final')\" class=\"close\"></a></div>\n  <div ng-if=\"downtime.display('general')\" class=\"warning general\"><span>{{ t('pageDowntimeGeneral') }}</span><a ng-click=\"downtime.hide('general')\" class=\"close\"></a></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"cell\"><span class=\"label\">{{ t('driverUsersMobile') }}</span><span>{{ drivers[route.driverUsername].phone || '&nbsp;' }}</span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('cUserName') }}</span><span>{{ drivers[route.driverUsername].userName || '&nbsp;' }}</span></div>\n  <div ng-if=\"drivers[route.driverUsername].deviceInfo\" class=\"cell\"><span class=\"label\">{{ t('driverInfoDevice') }}</span><span>{{ drivers[route.driverUsername].deviceInfo.brand || '&nbsp;' }} {{ drivers[route.driverUsername].deviceInfo.model || '&nbsp;' }}</span></div>\n  <div ng-if=\"drivers[route.driverUsername].deviceInfo\" class=\"cell\"><span class=\"label\">{{ t('driverInfoDeviceOS') }}</span><span>{{ drivers[route.driverUsername].deviceInfo.system || '&nbsp;' }} {{ drivers[route.driverUsername].deviceInfo.systemVersion || '&nbsp;' }}</span></div>\n  <div ng-if=\"drivers[route.driverUsername].deviceInfo\" class=\"cell\"><span class=\"label\">{{ t('driverInfoDeviceAppVersion') }}</span><span ng-class=\"{ 'outdated-app': drivers[route.driverUsername].shouldUpgradeApp }\">{{ drivers[route.driverUsername].deviceInfo.appVersion || '&nbsp;' }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<map-coordinates country-code=\"routePlan.countryCode\" city=\"city\" address=\"address\" on-save=\"setCoordinates\"></map-coordinates>");;return buf.join("");
	}

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form ng-submit=\"saveCustomer(customer)\" name=\"form\">\n  <div class=\"flex\">\n    <div ng-class=\"{ 'ng-invalid': ! customer.customerSystemId }\" class=\"select\">\n      <select ng-options=\"customerSystem.id as customerSystem.name for customerSystem                     in values(customerSystems) | orderBy:'name'\" ng-model=\"customer.customerSystemId\" ng-disabled=\"! customer.editable()\" required>\n        <option value=\"\">{{ t('customerModalChooseSupplier') }}</option>\n      </select>\n    </div>\n    <input type=\"text\" ng-model=\"customer.orderId\" ng-disabled=\"! customer.editable()\" placeholder=\"{{ t('customerOrder') }}\" maxlength=\"40\" class=\"name\">\n    <input type=\"text\" ng-model=\"customer.suggestedRoute\" ng-if=\"customer.suggestedRoute\" ng-disabled=\"true\" maxlength=\"35\" class=\"name\">\n  </div>\n  <div class=\"flex\">\n    <input type=\"text\" ng-model=\"customer.name\" placeholder=\"{{ t('customerName') }}\" maxlength=\"100\" required class=\"name\">\n  </div>\n  <div class=\"flex\">\n    <input type=\"text\" ng-model=\"customer.co\" placeholder=\"{{ t('customerCO') }}\" maxlength=\"50\">\n  </div>\n  <div class=\"flex\">\n    <textarea ng-model=\"customer.description\" placeholder=\"{{ t('customerDirective') }}\"></textarea>\n  </div>\n  <div class=\"flex\">\n    <input type=\"text\" ng-model=\"customer.phone1\" placeholder=\"{{ t('customerPhone1') }}\" maxlength=\"12\">\n    <input type=\"text\" ng-model=\"customer.phone2\" placeholder=\"{{ t('customerPhone2') }}\" maxlength=\"12\">\n  </div>\n  <address-helper country-code=\"routePlan.countryCode\" delivery-point-id=\"customer.deliveryPointId\" address=\"customer.address\" zip=\"customer.zip\" city=\"customer.city\" on-change=\"updateAddress\" ng-class=\"{ 'ah-complete': editAddress }\" ng-if=\"! customer.latitude || editAddress\"></address-helper>\n  <div ng-if=\"!! customer.latitude &amp;&amp; ! editAddress\" class=\"flex\">\n    <input type=\"text\" disabled=\"disabled\" value=\"{{ customer.address }}, {{ customer.zip }} {{ customer.city }}\">\n    <button ng-click=\"enterEditAddressMode()\" type=\"button\" class=\"link\">{{ t('customerModalChangeAddress') }}</button>\n  </div>\n  <div class=\"flex\">\n    <input type=\"text\" name=\"start\" ng-model=\"customer.deliveryWindowStart\" ng-pattern=\"timePattern\" placeholder=\"{{ t('customerTimeWindowStart') }}\" class=\"small\">\n    <input type=\"text\" name=\"stop\" ng-model=\"customer.deliveryWindowStop\" ng-pattern=\"timePattern\" placeholder=\"{{ t('customerTimeWindowStop') }}\" class=\"small\">\n    <input type=\"text\" name=\"duration\" ng-model=\"customer.duration\" placeholder=\"{{ t('customerDuration') }}\" class=\"small\">\n    <div class=\"flex-padding\"></div>\n    <button ng-if=\"! customer.latitude\" ng-click=\"openMap($event, customer)\" class=\"link\">{{ t('customerPlaceInMap') }}</button>\n  </div>\n  <div ng-if=\"form.start.$error.pattern || form.stop.$error.pattern\" class=\"error\">{{ t('customerTimeFormatHelp') }}</div>\n  <div class=\"flex-padding\"></div>\n  <div ng-if=\"(auth.roles.planner || auth.roles.clientPlus) &amp;&amp; isCollapsed &amp;&amp; showMovePlan &amp;&amp; !! customer.id &amp;&amp; !receivedComingSms\">\n    <button ng-click=\"toggleMoveToPlanRoute()\" type=\"button\" class=\"link showMove\">{{ t('customerModalChangeRoutePlan') }}</button>\n  </div>\n  <div ng-if=\"(auth.roles.planner || auth.roles.clientPlus) &amp;&amp; ! isCollapsed &amp;&amp; showMovePlan\" class=\"changePlanRouteSequence\">\n    <div style=\"text-align:right\" ng-if=\"!! customer.id\">\n      <button ng-click=\"toggleMoveToPlanRoute()\" type=\"button\" class=\"link cancelMove\">{{ t('customerModalResetChangeRoutePlan') }}</button>\n    </div>\n    <div ng-if=\"(routePlans | activeRoutePlans).length &amp;&amp; changeHolder.plan\" class=\"flex\">\n      <div class=\"changePlanRouteSequenceWrapper\">\n        <label>{{ t('customerModalPlanLabel') }}</label>\n        <div class=\"select\">\n          <select ng-model=\"changeHolder.plan\" ng-options=\"plan as plan.name + ' (' + (plan.date | moment:'llll') + ')' for plan in (routePlans | activeRoutePlans) | orderBy:'name'\" ng-change=\"updateRouteList()\"></select>\n        </div>\n      </div>\n    </div>\n    <div class=\"flex\">\n      <div class=\"changePlanRouteSequenceWrapper\">\n        <label>{{ t(! customer.id ? 'customerModalNewCustomerRouteLabel' : 'customerModalRouteLabel') }}</label>\n        <div ng-class=\"{ 'ng-invalid': ! customer.id &amp;&amp; ! changeHolder.selectedRoute }\" class=\"select\">\n          <select ng-model=\"changeHolder.selectedRoute\" ng-options=\"route as route.name + (route.estimatedTimestampStart ? ' (' + (route.estimatedTimestampStart | moment:'LT') + ')' : '') for route in changeHolder.routes | orderBy:'name'\" ng-change=\"routeChanged()\" ng-disabled=\"! changeHolder.routes.length\" ng-required=\"! customer.id\">\n            <option value=\"\">{{ t(changeHolder.routes.length ? 'customerModalChooseRoute' : 'customerModalChooseSoon') }}</option>\n          </select>\n        </div>\n      </div>\n    </div>\n    <div ng-if=\"changeHolder.showStops\" class=\"flex\">\n      <div class=\"changePlanRouteSequenceWrapper\">\n        <label>{{ t('customerModalStopLabel') }}</label>\n        <div class=\"select\">\n          <select ng-model=\"changeHolder.selectedStop\" ng-options=\"stop as stop.routeSequence + '. ' + stop.address for stop in changeHolder.filteredStopLocations | orderBy:'routesequence'\">\n            <option ng-if=\"changeHolder.selectedRoute!=null &amp;&amp; changeHolder.filteredStopLocations.length == changeHolder.selectedRoute.stopLocations.length\" value=\"\">0. {{ t('customerModalChooseFirstOnRoute') }}</option>\n          </select>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"(auth.roles.planner || auth.roles.clientPlus) &amp;&amp; receivedComingSms\" class=\"infoWrapper\">\n    <div class=\"info\">{{ t('receivedComingSms') }}</div>\n  </div>\n  <div class=\"deliveries\">\n    <div ng-repeat=\"delivery in customer.deliveries\" class=\"flex\">\n      <input type=\"text\" ng-model=\"delivery.productCount\" ng-disabled=\"true\" ng-class=\"{ cancelled: delivery.getStatus() === 'cancelled' }\" ng-if=\"customer.anyProductCounts()\" class=\"xsmall right\">\n      <input type=\"text\" ng-model=\"delivery.product\" ng-disabled=\"! customer.editable() &amp;&amp; !! delivery.id\" ng-class=\"{ cancelled: delivery.getStatus() === 'cancelled' }\" placeholder=\"{{ t('cProduct') }}\" required>\n      <button ng-if=\"! delivery.id\" type=\"button\" ng-click=\"deleteDelivery($event, $index, customer)\" class=\"delete\"></button>\n      <button ng-if=\"!! delivery.id &amp;&amp; delivery.deliveryStatus !== 11\" type=\"button\" ng-click=\"cancelDelivery($event, delivery.id, customer)\" class=\"delete\"></button>\n      <button ng-if=\"!! delivery.id &amp;&amp; delivery.deliveryStatus === 11\" type=\"button\" ng-click=\"undoCancelDelivery($event, delivery.id, customer)\" class=\"link\">{{ t('customerUndoCancelProduct') }}</button>\n    </div>\n    <button type=\"button\" ng-click=\"addDelivery($event, customer)\" class=\"link\">{{ t('customerAddProduct') }}</button>\n  </div>\n  <div class=\"flex\">\n    <button type=\"button\" ng-if=\"customer.deletable(routePlan.hasRoutes())\" ng-click=\"deleteCustomer(customer)\" class=\"link dangerous\">{{ t('customerDelete') }}</button>\n    <button type=\"button\" ng-if=\"customer.cancellable(routePlan.hasRoutes(), cancelled)\" ng-click=\"cancelCustomer(customer)\" class=\"link dangerous\">{{ t('customerCancel') }}</button>\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-disabled=\"(form.$invalid || ! customer.latitude) || (! isCollapsed &amp;&amp; ! changeHolder.selectedRoute)\" class=\"action\">{{ t('customerModalSave') }}</button>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form ng-submit=\"saveDriverUser(user)\" name=\"form\">\n  <div class=\"flex\">\n    <label>{{ t('cFirstName') }}</label>\n    <input type=\"text\" ng-model=\"user.firstName\" required class=\"name\">\n  </div>\n  <div class=\"flex\">\n    <label>{{ t('cLastName') }}</label>\n    <input type=\"text\" ng-model=\"user.lastName\" required class=\"name\">\n  </div>\n  <div ng-if=\"userNameUsed\" class=\"error\">{{ t('driverUsersUserNameTakenError') }}</div>\n  <div ng-if=\"userNameIllegalCharacters\" class=\"error\">{{ t('driverUsersUserNameInvalidError') }}</div>\n  <div ng-if=\"userNameTooShort\" class=\"error\">{{ t('driverUsersUserNameTooShortError') }}</div>\n  <div class=\"flex\">\n    <label>{{ t('cUserName') }}</label>\n    <input type=\"text\" ng-model=\"user.userName\" ng-disabled=\"! user.isNewUser\" ng-focus=\"suggestUsername(user)\" required class=\"name\">\n  </div>\n  <div ng-if=\"languageRequired\" class=\"error\">{{ t('driverUsersLanguageReguiredError') }}</div>\n  <div class=\"flex\">\n    <label>{{ t('loginLanguage') }}</label>\n    <div class=\"select\">\n      <select ng-options=\"lang.id as lang.name for lang in languages\" ng-model=\"user.language\">\n        <option value=\"\">{{ t('driverUsersChooseLanguage') }}</option>\n      </select>\n    </div>\n  </div>\n  <div class=\"flex\">\n    <label>{{ t('cEmail') }}</label>\n    <input type=\"email\" ng-model=\"user.email\" class=\"name\">\n  </div>\n  <div ng-if=\"invalidPhone\" class=\"error\">{{ t('driverUsersInvalidPhoneError') }}</div>\n  <div class=\"flex\">\n    <label>{{ t('driverUsersMobile') }}</label>\n    <input type=\"text\" ng-model=\"user.phone\" class=\"name\">\n  </div>\n  <div class=\"flex\">\n    <label for=\"regenerate\"></label>\n    <div class=\"checkbox_wrapper\">\n      <input type=\"checkbox\" id=\"regenerate\" ng-model=\"user.regeneratePassword\" ng-disabled=\"user.isNewUser\" class=\"name\"><span ng-if=\"user.isNewUser\">{{ t('driverUsersSendPasswordSMS') }}</span><span ng-if=\"!user.isNewUser\">{{ t('driverUsersSendNewPasswordSMS') }}</span>\n    </div>\n  </div>\n  <div ng-if=\"user.password\" class=\"flex\">\n    <label for=\"regenerate\">{{ t('loginPassword') }}</label>\n    <div class=\"checkbox_wrapper\">\n      <div class=\"message\"><span class=\"password\">{{user.password}}</span><span ng-if=\"user.phone\">&nbsp; {{ t('driverUsersSentSMS') }}</span></div>\n    </div>\n  </div>\n  <div class=\"flex\">\n    <div class=\"flex-padding\"></div>\n    <div ng-if=\"! isSaving\" class=\"button-bar\">\n      <button type=\"button\" ng-click=\"deactivateDriverUser(user)\" ng-if=\"!user.isNewUser &amp;&amp; user.active\" class=\"link deactivate\"><span>{{ t('driverUsersDeactivate') }}</span></button>\n      <button type=\"button\" ng-click=\"activateDriverUser(user)\" ng-disabled=\"form.$invalid\" ng-if=\"!user.isNewUser &amp;&amp; !user.active\" class=\"link activate\"><span>{{ t('driverUsersActivate') }}</span></button>\n      <button type=\"submit\" ng-disabled=\"form.$invalid\" ng-if=\"!user.password\" class=\"action\"><span ng-if=\"user.isNewUser\">{{ t('cCreate') }}</span><span ng-if=\"!user.isNewUser\">{{ t('cSave') }}</span></button>\n      <button type=\"button\" ng-click=\"closeDriverUserModal()\" ng-if=\"user.password\" class=\"action\"><span>{{ t('cClose') }}</span></button>\n    </div>\n    <div ng-if=\"isSaving\" class=\"button-bar\">\n      <spinner></spinner>\n    </div>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form ng-submit=\"saveRoute(editRoute)\" name=\"form\">\n  <div ng-if=\"routePlan.published &amp;&amp; reserveRoute &amp;&amp; ! editRoute.id\" class=\"wreckedRouteWrapper\">\n    <div>\n      <input type=\"checkbox\" id=\"fetchCustomers\" ng-model=\"editRoute.fetchCustomers\">\n      <label for=\"fetchCustomers\">{{ t('routeModalReserveFetchCustomersLabel') }}</label>\n    </div>\n    <div ng-if=\"editRoute.fetchCustomers\" class=\"select\">\n      <select ng-options=\"route as route.nameAndDriver(drivers, true) for route in routePlan.routes | filter: { type: 0 } | orderBy: 'name'\" ng-model=\"editRoute.fetchCustomersFromRoute\" ng-required=\"editRoute.fetchCustomers\">\n        <option value=\"\">{{ t('routeModalReserveChooseRoute') }}</option>\n      </select>\n    </div>\n    <div ng-if=\"false &amp;&amp; editRoute.fetchCustomers &amp;&amp; editRoute.fetchCustomersFromRoute &amp;&amp; editRoute.fetchCustomersFromRoute.timestampStart\" class=\"info\">{{ t('routeModalWreckInfo', editRoute.fetchCustomersFromRoute.name) }}</div>\n  </div>\n  <input type=\"text\" ng-model=\"editRoute.name\" maxlength=\"35\" placeholder=\"{{ t(reserveRoute ? 'routeModalReserveRouteName' : 'routeModalRouteName') }}\" required>\n  <div ng-if=\"reserveRoute &amp;&amp; editRoute.id &amp;&amp; ! editRoute.driverUsername\" class=\"info\">{{ t('routeModalReserveAssignDelayInfo') }}</div>\n  <div ng-if=\"editRoute.autoAssignedDriver\" class=\"info\">{{ t('routeModalAutoAssigned') }}</div>\n  <div ng-if=\"! (reserveRoute &amp;&amp; ! editRoute.id)\" class=\"select\">\n    <select ng-model=\"editRoute.driverUsername\" ng-options=\"driver.userName as nameAndPhone(driver) for driver in values(drivers) | orderBy: 'name'\">\n      <option value=\"\">{{ t('routeModalChooseDriver') }}</option>\n    </select>\n  </div>\n  <div ng-if=\"(reserveRoute &amp;&amp; ! editRoute.id) || ! routePlan.published\" class=\"select\">\n    <select ng-model=\"editRoute.pickupLocationId\" ng-options=\"pl.id as pl.address for pl in pickupLocations\" required>\n      <option value=\"\">{{ t('routeModalChoosePickupPoint') }}</option>\n    </select>\n  </div>\n  <div ng-if=\"! (reserveRoute &amp;&amp; ! editRoute.id)\" class=\"overriddenStartTime\">\n    <input type=\"text\" ng-model=\"editRoute.overriddenStart\" ng-pattern=\"timePattern\" placeholder=\"{{ t(reserveRoute ? 'routeModalReserveOverriddenStart' : 'routeModalOverriddenStart') }}\">\n    <div class=\"dayBeforeWrapper\">\n      <input type=\"checkbox\" id=\"dayBefore\" ng-model=\"editRoute.overriddenStartDayBefore\">\n      <label for=\"dayBefore\">{{ t('routeModalOverriddenStartDayBefore') }}</label>\n    </div>\n  </div>\n  <div class=\"driverComingWrapper\">\n    <input type=\"checkbox\" id=\"driverComingSMS\" ng-model=\"editRoute.permitDriverComingSMS\" ng-disabled=\"! (auth.roles.clientPlus || auth.roles.di)\">\n    <label for=\"driverComingSMS\">{{ t('routeModalPermitDriverComingSMS') }}</label>\n  </div>\n  <div class=\"colors\">\n    <div ng-repeat=\"n in routeColors\" ng-class=\"{ 'selected': $index == editRoute.color }\" ng-click=\"routeColorChosen($index)\" class=\"route-name color-{{ $index }}\"></div>\n  </div>\n  <div class=\"flex\">\n    <button type=\"button\" ng-if=\"!! editRoute.id &amp;&amp; routePlan.findRoute(editRoute.id).customers().length===0\" ng-click=\"deleteEmptyRoute(editRoute.id)\" class=\"link dangerous\">{{ t('routeModalDeleteEmptyRoute') }}</button>\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-if=\"! isSaving\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('routeModalSave') }}</button>\n    <spinner ng-if=\"isSaving\"></spinner>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form ng-submit=\"saveRoutePlan(editRoutePlan)\" name=\"form\">\n  <div class=\"row\">\n    <calendar date=\"editRoutePlan.date\"></calendar>\n    <div class=\"select\">\n      <select ng-options=\"distrNo as t('distrNo'+distrNo) for distrNo in [0, 1, 2, 3, 4, 5]\" ng-model=\"editRoutePlan.distrNo\"></select>\n    </div>\n  </div>\n  <div ng-if=\"showCompany\" class=\"row\">\n    <div class=\"select company-select\">\n      <select ng-options=\"company.id as company.name for company in settings.companies | orderBy:'name'\" ng-model=\"editRoutePlan.companyId\" required></select>\n    </div>\n  </div>\n  <div class=\"row\">\n    <input type=\"text\" ng-model=\"editRoutePlan.name\" placeholder=\"{{ t('planModalName') }}\">\n  </div>\n  <div class=\"row\">\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('cSave') }}</button>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form ng-submit=\"saveFile(newFile)\" name=\"form\">\n  <div class=\"select\">\n    <select ng-options=\"customerSystem.id as customerSystem.name for customerSystem in values(customerSystems) | orderBy:'name'\" ng-model=\"newFile.customerSystemId\">\n      <option value=\"\">{{ t('fileModalChooseCustomSystem') }}</option>\n    </select>\n  </div>\n  <input type=\"file\" ng-show=\"newFile.customerSystemId\" ng-model=\"newFile.file\" file-on-change required>\n  <div><a href=\"https://jira-di.atlassian.net/wiki/pages/viewpage.action?pageId=26640428\" target=\"_blank\" class=\"link fa fa-help\">{{ t('fileModalFormatHelp') }}</a>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('fileModalUploadBtn') }}</button>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"stats\">\n  <div>\n    <div class=\"stat count-all\">{{ route.name || routePlan.routes.length }}\n      <div class=\"label\">{{ t(route ? 'cRoute' : 'cRoutes') }}</div>\n    </div>\n    <div ng-if=\"! route &amp;&amp; routePlan.countDelayedUnfinishedRoutes()\" class=\"stat count-delayed\">{{ routePlan.countDelayedUnfinishedRoutes() }}\n      <div class=\"label\">{{ t('fleetDashDelayed') }}</div>\n    </div>\n    <div class=\"stat\"><span tooltip=\"routeProgressTooltipTemplate\" ng-class=\"{ map: page.includes('map') }\" class=\"route-progress-info tooltip-right biginfo\">\n        <progress-bar max=\"(route || routePlan).countCustomers()\" cancelled=\"(route || routePlan).countCustomersCancelled()\" delivered=\"(route || routePlan).countCustomersDelivered()\" deviation=\"(route || routePlan).countCustomersDeviation()\"></progress-bar></span>\n      <div class=\"label\">{{ t('fleetDashHandledCustomers') }}</div>\n    </div>\n    <div class=\"stat\"><a href=\"{{ router.link('fleet/deliveries', routePlan.id) }}/{{ route.id }}/notDelivered\">{{ ((route || routePlan).countCustomersNotCancelled() - (route || routePlan).countCustomersDone()) || '&nbsp;' }}</a>\n      <div class=\"label\">{{ t('fleetDashRemaining') }}</div>\n    </div>\n    <div class=\"stat\"><a href=\"{{ router.link('fleet/deliveries', routePlan.id) }}/{{ route.id }}/deviation\">{{ (route || routePlan).countDeliveries('deviation') }}</a>\n      <div class=\"label\">{{ t('fleetDashDeviation') }}</div>\n    </div>\n    <div ng-if=\"route\" class=\"stat\"><span tooltip=\"routeStatusTooltipTemplate\" class=\"{{ routeStatusClass(route) }} route-status\"></span><span class=\"delay\">{{ route.delayForHumans() }}</span>\n      <div class=\"label\">{{ t('fleetDashStatus') }}</div>\n    </div>\n    <div class=\"flex-padding\"></div>\n    <button type=\"button\" ng-if=\"routePlan.noRoutesAreLoadedOrStarted()\" ng-click=\"unpublish(routePlan)\" ng-disabled=\"! (auth.roles.plannerPlus || auth.roles.clientPlus)\" class=\"action\">{{ t('planRoutesUnpublishBtn') }}</button><a href=\"{{ exportRouteMetaUrl() }}\" target=\"_self\" class=\"action export stroked\">{{ t('fleetDashStatsRoutesBtn') }}</a><a ng-if=\"routePlan.pianoFile()\" href=\"{{ exportPianoUrl() }}\" target=\"_self\" class=\"action export stroked\">Pianofil</a><a href=\"{{ router.link('fleet/deliveries', routePlan.id) }}/{{ route.id }}\" class=\"customers link\">{{ t('fleetDashStatsCustomersBtn') }}</a>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"item header\"><span>{{ username }}</span><span class=\"headerTag\">{{ t(auth.role) }}</span></div>\n  <div ng-if=\"auth.roles.plannerPlus || auth.roles.clientPlus\" class=\"item\"><a href=\"https://support.di.no/support/tickets/new\" target=\"_blank\">{{ t('pageNewTicket') }}</a></div>\n  <div ng-if=\"auth.roles.plannerPlus || auth.roles.clientPlus\" class=\"item\"><a href=\"https://support.di.no/support/tickets\" target=\"_blank\">{{ t('pageViewTickets') }}</a></div>\n  <div class=\"item\"><a href=\"https://jira-di.atlassian.net/wiki/pages/viewpage.action?pageId=87228520\" target=\"_blank\">{{ t('pageDocumentation') }}</a></div>\n  <div class=\"item\"><a href=\"https://headwayapp.co/plan-go-release-notes\" target=\"_blank\">{{ t('pageChangeLog') }}</a></div>\n  <div class=\"item\"><a ng-click=\"logout()\">{{ t('pageLogout') }}</a></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("<span class=\"initials\">{{ initials(name) }}</span>");;return buf.join("");
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div id=\"map\" ng-class=\"downtime.numberOfDisplays(auth.daysUntilPasswordExpires!==null &amp;&amp; auth.daysUntilPasswordExpires &lt;= 14)\">\n  <div id=\"googleMaps\"></div>\n  <div id=\"openLayers\"></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div id=\"map\"></div>\n  <div class=\"flex\">\n    <div ng-class=\"{ empty: ! position }\" class=\"new-address\">\n      <div animate-on-change=\"position\">\n        &nbsp;\n        {{ newAddress }}\n        <div>{{ position.lat() | number:6 }}&nbsp; {{ position.lng() | number:6 }}</div>\n      </div>\n    </div>\n    <button ng-disabled=\"! position\" ng-click=\"save()\" class=\"action\">Bruk koordinater</button>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div id=\"mapTooltip\" class=\"map-tooltip\">\n  <div ng-if=\"! mapTooltip.isCluster\" ng-repeat=\"stop in stops = (mapTooltip.stops | orderBy: 'route.name')\">\n    <route-name ng-if=\"stop.route.id !== stops[$index - 1].route.id\" route-id=\"{{ stop.route.id }}\"></route-name>\n    <div ng-if=\"! stop.notCancelled()\" class=\"cancelled-notice\">{{ t('moveModalCancelled') }}</div>\n    <div ng-class=\"{ cancelled: ! stop.notCancelled() }\" class=\"address\">{{ stop.routeSequence }}. {{ stop.address }}</div>\n    <div ng-repeat=\"customer in stop.customers\" ng-class=\"{ cancelled: ! customer.notCancelled() }\" class=\"customer\"><span><span ng-if=\"customer.allDelivered()\" ng-class=\"{ deviation: customer.anyDeviations() }\" class=\"delivered\"></span></span><span><span ng-if=\"! auth.roles.client\" class=\"estimate\">{{ customer.estimatedTimestampDone | moment: 'LT' }}</span><span ng-if=\"customer.allDelivered() &amp;&amp; customer.deliveryStatusTimestamp()\">{{ customer.deliveryStatusTimestamp() | moment: 'LT' }}</span></span><span>{{ customer.name }}</span><span>{{ customerSystems[customer.customerSystemId].shortName }}</span><span>{{ customer.deliveries.length }}</span><span>{{ customer.deliveryWindow() }}</span></div>\n  </div>\n  <div ng-if=\"mapTooltip.route\">\n    <route-name route-id=\"{{ mapTooltip.route.id }}\"></route-name>\n    <div class=\"driver\">{{ drivers[route.driverUsername].name }}</div>\n  </div>\n  <div ng-if=\"mapTooltip.isCluster\">\n    <route-name route-id=\"{{ mapTooltip.stops[0].route.id }}\"></route-name>\n    <div class=\"stop-count\"><span ng-if=\"routePlan.published\">{{ mapTooltip.countStopLocationsDone() }}/</span>{{ mapTooltip.countStopLocationsNotCancelled() }} {{ t('progressStop') }},&nbsp;<span ng-if=\"routePlan.published\">{{ mapTooltip.countCustomersDone() }}/</span>{{ mapTooltip.countCustomersNotCancelled() }} {{ t('progressCustomers') }},&nbsp;<span ng-if=\"routePlan.published\">{{ mapTooltip.countDeliveriesDone() }}/</span>{{ mapTooltip.countDeliveriesNotCancelled() }} {{ t('progressParcels') }}</div>\n  </div>\n  <div ng-if=\"mapTooltip.pickupLocation\" class=\"pickup-location\">{{ t('mapPickupPoint') }}\n    <div class=\"address\">{{ routePlan.pickupLocationAddress(mapTooltip.pickupLocation) }}</div>\n    <div class=\"routes columns-{{ mapTooltip.nrOfRouteNameColumns() }}\">\n      <route-name ng-repeat=\"route in routePlan.routes |                    filter: { pickupLocationId: mapTooltip.pickupLocation.id } |                    orderBy: 'name'\" route-id=\"{{ route.id }}\"></route-name>\n    </div>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-click=\"_modal.close($event)\" class=\"modal {{ klass }}\">\n  <div ng-click=\"_modal.close($event)\" class=\"modal-center\">\n    <div ng-class=\"{ moveable: _modal.moveable }\" ng-mousedown=\"_modal.moveable &amp;&amp; _modal.mouseDown($event)\" ng-mouseup=\"_modal.moveable &amp;&amp; _modal.mouseUp($event)\" class=\"modal-window\">\n      <div class=\"modal-header\">\n        <button type=\"button\" ng-click=\"_modal.close()\"></button>\n        <h3>{{ title }}</h3>\n      </div>\n      <div class=\"modal-body\">{{ body }}</div>\n    </div>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<button type=\"button\" ng-click=\"openCalendar()\" class=\"date\">{{ date | moment:'L' }}</button>");;return buf.join("");
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form ng-submit=\"saveOptimization(optimize, optimizeRoutes)\" name=\"form\">\n  <div class=\"border\">\n    <div ng-show=\"optimize.countWarnings\" class=\"warning\"><a href=\"{{ router.link('plan/customers', routePlan.id) }}#deviation\" ng-click=\"closeModal()\">{{ t('optimizeModalMissingCoordsWarning', optimize.countWarnings) }}</a></div>\n    <div ng-if=\"! optimizeRoutes\" class=\"info\">{{ t('optimizeModalSuggestedRoutes', (routePlan.suggestedRoutesCoverage() | number : 0)) }}\n      <button type=\"button\" ng-click=\"openSuggestedRoutes(routePlan)\" class=\"link\">{{ t('optimizeModalSuggestedRoutesShowCounts', routePlan.suggestedRoutesCount()) }}</button>\n    </div>\n    <div class=\"flex\">\n      <div>\n        <label>{{ t('optimizeModalDate') }}</label>\n        <calendar date=\"optimize.date\"></calendar>\n      </div>\n      <div ng-if=\"optimize.showTraveller\">\n        <label>{{ t('optimizeModalTraveller') }}</label>\n        <div class=\"select\">\n          <select ng-model=\"optimize.traveller\" ng-options=\"traveller as t('optimizeModalTraveller_'+traveller) for traveller in travellers\" required></select>\n        </div>\n      </div>\n    </div>\n    <div ng-if=\"optimizeRoutes\">\n      <label>{{ t('optimizeModalOptionsHeader') }}</label>\n      <div class=\"checkbox_wrapper\">\n        <button type=\"button\" ng-click=\"optimize.toggleClusterInfo()\" class=\"help\"></button>\n        <input type=\"checkbox\" id=\"cluster\" ng-model=\"optimize.cluster\">\n        <label for=\"cluster\">{{ t('optimizeModalClustering') }}</label>\n      </div>\n      <div id=\"cluster-info\" class=\"optimize-help-info hide\">{{ t('optimizeModalClusteringHelp') }}</div>\n      <div ng-if=\"settings.boundaryBox.minX\" class=\"checkbox_wrapper\">\n        <button type=\"button\" ng-click=\"optimize.toggleRelocateInfo()\" class=\"help\"></button>\n        <input type=\"checkbox\" id=\"relocate\" ng-model=\"optimize.relocate\">\n        <label for=\"relocate\">{{ t('optimizeModalRelocate') }}</label>\n      </div>\n      <div id=\"relocate-info\" class=\"optimize-help-info hide\">{{ t('optimizeModalRelocateHelp') }}</div>\n    </div>\n  </div>\n  <div ng-if=\"optimizeRoutes\" class=\"border {{ optimize.type }} tab\">\n    <label>{{ t('optimizeModalTypeChooser') }}</label>\n    <button type=\"button\" ng-click=\"optimize.type = 'time'\">{{ t('optimizeModalTypeChooserTimeWindow') }}</button>\n    <button type=\"button\" ng-click=\"optimize.type = 'routes'\">{{ t('optimizeModalTypeChooserRouteCount') }}</button>\n  </div>\n  <div class=\"border {{ optimize.type }} type\">\n    <div class=\"time\">\n      <label>{{ t('optimizeModalTimeWindow') }}</label>\n      <div>\n        <button type=\"button\" ng-click=\"optimize.toggleCarsTimeWindowInfo()\" class=\"help large\"></button>\n        <input type=\"text\" name=\"start\" ng-model=\"optimize.start\" ng-pattern=\"timePattern\" ng-change=\"validateStartStopInterval(optimize)\" ng-required=\"optimize.type === 'time'\" placeholder=\"{{ t('optimizeModalTimeWindowStart') }}\"><span class=\"to\">-</span>\n        <input type=\"text\" name=\"stop\" ng-model=\"optimize.stop\" ng-pattern=\"timePattern\" ng-change=\"validateStartStopInterval(optimize)\" ng-required=\"optimize.type === 'time'\" placeholder=\"{{ t('optimizeModalTimeWindowStop') }}\"><span ng-if=\"form.start.$error.required\" class=\"error\">{{ t('optimizeModalTimeWindowRequiredError') }}</span><span ng-if=\"form.start.$error.pattern || (form.stop.$error.pattern &amp;&amp; ! form.start.$error.required)\" class=\"error\">{{ t('optimizeModalTimeWindowFormatError') }}</span><span ng-if=\"form.stop.$error.interval\" class=\"error\">{{ t('optimizeModalTimeWindowInvalidError') }}</span>\n      </div>\n      <div id=\"carstimewindow-info\" class=\"optimize-help-info hide\">{{ t('optimizeModalTimeWindowHelp') }}</div>\n    </div>\n    <div class=\"routes\">\n      <div class=\"flex\">\n        <div>\n          <label>{{ t('optimizeModalRouteCount') }}</label>\n          <input type=\"text\" name=\"count\" ng-model=\"optimize.routeCount\" ng-pattern=\"integerPattern\" ng-required=\"optimize.type === 'routes'\" placeholder=\"{{ t('optimizeModalRouteCountCount') }}\">\n        </div>\n        <div>\n          <label>{{ t('optimizeModalRouteCountStart') }}</label>\n          <input type=\"text\" name=\"countStart\" ng-pattern=\"timePattern\" ng-required=\"optimize.type === 'routes'\" ng-model=\"optimize.start\" placeholder=\"{{ t('optimizeModalRouteCountStart') }}\">\n        </div>\n        <div>\n          <label>{{ t('optimizeModalCapacityPerRoute') }}</label>\n          <input type=\"text\" name=\"maxPerRoute\" ng-pattern=\"integerPattern\" ng-model=\"optimize.capacityPerRoute\" placeholder=\"{{ t('optimizeModalCapacityPerRoute') }}\">\n        </div>\n      </div><span ng-if=\"form.count.$error.required\" class=\"error\">{{ t('optimizeModalRouteCountCountRequiredError') }}</span><span ng-if=\"form.countStart.$error.pattern &amp;&amp; ! form.count.$error.required\" class=\"error\">{{ t('optimizeModalTimeWindowFormatError') }}</span>\n    </div>\n  </div>\n  <div class=\"pickup-locations\">\n    <label>{{ t((optimize.editMode() || optimize.pickupLocations.length > 1) ? 'optimizeModalPickupPoints' : 'optimizeModalPickupPoint') }}</label>\n    <div ng-if=\"optimize.pickupLocation\">\n      <address-helper country-code=\"routePlan.countryCode\" delivery-point-id=\"optimize.pickupLocation.deliveryPointId\" on-change=\"optimize.updateAddress\"></address-helper>\n      <div ng-if=\"optimize.editMode()\" class=\"buttons\">\n        <button type=\"button\" ng-click=\"optimize.cancelPickupLocation()\" class=\"link cancel\">{{ t('cCancel') }}</button>\n        <button type=\"button\" ng-click=\"optimize.savePickupLocation()\" ng-disabled=\"! optimize.pickupLocation.latitude\" class=\"link save\">{{ t('cSave') }}</button>\n      </div>\n    </div>\n    <div ng-if=\"! optimize.pickupLocation\" ng-repeat=\"location in optimize.pickupLocations\" class=\"address\"><span ng-class=\"{ deviation: ! location.latitude }\">{{ optimize.displayAddress(location) }}</span>\n      <button type=\"button\" ng-click=\"optimize.editPickupLocation($index)\" class=\"edit\"></button>\n      <button type=\"button\" ng-click=\"optimize.deletePickupLocation($index)\" class=\"delete\"></button>\n    </div>\n    <div style=\"min-height:20px\"><span ng-if=\"optimizeRoutes\">\n        <input type=\"checkbox\" id=\"return\" ng-model=\"optimize.returnToPickupLocation\">\n        <label for=\"return\">{{ t('optimizeModalPickupPointReturn') }}</label></span>\n      <button type=\"button\" ng-if=\"! optimize.editMode() &amp;&amp; optimize.pickupLocations[0].latitude\" ng-click=\"optimize.newPickupLocation()\" class=\"link new\">{{ t('optimizeModalPickupPointNew') }}</button>\n    </div>\n  </div>\n  <div>\n    <button type=\"submit\" ng-disabled=\"optimize.editMode()\" class=\"action\">{{ t(optimizeRoutes ? 'optimizeModalHeaderOptimize' : 'optimizeModalHeaderCreateRoutes') }}</button>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<form id=\"optimizeRouteWithOptions\" ng-submit=\"optimizeRouteWithOptions(optimizeRouteOptions)\" name=\"form\">\n  <div class=\"info\">{{ t('optimizeRouteModalIntro') }}</div>\n  <div>\n    <label>{{ t('optimizeRouteModalFirstStopLabel') }}</label>\n    <div class=\"select\">\n      <select ng-model=\"optimizeRouteOptions.selectedFirstStopLocation\" ng-options=\"stop as stop.routeSequence + '. ' + stop.address for stop in optimizeRouteOptions.route.stopLocations | orderBy:'routesequence'\">\n        <option value=\"\">{{ t('optimizeRouteModalNoneSelected') }}</option>\n      </select>\n    </div>\n  </div>\n  <div>\n    <label>{{ t('optimizeRouteModalLastStopLabel') }}</label>\n    <div class=\"select\">\n      <select ng-model=\"optimizeRouteOptions.selectedLastStopLocation\" ng-options=\"stop as stop.routeSequence + '. ' + stop.address for stop in optimizeRouteOptions.route.stopLocations | orderBy:'routesequence'\">\n        <option value=\"\">{{ t('optimizeRouteModalNoneSelected') }}</option>\n      </select>\n    </div>\n  </div>\n  <div>\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('optimizeRouteModalBtn') }}</button>\n  </div>\n</form>");;return buf.join("");
	}

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-if=\"auth.daysUntilPasswordExpires!==null &amp;&amp; auth.daysUntilPasswordExpires &lt;= 14\" ng-class=\"{ warning: auth.daysUntilPasswordExpires &lt;= 2 }\" ng-bind-html=\"(auth.daysUntilPasswordExpires === 0) ? t('loginPasswordExpiresTomorrow', forgotPasswordURL(username)) : t('loginPasswordExpiresSoon', (auth.daysUntilPasswordExpires + 1), forgotPasswordURL(username))\" class=\"info\"></div>\n<downtime-warnings></downtime-warnings>\n<header>\n  <nav><a href=\"{{ router.link('index') }}\" class=\"logo\"></a><span ng-if=\"auth.roles.clientPlus || auth.roles.customerService\" class=\"distribution-links\"><a href=\"{{ router.link('distributions') }}\" class=\"distributionsLink\">{{ t(router.title('distributions')) }}</a><a href=\"{{ router.link('distribution', null, distribution || routePlan) }}\" ng-if=\"distribution || routePlan\" class=\"distributionLink\"><span class=\"weekday\">{{ (distribution || routePlan).date | moment:'lll' }}</span><span class=\"distrNo\">{{ ' - ' + t('distrNo' + (distribution || routePlan).distrNo) }}</span></a></span><a href=\"{{ router.link('distribution', null, distribution) }}/deviations\" ng-if=\"distribution &amp;&amp; (auth.roles.clientPlus || auth.roles.customerService)\" class=\"deviationsLink\">{{ t(router.title('distribution/deviations')) }}</a><a href=\"{{ router.link('distribution', null, distribution) }}/routes\" ng-if=\"distribution &amp;&amp; (auth.roles.clientPlus || auth.roles.customerService)\" class=\"routesLink\">{{ t(router.title('distribution/routes')) }}</a><a href=\"{{ router.link('plans') }}\" ng-if=\"auth &amp;&amp; ! (auth.roles.clientPlus || auth.roles.customerService)\" class=\"plansLink\">{{ t(router.title('plans')) }}</a><a href=\"{{ router.link('deviation') }}\" ng-if=\"auth &amp;&amp; ! (auth.roles.clientPlus || auth.roles.customerService) &amp;&amp; handleDeviationsLink()\">{{ t('pageDeviations') }}</a><a href=\"{{ router.link(page, routePlan.id) }}\" ng-if=\"dataLoaded()\" ng-repeat=\"page in router.availablePages(routePlan)\">{{ t(router.title(page)) }}</a>\n    <div class=\"flex-padding\"></div><span id=\"HW_wrapper\"></span>\n    <div ng-if=\"companies &amp;&amp; values(companies).length &gt; 1 &amp;&amp; (auth.roles.di || auth.roles.planner)\" class=\"select\">\n      <select ng-model=\"auth.companyId\" ng-options=\"company.id as company.name for company in values(companies) | orderBy:'name'\" ng-change=\"changeCompany(auth.companyId)\"></select>\n    </div>\n    <div tooltip=\"settingsMenuTemplate\" must-click=\"true\" ng-show=\"auth.roles.planner || auth.roles.client || auth.roles.customerService\" class=\"settings settings-menu tooltip-below\"></div>\n    <div tooltip=\"helpMenuTemplate\" must-click=\"true\" class=\"help help-menu tooltip-below\"></div>\n  </nav>\n</header>\n<div ng-if=\"! dataLoaded() &amp;&amp; ! serverError\" class=\"page-spinner\">\n  <div class=\"spinner\">\n    <div class=\"bounce\"></div>\n    <div class=\"bounce\"></div>\n    <div class=\"bounce\"></div>\n  </div>\n</div>\n<ng-transclude ng-if=\"dataLoaded()\"></ng-transclude>");;return buf.join("");
	}

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<h1>\n  <div class=\"date\"><span class=\"weekday\">{{ routePlan.date | moment:'llll' }}</span>\n    <button ng-if=\"! routePlan.published &amp;&amp; (auth.roles.planner || auth.roles.clientPlus)\" ng-click=\"openEditRoutePlan(routePlan)\" class=\"edit\"></button>\n  </div>\n  <div class=\"name\">{{ t('distrNo'+routePlan.distrNo) }}</div>\n  <div class=\"name\">{{ routePlan.name }}</div>\n  <div ng-repeat=\"name in customerSystemNames(routePlan.customerSystems)\" class=\"customer-system\">{{ name }}</div>\n</h1>");;return buf.join("");
	}

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <page-header>\n    <page-title></page-title>\n    <div class=\"actions\">\n      <button type=\"button\" ng-if=\"routePlan.editable() &amp;&amp; routePlan.suggestedRoutesCount()\" ng-click=\"openOptimize(false)\" ng-disabled=\"! routePlan.customers.length || routePlan.status() === 'importing' || ! auth.roles.planner\" class=\"action\">{{ t('planCustomersCreateRoutesBtn', routePlan.suggestedRoutesCount()) }}</button>\n      <button type=\"button\" ng-if=\"routePlan.editable()\" ng-click=\"openOptimize(true)\" ng-disabled=\"! routePlan.customers.length || routePlan.customers.length &gt; getOptimizeStopsLimit() || routePlan.status() === 'importing' || ! auth.roles.planner\" class=\"action\">{{ t('planCustomersOptimizeBtn') }}</button>\n      <div ng-if=\"routePlan.editable() &amp;&amp; routePlan.customers.length &gt; getOptimizeStopsLimit()\" class=\"warning\">{{ t('planCustomersOptimizeTooBigWarning', getOptimizeStopsLimit()) }}</div>\n      <input type=\"text\" ng-if=\"! routePlan.editable()\" ng-model=\"search.text\" placeholder=\"{{ t('cSearch') }}\" class=\"search\">\n    </div>\n    <nav><a href=\"{{ customersLink() }}\" ng-class=\"{ active: activeTab === 'all' }\">{{ t('planCustomersFilterAll') }}\n        <div class=\"badge\">{{ (routePlan.customers | filter: { fileId: filter.fileId }).length }}</div></a><a href=\"{{ customersLink('deviation') }}\" ng-class=\"{ active: activeTab === 'deviation' }\">{{ t('planCustomersFilterMissingCoordinates') }}\n        <div class=\"badge\">{{ (routePlan.customers | filter: { fileId: filter.fileId, latitude: null }).length }}</div></a><a href=\"{{ router.link('plan/files', routePlan.id) }}\" ng-class=\"{ active: activeTab === 'files' }\">{{ t('planCustomersFilterFiles') }}\n        <div class=\"badge\">{{ routePlan.files.length }}</div></a></nav>\n    <div ng-if=\"page === 'plan-customers'\" class=\"filters\">\n      <select ng-options=\"file.id as file.name for file in allFiles()\" ng-model=\"filter.fileId\" ng-change=\"setFileFilter(filter.fileId)\">\n        <option value=\"\">{{ t('planCustomersFilterShowAllFiles') }}</option>\n      </select>\n    </div>\n  </page-header>\n</div>");;return buf.join("");
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-if=\"! reserveRoutes\" class=\"stats\">\n  <div>\n    <div class=\"stat\">{{ map.route.name || routePlan.routes.length }}\n      <div class=\"label\">{{ t(map.route ? 'cRoute' : 'cRoutes') }}</div>\n    </div>\n    <div class=\"stat\">{{ map.route ? map.route.stopLocations.length : routePlan.countStopLocationsNotCancelled() }}\n      <div class=\"label\">{{ t('planRoutesStop') }}</div>\n    </div>\n    <div class=\"stat\"><span ng-if=\"map.route\">{{ map.route.length ? map.route.length + ' km' : '?' }}</span><span ng-if=\"! map.route\">{{ routePlan.validStats() ? routePlan.length() + ' km' : '?' }}</span>\n      <div class=\"label\">{{ t('planRoutesLength') }}</div>\n    </div>\n    <div class=\"stat\"><span ng-if=\"map.route\">{{ (map.route.durationDriving | duration) || '?' }}</span><span ng-if=\"! map.route\">{{ routePlan.validStats() ? (routePlan.durationDriving() | duration) : '?' }}</span>\n      <div class=\"label\">{{ t('planRoutesDrivingDuration') }}</div>\n    </div>\n    <div class=\"stat\"><span ng-if=\"map.route\">{{ (map.route.durationTotal | duration) || '?' }}</span><span ng-if=\"! map.route\">{{ routePlan.validStats() ? (routePlan.durationTotal() | duration) : '?' }}</span>\n      <div class=\"label\">{{ t('planRoutesTotalDuration') }}</div>\n    </div>\n    <div class=\"flex-padding\"></div>\n    <button type=\"button\" ng-if=\"showAskForDriverInput(routePlan)\" ng-click=\"askForDriverInput(routePlan)\" ng-disabled=\"! routePlan.allRoutesAreAssigned() || routePlan.unlinkedCustomers().length || ! routePlan.noRoutesAreOptimizing() || ! auth.roles.planner\" class=\"action\">{{ t('planRoutesAskForDriverInputBtn') }}</button>\n    <button type=\"button\" ng-if=\"! showAskForDriverInput(routePlan)\" ng-click=\"publish(routePlan)\" ng-disabled=\"routePlan.unlinkedCustomers().length || ! routePlan.noRoutesAreOptimizing() || ! auth.roles.planner\" class=\"action\">{{ t('planRoutesPublishBtn') }}</button>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"popper-tooltip\">\n  <div class=\"tooltip-arrow\"></div>\n  <div class=\"tooltip-inner\"></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-repeat=\"product in values(products) | orderBy: 'name'\" class=\"product\"><span>{{ product.count }}</span><span>{{ product.name }}</span></div>");;return buf.join("");
	}

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"progressBar\">\n  <div style=\"width: {{ calcPercentage(cancelled) }}\" ng-class=\"{ firstPart: isFirst('cancelled'), lastPart: isLast('cancelled') }\" class=\"cancelled\"></div>\n  <div style=\"width: {{ calcPercentage(delivered) }}\" ng-class=\"{ firstPart: isFirst('delivered'), lastPart: isLast('delivered') }\" class=\"delivered\"></div>\n  <div style=\"width: {{ calcPercentage(deviation) }}\" ng-class=\"{ firstPart: isFirst('deviation'), lastPart: isLast('deviation') }\" class=\"deviation\"></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div ng-if=\"customer.route.routeSequenceDelivery &amp;&amp; ! customer.route.timestampStop\" class=\"cell stopno\"><span class=\"label\">{{ t('distributionDriverStop') }}</span><span class=\"stopno\"><span class=\"circle color-{{ customer.route.color }}\">{{ customer.route.routeSequenceDelivery }}</span></span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('distributionCompany') }}</span><span>{{ customer.route.companyName }}</span></div>\n  <div ng-if=\"customer.route.driver.name\" class=\"cell\"><span class=\"label\">{{ t('fleetDashDriver') }}</span><span>\n       \n      {{ customer.route.driver.name }}<span ng-if=\"customer.route.driver.phone\">&nbsp;({{ formatPhone(customer.route.driver.phone) }})</span></span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("<span class=\"route-name color-{{ route.color % routeColors.length }}\">{{ route.name }}</span>");;return buf.join("");
	}

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"route-printed-tooltip\">\n  <div>\n    <div class=\"cell\"><span>{{ t('fleetPrinterName', '') }}</span></div>\n    <div class=\"cell right\"><span>{{ '#' }}</span></div>\n  </div>\n  <div ng-repeat=\"print in routePlan.prints\">\n    <div class=\"cell label\"><span>{{print.userName}}</span></div>\n    <div class=\"cell label right\"><span>{{print.numberOfPrints}}</span></div>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"cell\"><span class=\"label\">&nbsp;</span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCustomers') }}</span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('progressParcels') }}</span></div>\n</div>{{custCancelled=(route || routePlan).countCustomersCancelled();\"\"}}\n{{delCancelled=(route || routePlan).countDeliveries('cancelled');\"\"}}\n<div ng-show=\"custCancelled || delCancelled\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressCancelled') }}</span></div>\n  <div class=\"cell count\"><span class=\"cancelled\">{{ custCancelled }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ delCancelled }}</span></div>\n</div>{{custDelivered=(route || routePlan).countCustomersDelivered();\"\" }}\n{{delDelivered=(route || routePlan).countDeliveries('delivered');\"\" }}\n<div ng-show=\"custDelivered || delDelivered\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDelivered') }}</span></div>\n  <div class=\"cell count\"><span class=\"delivered\">{{ custDelivered }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ delDelivered }}</span></div>\n</div>{{custDeviation=(route || routePlan).countCustomersDeviation();\"\" }}\n{{delDeviation=(route || routePlan).countDeliveries('deviation');\"\" }}\n<div ng-show=\"custDeviation || delDeviation\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressDeviation') }}</span></div>\n  <div class=\"cell count\"><span class=\"deviation\">{{ custDeviation }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ delDeviation }}</span></div>\n</div>{{custRemaining=((route || routePlan).countCustomersNotCancelled() - (route || routePlan).countCustomersDone());\"\"}}\n{{delRemaining=((route || routePlan).countDeliveriesNotCancelled() - (route || routePlan).countDeliveriesDone());\"\"}}\n<div ng-show=\"custRemaining || delRemaining\" class=\"top-border\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressRemaining') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ custRemaining }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ delRemaining }}</span></div>\n</div>\n<div class=\"top-border-thick\">\n  <div class=\"cell\"><span class=\"label\">{{ t('progressTotal') }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ (route || routePlan).countCustomers() }}</span></div>\n  <div class=\"cell count\"><span class=\"clean\">{{ (route || routePlan).countDeliveries() }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"ol-route-zoom ol-unselectable ol-control\">\n  <button type=\"button\" ng-click=\"map.overview()\">{{ t('fleetDashOverview') }}</button>\n  <div ng-if=\"map.route\" class=\"ol-divider\"></div>\n  <button ng-if=\"map.route\" type=\"button\" ng-click=\"map.zoomToFitRoute()\">{{ t('fleetDashRouteOverview') }}</button>\n</div>");;return buf.join("");
	}

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<h3 ng-if=\"serverError.status\">{{ serverError.status }} {{ serverError.statusText }}</h3>\n<p>{{ serverError.message }}</p>\n<p ng-if=\"serverError.data &amp;&amp; serverError.data.errorKey\">{{ t(serverError.data.errorKey) }}</p>\n<p>{{ serverError.data.errorMap }}</p>\n<div ng-if=\"serverError.data &amp;&amp; serverError.data.link\" class=\"linkWrapper\">\n  <p ng-bind-html=\"serverError.data.link\"></p>\n</div>");;return buf.join("");
	}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div ng-if=\"auth.roles.planner\">\n    <div class=\"item header\"><span>{{ settings.companyName }}</span></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCompanyGeneral') }}\">{{ t(router.title('settingsCompanyGeneral')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCompanyAcknowledgements') }}\">{{ t(router.title('settingsCompanyAcknowledgements')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCompanyNotifications') }}\">{{ t(router.title('settingsCompanyNotifications')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCompanyDeliveryTimes') }}\">{{ t(router.title('settingsCompanyDeliveryTimes')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsDriverUsers') }}\">{{ t(router.title('driverUsers')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsUsers') }}\">{{ t(router.title('users')) }}</a></div>\n  </div>\n  <div ng-if=\"auth.roles.client || auth.roles.customerService\">\n    <div class=\"item header\">\n      <div ng-repeat=\"csSettings in settings.customerSystemSettings\">{{ csSettings.customerSystemName }}</div>\n    </div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCustomerSystemGeneral') }}\">{{ t(router.title('settingsCustomerSystemGeneral')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCustomerSystemAcknowledgements') }}\">{{ t(router.title('settingsCustomerSystemAcknowledgements')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCustomerSystemNotifications') }}\">{{ t(router.title('settingsCustomerSystemNotifications')) }}</a></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsCustomerSystemDeliveryTimes') }}\">{{ t(router.title('settingsCustomerSystemDeliveryTimes')) }}</a></div>\n  </div>\n  <div ng-if=\"auth.roles.di\">\n    <div class=\"item header\"><span>{{\"DI\"}}</span></div>\n    <div class=\"item\"><a href=\"{{ router.link('settingsSystemWarnings') }}\">{{ t(router.title('settingsSystemWarnings')) }}</a></div>\n  </div>\n</div>");;return buf.join("");
	}

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("<span class=\"spinner\"><span class=\"bounce\"></span><span class=\"bounce\"></span><span class=\"bounce\"></span></span>");;return buf.join("");
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-repeat=\"delivery in customer.deliveries\" ng-class=\"{ cancelledProduct: delivery.status === 'cancelled' }\"><span ng-class=\"{ 'has-comment': delivery.comment }\" tooltip=\"deliveryStatusTooltipTemplate\" class=\"{{ delivery.status }} delivery-status\"></span>{{ delivery.product }}<span ng-show=\"(delivery.productCount &gt; 1 || delivery.adhoc) &amp;&amp; delivery.productCountAdjusted === null\"> ({{ delivery.productCount }})</span><span ng-show=\"(delivery.productCount &gt; 1 || delivery.adhoc) &amp;&amp; delivery.productCountAdjusted &gt; 0\"> ({{ delivery.productCountAdjusted }}/{{ delivery.productCount }})</span></div>");;return buf.join("");
	}

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div>\n  <div class=\"coverage\"><span>{{ t('optimizeModalSuggestedRoutes', (routePlan.suggestedRoutesCoverage() | number : 0)) }}</span></div>\n  <div ng-repeat=\"suggestedRoute in suggestedRoutes\" ng-class=\"{ notOnRoute: ! suggestedRoute.name }\" class=\"suggested-route\"><span>{{ suggestedRoute.name ? suggestedRoute.name : t('suggestedRoutesModalNotOnRoute') }}</span><span>{{ suggestedRoute.customerCount }}</span></div>\n</div>");;return buf.join("");
	}

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div class=\"tooltip\">{{ body }}</div>");;return buf.join("");
	}

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(1);
	
	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	
	var jade_indent = [];
	buf.push("\n<div ng-if=\"customer.imageUrl\">\n  <spinner></spinner><img ng-src=\"{{ imageUrl(customer) }}\" width=\"{{ 540 }}\">\n</div>");;return buf.join("");
	}

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = {"loginUsername":"User name","loginPassword":"Password","loginLanguage":"Language","loginForgot":"Forgot you password?","loginHeader":"Login","loginLoginBtn":"Login","loginError":"Wrong user name or password","loginErrorAccountExpired":"Your account has been deactivated","loginErrorPasswordExpired":"Your password has expired, <a href=\"%1\">change your password</a>","loginErrorOnlyDriver":"You only have access to driver app","loginPasswordExpiresSoon":"Your password will expire in %1 days, <a href=\"%2\">change your password now</a>","loginPasswordExpiresTomorrow":"Your password expires today, <a href=\"%1\">change your password now</a>","pageDowntimePlanned":"Planned upgrade of servers on %1. Downtime is expected to be %2 minutes.","pageDowntimeGeneral":"We are experiencing some instability and we are working to fix this. We are sorry for your inconvenience.","pageDistributions":"Distributions","pageDistributionDeviations":"Deviation","pageDistributionRoutes":"Delayed routes","pagePlans":"Plans","pageUsers":"User overview","pageDrivers":"Driver administration","pageCustomers":"Customers","pageRoutesMap":"Routes","pageRoutesList":"Route list","pageDashboardList":"Dashboard","pageDashboardMap":"Map","pagePrint":"Print","pageLogin":"Login","pageLogout":"Logout","pageDocumentation":"User documentation","pageChangeLog":"Release notes","pageNewTicket":"New support ticket","pageViewTickets":"Your support tickets","pageSettingsAcknowledgements":"Acknowledgement Rules","pageSettingsNotifications":"Notification Rules","pageSettingsDeliveryTimes":"Delivery Time Rules","pageSettingsGeneral":"General Settings","pageSettingsSystemWarnings":"System notifications","pageDeviations":"Handle Deviations","roleClient":"Customer","roleClientPlus":"Customer Plus","roleCustomerService":"Customer Service","roleFleetManager":"Fleet Manager","rolePlanner":"Planner","rolePlannerPlus":"Planner Plus","distributionsActive":"Active distributions","distributionsHistoric":"Recent distributions","distributionAllPublished":"All %1 plans are published","distributionCountPublished":"%1 of %2 plans are published","distributionCompany":"Company","distributionDelayedRoutes":"Delayed routes","distributionPlans":"Plans","distributionPlanName":"Name","distributionShowPlan":"Show plan","distributionNoRoutesFound":"Can't find anything with \"%1\"...","distributionCustomerSearch":"Name, address, phone or order","distributionRouteFilter":"Filter route list","distributionDriverStop":"Previous stop","distributionNewDistributionBtn":"Create new distribution","distributionModalNew":"New distribution","distributionDeletePlan":"Delete","distrNo0":"Daytime","distrNo1":"Night","distrNo2":"Morning","distrNo3":"Before noon","distrNo4":"Afternoon","distrNo5":"Evening","driverInfoDevice":"Model/brand","driverInfoDeviceOS":"OS","driverInfoDeviceAppVersion":"Version","plansActivePlans":"Active plans","plansHistoricPlans":"Recent plans","plansCardOpen":"Open","plansNewPlanBtn":"Create new plan","plansGeoFencingBtn":"Geofencing","plansInvoiceDataBtn":"Invoicing","plansCompanyDeliveriesDataBtn":"Stats (last month)","planModalHeaderEdit":"Modify plan","planModalHeaderNew":"New plan","planModalName":"Name (not required)","planDeletePlan":"Delete plan","planDeletePlanConfirm":"Are you sure you want to delete the plan:<br> %1?","cRoute":"Route","cRoutes":"Routes","cCustomer":"Customer","cCustomers":"Customers","cAddress":"Address","cProduct":"Product","cSupplier":"Supplier","cCancel":"Cancel","cCreate":"Create","cClose":"Close","cSave":"Save","cSearch":"Search","cFirstName":"First name","cLastName":"Last name","cUserName":"User name","cEmail":"Email","fleetDashShowAllRoutes":"Show all routes","fleetDashShowFullscreen":"Show full screen","fleetDashShowFullscreenExit":"Close full screen","fleetDashOverview":"Show all routes","fleetDashRouteOverview":"Show route overview","fleetDashDelayed":"Delayed","fleetDashHandledCustomers":"Served customers","fleetDashRemaining":"Remaining","fleetDashDeviation":"Deviation","fleetDashOutdatedApp":"%1 driver(s) has an outdated app","fleetDashStatus":"Status","fleetDashAssign":"Assign","fleetDashStatsRoutesBtn":"Routes","fleetDashStatsCustomersBtn":"Customers","fleetDashDriver":"Driver","fleetDashFilter":"Filter customer list","fleetDashFilterAll":"All routes","fleetDashFilterNotStarted":"Not started","fleetDashFilterOngoing":"Ongoing","fleetDashFilterDelayed":"Delayed","fleetDashFilterReserve":"Reserve Routes","fleetDashEditReserve":"Create Reserve Routes","fleetDashWeight":"Weight","progressRoutes":"Routes","progressStop":"Stop","progressCustomers":"Customers","progressCancelled":"Cancelled","progressDelivered":"Delivered","progressDeviation":"Deviation","progressCompleted":"Completed","progressParcels":"Parcels","progressRemaining":"Remaining","progressTotal":"Total","statusNoGPS":"No GPS data","statusDone":"Done","statusNotStarted":"Not started","statusStarted":"Startet","statusEstimatedStart":"Est. start","statusEstimatedDone":"Est. done","mapPickupPoint":"Starting location","routeModalHeaderEdit":"Modify route","routeModalHeaderReserveEdit":"Modify reserve route","routeModalHeaderNew":"New route","routeModalHeaderReserveNew":"New reserve route","routeModalChooseDriver":"Choose driver","routeModalChoosePickupPoint":"Choose starting location","routeModalSave":"Save","routeModalPermitDriverComingSMS":"Allow \"driver soon there\"-SMS","routeModalDeleteEmptyRoute":"Delete empty route","routeModalRouteName":"Route name","routeModalOverriddenStart":"Start time (HH:MM)","routeModalOverriddenStartDayBefore":"Day before","routeModalReserveFetchCustomersLabel":"Transfer customers from another route","routeModalWreckInfo":"NB: Remaining customers on \"%1\" will receive an SMS","routeModalReserveChooseRoute":"Choose route","routeModalReserveAssignDelayInfo":"Wait with assignment untill the route is fully configured","routeModalReserveRouteName":"Reserve route name","routeModalReserveOverriddenStart":"Provisional start time (HH:MM)","routeModalAutoAssigned":"The route is automatically assigned to it's previous driver","addressHelperHint":"Write <em>,</em> and <em>City</em>","addressHelperStreetName":"Street name","addressHelperStreetNo":"Street no.","addressHelperZip":"Zip","addressHelperCity":"City","addressHelperNoCoords":"The address is unfortunately missing coordinates","fleetDelPrintBtn":"Print","fleetDelAcknowledgementsBtn":"Acknowledgements","fleetDelDeviationsBtn":"Deviation","fleetDelFilterAll":"All customers","fleetDelFilterRemaining":"Remaining","fleetDelFilterDelayed":"Delayed","fleetDelFilterDeviations":"Deviation","fleetDelFilterCancelled":"Cancelled","fleetDelFilterPartiallyDelivered":"Partial","fleetDelAllRoutes":"All routes","fleetDelStop":"Stop","fleetDelArrival":"Arrival","customerPhone1":"Mobile","customerPhone2":"Alternative phone","customerOrder":"Order","customerDeadline":"Deadline","customerDirective":"Delivery instruction","fleetDelAcknowledged":"Acknowledged","fleetDelOrderLine":"Order line","fleetDelParcelNumber":"Parcel number","fleetDelDriverComment":"Comment from driver","fleetDelTimePlanned":"Planned","fleetDelTimeRouteDelay":"Delay","fleetDelTimeCalculated":"Estimated","fleetDelTimeDeliveredClientSide":"Ack. time","fleetDelTimeDeliveredServerSide":"Received","fleetDelCallLog":"Call Log","fleetDelCallLogDriver":"Driver","delStatus0":"Not loaded","delStatus1":"Delivered to customer","delStatus2":"Delivered by the door","delStatus3":"Can't find customer","delStatus4":"Product missing","delStatus5":"Other (product)","delStatus6":"Loaded on car","delStatus7":"Customer not at home","delStatus8":"Product damaged","delStatus9":"Other (customer)","delStatus10":"Customer won't accept delivery","delStatus11":"Cancelled","delStatus12":"Delivered","delStatus13":"Picked up","delStatus14":"Partially delivered","delStatus15":"Automatic (GeoFence)","delStatus16":"Lost in own Supply Chain","delStatus17":"Lost before own Supply Chain","delStatus18":"Lost/stolen","delStatus19":"Recipient has changed location","delStatus20":"Unsuitable location","delStatus21":"Missing key/code","customerModalHeaderEdit":"Edit customer","customerModalHeaderNew":"New customer","customerModalConfirmDeleteHeader":"Delete customer","customerModalConfirmDeleteBody":"Are you sure you want to delete this customer?","customerModalConfirmCancelHeader":"Cancel customer","customerModalConfirmCancelBody":"Are you sure you want to cancel this customer?","customerModalChooseSupplier":"Choose supplier","customerModalChangeAddress":"Change address","customerModalChangeRoutePlan":"Move to another route/plan","customerModalResetChangeRoutePlan":"Cancel move","customerModalPlanLabel":"Move to plan","customerModalRouteLabel":"Move to route","customerModalNewCustomerRouteLabel":"Place on route","customerModalStopLabel":"Place after","customerModalChooseFirstOnRoute":"Start","customerModalChooseSoon":"Please wait...","customerModalChooseRoute":"- Choose route -","customerModalChooseStop":"- Choose stop to place the customer after -","customerModalSave":"Save","customerName":"Name","customerCO":"C/O","customerTimeWindowStart":"Earliest time for delivery is 09:00","customerTimeWindowStop":"Deadline for delivery is 13:00","customerTimeFormatHelp":"Time format: 17:30 or 1730","customerDuration":"Del.time (min)","customerPlaceInMap":"Place in map","customerUndoCancelProduct":"Undo","customerAddProduct":"Add product","customerDelete":"Delete customer","customerCancel":"Cancel customer","customerParcels":"# Parcels","planStatus_created":"Created","planStatus_imported":"Imported data","planStatus_importing":"File importing","planStatus_queued":"Waiting for optimization (line: %1)","planStatus_optimizing":"Optimizing","planStatus_generating":"Routes beeing calculated","planStatus_failed":"Optimization failed","planStatus_optimized":"Optimized","planStatus_readyfordriverinput":"Waiting for driver input","planStatus_published":"Published","planStatus_deleted":"Deleted","planStatus_routesimportqueued":"Waiting for routes to be created","planStatus_routesimporting":"Routes beeing created","planStatus_routesimported":"Routes created","planCustomersOptimizeBtn":"Optimize","planCustomersOptimizeTooBigWarning":"Too many customers to optimize (max %1)","planCustomersCreateRoutesBtn":"Create %1 routes","planCustomersBoundaryBoxMissingErrorHeader":"Geography-limits are missing","planCustomersBoundaryBoxMissingError":"Company is missing geography-limits, please contact support","planCustomersBoundaryBoxOutsideErrorHeader":"Outside geography-limits","planCustomersBoundaryBoxOutsideError":"The plan contains customers/pickup-points that are outside the company's geography-limits. Please check if the customer-file/pickup-point is inside the area for this company. Or maybe the company-area is too limited. Please contact support.","planCustomersRelocateUnbalancedErrorHeader":"Unbalanced plan for relocate","planCustomersRelocateUnbalancedError":"Number of pickups didn't match number of deliveries on this plan. To use the special optimization mode 'relocate', the plan has to be perfectly balanced regarding piups and deliveries. Pickups are specified by the PICKUP-column in the import file.","planCustomersFilterAll":"All customers","planCustomersFilterMissingCoordinates":"Missing coordinates","planCustomersFilterFiles":"Uploads","planCustomersFilterShowAllFiles":"Show all files","fileStatus_error":"File uploading failed","fileStatus_uploading":"Uploading","fileStatus_linking":"Finding coordinates","fileStatus_done":"Imported","generalErrorHeader":"We are sorry, something went wrong...","planFilesIndividual":"Individual deliveries","planFilesNewFileBtn":"Upload file","planFilesNewCustomerBtn":"New customer","planFilesCardShowProducts":"Show products","planFilesCardShowCustomers":"Show customers","planFilesIncompleteRowError":"Line %1 in the file is incomplete.","planFilesMissingPropertyNameError":"File is missing a required field: %1.","planFilesInvalidPropertyLengthError":"File has a column that's too long: %1.","planFilesDuplicateOrderLineIdError":"Duplicate ORDER_LINE_ID: %1.","planFilesDuplicateParcelNumberError":"Duplicate PARCEL_NUMBER: %1","planFilesUnknownHeaderError":"File contains unknown columns: %1.","planFilesUnknownFileTypeError":"Can't recognize the file type, please check our documentation","planFilesDatatypeError":"Invalid value \"%1\" for the column: %2.","planFilesAddressLinkerError":"Address Lookup failed","planFilesUnknownError":"Unknown error.","planFilesDeleteFile":"Delete file","planFilesDeleteFileConfirm":"Are you sure you want to delete all customers from the file: \"%1\"?","fileModalHeader":"Upload an Excel/CSV file","fileModalChooseCustomSystem":"Choose customer system","fileModalSameRouteAsLastTime":"Use the same routes as last time","fileModalFormatHelp":"Fileformat description","fileModalUploadBtn":"Upload","productsModalHeader":"Products","optimizeModalHeaderOptimize":"Optimize routes","optimizeModalHeaderCreateRoutes":"Create routes","optimizeModalMissingCoordsWarning":"%1 addresses missing coordinates and will not be placed on a route","optimizeModalDate":"Distribution date","optimizeModalOptionsHeader":"Optimization Options","optimizeModalClustering":"Cluster the orders","optimizeModalClusteringHelp":"Clustering means that the optimization will try to create routes that are grouped around a dence area, the opposite is routes with stops scattered around from start to end. Clustering can give less optimal routes (theoretically).","optimizeModalRelocate":"Relocate","optimizeModalRelocateHelp":"Relocate is a special mode to handle moving your resources. Collect your resources from undesired locations and relocate them to more suitable spots. Requires that the plan is perfectly balanced (regarding pickups and deliveries).","optimizeModalTypeChooser":"Choose an optimization criteria:","optimizeModalTypeChooserTimeWindow":"Time Window","optimizeModalTypeChooserRouteCount":"Number of Routes","optimizeModalRouteCount":"Number of Routes","optimizeModalRouteCountCount":"Count","optimizeModalRouteCountStart":"Start time","optimizeModalCapacityPerRoute":"Product Limit","optimizeModalRouteCountCountRequiredError":"Antall ruter er påkrevd","optimizeModalTimeWindow":"Time window for the routes","optimizeModalTimeWindowHelp":"This is the outer time frame for the routes. Each route's start time will be determined by the time frame of its orders. It's good practice to set the start time a bit earlier than when you want the first customer to be served.","optimizeModalTimeWindowStart":"Start","optimizeModalTimeWindowStop":"(End)","optimizeModalTimeWindowRequiredError":"Start time is required","optimizeModalTimeWindowFormatError":"Wrong time format (17:30 or 1730)","optimizeModalTimeWindowInvalidError":"Invalid time interval","optimizeModalPickupPointReturn":"Return to starting location","optimizeModalPickupPointNew":"Add another start location","optimizeModalPickupPoint":"Start location","optimizeModalPickupPoints":"Start locations","optimizeModalPickupPointDelete":"Delete starting location","optimizeModalPickupPointDeleteBody":"Are you sure you want to delete: %1","optimizeModalTimeWindowOutsideError":"<b class=\"warning\">Warning:</b> %1 customers have their time window outside the given time window. ","optimizeModalConfirmCreateRoutes":"Are you sure you want to create %1 routes?","optimizeModalConfirmOptimize":"Are you sure you want to optimize?","optimizeModalSuggestedRoutes":"%1% of the customers will be placed on an earlier used route.","optimizeModalSuggestedRoutesShowCounts":"Show count per route (%1 routes)","optimizeModalTraveller":"Choose vehicle","optimizeModalTraveller_car":"Car","optimizeModalTraveller_pedestrian":"Pedestrian","optimizeRouteModalHeader":"Options for optimize","optimizeRouteModalIntro":"Choosing first stop will enforce the direction of the route (i.e. avoiding rush traffic). Choose last stop to end closer to the drivers home.","optimizeRouteModalNoneSelected":"- Choose -","optimizeRouteModalFirstStopLabel":"Start with","optimizeRouteModalLastStopLabel":"End with","optimizeRouteModalBtn":"Optimize","suggestedRoutesModalHeader":"Routes that will be created","suggestedRoutesModalNotOnRoute":"Not on any route","taggedAutoAssigned":"auto","taggedAutoAssignedPlan":"a","notificationSent":"Sent","notificationMsg":"Template","notificationMsgSimulation":"Template (not sent, simulation only)","userHeader":"User overview","driverUserHeader":"Driver administration","driverUsersMobile":"Mobile","driverUsersLastLoggedIn":"Last logged in","driverUsersFilterActive":"Active","driverUsersFilterInactive":"Inactive","driverUsersNewDriverBtn":"New driver","driverUsersLanguageReguiredError":"Please select language","driverUsersUserNameTakenError":"User name is allready taken","driverUsersUserNameInvalidError":"User name has invalid characters. Use only A-Z","driverUsersUserNameTooShortError":"User name is too short","driverUsersChooseLanguage":"- Choose language -","driverUsersInvalidPhoneError":"Phone number is not valid","driverUsersSendPasswordSMS":"Send user password by SMS","driverUsersSendNewPasswordSMS":"Send user a new password by SMS","driverUsersSentSMS":"(sent by SMS)","driverUsersActivate":"Activate user","driverUsersDeactivate":"Deactivate user","driverUsersHeaderEdit":"Edit driver","driverUsersHeaderNew":"New driver","moveModalHeader":"Move","moveModalCancelled":"Stop cancelled","moveModalMoveToRouteChoose":"Choose route","moveModalMoveToRoute":"Move to route","moveModalPlaceAfterChoose":"Choose route first","moveModalPlaceAfter":"Place after","moveModalPlaceAfterStart":"Start","moveModalPlaceAfterCancelled":"CANCELLED: ","moveModalLastStop":"(last stop)","moveModalNextStop":"Next stop","moveModalEditRoute":"Edit route","moveModalCustomersSelected":"You have selected %1 customers","moveModalMultiTipTitle":"Tip:","moveModalMultiTipDescription":"Hold down the %1 key while dragging in the map to move multiple stops","planRoutesStop":"Stops","planRoutesWeight":"Weight","planRoutesLength":"Length","planRoutesDrivingDuration":"Driving duration","planRoutesTotalDuration":"Total duration","planRoutesAskForDriverInputBtn":"Send to drivers","planRoutesAskForDriverInputBtnConfirm":"Name: %1<br>Date: %2 (<b>%3 %4</b>)<br><br>Do you want to send this plan to the drivers, asking them to specify their first and/or last delivery?","planRoutesPublishBtn":"Publish","planRoutesPublishBtnConfirm":"Name: %1<br>Date: %2 (<b>%3 %4</b>)<br><br>Do you want to publish the plan?","planRoutesUnpublishBtn":"Unpublish","planRoutesUnpublishBtnConfirm":"Name: %1<br>Date: %2<br><br>Are you sure you want to unpublish the plan?","planRoutesOptimizeBtn":"Optimize","planRoutesOptimizeAllBtn":"Optimize All","planRoutesAssigned":"Assigned","planRoutesCustomersPerHour":"CPH","planRoutesCustomersPerHourDescription":"Number of customers per hour","planRoutesStartDone":"Start-Done","routeOptimStatus1":"Waiting","routeOptimStatus2":"Optimizing","routeOptimStatus3":"Waiting","routeOptimStatus4":"Exporting","routeOptimTooManyCustomers":"Too many customers...","planRoutesHeader":"Routes","planRoutesReserveHeader":"Reserve Routes","planRoutesReserveSubTitle":"Temporary routes that will not be recycled/suggested for a customer when importing","planRoutesOptimizeWithTimeWindowFailedSameInterval":"It wasn't possible to serve all these customers in the time window %1. <br>If you are certain that this route is possible, then optimize again (at your own risk).","planRoutesOptimizeWithTimeWindowFailedMultipleIntervals":"It wasn't possible to serve all these customers in the given time windows. Please move some customers to other routes.<br>PS: You can only optimize again if all the customers share the same time window.","planRoutesOptimizeWithoutTimeWindow":"Optimize without time window","planRoutesMoveStop":"Move to route","planRoutesMoveStops":"Move %1 stops","planRoutesDeleteAllRoutes":"Delete all routes","planRoutesDeleteAllRoutesConfirm":"Are you sure you want to delete all routes?","planRoutesNewRouteBtn":"New route","planRoutesNewReserveRouteBtn":"New Reserve Route","planRoutesBackToDashboardBtn":"Back to Dashboard","fleetPrintCount":"Count","fleetPrinterName":"Printed by: %1","fleetPrinterInstructions":"This document contains personal information and is considered confidential. The document shall be handled according to given routines.","settingsAcknowledgementsTitle":"Acknowledgement Rules","settingsAcknowledgementsForTitle":"Acknowledgement rules for %1","settingsCompanyMissingCustomerSystems":"No Suppliers have been configured","settingsActionsTitle":"Confirm delivery","settingsPictureProof":"Must take picture","settingsScanner":"Must scan","settingsCanComment":"Comment","settingsMiscTitle":"Miscellaneous","settingsMiscDescription":"Miscellaneous settings regarding driver app's view and functionality.","settingsPermitLoadingMinutesBefore":"Loading list: %1 minutes before estimated start","settingsPermitStartingMinutesBefore":"Start: %1 minutes before estimated time","settingsShowProductCount":"Show item count","settingsScanBeforeLoading":"Scan products when loading","settingsScanBeforeDelivery":"Scan products before delivery","settingsAdhocProducts":"Adhoc Products (the driver reports quantity on-site)","settingsAutoAssignDrivers":"Routes will automatically be assigned to their previous driver","settingsAskForDriverInput":"Send to drivers for input before publishing","settingsAutoConfirmOnExit":"Automatisk kvittering ved avreise fra stopp (geofence)","settingsHandleDeviations":"Handle deviations","settingsSendEventsToFlow":"Send hendelser til DI Flow (ifm. sporing)","settingsSendEventsToTransport":"Send hendelser til DI Transport (ifm. varsling til bud)","settingsShowTraveller":"Show vehicles (regarding optimizing/route creation)","settingsActionsDescription":"This shows which acknowledgement buttons the driver can choose from.","settingsCustomerDeviationsTitle":"Customer Deviations","settingsCustomerDeviationsDescription":"These options will be available when the driver wants to register a deviation for a customer.","settingsProductDeviationsTitle":"Product Deviations","settingsProductDeviationsDescription":"These options will be available when the driver wants to register a deviation for a product/package.","settingsCompanyNotificationsTitle":"Notifications for each Supplier","settingsCustSysNotificationsTitle":"Notifications for each Transport Company","settingsCompanyNotificationsDescription":"Notification rules can be set up for each Supplier. SMS will be sent to the customer on these events.  Note that you can choose to first simulate before choosing to go live and send SMSes to your customers.","settingsCustSysNotificationsDescription":"Notification rules can be created for each transport company. SMS will be sent to the customer on these events. Note that you can choose to first simulate before choosing to go live and send SMSes to your customers.","settingsCompanyNotificationsCol1":"Supplier","settingsCustSysNotificationsCol1":"Transport Company","settingsNotificationsColEvent":"Event","settingsNotificationsCol4":"Template","settingsNotificationsCol5":"Status","settingsNotificationsMinutesBefore":"Notice %1 minutes before arrival","settingsNotificationsActive":"Active","settingsNotificationsSimulate":"Only simulate","settingsCompanyGeneralTitle":"General Settings","settingsCompanyGeneralDescription":"Some settings are for the transport company, other settings follow the customer system (the goods that are distributed).","settingsCompanyBoundaryBoxMissing":"Company is MISSING geography-limits, contact support","settingsCompanyBoundaryBoxLink":"Show geography-limits for the company","settingsCompanyGeneralCompanySectionTitle":"Settings","settingsCompanyGeneralCustomerSystemsSectionTitle":"Settings per customer system","settingsCustSysGeneralTitle":"General Settings","settingsCompanyZipIntervalsTitle":"Delivery times for %1","settingsCustSysZipIntervalsTitle":"Delivery times for each Transport Company","settingsCompanyZipIntervalsDescription":"How long should the delivery take (after arriving at the customer's address). Note: The time on the road between each customers is not included here.","settingsCustSysZipIntervalsDescription":"Each Transport Company might have rules concerning the delivery time (after arriving at the customer's address). Note: The time on the road between each customers is not included here.","settingsDISysWarningTitle":"System notifications","settingsDISysWarningDescription":"Everyone with the DI role can set system notifications. If one or both of the boxes are not checked, the notification will be removed. ","settingsDISysWarningGeneral":"General problems / instability","settingsDISysWarningDowntime":"Notify planned down time","settingsDISysDowntimeDuration":"Duration","settingsDISaveSysWarning":"Save system notification","settingsZipIntervalsColCompany":"Transport Company","settingsZipIntervalsColCustomerSystem":"Customer System","settingsZipIntervalsColInterval":"Zip interval","settingsZipIntervalsColTime":"Delivery Time","settingsMissingActions":"No actions have been configured","settingsMissingCustomerDeviations":"No customer deviations have been configured","settingsMissingProductDeviations":"No product deviations have been configured","settingsMissingNotificationTypes":"No notifications rules have been configured","settingsMissingZipIntervals":"No delivery time rules have been configured","receivedComingSms":"Customer has received a notification that driver is on the way. Can not be moved.","customerNotMoved":"Customer has been updated. The customer has received sms that driver is on the way and can therefore not be moved\n ","distributionShowRouteMap":"Show map","distributionShowRouteCustomers":"Show customers","distributionShowRouteCustomer":"Show customer","distributionShowCustomers":"Show plan customers"}

/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports = {"loginUsername":"Nom d'utilisateur ","loginPassword":"Mot de passe","loginLanguage":"Langues ","loginForgot":"Mot de passe oublié ?","loginHeader":"Se connecter ","loginLoginBtn":"Se connecter\n\n","loginError":"Nom d'utilisateur ou mot de passe incorrect ","loginErrorAccountExpired":"Votre compte a été désactivé ","loginErrorPasswordExpired":"Votre mot de passe a expiré, <a href=\"%1\">introduisez un nouveau mot de passe</a>","loginErrorOnlyDriver":"Kun tilgang til sjåfør-applikasjonen","loginPasswordExpiresSoon":"Votre mot de passe expire dans%1 jour,  <a href=\"%2\">changez le mot de passe maintenant</a>","loginPasswordExpiresTomorrow":"Votre mot de passe expire aujourd'hui, <a href=\"%1\">changez le mot de passe maintenant</a>","pageDowntimePlanned":"Planlagt oppgradering av systemet inntreffer %1. Nedetid er forventet å vare i %2 minutter","pageDowntimeGeneral":"Vi opplever for tiden ustabilitet med systemet og arbeider med å få rettet opp dette. Beklager ulempene dette måtte medføre.","pageDistributions":"Distributions","pageDistributionDeviations":"Déviation","pageDistributionRoutes":"Forsinkede ruter","pagePlans":"Plans","pageUsers":"Brukeroversikt","pageDrivers":"Administration du conducteur","pageCustomers":"Clients","pageRoutesMap":"Itinéraires","pageRoutesList":"Ruteliste","pageDashboardList":"Dashbord","pageDashboardMap":"Kart","pagePrint":"Imprimer","pageLogin":"Se connecter ","pageLogout":"Se déconnecter ","pageDocumentation":"Manuel d'utilisation ","pageChangeLog":"Libérer notes","pageNewTicket":"Enregistrer nouveau cas de support","pageViewTickets":"Vos rapports","pageSettingsAcknowledgements":"Règles de reçus ","pageSettingsNotifications":"Règles de notifications","pageSettingsDeliveryTimes":"Règles sur le temps de livraison ","pageSettingsGeneral":"Generelle innstillinger","pageSettingsSystemWarnings":"Systemvarsler","pageDeviations":"Avvik","roleClient":"Client","roleClientPlus":"Client Plus","roleCustomerService":"Kundeservice","roleFleetManager":"Dirigeur de flotte","rolePlanner":"Planificateur ","rolePlannerPlus":"Planificateur Plus","distributionsActive":"Distributions actives","distributionsHistoric":"Nylige distribusjoner","distributionAllPublished":"Tous les %1 plans sont publiés","distributionCountPublished":"%1 de %2 plans sont publiés","distributionCompany":"Entreprise","distributionDelayedRoutes":"Itinéraires retardés ","distributionPlans":"Plans","distributionPlanName":"Nom","distributionShowPlan":"Afficher plan","distributionNoRoutesFound":"Rien trouvé pour \"%1\"...","distributionCustomerSearch":"Nom, adresse, téléphone portable ou commande","distributionRouteFilter":"Filtrer liste des itinéraires","distributionDriverStop":"Arrêt précédent ","distributionNewDistributionBtn":"Opprett en ny distribusjon","distributionModalNew":"Ny distribusjon","distributionDeletePlan":"Slett","distrNo0":"Dag","distrNo1":"Nuit","distrNo2":"Matin","distrNo3":"Matinée","distrNo4":"Après-midi","distrNo5":"Soir","driverInfoDevice":"Modell","driverInfoDeviceOS":"OS","driverInfoDeviceAppVersion":"Versjon","plansActivePlans":"Plans actifs","plansHistoricPlans":"Nylige planer","plansCardOpen":"Ouvrir","plansNewPlanBtn":"Créer un nouveau plan ","plansGeoFencingBtn":"Geofencing","plansInvoiceDataBtn":"Fakturagrunnlag","plansCompanyDeliveriesDataBtn":"Antall (sist mnd)","planModalHeaderEdit":"Modifier le plan","planModalHeaderNew":"Nouveau plan","planModalName":"Nom (non requis)","planDeletePlan":"Effacer le plan","planDeletePlanConfirm":"Etes-vous sûr de vouloir effacer le plan?:<br> %1?","cRoute":"Itinéraire","cRoutes":"Itinéraires","cCustomer":"Client","cCustomers":"Clients","cAddress":"Adresse","cProduct":"Produit","cSupplier":"Fournisseur ","cCancel":"Annuler","cCreate":"Créer","cClose":"Fermer","cSave":"Enregistrer","cSearch":"Rechercher","cFirstName":"Prénom","cLastName":"Nom","cUserName":"Nom d'utilisateur","cEmail":"Email","fleetDashShowAllRoutes":"Montrer tous les itinéraires","fleetDashShowFullscreen":"Montrer en grand écran","fleetDashShowFullscreenExit":"Quitter écran plein","fleetDashOverview":"Vis alle ruter","fleetDashRouteOverview":"Vis hele ruten","fleetDashDelayed":"Retardé","fleetDashHandledCustomers":"Clients servis","fleetDashRemaining":"Restant","fleetDashDeviation":"Déviation","fleetDashOutdatedApp":"%1 sjåfør(er) har utdatert app","fleetDashStatus":"Statut","fleetDashAssign":"Distribuer","fleetDashStatsRoutesBtn":"Itinéraire","fleetDashStatsCustomersBtn":"Clients","fleetDashDriver":"Conducteur","fleetDashFilter":"Filtrer liste des clients","fleetDashFilterAll":"Tous les itinéraires","fleetDashFilterNotStarted":"Non commencé","fleetDashFilterOngoing":"En cours","fleetDashFilterDelayed":"Retardé","fleetDashFilterReserve":"Itinéraires de réserve ","fleetDashEditReserve":"Créer itinéraires de réserve","fleetDashWeight":"Vekt","progressRoutes":"Itinéraires","progressStop":"Arrêt","progressCustomers":"Clients","progressCancelled":"Kansellert","progressDelivered":"Levert","progressDeviation":"Avvik","progressCompleted":"Fullført","progressParcels":"Coli ","progressRemaining":"Gjenstående","progressTotal":"Totalt","statusNoGPS":"Aucun GPS","statusDone":"Terminer","statusNotStarted":"Non commencé","statusStarted":"Commencé","statusEstimatedStart":"Départ estimé pour un itinéraire","statusEstimatedDone":"Fin estimée pour un itinéraire","mapPickupPoint":"Lieu de départ","routeModalHeaderEdit":"Mise à jour de l'itinéraire","routeModalHeaderReserveEdit":"Mise à jour d'itinéraire de réserve","routeModalHeaderNew":"Nouvel itinéraire","routeModalHeaderReserveNew":"Nouvel itinéraire de réserve","routeModalChooseDriver":"Saisir conducteur","routeModalChoosePickupPoint":"Saisir lieu de départ","routeModalSave":"Enregistrer","routeModalPermitDriverComingSMS":"Tillat utsending av \"Sjåfør kommer\"-SMS","routeModalDeleteEmptyRoute":"Effacer itinéraire vide","routeModalRouteName":"Nom d'itinéraire ","routeModalOverriddenStart":"Horaire de départ (HH:MM)","routeModalOverriddenStartDayBefore":"Jour précédent","routeModalReserveFetchCustomersLabel":"Transmettre clients d'un autre itinéraire (par ex. sortie)","routeModalWreckInfo":"Attention: Les clients restants sur \"%1\" vont maintenant recevoir un SMS","routeModalReserveChooseRoute":"Sélectionner itinéraire","routeModalReserveAssignDelayInfo":"Attendez de partager l'itinéraire de réserve avant qu'elle soit entièrement assemblée","routeModalReserveRouteName":"Nom de l'itinéraire de réserve","routeModalReserveOverriddenStart":"Horaire de départ provisoire (HH:MM)","routeModalAutoAssigned":"Ruten er automatisk tildelt sjåføren som hadde ruten forrige gang","addressHelperHint":"Ecrire <em>,</em> et <em>Code postal</em>","addressHelperStreetName":"Nom de rue","addressHelperStreetNo":"Numéro de rue","addressHelperZip":"Code postal","addressHelperCity":"Pays/Région","addressHelperNoCoords":"L'adresse manque malheureusement des coordonnées","fleetDelPrintBtn":"Imprimer","fleetDelAcknowledgementsBtn":"Recus ","fleetDelDeviationsBtn":"Déviation","fleetDelFilterAll":"Tous les clients","fleetDelFilterRemaining":"Restants ","fleetDelFilterDelayed":"Retardé","fleetDelFilterDeviations":"Déviation","fleetDelFilterCancelled":"Annulé","fleetDelFilterPartiallyDelivered":"Delvis levert","fleetDelAllRoutes":"Tous les itinéraires","fleetDelStop":"Arrêt","fleetDelArrival":"Arrivé","customerPhone1":"Numéro de portable","customerPhone2":"Numéro alternatif","customerOrder":"Commande","customerDeadline":"Date limite","customerDirective":"Guide de livraison","fleetDelAcknowledged":"Facturé","fleetDelOrderLine":"Ligne de commande","fleetDelParcelNumber":"Pakkenummer","fleetDelDriverComment":"Remarque du conducteur","fleetDelTimePlanned":"Planlagt","fleetDelTimeRouteDelay":"Forsinkelse","fleetDelTimeCalculated":"Beregnet","fleetDelTimeDeliveredClientSide":"Kvittert","fleetDelTimeDeliveredServerSide":"Mottatt","fleetDelCallLog":"Ringelogg","fleetDelCallLogDriver":"Sjåfør","delStatus0":"Non chargé","delStatus1":"Livré au client","delStatus2":"Livré à la porte","delStatus3":"Client non trouvé","delStatus4":"Produit manquant ","delStatus5":"Autre (produit)","delStatus6":"Chargé en voiture","delStatus7":"Client hors maison","delStatus8":"Produit cassé","delStatus9":"Autre (client)","delStatus10":"Le client ne recoit pas ","delStatus11":"Annulé","delStatus12":"Livré","delStatus13":"Récupérer ","delStatus14":"Delvis levert","customerModalHeaderEdit":"Modifier client","customerModalHeaderNew":"Nouveau client","customerModalConfirmDeleteHeader":"Effacer client","customerModalConfirmDeleteBody":"Etes-vous sûr de vouloir effacer ce client?","customerModalConfirmCancelHeader":"Annuler client","customerModalConfirmCancelBody":"Etes-vous sûr de vouloir annuler ce client?","customerModalChooseSupplier":"Saisir fournisseur","customerModalChangeAddress":"Modifier adresse","customerModalChangeRoutePlan":"Flytt til annen rute/plan","customerModalResetChangeRoutePlan":"Avbryt flytt","customerModalPlanLabel":"Flytt til plan","customerModalRouteLabel":"Flytt til rute","customerModalNewCustomerRouteLabel":"Plasser på rute","customerModalStopLabel":"Plasser etter","customerModalChooseFirstOnRoute":"Start","customerModalChooseSoon":"Vennligst vent...","customerModalChooseRoute":"- Velg rute -","customerModalChooseStop":"- Velg stopp kunden skal plasseres etter -","customerModalSave":"Enregistrer","customerName":"Nom","customerCO":"C/O","customerTimeWindowStart":"Livré au plus tôt 09:00","customerTimeWindowStop":"Livrer au plus tard 13:00","customerTimeFormatHelp":"Format temporel: 17:30 ou 1730","customerDuration":"Lev.tid (min)","customerPlaceInMap":"Plasser sur la carte","customerUndoCancelProduct":"Annuler","customerAddProduct":"Nouveau produit","customerDelete":"Effacer client","customerCancel":"Annuler client","customerParcels":"Coli ","planStatus_created":"Créé","planStatus_imported":"Information importée de Excel","planStatus_importing":"Importation de fichiers","planStatus_queued":"Venter på optimering (kø: %1)","planStatus_optimizing":"Optimisation en cours","planStatus_generating":"Itinéraires en calcul","planStatus_failed":"Optimisation échouée","planStatus_optimized":"Optimisé","planStatus_readyfordriverinput":"Avventer innspill fra sjåfører","planStatus_published":"Publié","planStatus_deleted":"Effacé","planStatus_routesimportqueued":"En attente d'instauration d'itinéraires ","planStatus_routesimporting":"En attente d'instauration d'itinéraires ","planStatus_routesimported":"Itinéraires créés","planCustomersOptimizeBtn":"Optimiser","planCustomersOptimizeTooBigWarning":"Planen er for stor for å kunne optimeres (maks %1 kunder)","planCustomersCreateRoutesBtn":"Crée %1 itinéraires","planCustomersFilterAll":"Tous les clients","planCustomersFilterMissingCoordinates":"Coordonnées manquantes","planCustomersFilterFiles":"Enregistrements","planCustomersFilterShowAllFiles":"Afficher tous les fichiers","fileStatus_error":"Chargement de fichier échoué ","fileStatus_uploading":"Chargement en cours","fileStatus_linking":"Recherche de coordinations en cours","fileStatus_done":"Importé","generalErrorHeader":"Veuillez nous excuser, un échec s'est produit","planFilesIndividual":"Livraisons individuelles","planFilesNewFileBtn":"Télécharger fichier","planFilesNewCustomerBtn":"Nouveau client","planFilesCardShowProducts":"Afficher les produits","planFilesCardShowCustomers":"Afficher les clients","planFilesIncompleteRowError":"Ligne%1 dans le fichier est incomplet","planFilesMissingPropertyNameError":"Le fichier manque une case obligatoire: %1.","planFilesInvalidPropertyLengthError":"Le fichier contient une colonne trop longue: %1.","planFilesDuplicateOrderLineIdError":"Dupliqué ORDER_LINE_ID: %1.","planFilesDuplicateParcelNumberError":"Duplikate PARCEL_NUMBER: %1.","planFilesUnknownHeaderError":"Le fichier contient des colonnes inconnues:%1.","planFilesUnknownFileTypeError":"Kan ikke kjenne igjen filtypen, sjekk dokumentasjonen","planFilesDatatypeError":"Valeur non validée \"%1\" dans la case: %2.","planFilesAddressLinkerError":"Adresseoppslaget feilet.","planFilesUnknownError":"Erreur inconnue","planFilesDeleteFile":"Effacer fichier","planFilesDeleteFileConfirm":"Etes-vous sûr de vouloir effacer tous les clients du fichier: \"%1\"?","fileModalHeader":"Ouvrir un fichier Excel/CSV","fileModalChooseCustomSystem":"Sélectionner système de clients","fileModalSameRouteAsLastTime":"Employer les mêmes itinéraires précédents","fileModalFormatHelp":"Aide pour formater du fichier","fileModalUploadBtn":"Télécharger","productsModalHeader":"Produits","optimizeModalHeaderOptimize":"Optimiser les itinéraires","optimizeModalHeaderCreateRoutes":"Créer des itinéraires","optimizeModalMissingCoordsWarning":"%1 adresses manquent des coordinations et ne peuvent pas se placer sur un itinéraire ","optimizeModalDate":"Date d'expédition ","optimizeModalClustering":"Mettre regroupement ","optimizeModalClusteringHelp":"Le regroupement fonctionne de telle facon à ce que l'optimisation va essayer de limiter l'espace sur lesquel se situe l'itinéraire, c'est à dire que les points sur l'itinéraire s'assemblent géographiquement. Cela peut avoir des conséquences sur le kilométrage optimal. ","optimizeModalTimeWindow":"Fenêtre temporelle pour les itinéraires","optimizeModalTimeWindowHelp":"Voici le cadre temporel pour les itinéraires. Mais l'heure de départ réelle pour chaque itinéraire est réglée par les demandes de la fenêtre temporelle. Veuillez donc choisir un temps de départ plus tôt que la première livraison de commande souhaitée.","optimizeModalTimeWindowStart":"Début","optimizeModalTimeWindowStop":"(Fin)","optimizeModalTimeWindowRequiredError":"Horaire de démarrage requis","optimizeModalTimeWindowFormatError":"Format temporel incorrect (17:30 ou 1730) ","optimizeModalTimeWindowInvalidError":"Espace temporel non valide ","optimizeModalPickupPointReturn":"Rendre au point de départ","optimizeModalPickupPointNew":"Rajouter un point de départ","optimizeModalPickupPoint":"Point de départ","optimizeModalPickupPoints":"Points de départ","optimizeModalPickupPointDelete":"Effacer point de départ","optimizeModalPickupPointDeleteBody":"Etes-vous sûr de vouloir effacer: %1","optimizeModalTimeWindowOutsideError":"<b class=\"warning\">Avertissement:</b> %1 clients ont une date limite hors de l'espace temporel selectionné","optimizeModalConfirmCreateRoutes":"Etes-vous sûr de vouloir créer %1 itinéraires?","optimizeModalConfirmOptimize":"Etes-vous sûr de vouloir optimiser?","optimizeModalSuggestedRoutes":"%1% des clients seront placés sur un itinéraire qui précède.","optimizeModalSuggestedRoutesShowCounts":"Afficher quantité par itinéraire (%1 itinéraires)","optimizeModalTraveller":"Sélectionner la véhicule","optimizeModalTraveller_car":"Voiture","optimizeModalTraveller_pedestrian":"En marchant ","optimizeRouteModalHeader":"Optimeringsvalg","optimizeRouteModalIntro":"Sett første stopp for å påvirke rutens retning (f.eks. motsatt av rushtrafikken). Sett siste stopp for f.eks. å få ruten til å ende opp nærmere sjåførens hjemsted.","optimizeRouteModalNoneSelected":"- Velg -","optimizeRouteModalFirstStopLabel":"Start med","optimizeRouteModalLastStopLabel":"Avslutt med","optimizeRouteModalBtn":"Optimer","suggestedRoutesModalHeader":"Itinéraires prêts à être mis en place","suggestedRoutesModalNotOnRoute":"Absent sur l'itinéraire","taggedAutoAssigned":"auto","taggedAutoAssignedPlan":"a","notificationSent":"Sendt","notificationMsg":"Melding","notificationMsgSimulation":"Melding (ikke sendt, kun simulert)","userHeader":"Brukeroversikt","driverUserHeader":"Administration du conducteur","driverUsersMobile":"Numéro de portable","driverUsersLastLoggedIn":"Dernièrement connecté","driverUsersFilterActive":"Actifs","driverUsersFilterInactive":"Inactifs","driverUsersNewDriverBtn":"Nouveau conducteur ","driverUsersLanguageReguiredError":"Du må velge språk","driverUsersUserNameTakenError":"Nom d'utilisateur pris ","driverUsersUserNameInvalidError":"Le nom d'utilisateur contient des caractères non valides. Employer seulement A-Z","driverUsersUserNameTooShortError":"Nom d'utilisateur trop court","driverUsersChooseLanguage":"- Sélectionner langue -","driverUsersInvalidPhoneError":"Numéro de téléphone non valide","driverUsersSendPasswordSMS":"Envoyer mot de passe par SMS à l'utilisateur","driverUsersSendNewPasswordSMS":"Envoyer nouveau mot de passe par SMS à l'utilisateur","driverUsersSentSMS":"(envoyé par SMS)","driverUsersActivate":"Activer l'utilisateur","driverUsersDeactivate":"Désactiver l'utilisateur","driverUsersHeaderEdit":"Modifier conducteur","driverUsersHeaderNew":"Nouveau conducteur ","moveModalHeader":"Déplacer","moveModalCancelled":"Arrêt annulé","moveModalMoveToRouteChoose":"Sélectionner itinéraire","moveModalMoveToRoute":"Déplacer à l'itinéraire","moveModalPlaceAfterChoose":"Sélectionner itinéraire d'abord","moveModalPlaceAfter":"Places après","moveModalPlaceAfterStart":"Début","moveModalPlaceAfterCancelled":"ANNULÉ:","moveModalLastStop":"(dernier arrêt)","moveModalNextStop":"Prochain arrêt","moveModalEditRoute":"Modifier itinéraire","moveModalCustomersSelected":"Vous avez sélectionné %1 clients","moveModalMultiTipTitle":"Conseils:","moveModalMultiTipDescription":"Maintenir les touches %1 et glisser la carte pour déplacer plusieurs à la fois","planRoutesStop":"Arrêter","planRoutesWeight":"Poid","planRoutesLength":"Durée","planRoutesDrivingDuration":"Durée de trajet","planRoutesTotalDuration":"Durée totale ","planRoutesAskForDriverInputBtn":"Send til sjåfører","planRoutesAskForDriverInputBtnConfirm":"Navn: %1<br>Dato: %2 (<b>%3 %4</b>)<br><br>Vil du oversende denne planen til sjåfører så de kan angi første og/eller siste levering?","planRoutesPublishBtn":"Publier","planRoutesPublishBtnConfirm":"Nom: %1<br>Dato: %2 (<b>%3 %4</b>)<br><br>Voulez-vous publier ce plan?","planRoutesOptimizeBtn":"Optimiser","planRoutesOptimizeAllBtn":"Optimiser tous","planRoutesAssigned":"Distribué","planRoutesCustomersPerHour":"KPT","planRoutesCustomersPerHourDescription":"Antall kunder pr. time","planRoutesStartDone":"Début-Fin","routeOptimStatus1":"En attente","routeOptimStatus2":"Optimisation en cours","routeOptimStatus3":"En attente","routeOptimStatus4":"Exportation en cours","routeOptimTooManyCustomers":"Il existe trop de clients...","planRoutesHeader":"Itinéraires","planRoutesReserveHeader":"Itinéraires de réserve ","planRoutesReserveSubTitle":"Itinéraires provisoires qui ne veulent pas être réutilisés/proposés à un client au prochain importation","planRoutesOptimizeWithTimeWindowFailedSameInterval":"Il manque suffisament d'espace pour tous les clients dans l'espace temporel %1. <br> Si dorénavant vous pensez que l'itinéraire est faisable, vous pourriez optimiser de nouveau. ","planRoutesOptimizeWithTimeWindowFailedMultipleIntervals":"Il manque suffisament d'espace pour tous les clients dans les espaces temporels convenus. Veuillez répartir quelques clients sur d'autres itinéraires.<br>PS: Vous pouvez seulement optimiser de nouveau si les client ont le même espace temporel.","planRoutesOptimizeWithoutTimeWindow":"Optimiser sans espace temporel","planRoutesMoveStop":"Déplacer à l'itinéraire","planRoutesMoveStops":"Déplacer %1 arrêt","planRoutesDeleteAllRoutes":"Effacer tous les itinéraires","planRoutesDeleteAllRoutesConfirm":"Etes-vous sûr de vouloir effacer tous les itinéraires?","planRoutesNewRouteBtn":"Nouvel itinéraire","planRoutesNewReserveRouteBtn":"Nouvel itinéraire de réserve","planRoutesBackToDashboardBtn":"Retour au dashboard","fleetPrintCount":"Montant","fleetPrinterName":"Skrevet ut av: %1","fleetPrinterInstructions":"Dette dokumentet inneholder personopplysninger og er konfidensiell informasjon. Dokumentet skal behandles etter gjeldende rutiner.","settingsAcknowledgementsTitle":"Kvitteringsregler","settingsAcknowledgementsForTitle":"Règles de reçus pour %1","settingsCompanyMissingCustomerSystems":"Aucun fournisseur n'a été configuré","settingsActionsTitle":"Confirmez la livraison","settingsPictureProof":"Photo nécessaire","settingsScanner":"Scanning nécessaire","settingsCanComment":"Remarque","settingsMiscTitle":"Divers","settingsMiscDescription":"Divers réglages en rapport avec l'affichage et la fonctionnalité dans l'app de conducteur.  ","settingsPermitLoadingMinutesBefore":"Lasteliste: %1 min før estimert start","settingsPermitStartingMinutesBefore":"Start: %1 min før estimert tid","settingsShowProductCount":"Afficher le nombre d'exemplaires ","settingsScanBeforeLoading":"Skann produkter inn på bil","settingsScanBeforeDelivery":"Skann produkter ved levering","settingsAdhocProducts":"Adhoc-produkter (sjåføren registrerer antall ifm. kvittering)","settingsAutoAssignDrivers":"Ruter vil automatisk bli tildelt samme sjåfør som sist","settingsAskForDriverInput":"Send til sjåfører for innspill før publisering","settingsActionsDescription":"Ici sont indiqués les touches de reçus parmi lesquelles le conducteur peut choisir.","settingsCustomerDeviationsTitle":"Déviation du client","settingsCustomerDeviationsDescription":"Les choix qui seront accessibles quand le chauffeur doit sélectionner la déviation pour un client.","settingsProductDeviationsTitle":"Déviation de produit","settingsProductDeviationsDescription":"Les choix qui seront accessibles quand le chauffeur doit sélectionner la déviation pour un seul produit/coli.","settingsCompanyNotificationsTitle":"Notifications pour chaque fournisseur ","settingsCustSysNotificationsTitle":"Notifications pour chaque entreprise de transport","settingsCompanyNotificationsDescription":"Des règles de notifications peuvent être mises en place pour chaque fournisseur. Des SMS sont envoyés au client final lors d'événements spécifiés. Notez que l'on peut d'abord simuler avant de choisir d'aller en direct avec de tels envois d'SMS. ","settingsCustSysNotificationsDescription":"Varslingsregler kan settes opp for hvert transportselskap. SMSer sendes til sluttkunde ved angitte hendelser. Merk at man kan først velge å simulere før man velger å gå live med slike SMS-utsendelser.","settingsCompanyNotificationsCol1":"Fournisseur ","settingsCustSysNotificationsCol1":"Entreprise de transport","settingsNotificationsColEvent":"Hendelse","settingsNotificationsCol4":"Message","settingsNotificationsCol5":"Statut","settingsNotificationsMinutesBefore":"Varsel %1 minutter før ankomst","settingsNotificationsActive":"Actif","settingsNotificationsSimulate":"Seule simulation ","settingsCompanyGeneralTitle":"Generelle innstillinger","settingsCompanyGeneralDescription":"Noen innstillinger er satt på transportselskapet, mens andre innstillinger følger kundesystemet som distribueres.","settingsCompanyGeneralCompanySectionTitle":"Innstillinger","settingsCompanyGeneralCustomerSystemsSectionTitle":"Innstillinger pr. kundesystem","settingsCompanyZipIntervalsTitle":"Temps de livraison pour %1","settingsCustSysZipIntervalsTitle":"Temps de livraison pour chaque entreprise de transport","settingsCompanyZipIntervalsDescription":"La durée de la livraison (c'est à dire depuis l'arrivée du véhicule). Notez: La durée de conduite entre chaque client compte évidemment en plus.","settingsCustSysZipIntervalsDescription":"Chaque entreprise de transport peut avoir des règles pour la durée de la la livraison (c'est à dire depuis l'arrivée du véhicule). Notez: La durée de conduite entre chaque client compte évidemment en plus.","settingsDISysWarningTitle":"Systemvarslinger","settingsDISysWarningDescription":"Her kan alle som har rollen DI sette systemvarslinger, om en eller begge av boksene ikke er krysset av vil den advarselen bli fjernet","settingsDISysWarningGeneral":"Generelle problemer/Ustabilitet","settingsDISysWarningDowntime":"Varsle om planlagt nedetid","settingsDISysDowntimeDuration":"Varighet","settingsDISaveSysWarning":"Lagre systemvarsel","settingsZipIntervalsColCompany":"Entreprise de transport","settingsZipIntervalsColCustomerSystem":"Kundesystem","settingsZipIntervalsColInterval":"Intervalle de code postal","settingsZipIntervalsColTime":"Temps de livraison","settingsMissingActions":"Aucune action configurée","settingsMissingCustomerDeviations":"Aucune configuration de déviation de client","settingsMissingProductDeviations":"Aucune configuration de déviation de produit","settingsMissingNotificationTypes":"Aucune configuration de règles d'avertissement ","settingsMissingZipIntervals":"Aucune configuration de commande de temps de livraison par intervalle de code postal","receivedComingSms":"Kunden er allerede varslet om at sjåfør kommer - Kan ikke flyttes","customerNotMoved":"Kunden har blitt oppdatert. Kunden har allerede fått SMS om at sjåfør kommer og kan derfor ikke flyttes.\n "}

/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = {"loginUsername":"Brukernavn","loginPassword":"Passord","loginLanguage":"Språk","loginForgot":"Glemt passord ?","loginHeader":"Logg inn","loginLoginBtn":"Logg inn","loginError":"Feil brukernavn eller passord","loginErrorAccountExpired":"Kontoen din er blitt deaktivert","loginErrorPasswordExpired":"Passordet ditt har utløpt, <a href=\"%1\">sett nytt passord</a>","loginErrorOnlyDriver":"Kun tilgang til sjåfør-applikasjonen","loginPasswordExpiresSoon":"Passordet ditt utløper om %1 dager, <a href=\"%2\">bytt passord nå</a>","loginPasswordExpiresTomorrow":"Passordet ditt utløper i dag, <a href=\"%1\">bytt passord nå</a>","pageDowntimePlanned":"Planlagt oppgradering av systemet inntreffer %1. Nedetid er forventet å vare i %2 minutter","pageDowntimeGeneral":"Vi opplever for tiden ustabilitet med systemet og arbeider med å få rettet opp dette. Beklager ulempene dette måtte medføre.","pageDistributions":"Distribusjoner","pageDistributionDeviations":"Avvik","pageDistributionRoutes":"Forsinkede ruter","pagePlans":"Planer","pageUsers":"Brukeroversikt","pageDrivers":"Sjåføradministrasjon","pageCustomers":"Kunder","pageRoutesMap":"Ruter","pageRoutesList":"Ruteliste","pageDashboardList":"Dashbord","pageDashboardMap":"Kart","pagePrint":"Utskrift","pageLogin":"Logg inn","pageLogout":"Logg ut","pageDocumentation":"Brukermanual","pageChangeLog":"Release notes","pageNewTicket":"Registrer ny supportsak","pageViewTickets":"Dine supportsaker","pageSettingsAcknowledgements":"Kvitteringsregler","pageSettingsNotifications":"Varslingsregler","pageSettingsDeliveryTimes":"Leveringstidregler","pageSettingsGeneral":"Generelle innstillinger","pageSettingsSystemWarnings":"Systemvarsler","pageDeviations":"Avviksbehandling","roleClient":"Kunde","roleClientPlus":"Kunde Pluss","roleCustomerService":"Kundeservice","roleFleetManager":"Flåtestyrer","rolePlanner":"Planlegger","rolePlannerPlus":"Planlegger Pluss","distributionsActive":"Aktive distribusjoner","distributionsHistoric":"Nylige distribusjoner","distributionAllPublished":"Alle %1 planer er publisert","distributionCountPublished":"%1 av %2 planer er publisert","distributionCompany":"Selskap","distributionDelayedRoutes":"Forsinkede ruter","distributionPlans":"Planer","distributionPlanName":"Navn","distributionShowPlan":"Vis plan","distributionNoRoutesFound":"Finner ingenting på \"%1\"...","distributionCustomerSearch":"Navn, adresse, mobil eller ordre","distributionRouteFilter":"Filtrér rutelisten","distributionDriverStop":"Forrige stopp","distributionNewDistributionBtn":"Opprett en ny distribusjon","distributionModalNew":"Ny distribusjon","distributionDeletePlan":"Slett","distrNo0":"Dag","distrNo1":"Natt","distrNo2":"Morgen","distrNo3":"Formiddag","distrNo4":"Ettermiddag","distrNo5":"Kveld","driverInfoDevice":"Modell","driverInfoDeviceOS":"OS","driverInfoDeviceAppVersion":"Versjon","plansActivePlans":"Aktive planer","plansHistoricPlans":"Nylige planer","plansCardOpen":"Åpne","plansNewPlanBtn":"Opprett en ny plan","plansGeoFencingBtn":"Geofencing","plansInvoiceDataBtn":"Fakturagrunnlag","plansCompanyDeliveriesDataBtn":"Antall (sist mnd)","planModalHeaderEdit":"Endre plan","planModalHeaderNew":"Ny plan","planModalName":"Navn (ikke påkrevd)","planDeletePlan":"Slett plan","planDeletePlanConfirm":"Er du sikker på at du vil slette planen:<br> %1?","cRoute":"Rute","cRoutes":"Ruter","cCustomer":"Kunde","cCustomers":"Kunder","cAddress":"Adresse","cProduct":"Produkt","cSupplier":"Leverandør","cCancel":"Avbryt","cCreate":"Opprett","cClose":"Lukk","cSave":"Lagre","cSearch":"Søk","cFirstName":"Fornavn","cLastName":"Etternavn","cUserName":"Brukernavn","cEmail":"Epost","fleetDashShowAllRoutes":"Vis alle ruter","fleetDashShowFullscreen":"Vis fullskjerm","fleetDashShowFullscreenExit":"Avslutt fullskjerm","fleetDashOverview":"Vis alle ruter","fleetDashRouteOverview":"Vis hele ruten","fleetDashDelayed":"Forsinket","fleetDashHandledCustomers":"Betjente kunder","fleetDashRemaining":"Gjenstående","fleetDashDeviation":"Avvik","fleetDashOutdatedApp":"%1 sjåfør(er) har utdatert app","fleetDashStatus":"Status","fleetDashAssign":"Tildel","fleetDashStatsRoutesBtn":"Ruter","fleetDashStatsCustomersBtn":"Kunder","fleetDashDriver":"Sjåfør","fleetDashFilter":"Filtrér kundelisten","fleetDashFilterAll":"Alle ruter","fleetDashFilterNotStarted":"Ikke startet","fleetDashFilterOngoing":"Pågående","fleetDashFilterDelayed":"Forsinket","fleetDashFilterReserve":"Reserveruter","fleetDashEditReserve":"Lag reserveruter","fleetDashWeight":"Vekt","progressRoutes":"Ruter","progressStop":"Stopp","progressCustomers":"Kunder","progressCancelled":"Kansellert","progressDelivered":"Levert","progressDeviation":"Avvik","progressCompleted":"Fullført","progressParcels":"Kolli","progressRemaining":"Gjenstående","progressTotal":"Totalt","statusNoGPS":"Ingen GPS","statusDone":"Ferdig","statusNotStarted":"Ikke startet","statusStarted":"Startet","statusEstimatedStart":"Est. start","statusEstimatedDone":"Est. ferdig","mapPickupPoint":"Startsted","routeModalHeaderEdit":"Oppdater rute","routeModalHeaderReserveEdit":"Oppdater reserverute","routeModalHeaderNew":"Ny rute","routeModalHeaderReserveNew":"Ny reserverute","routeModalChooseDriver":"Velg sjåfør","routeModalChoosePickupPoint":"Velg startsted","routeModalSave":"Lagre","routeModalPermitDriverComingSMS":"Tillat utsending av \"Sjåfør kommer\"-SMS","routeModalDeleteEmptyRoute":"Slett tom rute","routeModalRouteName":"Rutenavn","routeModalOverriddenStart":"Starttid (HH:MM)","routeModalOverriddenStartDayBefore":"Dagen før","routeModalReserveFetchCustomersLabel":"Overfør kunder fra annen rute (f.eks. avkjøring)","routeModalWreckInfo":"NB: Gjenstående kunder på \"%1\" vil nå få en SMS","routeModalReserveChooseRoute":"Velg rute","routeModalReserveAssignDelayInfo":"Vent med å tildele reserveruta til den er ferdig satt opp.","routeModalReserveRouteName":"Navn på reserverute","routeModalReserveOverriddenStart":"Foreløpig starttid (HH:MM)","routeModalAutoAssigned":"Ruten er automatisk tildelt sjåføren som hadde ruten forrige gang","addressHelperHint":"Skriv <em>,</em> og <em>Poststed</em>","addressHelperStreetName":"Gatenavn","addressHelperStreetNo":"Gatenr.","addressHelperZip":"Postnr.","addressHelperCity":"Poststed","addressHelperNoCoords":"Adressen mangler dessverre koordinater","fleetDelPrintBtn":"Utskrift","fleetDelAcknowledgementsBtn":"Kvitteringer","fleetDelDeviationsBtn":"Avvik","fleetDelFilterAll":"Alle kunder","fleetDelFilterRemaining":"Gjenstår","fleetDelFilterDelayed":"Forsinket","fleetDelFilterDeviations":"Avvik","fleetDelFilterCancelled":"Kansellert","fleetDelFilterPartiallyDelivered":"Delvis levert","fleetDelAllRoutes":"Alle ruter","fleetDelStop":"Stopp","fleetDelArrival":"Ankomst","customerPhone1":"Mobil","customerPhone2":"Alternativ telefon","customerOrder":"Ordre","customerDeadline":"Tidsfrist","customerDirective":"Leveringsanvisning","fleetDelAcknowledged":"Kvittert","fleetDelOrderLine":"Ordrelinje","fleetDelParcelNumber":"Pakkenummer","fleetDelDriverComment":"Kommentar fra sjåfør","fleetDelTimePlanned":"Planlagt","fleetDelTimeRouteDelay":"Forsinkelse","fleetDelTimeCalculated":"Beregnet","fleetDelTimeDeliveredClientSide":"Kvittert","fleetDelTimeDeliveredServerSide":"Mottatt","fleetDelCallLog":"Ringelogg","fleetDelCallLogDriver":"Sjåfør","delStatus0":"Ikke lastet","delStatus1":"Levert til kunde","delStatus2":"Levert på dør","delStatus3":"Finner ikke kunde","delStatus4":"Produkt mangler","delStatus5":"Annet (produkt)","delStatus6":"Lastet på bil","delStatus7":"Kunde er ikke hjemme","delStatus8":"Produkt ødelagt","delStatus9":"Annet (kunde)","delStatus10":"Kunde vil ikke motta","delStatus11":"Kansellert","delStatus12":"Levert","delStatus13":"Hentet","delStatus14":"Delvis levert","delStatus15":"Automatisk (geofence)","delStatus16":"Tapt i egen verdikjede","delStatus17":"Tapt før egen verdikjede","delStatus18":"Tapt/stjålet","delStatus19":"Mottaker har endret leveringssted","delStatus20":"Uegnet leveringssted","delStatus21":"Mangler nøkkel/kode","customerModalHeaderEdit":"Rediger kunde","customerModalHeaderNew":"Ny kunde","customerModalConfirmDeleteHeader":"Slett kunde","customerModalConfirmDeleteBody":"Er du sikker på at du vil slette denne kunden?","customerModalConfirmCancelHeader":"Kanseller kunde","customerModalConfirmCancelBody":"Er du sikker på at du vil kansellere denne kunden?","customerModalChooseSupplier":"Velg leverandør","customerModalChangeAddress":"Endre adresse","customerModalChangeRoutePlan":"Flytt til annen rute/plan","customerModalResetChangeRoutePlan":"Avbryt flytt","customerModalPlanLabel":"Flytt til plan","customerModalRouteLabel":"Flytt til rute","customerModalNewCustomerRouteLabel":"Plasser på rute","customerModalStopLabel":"Plasser etter","customerModalChooseFirstOnRoute":"Start","customerModalChooseSoon":"Vennligst vent...","customerModalChooseRoute":"- Velg rute -","customerModalChooseStop":"- Velg stopp kunden skal plasseres etter -","customerModalSave":"Lagre","customerName":"Navn","customerCO":"C/O","customerTimeWindowStart":"Lever tidligst 09:00","customerTimeWindowStop":"Lever senest 13:00","customerTimeFormatHelp":"Tidsformat: 17:30 eller 1730","customerDuration":"Lev.tid (min)","customerPlaceInMap":"Plasser i kart","customerUndoCancelProduct":"Angre","customerAddProduct":"Nytt produkt","customerDelete":"Slett kunde","customerCancel":"Kanseller kunde","customerParcels":"Kolli","planStatus_created":"Opprettet","planStatus_imported":"Importert data","planStatus_importing":"Fil importeres","planStatus_queued":"Venter på optimering (kø: %1)","planStatus_optimizing":"Optimering pågår","planStatus_generating":"Ruter kalkuleres","planStatus_failed":"Optimering feilet","planStatus_optimized":"Optimert","planStatus_readyfordriverinput":"Avventer innspill fra sjåfører","planStatus_published":"Publisert","planStatus_deleted":"Slettet","planStatus_routesimportqueued":"Venter på oppretting av ruter","planStatus_routesimporting":"Ruter under oppretting","planStatus_routesimported":"Ruter opprettet","planCustomersOptimizeBtn":"Optimer","planCustomersOptimizeTooBigWarning":"Planen er for stor for å kunne optimeres (maks %1 kunder)","planCustomersCreateRoutesBtn":"Lag %1 ruter","planCustomersBoundaryBoxMissingErrorHeader":"Geografi-avgrensning mangler","planCustomersBoundaryBoxMissingError":"Selskap mangler geografi-avgrensning, kontakt support","planCustomersBoundaryBoxOutsideErrorHeader":"Utenfor geografi-avgresning","planCustomersBoundaryBoxOutsideError":"Planen inneholder kunder som er plassert utenfor selskapets geografi-avgrensning, dvs. enten er det feil i kundefil eller så er selskapets satt med for avgrenset geografi. Kontakt support.","planCustomersRelocateUnbalancedErrorHeader":"Ubalansert plan for relokalisering","planCustomersRelocateUnbalancedError":"Antall opphentinger stemte ikke med antall utleveringer for planen. For å bruke den spesielle optimaliseringsmodusen 'relokalisering', må planen inneholde like mange opphentinger som utleveringer. Opphentinger angis med kolonnen PICKUP i importfilen.","planCustomersFilterAll":"Alle kunder","planCustomersFilterMissingCoordinates":"Mangler koordinater","planCustomersFilterFiles":"Opplastinger","planCustomersFilterShowAllFiles":"Vis alle filer","fileStatus_error":"Filopplasting feilet","fileStatus_uploading":"Lastes opp","fileStatus_linking":"Finner koordinater","fileStatus_done":"Importert","generalErrorHeader":"Vi beklager, noe gikk galt","planFilesIndividual":"Individuelle leveranser","planFilesNewFileBtn":"Last opp fil","planFilesNewCustomerBtn":"Ny kunde","planFilesCardShowProducts":"Vis produkter","planFilesCardShowCustomers":"Vis kunder","planFilesIncompleteRowError":"Linje %1 i filen er ufullstendig.","planFilesMissingPropertyNameError":"Filen mangler et obligatorisk felt: %1.","planFilesInvalidPropertyLengthError":"Filen har en kolonne som er for lang: %1.","planFilesDuplicateOrderLineIdError":"Duplikate ORDER_LINE_ID: %1.","planFilesDuplicateParcelNumberError":"Duplikate PARCEL_NUMBER: %1.","planFilesUnknownHeaderError":"Filen inneholder ukjente kolonner: %1.","planFilesUnknownFileTypeError":"Kan ikke kjenne igjen filtypen, sjekk dokumentasjonen","planFilesDatatypeError":"Ugyldig verdi \"%1\" i feltet: %2.","planFilesAddressLinkerError":"Adresseoppslaget feilet.","planFilesUnknownError":"Ukjent feil.","planFilesDeleteFile":"Slett fil","planFilesDeleteFileConfirm":"Er du sikker på at du vil slette alle kunder fra filen: \"%1\"?","fileModalHeader":"Last opp en Excel/CSV fil","fileModalChooseCustomSystem":"Velg kundesystem","fileModalSameRouteAsLastTime":"Bruk samme ruter som forrige gang","fileModalFormatHelp":"Hjelp til filformat","fileModalUploadBtn":"Last opp","productsModalHeader":"Produkter","optimizeModalHeaderOptimize":"Optimer ruter","optimizeModalHeaderCreateRoutes":"Lag ruter","optimizeModalMissingCoordsWarning":"%1 adresser mangler koordinater og vil ikke plasseres på en rute","optimizeModalDate":"Dato for utkjøring","optimizeModalOptionsHeader":"Optimeringsvalg","optimizeModalClustering":"Klustering av ordre","optimizeModalClusteringHelp":"Klustering innebærer at optimeringen vil forsøke å gjøre rutenes innbyrdes utstrekning mindre, dvs. at stopp i større grad vil samles geografisk. Dette kan gå på bekostning av optimal kjørelengde.","optimizeModalRelocate":"Relokalisering","optimizeModalRelocateHelp":"Relokalisering er en modus for å organisere forfytting av ressurser. Hent ressurser fra uønskede lokasjoner og plasser dem på mer egnede plasser. Krever at planen er balansert ift. opphentinger og utleveringer.","optimizeModalTypeChooser":"Velg optimeringskriterie:","optimizeModalTypeChooserTimeWindow":"Tidsrom","optimizeModalTypeChooserRouteCount":"Antall ruter","optimizeModalRouteCount":"Antall ruter","optimizeModalRouteCountCount":"Antall ruter","optimizeModalRouteCountStart":"Start tid","optimizeModalCapacityPerRoute":"Maks produkter","optimizeModalRouteCountCountRequiredError":"Antall ruter er påkrevd","optimizeModalTimeWindow":"Tidsvindu for rutene","optimizeModalTimeWindowHelp":"Dette er den ytre tidsrammen for rutene. Men faktisk starttid for hver rute overstyres uansett av ordrenes tidsvindu. Sett derfor en tidligere starttid enn første ønskede ordrelevering.","optimizeModalTimeWindowStart":"Start","optimizeModalTimeWindowStop":"(Slutt)","optimizeModalTimeWindowRequiredError":"Starttidspunkt er påkrevd","optimizeModalTimeWindowFormatError":"Feil tidsformat (17:30 eller 1730)","optimizeModalTimeWindowInvalidError":"Ugyldig tidsrom","optimizeModalPickupPointReturn":"Returner til startsted","optimizeModalPickupPointNew":"Legg til enda et startsted","optimizeModalPickupPoint":"Startsted","optimizeModalPickupPoints":"Startsteder","optimizeModalPickupPointDelete":"Slett startsted","optimizeModalPickupPointDeleteBody":"Er du sikker på at du vil slette: %1","optimizeModalTimeWindowOutsideError":"<b class=\"warning\">Advarsel:</b> %1 kunder har tidsfrist utenfor det angitte tidsrommet. ","optimizeModalConfirmCreateRoutes":"Er du sikker på at du vil lage %1 ruter?","optimizeModalConfirmOptimize":"Er du sikker på at du vil optimere?","optimizeModalSuggestedRoutes":"%1% av kundene vil plasseres på en tidligere rute.","optimizeModalSuggestedRoutesShowCounts":"Vis antall pr. rute (%1 ruter)","optimizeModalTraveller":"Velg kjøretøy","optimizeModalTraveller_car":"Bil","optimizeModalTraveller_pedestrian":"Gående","optimizeRouteModalHeader":"Optimeringsvalg","optimizeRouteModalIntro":"Sett første stopp for å påvirke rutens retning (f.eks. motsatt av rushtrafikken). Sett siste stopp for f.eks. å få ruten til å ende opp nærmere sjåførens hjemsted.","optimizeRouteModalNoneSelected":"- Velg -","optimizeRouteModalFirstStopLabel":"Start med","optimizeRouteModalLastStopLabel":"Avslutt med","optimizeRouteModalBtn":"Optimer","suggestedRoutesModalHeader":"Ruter som vil opprettes","suggestedRoutesModalNotOnRoute":"Ikke på rute","taggedAutoAssigned":"auto","taggedAutoAssignedPlan":"a","notificationSent":"Sendt","notificationMsg":"Mal","notificationMsgSimulation":"Mal (ikke sendt, kun simulert)","userHeader":"Brukeroversikt","driverUserHeader":"Sjåføradministrasjon","driverUsersMobile":"Mobil","driverUsersLastLoggedIn":"Sist innlogget","driverUsersFilterActive":"Aktive","driverUsersFilterInactive":"Inaktive","driverUsersNewDriverBtn":"Ny sjåfør","driverUsersLanguageReguiredError":"Du må velge språk","driverUsersUserNameTakenError":"Brukernavnet er opptatt","driverUsersUserNameInvalidError":"Brukernavnet har ugyldige tegn. Bruk kun A-Z","driverUsersUserNameTooShortError":"Brukernavnet er for kort","driverUsersChooseLanguage":"- Velg språk -","driverUsersInvalidPhoneError":"Ikke gyldig telefonnummer","driverUsersSendPasswordSMS":"Send bruker passord på SMS","driverUsersSendNewPasswordSMS":"Send bruker nytt passord på SMS","driverUsersSentSMS":"(sendt på SMS)","driverUsersActivate":"Aktiver bruker","driverUsersDeactivate":"Deaktiver bruker","driverUsersHeaderEdit":"Rediger sjåfør","driverUsersHeaderNew":"Ny sjåfør","moveModalHeader":"Flytt","moveModalCancelled":"Stopp kansellert","moveModalMoveToRouteChoose":"Velg rute","moveModalMoveToRoute":"Flytt til rute","moveModalPlaceAfterChoose":"Velg rute først","moveModalPlaceAfter":"Plasser etter","moveModalPlaceAfterStart":"Start","moveModalPlaceAfterCancelled":"KANSELLERT: ","moveModalLastStop":"(siste stopp)","moveModalNextStop":"Neste stopp","moveModalEditRoute":"Rediger rute","moveModalCustomersSelected":"Du har valgt %1 kunder","moveModalMultiTipTitle":"Tips:","moveModalMultiTipDescription":"Hold %1-tasten inne og dra i kartet for å flytte mange på én gang","planRoutesStop":"Stopp","planRoutesWeight":"Vekt","planRoutesLength":"Lengde","planRoutesDrivingDuration":"Kjøretid","planRoutesTotalDuration":"Totaltid","planRoutesAskForDriverInputBtn":"Send til sjåfører","planRoutesAskForDriverInputBtnConfirm":"Navn: %1<br>Dato: %2 (<b>%3 %4</b>)<br><br>Vil du oversende denne planen til sjåfører så de kan angi første og/eller siste levering?","planRoutesPublishBtn":"Publiser","planRoutesPublishBtnConfirm":"Navn: %1<br>Dato: %2 (<b>%3 %4</b>)<br><br>Vil du publisere denne planen?","planRoutesUnpublishBtn":"Avpubliser","planRoutesUnpublishBtnConfirm":"Navn: %1<br>Dato: %2<br><br>Er du sikker på at du vil avpublisere denne planen?","planRoutesOptimizeBtn":"Optimer","planRoutesOptimizeAllBtn":"Optimer alle","planRoutesAssigned":"Tildelt","planRoutesCustomersPerHour":"KPT","planRoutesCustomersPerHourDescription":"Antall kunder pr. time","planRoutesStartDone":"Start-Ferdig","routeOptimStatus1":"Venter","routeOptimStatus2":"Optimeres","routeOptimStatus3":"Venter","routeOptimStatus4":"Eksporteres","routeOptimTooManyCustomers":"For mange kunder...","planRoutesHeader":"Ruter","planRoutesReserveHeader":"Reserveruter","planRoutesReserveSubTitle":"Midlertidige ruter som ikke vil gjenbrukes/foreslås for en kunde ved neste import","planRoutesOptimizeWithTimeWindowFailedSameInterval":"Vi klarte ikke å få plass til alle kundene i tidsrommet %1. <br>Dersom du likevel mener ruten er gjennomførbar, kan du optimere igjen.","planRoutesOptimizeWithTimeWindowFailedMultipleIntervals":"Vi klarte ikke å få på plass alle kundene i de avtalte tidsrommene. Vennligst fordel noen kunder på andre ruter.<br>PS: Du kan kun optimalisere på nytt dersom alle kundene har likt tidsrom.","planRoutesOptimizeWithoutTimeWindow":"Optimer uten tidsrom","planRoutesMoveStop":"Flytt til rute","planRoutesMoveStops":"Flytt %1 stopp","planRoutesDeleteAllRoutes":"Slett alle ruter","planRoutesDeleteAllRoutesConfirm":"Er du sikker på at du vil slette alle ruter?","planRoutesNewRouteBtn":"Ny rute","planRoutesNewReserveRouteBtn":"Ny reserverute","planRoutesBackToDashboardBtn":"Tilbake til dashboard","fleetPrintCount":"Antall","fleetPrinterName":"Skrevet ut av: %1","fleetPrinterInstructions":"Dette dokumentet inneholder personopplysninger og er konfidensiell informasjon. Dokumentet skal behandles etter gjeldende rutiner.","settingsAcknowledgementsTitle":"Kvitteringsregler","settingsAcknowledgementsForTitle":"Kvitteringsregler for %1","settingsCompanyMissingCustomerSystems":"Ingen leverandører er konfigurert","settingsActionsTitle":"Bekreft levert","settingsPictureProof":"Må ta bilde","settingsScanner":"Må skannes","settingsCanComment":"Kommentar","settingsMiscTitle":"Diverse","settingsMiscDescription":"Ulike innstillinger ift. visning og funksjonalitet i sjåfør-app.","settingsPermitLoadingMinutesBefore":"Lasteliste: %1 min før estimert start","settingsPermitStartingMinutesBefore":"Start: %1 min før estimert tid","settingsShowProductCount":"Vis eksemplarantall","settingsScanBeforeLoading":"Skann produkter inn på bil","settingsScanBeforeDelivery":"Skann produkter ved levering","settingsAdhocProducts":"Adhoc-produkter (sjåføren registrerer antall ifm. kvittering)","settingsAutoAssignDrivers":"Ruter vil automatisk bli tildelt samme sjåfør som sist","settingsAskForDriverInput":"Send til sjåfører for innspill før publisering","settingsAutoConfirmOnExit":"Automatisk kvittering ved avreise fra stopp (geofence)","settingsHandleDeviations":"Avviksbehandling","settingsSendEventsToFlow":"Send hendelser til DI Flow (ifm. sporing)","settingsSendEventsToTransport":"Send hendelser til DI Transport (ifm. varsling til bud)","settingsShowTraveller":"Vis flere kjøretøysvalg (ifm. optimer/lag ruter)","settingsActionsDescription":"Her vises hvilke kvitteringsknapper som sjåfør kan velge fra.","settingsCustomerDeviationsTitle":"Kundeavvik","settingsCustomerDeviationsDescription":"Valgene som vil være tilgjengelig når sjåfør skal velge avvik for en kunde.","settingsProductDeviationsTitle":"Produktavvik","settingsProductDeviationsDescription":"Valgene som vil være tilgjengelig når sjåfør skal velge avvik for et enkelt produkt/kolli.","settingsCompanyNotificationsTitle":"Varslinger for hver leverandør","settingsCustSysNotificationsTitle":"Varslinger for hvert transportselskap","settingsCompanyNotificationsDescription":"Varslingsregler kan settes opp for hver leverandør. SMSer sendes til sluttkunde ved angitte hendelser. Merk at man kan først velge å simulere før man velger å gå live med slike SMS-utsendelser.","settingsCustSysNotificationsDescription":"Varslingsregler kan settes opp for hvert transportselskap. SMSer sendes til sluttkunde ved angitte hendelser. Merk at man kan først velge å simulere før man velger å gå live med slike SMS-utsendelser.","settingsCompanyNotificationsCol1":"Leverandør","settingsCustSysNotificationsCol1":"Transportselskap","settingsNotificationsColEvent":"Hendelse","settingsNotificationsCol4":"Mal","settingsNotificationsCol5":"Status","settingsNotificationsMinutesBefore":"Varsel %1 minutter før ankomst","settingsNotificationsActive":"Aktiv","settingsNotificationsSimulate":"Kun simulering","settingsCompanyGeneralTitle":"Generelle innstillinger","settingsCompanyGeneralDescription":"Noen innstillinger er satt på transportselskapet, mens andre innstillinger følger kundesystemet som distribueres.","settingsCompanyBoundaryBoxMissing":"Selskapet MANGLER geografiavgrensning, kontakt support","settingsCompanyBoundaryBoxLink":"Vis selskapets geografiavgrensning","settingsCompanyGeneralCompanySectionTitle":"Innstillinger","settingsCompanyGeneralCustomerSystemsSectionTitle":"Innstillinger pr. kundesystem","settingsCustSysGeneralTitle":"Generelle innstillinger","settingsCompanyZipIntervalsTitle":"Leveringstider for %1","settingsCustSysZipIntervalsTitle":"Leveringstider for hvert transportselskap","settingsCompanyZipIntervalsDescription":"Hvor lang tid man skal bruke på selve leveringen (dvs. fra man har ankommet med bilen). Merk at kjøretiden mellom hver kunde kommer selvsagt i tillegg.","settingsCustSysZipIntervalsDescription":"Hvert transportselskap kan ha regler for hvor lang tid man skal bruke på selve leveringen (dvs. fra man har ankommet med bilen). Merk at kjøretiden mellom hver kunde kommer selvsagt i tillegg.","settingsDISysWarningTitle":"Systemvarslinger","settingsDISysWarningDescription":"Her kan alle som har rollen DI sette systemvarslinger, om en eller begge av boksene ikke er krysset av vil den advarselen bli fjernet","settingsDISysWarningGeneral":"Generelle problemer/Ustabilitet","settingsDISysWarningDowntime":"Varsle om planlagt nedetid","settingsDISysDowntimeDuration":"Varighet","settingsDISaveSysWarning":"Lagre systemvarsel","settingsZipIntervalsColCompany":"Transportselskap","settingsZipIntervalsColCustomerSystem":"Kundesystem","settingsZipIntervalsColInterval":"Postnummerintervall","settingsZipIntervalsColTime":"Leveringstid","settingsMissingActions":"Ingen handlinger konfigurert","settingsMissingCustomerDeviations":"Ingen kundeavvik konfigurert","settingsMissingProductDeviations":"Ingen produktavvik konfigurert","settingsMissingNotificationTypes":"Ingen notifikasjonsregler konfigurert","settingsMissingZipIntervals":"Ingen overstyringer av leveringstid pr. postnummerintervall konfigurert","receivedComingSms":"Kunden er allerede varslet om at sjåfør kommer - Kan ikke flyttes","customerNotMoved":"Kunden har blitt oppdatert. Kunden har allerede fått SMS om at sjåfør kommer og kan derfor ikke flyttes.\n ","distributionShowRouteMap":"Vis kart","distributionShowRouteCustomers":"Vis kunder","distributionShowRouteCustomer":"Vis kunde","distributionShowCustomers":"Vis kunder på plan"}

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports = {"loginUsername":"Användarnamn","loginPassword":"Lösenord","loginLanguage":"Språk","loginForgot":"Glömt lösenord?","loginHeader":"Logga in","loginLoginBtn":"Logga in","loginError":"Fel användarnamn eller lösenord","loginErrorAccountExpired":"Ditt konto har inaktiverats","loginErrorPasswordExpired":"Lösenordet har gått ut, <a href=\"%1\"> sätt nytt lösenord</a>","loginErrorOnlyDriver":"Kun tilgang til sjåfør-applikasjonen","loginPasswordExpiresSoon":"Ditt lösenord går ut om %1 dagar,<a href=\"%2\">byta lösenord nu</a>","loginPasswordExpiresTomorrow":"Ditt lösenord går ut i dag,<a href=\"%1\">byt lösenord nu</a>","pageDowntimePlanned":"Schemalagda systemuppgraderingar inträffar %1.  Driftstopp väntas pågå i %2 minuter","pageDowntimeGeneral":"Vi upplever för närvarande instabilitet med systemet och arbetar för att åtgärda detta. Vi ber om ursäkt för eventuella olägenheter det kan skapa för er.","pageDistributions":"Distributioner","pageDistributionDeviations":"Avvikelse","pageDistributionRoutes":"Försenade distrikt","pagePlans":"Planer","pageUsers":"Användaröversikt","pageDrivers":"Chaufföradministration","pageCustomers":"Kunder","pageRoutesMap":"Distrikt","pageRoutesList":"Distriktliste","pageDashboardList":"Dashboard","pageDashboardMap":"Karta","pagePrint":"Utskrift","pageLogin":"Logga in","pageLogout":"Logga ut","pageDocumentation":"Användarmanual","pageChangeLog":"Release notes","pageNewTicket":"Registrera ny supportärende","pageViewTickets":"Dina supportärenden  ","pageSettingsAcknowledgements":"Kvittoregler","pageSettingsNotifications":"Varselregler","pageSettingsDeliveryTimes":"Leveranstidregler","pageSettingsGeneral":"Allmänna inställningar","pageSettingsSystemWarnings":"Systemvarningar","pageDeviations":"Avvikelsehantering","roleClient":"Kund","roleClientPlus":"Kund Plus","roleCustomerService":"Kundtjänst","roleFleetManager":"Flottansvarig","rolePlanner":"Planerar","rolePlannerPlus":"Planerar Plus","distributionsActive":"Aktiva distributioner","distributionsHistoric":"Senaste distributioner","distributionAllPublished":"Alla %1 planer har publicerats","distributionCountPublished":"%1 av %2 planer har publicerats","distributionCompany":"Bolag","distributionDelayedRoutes":"Försenade distrikt","distributionPlans":"Planer","distributionPlanName":"Namn","distributionShowPlan":"Visa plan","distributionNoRoutesFound":"Hittar inget på \"%1\"...","distributionCustomerSearch":"Namn, adress, mobil eller beställning","distributionRouteFilter":"Filtrera distriktlistan","distributionDriverStop":"Föregående stopp","distributionNewDistributionBtn":"Skapa ny distribution","distributionModalNew":"Ny distribution","distributionDeletePlan":"Ta bort","distrNo0":"Dag","distrNo1":"Natt","distrNo2":"Morgon","distrNo3":"Förmiddag","distrNo4":"Eftermiddag","distrNo5":"Kväll","driverInfoDevice":"Modell","driverInfoDeviceOS":"OS","driverInfoDeviceAppVersion":"Version","plansActivePlans":"Aktiva planer","plansHistoricPlans":"Senaste planer","plansCardOpen":"Öppna","plansNewPlanBtn":"Skapa ny plan","plansGeoFencingBtn":"Geofencing","plansInvoiceDataBtn":"Fakturaunderlag","plansCompanyDeliveriesDataBtn":"Antall (sist mnd)","planModalHeaderEdit":"Ändra plan","planModalHeaderNew":"Ny plan","planModalName":"Namn (krävs inte)","planDeletePlan":"Ta bort plan","planDeletePlanConfirm":"Är du säker på att du vill ta bort denna planen:<br> %1?","cRoute":"Distrikt","cRoutes":"Distrikt","cCustomer":"Kund","cCustomers":"Kunder","cAddress":"Adress","cProduct":"Produkt","cSupplier":"Leverantör ","cCancel":"Avbryt","cCreate":"Skapa","cClose":"Stäng","cSave":"Spara","cSearch":"Sök","cFirstName":"Förnamn","cLastName":"Efternamn","cUserName":"Användarnamn","cEmail":"Epost","fleetDashShowAllRoutes":"Visa alla distrikt","fleetDashShowFullscreen":"Visa helskärm","fleetDashShowFullscreenExit":"Avsluta helskärm","fleetDashOverview":"Visa alla distrikt","fleetDashRouteOverview":"Visa hela distriktet","fleetDashDelayed":"Försenad","fleetDashHandledCustomers":"Betjänade kunder","fleetDashRemaining":"Återstående","fleetDashDeviation":"Avvikelse","fleetDashOutdatedApp":"%1 chaufför(er) behöver uppdatera appen","fleetDashStatus":"Status","fleetDashAssign":"Tilldela","fleetDashStatsRoutesBtn":"Distrikt","fleetDashStatsCustomersBtn":"Kunder","fleetDashDriver":"Chaufför","fleetDashFilter":"Filtrera kundlistan","fleetDashFilterAll":"Alla distrikt","fleetDashFilterNotStarted":"Inte startat","fleetDashFilterOngoing":"Pågående","fleetDashFilterDelayed":"Försenad","fleetDashFilterReserve":"Reservdistrikt","fleetDashEditReserve":"Skapa reservdistrikt","fleetDashWeight":"Vikt","progressRoutes":"Distrikt","progressStop":"Stopp","progressCustomers":"Kunder","progressCancelled":"Avbruten","progressDelivered":"Levererad","progressDeviation":"Avvikelse","progressCompleted":"Avslutade","progressParcels":"Kolli","progressRemaining":"Återstående","progressTotal":"Totalt","statusNoGPS":"Ingen GPS","statusDone":"Färdig","statusNotStarted":"Inte startat","statusStarted":"Startat","statusEstimatedStart":"Beräknad start","statusEstimatedDone":"Beräknad klar","mapPickupPoint":"Startplats","routeModalHeaderEdit":"Uppdatera distrikt","routeModalHeaderReserveEdit":"Uppdatera reservdistrikt","routeModalHeaderNew":"Nytt distrikt","routeModalHeaderReserveNew":"Nytt reservdistrikt","routeModalChooseDriver":"Välj chaufför","routeModalChoosePickupPoint":"Välj startplats","routeModalSave":"Spara","routeModalPermitDriverComingSMS":"Tillåt sändning av \"chaufför kommer\"-SMS","routeModalDeleteEmptyRoute":"Ta bort tomt distrikt","routeModalRouteName":"Distriktsnamn","routeModalOverriddenStart":"Starttid (HH:MM)","routeModalOverriddenStartDayBefore":"Dagen före","routeModalReserveFetchCustomersLabel":"Överför kunder från ett annat distrikt (t.ex avkörning)","routeModalWreckInfo":"OBS: Återstående kunder på \"%1\" kommer nu att få ett SMS","routeModalReserveChooseRoute":"Välj distrikt","routeModalReserveAssignDelayInfo":"Vänta med att tilldela reservdistriktet tills planen är färdig.","routeModalReserveRouteName":"Namn på reservdistrikt","routeModalReserveOverriddenStart":"Planlagd starttid (HH:MM)","routeModalAutoAssigned":"Distriktet tilldelas automatiskt till chauffören som senast hade distriktet ","addressHelperHint":"Skriv <em>,</em> och <em>Poststed</em>","addressHelperStreetName":"Gatunamn","addressHelperStreetNo":"Gatunr.","addressHelperZip":"Postnr.","addressHelperCity":"Postort","addressHelperNoCoords":"Adressen saknar tyvärr koordinater","fleetDelPrintBtn":"Utskrift","fleetDelAcknowledgementsBtn":"Kvitto","fleetDelDeviationsBtn":"Avvikelse","fleetDelFilterAll":"Alla kunder","fleetDelFilterRemaining":"Återstår","fleetDelFilterDelayed":"Försenad","fleetDelFilterDeviations":"Avvikelse","fleetDelFilterCancelled":"Avbeställt","fleetDelFilterPartiallyDelivered":"Delvis levererad","fleetDelAllRoutes":"Alla distrikt","fleetDelStop":"Stopp","fleetDelArrival":"Ankomst","customerPhone1":"Mobil","customerPhone2":"Alternativ telefon","customerOrder":"Order","customerDeadline":"Tidsfrist","customerDirective":"Leveransinstruktioner","fleetDelAcknowledged":"Kvitterat","fleetDelOrderLine":"Orderrad","fleetDelParcelNumber":"Paketnummer","fleetDelDriverComment":"Kommentar från chaufför","fleetDelTimePlanned":"Planlagt","fleetDelTimeRouteDelay":"Forsinkelse","fleetDelTimeCalculated":"Beregnet","fleetDelTimeDeliveredClientSide":"Kvittert","fleetDelTimeDeliveredServerSide":"Mottatt","fleetDelCallLog":"Ringelogg","fleetDelCallLogDriver":"Sjåfør","delStatus0":"Inte lastat upp","delStatus1":"Levererat till kund","delStatus2":"Levererat på dörr","delStatus3":"Hittar inte kund","delStatus4":"Produkt saknas","delStatus5":"Annat (produkt)","delStatus6":"Lastade på bil","delStatus7":"Kund är inte hemma","delStatus8":"Produkten förstörd","delStatus9":"Annat (kund)","delStatus10":"Kund vil inte ta imot","delStatus11":"Avbruten","delStatus12":"Levererat","delStatus13":"Hämtat","delStatus14":"Delvis levererad","delStatus15":"Automatisk (geofence)","delStatus16":"Tapt i egen verdikjede","delStatus17":"Tapt før egen verdikjede","delStatus18":"Tapt/stjålet","delStatus19":"Mottaker har endret leveringssted","delStatus20":"Uegnet leveringssted","delStatus21":"Mangler nøkkel/kode","customerModalHeaderEdit":"Redigera kund","customerModalHeaderNew":"Ny kund","customerModalConfirmDeleteHeader":"Ta bort kund","customerModalConfirmDeleteBody":"Är du säker på att du vill ta bort denna kund?","customerModalConfirmCancelHeader":"Avbeställ kund","customerModalConfirmCancelBody":"Är du säker på att du vill anullera denna kund?","customerModalChooseSupplier":"Välj leverantör ","customerModalChangeAddress":"Ändra adress","customerModalChangeRoutePlan":"Flytta till annan distrikt/plan","customerModalResetChangeRoutePlan":"Avbryt flytt","customerModalPlanLabel":"Flytta till plan","customerModalRouteLabel":"Flytta till distrikt","customerModalNewCustomerRouteLabel":"Placera på distrikt","customerModalStopLabel":"Placera efter","customerModalChooseFirstOnRoute":"Starta","customerModalChooseSoon":"Vänligen vänta...","customerModalChooseRoute":"- Välj distrikt -","customerModalChooseStop":"- Välj vilket stopp kunden ska placeras efter - ","customerModalSave":"Spara","customerName":"Namn","customerCO":"C/O","customerTimeWindowStart":"Leverera tidigast 09:00","customerTimeWindowStop":"Leverera senast kl 13:00","customerTimeFormatHelp":"Tidsformat: 17:30 eller 1730","customerDuration":"Lev.tid (min)","customerPlaceInMap":"Placera på karta","customerUndoCancelProduct":"Ångra","customerAddProduct":"Ny produkt","customerDelete":"Ta bort kund","customerCancel":"Avbeställ kund","customerParcels":"Kolli","planStatus_created":"Skapad ","planStatus_imported":"Importerat data","planStatus_importing":"Fil importeras","planStatus_queued":"Väntar på optimering (kö: %1)","planStatus_optimizing":"Optimering pågår","planStatus_generating":"Distrikt beräknas","planStatus_failed":"Optimering misslyckades","planStatus_optimized":"Optimerad","planStatus_readyfordriverinput":"Klar for inmatning från chaufförer","planStatus_published":"Publicerat","planStatus_deleted":"Borttaget","planStatus_routesimportqueued":"Väntar på att distrikt ska skapas","planStatus_routesimporting":"Distrikt genereras","planStatus_routesimported":"Distrikt skapat","planCustomersOptimizeBtn":"Optimera","planCustomersOptimizeTooBigWarning":"Planen är för stor för att optimeras (max %1 kunder)","planCustomersCreateRoutesBtn":"Skapa %1 distrikt","planCustomersBoundaryBoxMissingErrorHeader":"Geografi-avgrensning mangler","planCustomersBoundaryBoxMissingError":"Selskap mangler geografi-avgrensning, kontakt support","planCustomersBoundaryBoxOutsideErrorHeader":"Utenfor geografi-avgresning","planCustomersBoundaryBoxOutsideError":"Planen inneholder kunder som er plassert utenfor selskapets geografi-avgrensning, dvs. enten er det feil i kundefil eller så er selskapets satt med for avgrenset geografi. Kontakt support.","planCustomersRelocateUnbalancedErrorHeader":"Ubalansert plan for relokalisering","planCustomersRelocateUnbalancedError":"Antall opphentinger stemte ikke med antall utleveringer for planen. For å bruke den spesielle optimaliseringsmodusen 'relokalisering', må planen inneholde like mange opphentinger som utleveringer. Opphentinger angis med kolonnen PICKUP i importfilen.","planCustomersFilterAll":"Alla kunder","planCustomersFilterMissingCoordinates":"Koordinat saknas","planCustomersFilterFiles":"Uppladdningar","planCustomersFilterShowAllFiles":"Visa alla filerna","fileStatus_error":"Filuppladdningen misslyckades","fileStatus_uploading":"Laddas upp","fileStatus_linking":"Hittar koordinat","fileStatus_done":"Importerat","generalErrorHeader":"Tyvärr,  något gick fel","planFilesIndividual":"Individuella leveranser","planFilesNewFileBtn":"Ladda upp fil","planFilesNewCustomerBtn":"Ny kund","planFilesCardShowProducts":"Visa produkter","planFilesCardShowCustomers":"Visa kunder","planFilesIncompleteRowError":"Linje %1 i filen är ofullständig.","planFilesMissingPropertyNameError":"Filen saknar ett obligatoriskt fält: %1.","planFilesInvalidPropertyLengthError":"Filen har en kolumn som är för lång: %1.","planFilesDuplicateOrderLineIdError":"Duplicerad ORDER_LINE_ID: %1.","planFilesDuplicateParcelNumberError":"Duplikata PARCEL_NUMBER: %1.","planFilesUnknownHeaderError":"Filen innehåller okända kolonner: %1.","planFilesUnknownFileTypeError":"Känner inte igen filtypen. Jämför med dokumentationen.","planFilesDatatypeError":"Ogiltigt värde \"%1\" i fält %2.","planFilesAddressLinkerError":"Adresseoppslaget feilet.","planFilesUnknownError":"Okänt fel","planFilesDeleteFile":"Ta bort fil","planFilesDeleteFileConfirm":"Är du säker på att du vill ta bort alla kunder från fil: \"%1\"?","fileModalHeader":"Ladda upp en Excel/CSV fil","fileModalChooseCustomSystem":"Välj kundsystem","fileModalSameRouteAsLastTime":"Använd samma distrikt som förra gången","fileModalFormatHelp":"Hjälp till filformat","fileModalUploadBtn":"Ladda upp","productsModalHeader":"Produkter","optimizeModalHeaderOptimize":"Optimera distrikt","optimizeModalHeaderCreateRoutes":"Skapa distrikt","optimizeModalMissingCoordsWarning":"%1 adresser saknar koordinater och vill inte plasseras på ett distrikt","optimizeModalDate":"Datum för utkörning","optimizeModalOptionsHeader":"Optimeringsval","optimizeModalClustering":"Klustring av order","optimizeModalClusteringHelp":"Klustring innebär att optimaliseringen försöker minska distriktens inbördes geografiska utsträckning, dvs att stopp i större grad samlas geografiskt. Detta kan gå på bekostning av optimal körlängd.","optimizeModalRelocate":"Relokalisering","optimizeModalRelocateHelp":"Relokalisering er en modus for å organisere forfytting av ressurser. Hent ressurser fra uønskede lokasjoner og plasser dem på mer egnede plasser. Krever at planen er balansert ift. opphentinger og utleveringer.","optimizeModalTypeChooser":"Velg optimeringskriterie:","optimizeModalTypeChooserTimeWindow":"Tidsrom","optimizeModalTypeChooserRouteCount":"Antall ruter","optimizeModalRouteCount":"Antall ruter","optimizeModalRouteCountCount":"Antall ruter","optimizeModalRouteCountStart":"Start tid","optimizeModalCapacityPerRoute":"Max produkter","optimizeModalRouteCountCountRequiredError":"Antall ruter er påkrevd","optimizeModalTimeWindow":"Tidsfönster för distrikt","optimizeModalTimeWindowHelp":"Detta är den yttre tidsramen för distrikten. Den faktiska starttiden för varje distrikt överstyrs oavsett av ordrens tidsfönster. Sätt därför en tidigare starttid än första önskade orderleverans.","optimizeModalTimeWindowStart":"Start","optimizeModalTimeWindowStop":"(Slut)","optimizeModalTimeWindowRequiredError":"Starttid krävs","optimizeModalTimeWindowFormatError":"Fel tidsformat (17:30 eller 1730)","optimizeModalTimeWindowInvalidError":"Ogiltig tidsintervall","optimizeModalPickupPointReturn":"Retur till startplats","optimizeModalPickupPointNew":"Lägg till ytterligare startställe","optimizeModalPickupPoint":"Startplats","optimizeModalPickupPoints":"Startplats","optimizeModalPickupPointDelete":"Ta bort startplats","optimizeModalPickupPointDeleteBody":"Är du säker på att du vill ta bort: %1","optimizeModalTimeWindowOutsideError":"<b class=\"warning\">Varning:</b> %1 kunder har tidsfrist utanför det angivna tidsrummet.","optimizeModalConfirmCreateRoutes":"Är du säker på att du vill skapa %1 distrikt?","optimizeModalConfirmOptimize":"Är du säker på att du vill optimera?","optimizeModalSuggestedRoutes":"%1% av kunderna kommer att plasseras på ett tidigare distrikt","optimizeModalSuggestedRoutesShowCounts":"Visa antal pr. distrikt (%1 distrikt)","optimizeModalTraveller":"Välj fordon","optimizeModalTraveller_car":"Bil","optimizeModalTraveller_pedestrian":"Gående ","optimizeRouteModalHeader":"Optimaliseringsval","optimizeRouteModalIntro":"Välj den första stoppen för att påverka distriktets riktning (t.ex motsatt av rusningstrafik). Välj den sista stoppen för att t.ex få distriktet att avslutas nära chaufförens hem.","optimizeRouteModalNoneSelected":"- Välj -","optimizeRouteModalFirstStopLabel":"Starta med","optimizeRouteModalLastStopLabel":"Avsluta med","optimizeRouteModalBtn":"Optimera","suggestedRoutesModalHeader":"Distrikt som kommer att skapas","suggestedRoutesModalNotOnRoute":"Inte på distrikt","taggedAutoAssigned":"auto","taggedAutoAssignedPlan":"a","notificationSent":"Skickat","notificationMsg":"Meddelande","notificationMsgSimulation":"Meddelande (ej skickat, endast simulering)","userHeader":"Användaröversikt","driverUserHeader":"Chaufföradministration","driverUsersMobile":"Mobil","driverUsersLastLoggedIn":"Senaste inloggning","driverUsersFilterActive":"Aktiva","driverUsersFilterInactive":"Inaktiva","driverUsersNewDriverBtn":"Ny chaufför","driverUsersLanguageReguiredError":"Du må velge språk","driverUsersUserNameTakenError":"Användarnamnet är upptaget","driverUsersUserNameInvalidError":"Användarnamnet har ogiltiga tecken. Använd endast A-Z","driverUsersUserNameTooShortError":"Användarnamnet är för kort","driverUsersChooseLanguage":"-Välj språk-","driverUsersInvalidPhoneError":"Inget giltigt telefonnummer","driverUsersSendPasswordSMS":"Skicka lösenord till användare på SMS","driverUsersSendNewPasswordSMS":"Skicka nytt lösenord till användare på SMS","driverUsersSentSMS":"(skickat på SMS)","driverUsersActivate":"Aktivera användare","driverUsersDeactivate":"Inaktivera användare","driverUsersHeaderEdit":"Redigera chaufför","driverUsersHeaderNew":"Ny chaufför","moveModalHeader":"Flytta","moveModalCancelled":"Stoppa avbeställd","moveModalMoveToRouteChoose":"Välj distrikt","moveModalMoveToRoute":"Flytta till distrikt","moveModalPlaceAfterChoose":"Välj distrikt först","moveModalPlaceAfter":"Placera efter","moveModalPlaceAfterStart":"Start","moveModalPlaceAfterCancelled":"AVBESTÄLLT:","moveModalLastStop":"Sista stopp","moveModalNextStop":"Nästa stopp","moveModalEditRoute":"Redigera distrikt","moveModalCustomersSelected":"Du har valt %1 kunder","moveModalMultiTipTitle":"Tips:","moveModalMultiTipDescription":"Håll in \"%1\" och dra i kartan för att flytta flera på en gång.","planRoutesStop":"Stopp","planRoutesWeight":"Vikt","planRoutesLength":"Längd","planRoutesDrivingDuration":"Körtid","planRoutesTotalDuration":"Totaltid","planRoutesAskForDriverInputBtn":"Skicka till chaufförer","planRoutesAskForDriverInputBtnConfirm":"Namn: %1<br>Dato: %2 (<b>%3 %4</b>)<br><br>Vill du överföra denna plan til chaufförer så de kan sätta första/siste leverans?","planRoutesPublishBtn":"Publicera","planRoutesPublishBtnConfirm":"Namn: %1<br>Dato: %2 (<b>%3 %4</b>)<br><br>Vill du publicera denna plan?","planRoutesUnpublishBtn":"Avpublicera","planRoutesUnpublishBtnConfirm":"Namn: %1<br>Dato: %2<br><br>Är du säker på att du vill avpublicera denna plan?","planRoutesOptimizeBtn":"Optimera","planRoutesOptimizeAllBtn":"Optimera alla","planRoutesAssigned":"Tilldelade","planRoutesCustomersPerHour":"KPT","planRoutesCustomersPerHourDescription":"Antall kunder per timma","planRoutesStartDone":"Start- Färdigt","routeOptimStatus1":"Väntar","routeOptimStatus2":"Optimeras ","routeOptimStatus3":"Väntar","routeOptimStatus4":"Exporteras","routeOptimTooManyCustomers":"För många kunder...","planRoutesHeader":"Distrikt","planRoutesReserveHeader":"Reservdistrikt","planRoutesReserveSubTitle":"Temporära distrikt som inte ska återanvändas/föreslås för en kund vid nästa import.","planRoutesOptimizeWithTimeWindowFailedSameInterval":"Vi lyckades inte rymma alla kunderna i tidsintervallet %1. <br>Om du ändå tycker att distriktet är genomförbart kan du optimera på nytt.","planRoutesOptimizeWithTimeWindowFailedMultipleIntervals":"Vi lyckades inte få plats till alla kunderna inom angivet tidsintervall. Var god fördela några kunder på andra distrikt.<br>PS: Du kan bara optimalisera på nytt om alla kunderna har lika tidsintervall.","planRoutesOptimizeWithoutTimeWindow":"Optimera utan tidsintervall","planRoutesMoveStop":"Flytta till distrikt","planRoutesMoveStops":"Flytta %1 stopp","planRoutesDeleteAllRoutes":"Ta bort alla distrikt","planRoutesDeleteAllRoutesConfirm":"Är du säker på att du vill ta bort alla distrikt?","planRoutesNewRouteBtn":"Nytt distrikt","planRoutesNewReserveRouteBtn":"Nytt reservdistrikt","planRoutesBackToDashboardBtn":"Tillbaka till dashboard","fleetPrintCount":"Antal","fleetPrinterName":"Utskrivet av: %1","fleetPrinterInstructions":"Detta dokument innehåller personuppgifter och är konfidentiell information. Dokumentet ska behandlas enligt gällande rutiner.","settingsAcknowledgementsTitle":"Kvittoregler","settingsAcknowledgementsForTitle":"Kvittoregler för %1","settingsCompanyMissingCustomerSystems":"Inga leverantörer är konfigurerade","settingsActionsTitle":"Bekräfta levererad","settingsPictureProof":"Måste ta bild","settingsScanner":"Måste scannas","settingsCanComment":"Kommentar","settingsMiscTitle":"Diverse","settingsMiscDescription":"Olika visningar i förhållande till visning och funktionalitet i chaufför-app","settingsPermitLoadingMinutesBefore":"Lasteliste: %1 minutter före estimerad start","settingsPermitStartingMinutesBefore":"Start: %1 före estimerad tid","settingsShowProductCount":"Visa exemplarantal","settingsScanBeforeLoading":"Scanna produkter in på bil","settingsScanBeforeDelivery":"Scanna produkter vid leverans","settingsAdhocProducts":"Adhoc-produkter (sjåføren registrerer antall ifm. kvittering)","settingsAutoAssignDrivers":"Distrikt tilldelas automatiskt till samma chaufför som senast hade distriktet ","settingsAskForDriverInput":"Skicka til chaufförer for inmatning för publisering","settingsAutoConfirmOnExit":"Automatisk kvittering ved avreise fra stopp (geofence)","settingsHandleDeviations":"Avvikelseshandtering","settingsSendEventsToFlow":"Send hendelser til DI Flow (ifm. sporing)","settingsSendEventsToTransport":"Send hendelser til DI Transport (ifm. varsling til bud)","settingsShowTraveller":"Vis flere kjøretøysvalg (ifm. optimer/lag ruter)","settingsActionsDescription":"Här visas vilka kvittensknappar som chauffören kan välja ifrån.","settingsCustomerDeviationsTitle":"Kund avvikelse","settingsCustomerDeviationsDescription":"Val som är tilgängliga när chaufför ska välja avvikelse för en kund","settingsProductDeviationsTitle":"Produkt avvikelse","settingsProductDeviationsDescription":"Val som är tilgängliga när chaufför ska välja avvikelse för en enskild produkt/kolli","settingsCompanyNotificationsTitle":"Aviseringar för varje leverantör","settingsCustSysNotificationsTitle":"Aviseringar för varje transportföretag","settingsCompanyNotificationsDescription":"Aviseringsregler kan ställas in för varje leverantör. SMS-meddelanden som skickas till slutkund vid angivna händelser. Observera att man kan välja att först simulera innan man väljer att gå live med SMS-utskick.","settingsCustSysNotificationsDescription":"Varselregler kan sättas för varje transportbolag. SMS skickas till slutkund vid angivna händelser. Observera att man kan välja att simulera innan man väljer att gå live med SMS-utskick.","settingsCompanyNotificationsCol1":"Leverantör ","settingsCustSysNotificationsCol1":"Transportföretag","settingsNotificationsColEvent":"Händelse","settingsNotificationsCol4":"Meddelande","settingsNotificationsCol5":"Status","settingsNotificationsMinutesBefore":"Meddelande %1 minuter före ankomst","settingsNotificationsActive":"Aktiv","settingsNotificationsSimulate":"Bara simulering","settingsCompanyGeneralTitle":"Generella inställningar","settingsCompanyGeneralDescription":"Vissa inställningar ställs in på transportbolaget medan andra inställningar följer det kundsystem som distribueras.","settingsCompanyBoundaryBoxMissing":"Selskapet MANGLER geografiavgrensning, kontakt support","settingsCompanyBoundaryBoxLink":"Vis selskapets geografiavgrensning","settingsCompanyGeneralCompanySectionTitle":"Inställningar","settingsCompanyGeneralCustomerSystemsSectionTitle":"Inställningar per kundsystem","settingsCustSysGeneralTitle":"Generella inställningar","settingsCompanyZipIntervalsTitle":"Leveranstider för %1","settingsCustSysZipIntervalsTitle":"Leveranstid för varje transportbolag","settingsCompanyZipIntervalsDescription":"Hur lång tid själva leveransen ska ta (dvs. från chaufför har ankommit med bilen). Körtiden mellan varje kund kommer så klart i tillägg.","settingsCustSysZipIntervalsDescription":"Varje transportbolag kan ha regler för hur lång tid själva leveransen ska ta (dvs. från chaufför har ankommit med bilen). Körtiden mellan varje kund kommer så klart i tillägg.","settingsDISysWarningTitle":"Systemmeddelanden","settingsDISysWarningDescription":"Här kan alla som har rollen DI ställa in systemvarningar, om en eller båda rutorna inte är markerade, kommer varningen att tas bort.","settingsDISysWarningGeneral":"Allmänna problem / instabilitet","settingsDISysWarningDowntime":"Meddela om planerat driftstopp","settingsDISysDowntimeDuration":"Varaktighet","settingsDISaveSysWarning":"Spara systemmeddelande","settingsZipIntervalsColCompany":"Transportföretag","settingsZipIntervalsColCustomerSystem":"Kundesystem","settingsZipIntervalsColInterval":"Postnummerintervall","settingsZipIntervalsColTime":"Leveranstid","settingsMissingActions":"Ingen handling är konfigurerad","settingsMissingCustomerDeviations":"Inga kundavvikelser är konfigurerade.","settingsMissingProductDeviations":"Inga produktavvikelser är konfigurerade","settingsMissingNotificationTypes":"Inga notifikationsregler är konfigurerade","settingsMissingZipIntervals":"Ingen överstyrning av leveranstid per postnummerintervall är konfigurerat","receivedComingSms":"Kunden har redan fått SMS om att chaufför kommer och kan inte flyttas.","customerNotMoved":"Kunden är uppdaterad. Kunden har redan fått SMS om att chaufför är på väg och kan därför inte flyttas.","distributionShowRouteMap":"Visa karta","distributionShowRouteCustomers":"Visa kunder","distributionShowRouteCustomer":"Visa kund","distributionShowCustomers":"Visa kunder på plan"}

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.12.9
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  // NOTE: 1 DOM access here
	  var offsetParent = element && element.offsetParent;
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    if (element) {
	      return element.ownerDocument.documentElement;
	    }
	
	    return document.documentElement;
	  }
	
	  // .offsetParent will return the closest TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	/**
	 * Tells if you are running Internet Explorer 10
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean} isIE10
	 */
	var isIE10 = undefined;
	
	var isIE10$1 = function () {
	  if (isIE10 === undefined) {
	    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
	  }
	  return isIE10;
	};
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
	}
	
	function getWindowSizes() {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE10$1() && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  if (isIE10$1()) {
	    try {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } catch (err) {}
	  } else {
	    rect = element.getBoundingClientRect();
	  }
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var isIE10 = isIE10$1();
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = getScroll(html);
	  var scrollLeft = getScroll(html, 'left');
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  // NOTE: 1 DOM access here
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  boundaries.left += padding;
	  boundaries.top += padding;
	  boundaries.right -= padding;
	  boundaries.bottom -= padding;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var commonOffsetParent = findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var styles = getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	  data.offsets.popper.position = 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length - 1; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroy the popper
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.left = '';
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger onUpdate callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper.
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // floor sides to avoid blurry text
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.floor(popper.top),
	    bottom: Math.floor(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    top = -offsetParentRect.height + offsets.bottom;
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    left = -offsetParentRect.width + offsets.right;
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjuction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-right` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unitless, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the height.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * An scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper this makes sure the popper has always a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier, can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near eachothers
	   * without leaving any gap between the two. Expecially useful when the arrow is
	   * enabled and you want to assure it to point to its reference element.
	   * It cares only about the first axis, you can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjuction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations).
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position,
	     * the popper will never be placed outside of the defined boundaries
	     * (except if keepTogether is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define you own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the informations used by Popper.js
	 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overriden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass as 3rd argument an object with the same
	 * structure of this object, example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Whether events (resize, scroll) are initially enabled
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated, this callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Create a new Popper.js instance
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper.
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedule an update, it will run on the next UI update available
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 117 */
/***/ function(module, exports) {

	function RavenConfigError(message) {
	  this.name = 'RavenConfigError';
	  this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(8);
	
	var wrapMethod = function(console, level, callback) {
	  var originalConsoleLevel = console[level];
	  var originalConsole = console;
	
	  if (!(level in console)) {
	    return;
	  }
	
	  var sentryLevel = level === 'warn' ? 'warning' : level;
	
	  console[level] = function() {
	    var args = [].slice.call(arguments);
	
	    var msg = utils.safeJoin(args, ' ');
	    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};
	
	    if (level === 'assert') {
	      if (args[0] === false) {
	        // Default browsers message
	        msg =
	          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
	        data.extra.arguments = args.slice(1);
	        callback && callback(msg, data);
	      }
	    } else {
	      callback && callback(msg, data);
	    }
	
	    // this fails for some browsers. :(
	    if (originalConsoleLevel) {
	      // IE9 doesn't allow calling apply on console functions directly
	      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
	    }
	  };
	};
	
	module.exports = {
	  wrapMethod: wrapMethod
	};


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */
	
	var TraceKit = __webpack_require__(121);
	var stringify = __webpack_require__(30);
	var md5 = __webpack_require__(122);
	var RavenConfigError = __webpack_require__(117);
	
	var utils = __webpack_require__(8);
	var isErrorEvent = utils.isErrorEvent;
	var isDOMError = utils.isDOMError;
	var isDOMException = utils.isDOMException;
	var isError = utils.isError;
	var isObject = utils.isObject;
	var isPlainObject = utils.isPlainObject;
	var isUndefined = utils.isUndefined;
	var isFunction = utils.isFunction;
	var isString = utils.isString;
	var isArray = utils.isArray;
	var isEmptyObject = utils.isEmptyObject;
	var each = utils.each;
	var objectMerge = utils.objectMerge;
	var truncate = utils.truncate;
	var objectFrozen = utils.objectFrozen;
	var hasKey = utils.hasKey;
	var joinRegExp = utils.joinRegExp;
	var urlencode = utils.urlencode;
	var uuid4 = utils.uuid4;
	var htmlTreeAsString = utils.htmlTreeAsString;
	var isSameException = utils.isSameException;
	var isSameStacktrace = utils.isSameStacktrace;
	var parseUrl = utils.parseUrl;
	var fill = utils.fill;
	var supportsFetch = utils.supportsFetch;
	var supportsReferrerPolicy = utils.supportsReferrerPolicy;
	var serializeKeysForMessage = utils.serializeKeysForMessage;
	var serializeException = utils.serializeException;
	var sanitize = utils.sanitize;
	
	var wrapConsoleMethod = __webpack_require__(118).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	  return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	var _navigator = _window.navigator;
	
	function keepOriginalCallback(original, callback) {
	  return isFunction(callback)
	    ? function(data) {
	        return callback(data, original);
	      }
	    : callback;
	}
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	  // Raven can run in contexts where there's no document (react-native)
	  this._hasDocument = !isUndefined(_document);
	  this._hasNavigator = !isUndefined(_navigator);
	  this._lastCapturedException = null;
	  this._lastData = null;
	  this._lastEventId = null;
	  this._globalServer = null;
	  this._globalKey = null;
	  this._globalProject = null;
	  this._globalContext = {};
	  this._globalOptions = {
	    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
	    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
	    logger: 'javascript',
	    ignoreErrors: [],
	    ignoreUrls: [],
	    whitelistUrls: [],
	    includePaths: [],
	    headers: null,
	    collectWindowErrors: true,
	    captureUnhandledRejections: true,
	    maxMessageLength: 0,
	    // By default, truncates URL values to 250 chars
	    maxUrlLength: 250,
	    stackTraceLimit: 50,
	    autoBreadcrumbs: true,
	    instrument: true,
	    sampleRate: 1,
	    sanitizeKeys: []
	  };
	  this._fetchDefaults = {
	    method: 'POST',
	    keepalive: true,
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
	  };
	  this._ignoreOnError = 0;
	  this._isRavenInstalled = false;
	  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	  // capture references to window.console *and* all its methods first
	  // before the console plugin has a chance to monkey patch
	  this._originalConsole = _window.console || {};
	  this._originalConsoleMethods = {};
	  this._plugins = [];
	  this._startTime = now();
	  this._wrappedBuiltIns = [];
	  this._breadcrumbs = [];
	  this._lastCapturedEvent = null;
	  this._keypressTimeout;
	  this._location = _window.location;
	  this._lastHref = this._location && this._location.href;
	  this._resetBackoff();
	
	  // eslint-disable-next-line guard-for-in
	  for (var method in this._originalConsole) {
	    this._originalConsoleMethods[method] = this._originalConsole[method];
	  }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	  // Hardcode version string so that raven source can be loaded directly via
	  // webpack (using a build step causes webpack #1617). Grunt verifies that
	  // this value matches package.json during build.
	  //   See: https://github.com/getsentry/raven-js/issues/465
	  VERSION: '3.25.2',
	
	  debug: false,
	
	  TraceKit: TraceKit, // alias to TraceKit
	
	  /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Set of global options [optional]
	     * @return {Raven}
	     */
	  config: function(dsn, options) {
	    var self = this;
	
	    if (self._globalServer) {
	      this._logDebug('error', 'Error: Raven has already been configured');
	      return self;
	    }
	    if (!dsn) return self;
	
	    var globalOptions = self._globalOptions;
	
	    // merge in options
	    if (options) {
	      each(options, function(key, value) {
	        // tags and extra are special and need to be put into context
	        if (key === 'tags' || key === 'extra' || key === 'user') {
	          self._globalContext[key] = value;
	        } else {
	          globalOptions[key] = value;
	        }
	      });
	    }
	
	    self.setDSN(dsn);
	
	    // "Script error." is hard coded into browsers for errors that it can't read.
	    // this is the result of a script being pulled in from an external domain and CORS.
	    globalOptions.ignoreErrors.push(/^Script error\.?$/);
	    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	    // join regexp rules into one big rule
	    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
	      ? joinRegExp(globalOptions.ignoreUrls)
	      : false;
	    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
	      ? joinRegExp(globalOptions.whitelistUrls)
	      : false;
	    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	    globalOptions.maxBreadcrumbs = Math.max(
	      0,
	      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
	    ); // default and hard limit is 100
	
	    var autoBreadcrumbDefaults = {
	      xhr: true,
	      console: true,
	      dom: true,
	      location: true,
	      sentry: true
	    };
	
	    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	    } else if (autoBreadcrumbs !== false) {
	      autoBreadcrumbs = autoBreadcrumbDefaults;
	    }
	    globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	    var instrumentDefaults = {
	      tryCatch: true
	    };
	
	    var instrument = globalOptions.instrument;
	    if ({}.toString.call(instrument) === '[object Object]') {
	      instrument = objectMerge(instrumentDefaults, instrument);
	    } else if (instrument !== false) {
	      instrument = instrumentDefaults;
	    }
	    globalOptions.instrument = instrument;
	
	    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	    // return for chaining
	    return self;
	  },
	
	  /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	  install: function() {
	    var self = this;
	    if (self.isSetup() && !self._isRavenInstalled) {
	      TraceKit.report.subscribe(function() {
	        self._handleOnErrorStackInfo.apply(self, arguments);
	      });
	
	      if (self._globalOptions.captureUnhandledRejections) {
	        self._attachPromiseRejectionHandler();
	      }
	
	      self._patchFunctionToString();
	
	      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
	        self._instrumentTryCatch();
	      }
	
	      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();
	
	      // Install all of the plugins
	      self._drainPlugins();
	
	      self._isRavenInstalled = true;
	    }
	
	    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	    return this;
	  },
	
	  /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	  setDSN: function(dsn) {
	    var self = this,
	      uri = self._parseDSN(dsn),
	      lastSlash = uri.path.lastIndexOf('/'),
	      path = uri.path.substr(1, lastSlash);
	
	    self._dsn = dsn;
	    self._globalKey = uri.user;
	    self._globalSecret = uri.pass && uri.pass.substr(1);
	    self._globalProject = uri.path.substr(lastSlash + 1);
	
	    self._globalServer = self._getGlobalServer(uri);
	
	    self._globalEndpoint =
	      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';
	
	    // Reset backoff state since we may be pointing at a
	    // new project/server
	    this._resetBackoff();
	  },
	
	  /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	  context: function(options, func, args) {
	    if (isFunction(options)) {
	      args = func || [];
	      func = options;
	      options = undefined;
	    }
	
	    return this.wrap(options, func).apply(this, args);
	  },
	
	  /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	  wrap: function(options, func, _before) {
	    var self = this;
	    // 1 argument has been passed, and it's not a function
	    // so just return it
	    if (isUndefined(func) && !isFunction(options)) {
	      return options;
	    }
	
	    // options is optional
	    if (isFunction(options)) {
	      func = options;
	      options = undefined;
	    }
	
	    // At this point, we've passed along 2 arguments, and the second one
	    // is not a function either, so we'll just return the second argument.
	    if (!isFunction(func)) {
	      return func;
	    }
	
	    // We don't wanna wrap it twice!
	    try {
	      if (func.__raven__) {
	        return func;
	      }
	
	      // If this has already been wrapped in the past, return that
	      if (func.__raven_wrapper__) {
	        return func.__raven_wrapper__;
	      }
	    } catch (e) {
	      // Just accessing custom props in some Selenium environments
	      // can cause a "Permission denied" exception (see raven-js#495).
	      // Bail on wrapping and return the function as-is (defers to window.onerror).
	      return func;
	    }
	
	    function wrapped() {
	      var args = [],
	        i = arguments.length,
	        deep = !options || (options && options.deep !== false);
	
	      if (_before && isFunction(_before)) {
	        _before.apply(this, arguments);
	      }
	
	      // Recursively wrap all of a function's arguments that are
	      // functions themselves.
	      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	      try {
	        // Attempt to invoke user-land function
	        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	        //       means Raven caught an error invoking your application code. This is
	        //       expected behavior and NOT indicative of a bug with Raven.js.
	        return func.apply(this, args);
	      } catch (e) {
	        self._ignoreNextOnError();
	        self.captureException(e, options);
	        throw e;
	      }
	    }
	
	    // copy over properties of the old function
	    for (var property in func) {
	      if (hasKey(func, property)) {
	        wrapped[property] = func[property];
	      }
	    }
	    wrapped.prototype = func.prototype;
	
	    func.__raven_wrapper__ = wrapped;
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    wrapped.__raven__ = true;
	    wrapped.__orig__ = func;
	
	    return wrapped;
	  },
	
	  /**
	   * Uninstalls the global error handler.
	   *
	   * @return {Raven}
	   */
	  uninstall: function() {
	    TraceKit.report.uninstall();
	
	    this._detachPromiseRejectionHandler();
	    this._unpatchFunctionToString();
	    this._restoreBuiltIns();
	    this._restoreConsole();
	
	    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	    this._isRavenInstalled = false;
	
	    return this;
	  },
	
	  /**
	   * Callback used for `unhandledrejection` event
	   *
	   * @param {PromiseRejectionEvent} event An object containing
	   *   promise: the Promise that was rejected
	   *   reason: the value with which the Promise was rejected
	   * @return void
	   */
	  _promiseRejectionHandler: function(event) {
	    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
	    this.captureException(event.reason, {
	      extra: {
	        unhandledPromiseRejection: true
	      }
	    });
	  },
	
	  /**
	   * Installs the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _attachPromiseRejectionHandler: function() {
	    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
	    _window.addEventListener &&
	      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Uninstalls the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _detachPromiseRejectionHandler: function() {
	    _window.removeEventListener &&
	      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Manually capture an exception and send it over to Sentry
	   *
	   * @param {error} ex An exception to be logged
	   * @param {object} options A specific set of options for this error [optional]
	   * @return {Raven}
	   */
	  captureException: function(ex, options) {
	    options = objectMerge({trimHeadFrames: 0}, options ? options : {});
	
	    if (isErrorEvent(ex) && ex.error) {
	      // If it is an ErrorEvent with `error` property, extract it to get actual Error
	      ex = ex.error;
	    } else if (isDOMError(ex) || isDOMException(ex)) {
	      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
	      // then we just extract the name and message, as they don't provide anything else
	      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
	      var message = ex.message ? name + ': ' + ex.message : name;
	
	      return this.captureMessage(
	        message,
	        objectMerge(options, {
	          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
	          // but it's barely any overhead so we may at least try
	          stacktrace: true,
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    } else if (isError(ex)) {
	      // we have a real Error object
	      ex = ex;
	    } else if (isPlainObject(ex)) {
	      // If it is plain Object, serialize it manually and extract options
	      // This will allow us to group events based on top-level keys
	      // which is much better than creating new group when any key/value change
	      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
	      ex = new Error(options.message);
	    } else {
	      // If none of previous checks were valid, then it means that
	      // it's not a DOMError/DOMException
	      // it's not a plain Object
	      // it's not a valid ErrorEvent (one with an error property)
	      // it's not an Error
	      // So bail out and capture it as a simple message:
	      return this.captureMessage(
	        ex,
	        objectMerge(options, {
	          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    }
	
	    // Store the raw exception object for potential debugging and introspection
	    this._lastCapturedException = ex;
	
	    // TraceKit.report will re-raise any exception passed to it,
	    // which means you have to wrap it in try/catch. Instead, we
	    // can wrap it here and only re-raise if TraceKit.report
	    // raises an exception different from the one we asked to
	    // report on.
	    try {
	      var stack = TraceKit.computeStackTrace(ex);
	      this._handleStackInfo(stack, options);
	    } catch (ex1) {
	      if (ex !== ex1) {
	        throw ex1;
	      }
	    }
	
	    return this;
	  },
	
	  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
	    var exKeys = Object.keys(ex).sort();
	    var options = objectMerge(currentOptions, {
	      message:
	        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
	      fingerprint: [md5(exKeys)],
	      extra: currentOptions.extra || {}
	    });
	    options.extra.__serialized__ = serializeException(ex);
	
	    return options;
	  },
	
	  /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	  captureMessage: function(msg, options) {
	    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	    // early call; we'll error on the side of logging anything called before configuration since it's
	    // probably something you should see:
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      this._globalOptions.ignoreErrors.test(msg)
	    ) {
	      return;
	    }
	
	    options = options || {};
	    msg = msg + ''; // Make sure it's actually a string
	
	    var data = objectMerge(
	      {
	        message: msg
	      },
	      options
	    );
	
	    var ex;
	    // Generate a "synthetic" stack trace from this point.
	    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
	    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
	    //       or if it catches a thrown object without a "stack" property.
	    try {
	      throw new Error(msg);
	    } catch (ex1) {
	      ex = ex1;
	    }
	
	    // null exception name so `Error` isn't prefixed to msg
	    ex.name = null;
	    var stack = TraceKit.computeStackTrace(ex);
	
	    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
	    var initialCall = isArray(stack.stack) && stack.stack[1];
	
	    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
	    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
	    // initialCall => captureException(string) => captureMessage(string)
	    if (initialCall && initialCall.func === 'Raven.captureException') {
	      initialCall = stack.stack[2];
	    }
	
	    var fileurl = (initialCall && initialCall.url) || '';
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
	      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
	      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;
	
	      options = objectMerge(
	        {
	          trimHeadFrames: 0
	        },
	        options
	      );
	      // Since we know this is a synthetic trace, the top frame (this function call)
	      // MUST be from Raven.js, so mark it for trimming
	      // We add to the trim counter so that callers can choose to trim extra frames, such
	      // as utility functions.
	      options.trimHeadFrames += 1;
	
	      var frames = this._prepareFrames(stack, options);
	      data.stacktrace = {
	        // Sentry expects frames oldest to newest
	        frames: frames.reverse()
	      };
	    }
	
	    // Make sure that fingerprint is always wrapped in an array
	    if (data.fingerprint) {
	      data.fingerprint = isArray(data.fingerprint)
	        ? data.fingerprint
	        : [data.fingerprint];
	    }
	
	    // Fire away!
	    this._send(data);
	
	    return this;
	  },
	
	  captureBreadcrumb: function(obj) {
	    var crumb = objectMerge(
	      {
	        timestamp: now() / 1000
	      },
	      obj
	    );
	
	    if (isFunction(this._globalOptions.breadcrumbCallback)) {
	      var result = this._globalOptions.breadcrumbCallback(crumb);
	
	      if (isObject(result) && !isEmptyObject(result)) {
	        crumb = result;
	      } else if (result === false) {
	        return this;
	      }
	    }
	
	    this._breadcrumbs.push(crumb);
	    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	      this._breadcrumbs.shift();
	    }
	    return this;
	  },
	
	  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	    var pluginArgs = [].slice.call(arguments, 1);
	
	    this._plugins.push([plugin, pluginArgs]);
	    if (this._isRavenInstalled) {
	      this._drainPlugins();
	    }
	
	    return this;
	  },
	
	  /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	  setUserContext: function(user) {
	    // Intentionally do not merge here since that's an unexpected behavior.
	    this._globalContext.user = user;
	
	    return this;
	  },
	
	  /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	  setExtraContext: function(extra) {
	    this._mergeContext('extra', extra);
	
	    return this;
	  },
	
	  /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	  setTagsContext: function(tags) {
	    this._mergeContext('tags', tags);
	
	    return this;
	  },
	
	  /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	  clearContext: function() {
	    this._globalContext = {};
	
	    return this;
	  },
	
	  /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	  getContext: function() {
	    // lol javascript
	    return JSON.parse(stringify(this._globalContext));
	  },
	
	  /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	  setEnvironment: function(environment) {
	    this._globalOptions.environment = environment;
	
	    return this;
	  },
	
	  /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	  setRelease: function(release) {
	    this._globalOptions.release = release;
	
	    return this;
	  },
	
	  /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	  setDataCallback: function(callback) {
	    var original = this._globalOptions.dataCallback;
	    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	  setBreadcrumbCallback: function(callback) {
	    var original = this._globalOptions.breadcrumbCallback;
	    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	  setShouldSendCallback: function(callback) {
	    var original = this._globalOptions.shouldSendCallback;
	    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /**
	   * Override the default HTTP transport mechanism that transmits data
	   * to the Sentry server.
	   *
	   * @param {function} transport Function invoked instead of the default
	   *                             `makeRequest` handler.
	   *
	   * @return {Raven}
	   */
	  setTransport: function(transport) {
	    this._globalOptions.transport = transport;
	
	    return this;
	  },
	
	  /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	  lastException: function() {
	    return this._lastCapturedException;
	  },
	
	  /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	  lastEventId: function() {
	    return this._lastEventId;
	  },
	
	  /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	  isSetup: function() {
	    if (!this._hasJSON) return false; // needs JSON support
	    if (!this._globalServer) {
	      if (!this.ravenNotConfiguredError) {
	        this.ravenNotConfiguredError = true;
	        this._logDebug('error', 'Error: Raven has not been configured.');
	      }
	      return false;
	    }
	    return true;
	  },
	
	  afterLoad: function() {
	    // TODO: remove window dependence?
	
	    // Attempt to initialize Raven on load
	    var RavenConfig = _window.RavenConfig;
	    if (RavenConfig) {
	      this.config(RavenConfig.dsn, RavenConfig.config).install();
	    }
	  },
	
	  showReportDialog: function(options) {
	    if (
	      !_document // doesn't work without a document (React native)
	    )
	      return;
	
	    options = options || {};
	
	    var lastEventId = options.eventId || this.lastEventId();
	    if (!lastEventId) {
	      throw new RavenConfigError('Missing eventId');
	    }
	
	    var dsn = options.dsn || this._dsn;
	    if (!dsn) {
	      throw new RavenConfigError('Missing DSN');
	    }
	
	    var encode = encodeURIComponent;
	    var qs = '';
	    qs += '?eventId=' + encode(lastEventId);
	    qs += '&dsn=' + encode(dsn);
	
	    var user = options.user || this._globalContext.user;
	    if (user) {
	      if (user.name) qs += '&name=' + encode(user.name);
	      if (user.email) qs += '&email=' + encode(user.email);
	    }
	
	    var globalServer = this._getGlobalServer(this._parseDSN(dsn));
	
	    var script = _document.createElement('script');
	    script.async = true;
	    script.src = globalServer + '/api/embed/error-page/' + qs;
	    (_document.head || _document.body).appendChild(script);
	  },
	
	  /**** Private functions ****/
	  _ignoreNextOnError: function() {
	    var self = this;
	    this._ignoreOnError += 1;
	    setTimeout(function() {
	      // onerror should trigger before setTimeout
	      self._ignoreOnError -= 1;
	    });
	  },
	
	  _triggerEvent: function(eventType, options) {
	    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	    var evt, key;
	
	    if (!this._hasDocument) return;
	
	    options = options || {};
	
	    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);
	
	    if (_document.createEvent) {
	      evt = _document.createEvent('HTMLEvents');
	      evt.initEvent(eventType, true, true);
	    } else {
	      evt = _document.createEventObject();
	      evt.eventType = eventType;
	    }
	
	    for (key in options)
	      if (hasKey(options, key)) {
	        evt[key] = options[key];
	      }
	
	    if (_document.createEvent) {
	      // IE9 if standards
	      _document.dispatchEvent(evt);
	    } else {
	      // IE8 regardless of Quirks or Standards
	      // IE9 if quirks
	      try {
	        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	      } catch (e) {
	        // Do nothing
	      }
	    }
	  },
	
	  /**
	   * Wraps addEventListener to capture UI breadcrumbs
	   * @param evtName the event name (e.g. "click")
	   * @returns {Function}
	   * @private
	   */
	  _breadcrumbEventHandler: function(evtName) {
	    var self = this;
	    return function(evt) {
	      // reset keypress timeout; e.g. triggering a 'click' after
	      // a 'keypress' will reset the keypress debounce so that a new
	      // set of keypresses can be recorded
	      self._keypressTimeout = null;
	
	      // It's possible this handler might trigger multiple times for the same
	      // event (e.g. event propagation through node ancestors). Ignore if we've
	      // already captured the event.
	      if (self._lastCapturedEvent === evt) return;
	
	      self._lastCapturedEvent = evt;
	
	      // try/catch both:
	      // - accessing evt.target (see getsentry/raven-js#838, #768)
	      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	      //   can throw an exception in some circumstances.
	      var target;
	      try {
	        target = htmlTreeAsString(evt.target);
	      } catch (e) {
	        target = '<unknown>';
	      }
	
	      self.captureBreadcrumb({
	        category: 'ui.' + evtName, // e.g. ui.click, ui.input
	        message: target
	      });
	    };
	  },
	
	  /**
	   * Wraps addEventListener to capture keypress UI events
	   * @returns {Function}
	   * @private
	   */
	  _keypressEventHandler: function() {
	    var self = this,
	      debounceDuration = 1000; // milliseconds
	
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function(evt) {
	      var target;
	      try {
	        target = evt.target;
	      } catch (e) {
	        // just accessing event properties can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/raven-js/issues/838
	        return;
	      }
	      var tagName = target && target.tagName;
	
	      // only consider keypress events on actual input elements
	      // this will disregard keypresses targeting body (e.g. tabbing
	      // through elements, hotkeys, etc)
	      if (
	        !tagName ||
	        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	      )
	        return;
	
	      // record first keypress in a series, but ignore subsequent
	      // keypresses until debounce clears
	      var timeout = self._keypressTimeout;
	      if (!timeout) {
	        self._breadcrumbEventHandler('input')(evt);
	      }
	      clearTimeout(timeout);
	      self._keypressTimeout = setTimeout(function() {
	        self._keypressTimeout = null;
	      }, debounceDuration);
	    };
	  },
	
	  /**
	   * Captures a breadcrumb of type "navigation", normalizing input URLs
	   * @param to the originating URL
	   * @param from the target URL
	   * @private
	   */
	  _captureUrlChange: function(from, to) {
	    var parsedLoc = parseUrl(this._location.href);
	    var parsedTo = parseUrl(to);
	    var parsedFrom = parseUrl(from);
	
	    // because onpopstate only tells you the "new" (to) value of location.href, and
	    // not the previous (from) value, we need to track the value of the current URL
	    // state ourselves
	    this._lastHref = to;
	
	    // Use only the path component of the URL if the URL matches the current
	    // document (almost all the time when using pushState)
	    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	      to = parsedTo.relative;
	    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	      from = parsedFrom.relative;
	
	    this.captureBreadcrumb({
	      category: 'navigation',
	      data: {
	        to: to,
	        from: from
	      }
	    });
	  },
	
	  _patchFunctionToString: function() {
	    var self = this;
	    self._originalFunctionToString = Function.prototype.toString;
	    // eslint-disable-next-line no-extend-native
	    Function.prototype.toString = function() {
	      if (typeof this === 'function' && this.__raven__) {
	        return self._originalFunctionToString.apply(this.__orig__, arguments);
	      }
	      return self._originalFunctionToString.apply(this, arguments);
	    };
	  },
	
	  _unpatchFunctionToString: function() {
	    if (this._originalFunctionToString) {
	      // eslint-disable-next-line no-extend-native
	      Function.prototype.toString = this._originalFunctionToString;
	    }
	  },
	
	  /**
	   * Wrap timer functions and event targets to catch errors and provide
	   * better metadata.
	   */
	  _instrumentTryCatch: function() {
	    var self = this;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapTimeFn(orig) {
	      return function(fn, t) {
	        // preserve arity
	        // Make a copy of the arguments to prevent deoptimization
	        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	        var args = new Array(arguments.length);
	        for (var i = 0; i < args.length; ++i) {
	          args[i] = arguments[i];
	        }
	        var originalCallback = args[0];
	        if (isFunction(originalCallback)) {
	          args[0] = self.wrap(originalCallback);
	        }
	
	        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	        // also supports only two arguments and doesn't care what this is, so we
	        // can just call the original function directly.
	        if (orig.apply) {
	          return orig.apply(this, args);
	        } else {
	          return orig(args[0], args[1]);
	        }
	      };
	    }
	
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    function wrapEventTarget(global) {
	      var proto = _window[global] && _window[global].prototype;
	      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	        fill(
	          proto,
	          'addEventListener',
	          function(orig) {
	            return function(evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(fn.handleEvent);
	                }
	              } catch (err) {
	                // can sometimes get 'Permission denied to access property "handle Event'
	              }
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before, clickHandler, keypressHandler;
	
	              if (
	                autoBreadcrumbs &&
	                autoBreadcrumbs.dom &&
	                (global === 'EventTarget' || global === 'Node')
	              ) {
	                // NOTE: generating multiple handlers per addEventListener invocation, should
	                //       revisit and verify we can just use one (almost certainly)
	                clickHandler = self._breadcrumbEventHandler('click');
	                keypressHandler = self._keypressEventHandler();
	                before = function(evt) {
	                  // need to intercept every DOM event in `before` argument, in case that
	                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                  // see #724
	                  if (!evt) return;
	
	                  var eventType;
	                  try {
	                    eventType = evt.type;
	                  } catch (e) {
	                    // just accessing event properties can throw an exception in some rare circumstances
	                    // see: https://github.com/getsentry/raven-js/issues/838
	                    return;
	                  }
	                  if (eventType === 'click') return clickHandler(evt);
	                  else if (eventType === 'keypress') return keypressHandler(evt);
	                };
	              }
	              return orig.call(
	                this,
	                evtName,
	                self.wrap(fn, undefined, before),
	                capture,
	                secure
	              );
	            };
	          },
	          wrappedBuiltIns
	        );
	        fill(
	          proto,
	          'removeEventListener',
	          function(orig) {
	            return function(evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          },
	          wrappedBuiltIns
	        );
	      }
	    }
	
	    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	    if (_window.requestAnimationFrame) {
	      fill(
	        _window,
	        'requestAnimationFrame',
	        function(orig) {
	          return function(cb) {
	            return orig(self.wrap(cb));
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // event targets borrowed from bugsnag-js:
	    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	    var eventTargets = [
	      'EventTarget',
	      'Window',
	      'Node',
	      'ApplicationCache',
	      'AudioTrackList',
	      'ChannelMergerNode',
	      'CryptoOperation',
	      'EventSource',
	      'FileReader',
	      'HTMLUnknownElement',
	      'IDBDatabase',
	      'IDBRequest',
	      'IDBTransaction',
	      'KeyOperation',
	      'MediaController',
	      'MessagePort',
	      'ModalWindow',
	      'Notification',
	      'SVGElementInstance',
	      'Screen',
	      'TextTrack',
	      'TextTrackCue',
	      'TextTrackList',
	      'WebSocket',
	      'WebSocketWorker',
	      'Worker',
	      'XMLHttpRequest',
	      'XMLHttpRequestEventTarget',
	      'XMLHttpRequestUpload'
	    ];
	    for (var i = 0; i < eventTargets.length; i++) {
	      wrapEventTarget(eventTargets[i]);
	    }
	  },
	
	  /**
	   * Instrument browser built-ins w/ breadcrumb capturing
	   *  - XMLHttpRequests
	   *  - DOM interactions (click/typing)
	   *  - window.location changes
	   *  - console
	   *
	   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	   */
	  _instrumentBreadcrumbs: function() {
	    var self = this;
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapProp(prop, xhr) {
	      if (prop in xhr && isFunction(xhr[prop])) {
	        fill(xhr, prop, function(orig) {
	          return self.wrap(orig);
	        }); // intentionally don't track filled methods on XHR instances
	      }
	    }
	
	    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
	      fill(
	        xhrproto,
	        'open',
	        function(origOpen) {
	          return function(method, url) {
	            // preserve arity
	
	            // if Sentry key appears in URL, don't capture
	            if (isString(url) && url.indexOf(self._globalKey) === -1) {
	              this.__raven_xhr = {
	                method: method,
	                url: url,
	                status_code: null
	              };
	            }
	
	            return origOpen.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	
	      fill(
	        xhrproto,
	        'send',
	        function(origSend) {
	          return function() {
	            // preserve arity
	            var xhr = this;
	
	            function onreadystatechangeHandler() {
	              if (xhr.__raven_xhr && xhr.readyState === 4) {
	                try {
	                  // touching statusCode in some platforms throws
	                  // an exception
	                  xhr.__raven_xhr.status_code = xhr.status;
	                } catch (e) {
	                  /* do nothing */
	                }
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'xhr',
	                  data: xhr.__raven_xhr
	                });
	              }
	            }
	
	            var props = ['onload', 'onerror', 'onprogress'];
	            for (var j = 0; j < props.length; j++) {
	              wrapProp(props[j], xhr);
	            }
	
	            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	              fill(
	                xhr,
	                'onreadystatechange',
	                function(orig) {
	                  return self.wrap(orig, undefined, onreadystatechangeHandler);
	                } /* intentionally don't track this instrumentation */
	              );
	            } else {
	              // if onreadystatechange wasn't actually set by the page on this xhr, we
	              // are free to set our own and capture the breadcrumb
	              xhr.onreadystatechange = onreadystatechangeHandler;
	            }
	
	            return origSend.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    if (autoBreadcrumbs.xhr && supportsFetch()) {
	      fill(
	        _window,
	        'fetch',
	        function(origFetch) {
	          return function() {
	            // preserve arity
	            // Make a copy of the arguments to prevent deoptimization
	            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	            var args = new Array(arguments.length);
	            for (var i = 0; i < args.length; ++i) {
	              args[i] = arguments[i];
	            }
	
	            var fetchInput = args[0];
	            var method = 'GET';
	            var url;
	
	            if (typeof fetchInput === 'string') {
	              url = fetchInput;
	            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
	              url = fetchInput.url;
	              if (fetchInput.method) {
	                method = fetchInput.method;
	              }
	            } else {
	              url = '' + fetchInput;
	            }
	
	            // if Sentry key appears in URL, don't capture, as it's our own request
	            if (url.indexOf(self._globalKey) !== -1) {
	              return origFetch.apply(this, args);
	            }
	
	            if (args[1] && args[1].method) {
	              method = args[1].method;
	            }
	
	            var fetchData = {
	              method: method,
	              url: url,
	              status_code: null
	            };
	
	            return origFetch
	              .apply(this, args)
	              .then(function(response) {
	                fetchData.status_code = response.status;
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'fetch',
	                  data: fetchData
	                });
	
	                return response;
	              })
	              ['catch'](function(err) {
	                // if there is an error performing the request
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'fetch',
	                  data: fetchData,
	                  level: 'error'
	                });
	
	                throw err;
	              });
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    if (autoBreadcrumbs.dom && this._hasDocument) {
	      if (_document.addEventListener) {
	        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	        _document.addEventListener('keypress', self._keypressEventHandler(), false);
	      } else if (_document.attachEvent) {
	        // IE8 Compatibility
	        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	        _document.attachEvent('onkeypress', self._keypressEventHandler());
	      }
	    }
	
	    // record navigation (URL) changes
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var chrome = _window.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    var hasPushAndReplaceState =
	      !isChromePackagedApp &&
	      _window.history &&
	      _window.history.pushState &&
	      _window.history.replaceState;
	    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
	      // TODO: remove onpopstate handler on uninstall()
	      var oldOnPopState = _window.onpopstate;
	      _window.onpopstate = function() {
	        var currentHref = self._location.href;
	        self._captureUrlChange(self._lastHref, currentHref);
	
	        if (oldOnPopState) {
	          return oldOnPopState.apply(this, arguments);
	        }
	      };
	
	      var historyReplacementFunction = function(origHistFunction) {
	        // note history.pushState.length is 0; intentionally not declaring
	        // params to preserve 0 arity
	        return function(/* state, title, url */) {
	          var url = arguments.length > 2 ? arguments[2] : undefined;
	
	          // url argument is optional
	          if (url) {
	            // coerce to string (this is what pushState does)
	            self._captureUrlChange(self._lastHref, url + '');
	          }
	
	          return origHistFunction.apply(this, arguments);
	        };
	      };
	
	      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
	      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
	    }
	
	    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	      // console
	      var consoleMethodCallback = function(msg, data) {
	        self.captureBreadcrumb({
	          message: msg,
	          level: data.level,
	          category: 'console'
	        });
	      };
	
	      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
	        wrapConsoleMethod(console, level, consoleMethodCallback);
	      });
	    }
	  },
	
	  _restoreBuiltIns: function() {
	    // restore any wrapped builtins
	    var builtin;
	    while (this._wrappedBuiltIns.length) {
	      builtin = this._wrappedBuiltIns.shift();
	
	      var obj = builtin[0],
	        name = builtin[1],
	        orig = builtin[2];
	
	      obj[name] = orig;
	    }
	  },
	
	  _restoreConsole: function() {
	    // eslint-disable-next-line guard-for-in
	    for (var method in this._originalConsoleMethods) {
	      this._originalConsole[method] = this._originalConsoleMethods[method];
	    }
	  },
	
	  _drainPlugins: function() {
	    var self = this;
	
	    // FIX ME TODO
	    each(this._plugins, function(_, plugin) {
	      var installer = plugin[0];
	      var args = plugin[1];
	      installer.apply(self, [self].concat(args));
	    });
	  },
	
	  _parseDSN: function(str) {
	    var m = dsnPattern.exec(str),
	      dsn = {},
	      i = 7;
	
	    try {
	      while (i--) dsn[dsnKeys[i]] = m[i] || '';
	    } catch (e) {
	      throw new RavenConfigError('Invalid DSN: ' + str);
	    }
	
	    if (dsn.pass && !this._globalOptions.allowSecretKey) {
	      throw new RavenConfigError(
	        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
	      );
	    }
	
	    return dsn;
	  },
	
	  _getGlobalServer: function(uri) {
	    // assemble the endpoint from the uri pieces
	    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');
	
	    if (uri.protocol) {
	      globalServer = uri.protocol + ':' + globalServer;
	    }
	    return globalServer;
	  },
	
	  _handleOnErrorStackInfo: function() {
	    // if we are intentionally ignoring errors via onerror, bail out
	    if (!this._ignoreOnError) {
	      this._handleStackInfo.apply(this, arguments);
	    }
	  },
	
	  _handleStackInfo: function(stackInfo, options) {
	    var frames = this._prepareFrames(stackInfo, options);
	
	    this._triggerEvent('handle', {
	      stackInfo: stackInfo,
	      options: options
	    });
	
	    this._processException(
	      stackInfo.name,
	      stackInfo.message,
	      stackInfo.url,
	      stackInfo.lineno,
	      frames,
	      options
	    );
	  },
	
	  _prepareFrames: function(stackInfo, options) {
	    var self = this;
	    var frames = [];
	    if (stackInfo.stack && stackInfo.stack.length) {
	      each(stackInfo.stack, function(i, stack) {
	        var frame = self._normalizeFrame(stack, stackInfo.url);
	        if (frame) {
	          frames.push(frame);
	        }
	      });
	
	      // e.g. frames captured via captureMessage throw
	      if (options && options.trimHeadFrames) {
	        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	          frames[j].in_app = false;
	        }
	      }
	    }
	    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	    return frames;
	  },
	
	  _normalizeFrame: function(frame, stackInfoUrl) {
	    // normalize the frames data
	    var normalized = {
	      filename: frame.url,
	      lineno: frame.line,
	      colno: frame.column,
	      function: frame.func || '?'
	    };
	
	    // Case when we don't have any information about the error
	    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
	    // Generating synthetic error doesn't add any value here
	    //
	    // We should probably somehow let a user know that they should fix their code
	    if (!frame.url) {
	      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
	    }
	
	    normalized.in_app = !// determine if an exception came from outside of our app
	    // first we check the global includePaths list.
	    (
	      (!!this._globalOptions.includePaths.test &&
	        !this._globalOptions.includePaths.test(normalized.filename)) ||
	      // Now we check for fun, if the function name is Raven or TraceKit
	      /(Raven|TraceKit)\./.test(normalized['function']) ||
	      // finally, we do a last ditch effort and check for raven.min.js
	      /raven\.(min\.)?js$/.test(normalized.filename)
	    );
	
	    return normalized;
	  },
	
	  _processException: function(type, message, fileurl, lineno, frames, options) {
	    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      (this._globalOptions.ignoreErrors.test(message) ||
	        this._globalOptions.ignoreErrors.test(prefixedMessage))
	    ) {
	      return;
	    }
	
	    var stacktrace;
	
	    if (frames && frames.length) {
	      fileurl = frames[0].filename || fileurl;
	      // Sentry expects frames oldest to newest
	      // and JS sends them as newest to oldest
	      frames.reverse();
	      stacktrace = {frames: frames};
	    } else if (fileurl) {
	      stacktrace = {
	        frames: [
	          {
	            filename: fileurl,
	            lineno: lineno,
	            in_app: true
	          }
	        ]
	      };
	    }
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    var data = objectMerge(
	      {
	        // sentry.interfaces.Exception
	        exception: {
	          values: [
	            {
	              type: type,
	              value: message,
	              stacktrace: stacktrace
	            }
	          ]
	        },
	        transaction: fileurl
	      },
	      options
	    );
	
	    // Fire away!
	    this._send(data);
	  },
	
	  _trimPacket: function(data) {
	    // For now, we only want to truncate the two different messages
	    // but this could/should be expanded to just trim everything
	    var max = this._globalOptions.maxMessageLength;
	    if (data.message) {
	      data.message = truncate(data.message, max);
	    }
	    if (data.exception) {
	      var exception = data.exception.values[0];
	      exception.value = truncate(exception.value, max);
	    }
	
	    var request = data.request;
	    if (request) {
	      if (request.url) {
	        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
	      }
	      if (request.Referer) {
	        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
	      }
	    }
	
	    if (data.breadcrumbs && data.breadcrumbs.values)
	      this._trimBreadcrumbs(data.breadcrumbs);
	
	    return data;
	  },
	
	  /**
	   * Truncate breadcrumb values (right now just URLs)
	   */
	  _trimBreadcrumbs: function(breadcrumbs) {
	    // known breadcrumb properties with urls
	    // TODO: also consider arbitrary prop values that start with (https?)?://
	    var urlProps = ['to', 'from', 'url'],
	      urlProp,
	      crumb,
	      data;
	
	    for (var i = 0; i < breadcrumbs.values.length; ++i) {
	      crumb = breadcrumbs.values[i];
	      if (
	        !crumb.hasOwnProperty('data') ||
	        !isObject(crumb.data) ||
	        objectFrozen(crumb.data)
	      )
	        continue;
	
	      data = objectMerge({}, crumb.data);
	      for (var j = 0; j < urlProps.length; ++j) {
	        urlProp = urlProps[j];
	        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
	          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
	        }
	      }
	      breadcrumbs.values[i].data = data;
	    }
	  },
	
	  _getHttpData: function() {
	    if (!this._hasNavigator && !this._hasDocument) return;
	    var httpData = {};
	
	    if (this._hasNavigator && _navigator.userAgent) {
	      httpData.headers = {
	        'User-Agent': _navigator.userAgent
	      };
	    }
	
	    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
	    if (_window.location && _window.location.href) {
	      httpData.url = _window.location.href;
	    }
	
	    if (this._hasDocument && _document.referrer) {
	      if (!httpData.headers) httpData.headers = {};
	      httpData.headers.Referer = _document.referrer;
	    }
	
	    return httpData;
	  },
	
	  _resetBackoff: function() {
	    this._backoffDuration = 0;
	    this._backoffStart = null;
	  },
	
	  _shouldBackoff: function() {
	    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
	  },
	
	  /**
	   * Returns true if the in-process data payload matches the signature
	   * of the previously-sent data
	   *
	   * NOTE: This has to be done at this level because TraceKit can generate
	   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
	   *       other old browsers). This can take the form of an "exception"
	   *       data object with a single frame (derived from the onerror args).
	   */
	  _isRepeatData: function(current) {
	    var last = this._lastData;
	
	    if (
	      !last ||
	      current.message !== last.message || // defined for captureMessage
	      current.transaction !== last.transaction // defined for captureException/onerror
	    )
	      return false;
	
	    // Stacktrace interface (i.e. from captureMessage)
	    if (current.stacktrace || last.stacktrace) {
	      return isSameStacktrace(current.stacktrace, last.stacktrace);
	    } else if (current.exception || last.exception) {
	      // Exception interface (i.e. from captureException/onerror)
	      return isSameException(current.exception, last.exception);
	    }
	
	    return true;
	  },
	
	  _setBackoffState: function(request) {
	    // If we are already in a backoff state, don't change anything
	    if (this._shouldBackoff()) {
	      return;
	    }
	
	    var status = request.status;
	
	    // 400 - project_id doesn't exist or some other fatal
	    // 401 - invalid/revoked dsn
	    // 429 - too many requests
	    if (!(status === 400 || status === 401 || status === 429)) return;
	
	    var retry;
	    try {
	      // If Retry-After is not in Access-Control-Expose-Headers, most
	      // browsers will throw an exception trying to access it
	      if (supportsFetch()) {
	        retry = request.headers.get('Retry-After');
	      } else {
	        retry = request.getResponseHeader('Retry-After');
	      }
	
	      // Retry-After is returned in seconds
	      retry = parseInt(retry, 10) * 1000;
	    } catch (e) {
	      /* eslint no-empty:0 */
	    }
	
	    this._backoffDuration = retry
	      ? // If Sentry server returned a Retry-After value, use it
	        retry
	      : // Otherwise, double the last backoff duration (starts at 1 sec)
	        this._backoffDuration * 2 || 1000;
	
	    this._backoffStart = now();
	  },
	
	  _send: function(data) {
	    var globalOptions = this._globalOptions;
	
	    var baseData = {
	        project: this._globalProject,
	        logger: globalOptions.logger,
	        platform: 'javascript'
	      },
	      httpData = this._getHttpData();
	
	    if (httpData) {
	      baseData.request = httpData;
	    }
	
	    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	    if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	    data = objectMerge(baseData, data);
	
	    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	    // Send along our own collected metadata with extra
	    data.extra['session:duration'] = now() - this._startTime;
	
	    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	      // intentionally make shallow copy so that additions
	      // to breadcrumbs aren't accidentally sent in this request
	      data.breadcrumbs = {
	        values: [].slice.call(this._breadcrumbs, 0)
	      };
	    }
	
	    if (this._globalContext.user) {
	      // sentry.interfaces.User
	      data.user = this._globalContext.user;
	    }
	
	    // Include the environment if it's defined in globalOptions
	    if (globalOptions.environment) data.environment = globalOptions.environment;
	
	    // Include the release if it's defined in globalOptions
	    if (globalOptions.release) data.release = globalOptions.release;
	
	    // Include server_name if it's defined in globalOptions
	    if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	    data = this._sanitizeData(data);
	
	    // Cleanup empty properties before sending them to the server
	    Object.keys(data).forEach(function(key) {
	      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
	        delete data[key];
	      }
	    });
	
	    if (isFunction(globalOptions.dataCallback)) {
	      data = globalOptions.dataCallback(data) || data;
	    }
	
	    // Why??????????
	    if (!data || isEmptyObject(data)) {
	      return;
	    }
	
	    // Check if the request should be filtered or not
	    if (
	      isFunction(globalOptions.shouldSendCallback) &&
	      !globalOptions.shouldSendCallback(data)
	    ) {
	      return;
	    }
	
	    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
	    // so drop requests until "cool-off" period has elapsed.
	    if (this._shouldBackoff()) {
	      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
	      return;
	    }
	
	    if (typeof globalOptions.sampleRate === 'number') {
	      if (Math.random() < globalOptions.sampleRate) {
	        this._sendProcessedPayload(data);
	      }
	    } else {
	      this._sendProcessedPayload(data);
	    }
	  },
	
	  _sanitizeData: function(data) {
	    return sanitize(data, this._globalOptions.sanitizeKeys);
	  },
	
	  _getUuid: function() {
	    return uuid4();
	  },
	
	  _sendProcessedPayload: function(data, callback) {
	    var self = this;
	    var globalOptions = this._globalOptions;
	
	    if (!this.isSetup()) return;
	
	    // Try and clean up the packet before sending by truncating long values
	    data = this._trimPacket(data);
	
	    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
	    // but this would require copying an un-truncated copy of the data packet, which can be
	    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
	    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
	      this._logDebug('warn', 'Raven dropped repeat event: ', data);
	      return;
	    }
	
	    // Send along an event_id if not explicitly passed.
	    // This event_id can be used to reference the error within Sentry itself.
	    // Set lastEventId after we know the error should actually be sent
	    this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	    // Store outbound payload after trim
	    this._lastData = data;
	
	    this._logDebug('debug', 'Raven about to send:', data);
	
	    var auth = {
	      sentry_version: '7',
	      sentry_client: 'raven-js/' + this.VERSION,
	      sentry_key: this._globalKey
	    };
	
	    if (this._globalSecret) {
	      auth.sentry_secret = this._globalSecret;
	    }
	
	    var exception = data.exception && data.exception.values[0];
	
	    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
	    if (
	      this._globalOptions.autoBreadcrumbs &&
	      this._globalOptions.autoBreadcrumbs.sentry
	    ) {
	      this.captureBreadcrumb({
	        category: 'sentry',
	        message: exception
	          ? (exception.type ? exception.type + ': ' : '') + exception.value
	          : data.message,
	        event_id: data.event_id,
	        level: data.level || 'error' // presume error unless specified
	      });
	    }
	
	    var url = this._globalEndpoint;
	    (globalOptions.transport || this._makeRequest).call(this, {
	      url: url,
	      auth: auth,
	      data: data,
	      options: globalOptions,
	      onSuccess: function success() {
	        self._resetBackoff();
	
	        self._triggerEvent('success', {
	          data: data,
	          src: url
	        });
	        callback && callback();
	      },
	      onError: function failure(error) {
	        self._logDebug('error', 'Raven transport failed to send: ', error);
	
	        if (error.request) {
	          self._setBackoffState(error.request);
	        }
	
	        self._triggerEvent('failure', {
	          data: data,
	          src: url
	        });
	        error = error || new Error('Raven send failed (no additional details provided)');
	        callback && callback(error);
	      }
	    });
	  },
	
	  _makeRequest: function(opts) {
	    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
	    var url = opts.url + '?' + urlencode(opts.auth);
	
	    var evaluatedHeaders = null;
	    var evaluatedFetchParameters = {};
	
	    if (opts.options.headers) {
	      evaluatedHeaders = this._evaluateHash(opts.options.headers);
	    }
	
	    if (opts.options.fetchParameters) {
	      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
	    }
	
	    if (supportsFetch()) {
	      evaluatedFetchParameters.body = stringify(opts.data);
	
	      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
	      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);
	
	      if (evaluatedHeaders) {
	        fetchOptions.headers = evaluatedHeaders;
	      }
	
	      return _window
	        .fetch(url, fetchOptions)
	        .then(function(response) {
	          if (response.ok) {
	            opts.onSuccess && opts.onSuccess();
	          } else {
	            var error = new Error('Sentry error code: ' + response.status);
	            // It's called request only to keep compatibility with XHR interface
	            // and not add more redundant checks in setBackoffState method
	            error.request = response;
	            opts.onError && opts.onError(error);
	          }
	        })
	        ['catch'](function() {
	          opts.onError &&
	            opts.onError(new Error('Sentry error code: network unavailable'));
	        });
	    }
	
	    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
	    if (!request) return;
	
	    // if browser doesn't support CORS (e.g. IE7), we are out of luck
	    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';
	
	    if (!hasCORS) return;
	
	    if ('withCredentials' in request) {
	      request.onreadystatechange = function() {
	        if (request.readyState !== 4) {
	          return;
	        } else if (request.status === 200) {
	          opts.onSuccess && opts.onSuccess();
	        } else if (opts.onError) {
	          var err = new Error('Sentry error code: ' + request.status);
	          err.request = request;
	          opts.onError(err);
	        }
	      };
	    } else {
	      request = new XDomainRequest();
	      // xdomainrequest cannot go http -> https (or vice versa),
	      // so always use protocol relative
	      url = url.replace(/^https?:/, '');
	
	      // onreadystatechange not supported by XDomainRequest
	      if (opts.onSuccess) {
	        request.onload = opts.onSuccess;
	      }
	      if (opts.onError) {
	        request.onerror = function() {
	          var err = new Error('Sentry error code: XDomainRequest');
	          err.request = request;
	          opts.onError(err);
	        };
	      }
	    }
	
	    request.open('POST', url);
	
	    if (evaluatedHeaders) {
	      each(evaluatedHeaders, function(key, value) {
	        request.setRequestHeader(key, value);
	      });
	    }
	
	    request.send(stringify(opts.data));
	  },
	
	  _evaluateHash: function(hash) {
	    var evaluated = {};
	
	    for (var key in hash) {
	      if (hash.hasOwnProperty(key)) {
	        var value = hash[key];
	        evaluated[key] = typeof value === 'function' ? value() : value;
	      }
	    }
	
	    return evaluated;
	  },
	
	  _logDebug: function(level) {
	    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
	    if (
	      this._originalConsoleMethods[level] &&
	      (this.debug || this._globalOptions.debug)
	    ) {
	      // In IE<10 console methods do not have their own 'apply' method
	      Function.prototype.apply.call(
	        this._originalConsoleMethods[level],
	        this._originalConsole,
	        [].slice.call(arguments, 1)
	      );
	    }
	  },
	
	  _mergeContext: function(key, context) {
	    if (isUndefined(context)) {
	      delete this._globalContext[key];
	    } else {
	      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	    }
	  }
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	var RavenConstructor = __webpack_require__(119);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function() {
	  _window.Raven = _Raven;
	  return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/**
	 * DISCLAIMER:
	 *
	 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
	 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
	 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
	 *
	 * It's called `Client' to be in-line with Raven Node implementation.
	 *
	 * HOWTO:
	 *
	 * import Raven from 'raven-js';
	 *
	 * const someAppReporter = new Raven.Client();
	 * const someOtherAppReporter = new Raven.Client();
	 *
	 * someAppReporter.config('__DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someOtherAppReporter.config('__OTHER_DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someAppReporter.captureMessage(...);
	 * someAppReporter.captureException(...);
	 * someAppReporter.captureBreadcrumb(...);
	 *
	 * someOtherAppReporter.captureMessage(...);
	 * someOtherAppReporter.captureException(...);
	 * someOtherAppReporter.captureBreadcrumb(...);
	 *
	 * It should "just work".
	 */
	module.exports.Client = RavenConstructor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(8);
	
	/*
	 TraceKit - Cross brower stack traces
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	  collectWindowErrors: true,
	  debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
	
	function getLocationHref() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	  return document.location.href;
	}
	
	function getLocationOrigin() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	
	  // Oh dear IE10...
	  if (!document.location.origin) {
	    document.location.origin =
	      document.location.protocol +
	      '//' +
	      document.location.hostname +
	      (document.location.port ? ':' + document.location.port : '');
	  }
	
	  return document.location.origin;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	  var handlers = [],
	    lastArgs = null,
	    lastException = null,
	    lastExceptionStack = null;
	
	  /**
	   * Add a crash handler.
	   * @param {Function} handler
	   */
	  function subscribe(handler) {
	    installGlobalHandler();
	    handlers.push(handler);
	  }
	
	  /**
	   * Remove a crash handler.
	   * @param {Function} handler
	   */
	  function unsubscribe(handler) {
	    for (var i = handlers.length - 1; i >= 0; --i) {
	      if (handlers[i] === handler) {
	        handlers.splice(i, 1);
	      }
	    }
	  }
	
	  /**
	   * Remove all crash handlers.
	   */
	  function unsubscribeAll() {
	    uninstallGlobalHandler();
	    handlers = [];
	  }
	
	  /**
	   * Dispatch stack information to all handlers.
	   * @param {Object.<string, *>} stack
	   */
	  function notifyHandlers(stack, isWindowError) {
	    var exception = null;
	    if (isWindowError && !TraceKit.collectWindowErrors) {
	      return;
	    }
	    for (var i in handlers) {
	      if (handlers.hasOwnProperty(i)) {
	        try {
	          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	        } catch (inner) {
	          exception = inner;
	        }
	      }
	    }
	
	    if (exception) {
	      throw exception;
	    }
	  }
	
	  var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	  /**
	   * Ensures all global unhandled exceptions are recorded.
	   * Supported by Gecko and IE.
	   * @param {string} msg Error message.
	   * @param {string} url URL of script that generated the exception.
	   * @param {(number|string)} lineNo The line number at which the error
	   * occurred.
	   * @param {?(number|string)} colNo The column number at which the error
	   * occurred.
	   * @param {?Error} ex The actual Error object.
	   */
	  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
	    var stack = null;
	    // If 'ex' is ErrorEvent, get real Error from inside
	    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
	    // If 'msg' is ErrorEvent, get real message from inside
	    var message = utils.isErrorEvent(msg) ? msg.message : msg;
	
	    if (lastExceptionStack) {
	      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
	        lastExceptionStack,
	        url,
	        lineNo,
	        message
	      );
	      processLastException();
	    } else if (exception && utils.isError(exception)) {
	      // non-string `exception` arg; attempt to extract stack trace
	
	      // New chrome and blink send along a real error object
	      // Let's just report that like a normal error.
	      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	      stack = TraceKit.computeStackTrace(exception);
	      notifyHandlers(stack, true);
	    } else {
	      var location = {
	        url: url,
	        line: lineNo,
	        column: colNo
	      };
	
	      var name = undefined;
	      var groups;
	
	      if ({}.toString.call(message) === '[object String]') {
	        var groups = message.match(ERROR_TYPES_RE);
	        if (groups) {
	          name = groups[1];
	          message = groups[2];
	        }
	      }
	
	      location.func = UNKNOWN_FUNCTION;
	
	      stack = {
	        name: name,
	        message: message,
	        url: getLocationHref(),
	        stack: [location]
	      };
	      notifyHandlers(stack, true);
	    }
	
	    if (_oldOnerrorHandler) {
	      return _oldOnerrorHandler.apply(this, arguments);
	    }
	
	    return false;
	  }
	
	  function installGlobalHandler() {
	    if (_onErrorHandlerInstalled) {
	      return;
	    }
	    _oldOnerrorHandler = _window.onerror;
	    _window.onerror = traceKitWindowOnError;
	    _onErrorHandlerInstalled = true;
	  }
	
	  function uninstallGlobalHandler() {
	    if (!_onErrorHandlerInstalled) {
	      return;
	    }
	    _window.onerror = _oldOnerrorHandler;
	    _onErrorHandlerInstalled = false;
	    _oldOnerrorHandler = undefined;
	  }
	
	  function processLastException() {
	    var _lastExceptionStack = lastExceptionStack,
	      _lastArgs = lastArgs;
	    lastArgs = null;
	    lastExceptionStack = null;
	    lastException = null;
	    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	  }
	
	  /**
	   * Reports an unhandled Error to TraceKit.
	   * @param {Error} ex
	   * @param {?boolean} rethrow If false, do not re-throw the exception.
	   * Only used for window.onerror to not cause an infinite loop of
	   * rethrowing.
	   */
	  function report(ex, rethrow) {
	    var args = _slice.call(arguments, 1);
	    if (lastExceptionStack) {
	      if (lastException === ex) {
	        return; // already caught by an inner catch block, ignore
	      } else {
	        processLastException();
	      }
	    }
	
	    var stack = TraceKit.computeStackTrace(ex);
	    lastExceptionStack = stack;
	    lastException = ex;
	    lastArgs = args;
	
	    // If the stack trace is incomplete, wait for 2 seconds for
	    // slow slow IE to see if onerror occurs or not before reporting
	    // this exception; otherwise, we will end up with an incomplete
	    // stack trace
	    setTimeout(function() {
	      if (lastException === ex) {
	        processLastException();
	      }
	    }, stack.incomplete ? 2000 : 0);
	
	    if (rethrow !== false) {
	      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	    }
	  }
	
	  report.subscribe = subscribe;
	  report.unsubscribe = unsubscribe;
	  report.uninstall = unsubscribeAll;
	  return report;
	})();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	  // Contents of Exception in various browsers.
	  //
	  // SAFARI:
	  // ex.message = Can't find variable: qq
	  // ex.line = 59
	  // ex.sourceId = 580238192
	  // ex.sourceURL = http://...
	  // ex.expressionBeginOffset = 96
	  // ex.expressionCaretOffset = 98
	  // ex.expressionEndOffset = 98
	  // ex.name = ReferenceError
	  //
	  // FIREFOX:
	  // ex.message = qq is not defined
	  // ex.fileName = http://...
	  // ex.lineNumber = 59
	  // ex.columnNumber = 69
	  // ex.stack = ...stack trace... (see the example below)
	  // ex.name = ReferenceError
	  //
	  // CHROME:
	  // ex.message = qq is not defined
	  // ex.name = ReferenceError
	  // ex.type = not_defined
	  // ex.arguments = ['aa']
	  // ex.stack = ...stack trace...
	  //
	  // INTERNET EXPLORER:
	  // ex.message = ...
	  // ex.name = ReferenceError
	  //
	  // OPERA:
	  // ex.message = ...message... (see the example below)
	  // ex.name = ReferenceError
	  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	  /**
	   * Computes stack trace information from the stack property.
	   * Chrome and Gecko use this property.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceFromStackProp(ex) {
	    if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
	    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
	    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
	    // Used to additionally parse URL/line/column from eval frames
	    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	    var lines = ex.stack.split('\n');
	    var stack = [];
	    var submatch;
	    var parts;
	    var element;
	    var reference = /^(.*) is undefined$/.exec(ex.message);
	
	    for (var i = 0, j = lines.length; i < j; ++i) {
	      if ((parts = chrome.exec(lines[i]))) {
	        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	          // throw out eval line/column and use top-most line/column number
	          parts[2] = submatch[1]; // url
	          parts[3] = submatch[2]; // line
	          parts[4] = submatch[3]; // column
	        }
	        element = {
	          url: !isNative ? parts[2] : null,
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: isNative ? [parts[2]] : [],
	          line: parts[3] ? +parts[3] : null,
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = winjs.exec(lines[i]))) {
	        element = {
	          url: parts[2],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: [],
	          line: +parts[3],
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = gecko.exec(lines[i]))) {
	        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	          // throw out eval line/column and use top-most line number
	          parts[3] = submatch[1];
	          parts[4] = submatch[2];
	          parts[5] = null; // no column when eval
	        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
	          // FireFox uses this awesome columnNumber property for its top frame
	          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	          // so adding 1
	          // NOTE: this hack doesn't work if top-most frame is eval
	          stack[0].column = ex.columnNumber + 1;
	        }
	        element = {
	          url: parts[3],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: parts[2] ? parts[2].split(',') : [],
	          line: parts[4] ? +parts[4] : null,
	          column: parts[5] ? +parts[5] : null
	        };
	      } else {
	        continue;
	      }
	
	      if (!element.func && element.line) {
	        element.func = UNKNOWN_FUNCTION;
	      }
	
	      if (element.url && element.url.substr(0, 5) === 'blob:') {
	        // Special case for handling JavaScript loaded into a blob.
	        // We use a synchronous AJAX request here as a blob is already in
	        // memory - it's not making a network request.  This will generate a warning
	        // in the browser console, but there has already been an error so that's not
	        // that much of an issue.
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', element.url, false);
	        xhr.send(null);
	
	        // If we failed to download the source, skip this patch
	        if (xhr.status === 200) {
	          var source = xhr.responseText || '';
	
	          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
	          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
	          source = source.slice(-300);
	
	          // Now we dig out the source map URL
	          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);
	
	          // If we don't find a source map comment or we find more than one, continue on to the next element.
	          if (sourceMaps) {
	            var sourceMapAddress = sourceMaps[1];
	
	            // Now we check to see if it's a relative URL.
	            // If it is, convert it to an absolute one.
	            if (sourceMapAddress.charAt(0) === '~') {
	              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
	            }
	
	            // Now we strip the '.map' off of the end of the URL and update the
	            // element so that Sentry can match the map to the blob.
	            element.url = sourceMapAddress.slice(0, -4);
	          }
	        }
	      }
	
	      stack.push(element);
	    }
	
	    if (!stack.length) {
	      return null;
	    }
	
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	  }
	
	  /**
	   * Adds information about the first frame to incomplete stack traces.
	   * Safari and IE require this to get complete data on the first frame.
	   * @param {Object.<string, *>} stackInfo Stack trace information from
	   * one of the compute* methods.
	   * @param {string} url The URL of the script that caused an error.
	   * @param {(number|string)} lineNo The line number of the script that
	   * caused an error.
	   * @param {string=} message The error generated by the browser, which
	   * hopefully contains the name of the object that caused the error.
	   * @return {boolean} Whether or not the stack information was
	   * augmented.
	   */
	  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	    var initial = {
	      url: url,
	      line: lineNo
	    };
	
	    if (initial.url && initial.line) {
	      stackInfo.incomplete = false;
	
	      if (!initial.func) {
	        initial.func = UNKNOWN_FUNCTION;
	      }
	
	      if (stackInfo.stack.length > 0) {
	        if (stackInfo.stack[0].url === initial.url) {
	          if (stackInfo.stack[0].line === initial.line) {
	            return false; // already in stack trace
	          } else if (
	            !stackInfo.stack[0].line &&
	            stackInfo.stack[0].func === initial.func
	          ) {
	            stackInfo.stack[0].line = initial.line;
	            return false;
	          }
	        }
	      }
	
	      stackInfo.stack.unshift(initial);
	      stackInfo.partial = true;
	      return true;
	    } else {
	      stackInfo.incomplete = true;
	    }
	
	    return false;
	  }
	
	  /**
	   * Computes stack trace information by walking the arguments.caller
	   * chain at the time the exception occurred. This will cause earlier
	   * frames to be missed but is the only way to get any stack trace in
	   * Safari and IE. The top frame is restored by
	   * {@link augmentStackTraceWithInitialElement}.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceByWalkingCallerChain(ex, depth) {
	    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	      stack = [],
	      funcs = {},
	      recursion = false,
	      parts,
	      item,
	      source;
	
	    for (
	      var curr = computeStackTraceByWalkingCallerChain.caller;
	      curr && !recursion;
	      curr = curr.caller
	    ) {
	      if (curr === computeStackTrace || curr === TraceKit.report) {
	        // console.log('skipping internal function');
	        continue;
	      }
	
	      item = {
	        url: null,
	        func: UNKNOWN_FUNCTION,
	        line: null,
	        column: null
	      };
	
	      if (curr.name) {
	        item.func = curr.name;
	      } else if ((parts = functionName.exec(curr.toString()))) {
	        item.func = parts[1];
	      }
	
	      if (typeof item.func === 'undefined') {
	        try {
	          item.func = parts.input.substring(0, parts.input.indexOf('{'));
	        } catch (e) {}
	      }
	
	      if (funcs['' + curr]) {
	        recursion = true;
	      } else {
	        funcs['' + curr] = true;
	      }
	
	      stack.push(item);
	    }
	
	    if (depth) {
	      // console.log('depth is ' + depth);
	      // console.log('stack is ' + stack.length);
	      stack.splice(0, depth);
	    }
	
	    var result = {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	    augmentStackTraceWithInitialElement(
	      result,
	      ex.sourceURL || ex.fileName,
	      ex.line || ex.lineNumber,
	      ex.message || ex.description
	    );
	    return result;
	  }
	
	  /**
	   * Computes a stack trace for an exception.
	   * @param {Error} ex
	   * @param {(string|number)=} depth
	   */
	  function computeStackTrace(ex, depth) {
	    var stack = null;
	    depth = depth == null ? 0 : +depth;
	
	    try {
	      stack = computeStackTraceFromStackProp(ex);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	
	    try {
	      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref()
	    };
	  }
	
	  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	  return computeStackTrace;
	})();
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 122 */
/***/ function(module, exports) {

	/*
	 * JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	/*
	* Add integers, wrapping at 2^32. This uses 16-bit operations internally
	* to work around bugs in some JS interpreters.
	*/
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xffff);
	}
	
	/*
	* Bitwise rotate a 32-bit number to the left.
	*/
	function bitRotateLeft(num, cnt) {
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	/*
	* These functions implement the four basic operations the algorithm uses.
	*/
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
	}
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
	}
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	/*
	* Calculate the MD5 of an array of little-endian words, and a bit length.
	*/
	function binlMD5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << (len % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	  return [a, b, c, d];
	}
	
	/*
	* Convert an array of little-endian words to a string
	*/
	function binl2rstr(input) {
	  var i;
	  var output = '';
	  var length32 = input.length * 32;
	  for (i = 0; i < length32; i += 8) {
	    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
	  }
	  return output;
	}
	
	/*
	* Convert a raw string to an array of little-endian words
	* Characters >255 have their high-byte silently ignored.
	*/
	function rstr2binl(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	  var length8 = input.length * 8;
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
	  }
	  return output;
	}
	
	/*
	* Calculate the MD5 of a raw string
	*/
	function rstrMD5(s) {
	  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
	}
	
	/*
	* Calculate the HMAC-MD5, of a key and some data (raw strings)
	*/
	function rstrHMACMD5(key, data) {
	  var i;
	  var bkey = rstr2binl(key);
	  var ipad = [];
	  var opad = [];
	  var hash;
	  ipad[15] = opad[15] = undefined;
	  if (bkey.length > 16) {
	    bkey = binlMD5(bkey, key.length * 8);
	  }
	  for (i = 0; i < 16; i += 1) {
	    ipad[i] = bkey[i] ^ 0x36363636;
	    opad[i] = bkey[i] ^ 0x5c5c5c5c;
	  }
	  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
	  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
	}
	
	/*
	* Convert a raw string to a hex string
	*/
	function rstr2hex(input) {
	  var hexTab = '0123456789abcdef';
	  var output = '';
	  var x;
	  var i;
	  for (i = 0; i < input.length; i += 1) {
	    x = input.charCodeAt(i);
	    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
	  }
	  return output;
	}
	
	/*
	* Encode a string as utf-8
	*/
	function str2rstrUTF8(input) {
	  return unescape(encodeURIComponent(input));
	}
	
	/*
	* Take string arguments and return either raw or hex encoded strings
	*/
	function rawMD5(s) {
	  return rstrMD5(str2rstrUTF8(s));
	}
	function hexMD5(s) {
	  return rstr2hex(rawMD5(s));
	}
	function rawHMACMD5(k, d) {
	  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
	}
	function hexHMACMD5(k, d) {
	  return rstr2hex(rawHMACMD5(k, d));
	}
	
	function md5(string, key, raw) {
	  if (!key) {
	    if (!raw) {
	      return hexMD5(string);
	    }
	    return rawMD5(string);
	  }
	  if (!raw) {
	    return hexHMACMD5(key, string);
	  }
	  return rawHMACMD5(key, string);
	}
	
	module.exports = md5;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.2.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__(116)) :
		typeof define === 'function' && define.amd ? define(['popper.js'], factory) :
		(global.Tooltip = factory(global.Popper));
	}(this, (function (Popper) { 'use strict';
	
	Popper = Popper && Popper.hasOwnProperty('default') ? Popper['default'] : Popper;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var DEFAULT_OPTIONS = {
	  container: false,
	  delay: 0,
	  html: false,
	  placement: 'top',
	  title: '',
	  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	  trigger: 'hover focus',
	  offset: 0
	};
	
	var Tooltip = function () {
	  /**
	   * Create a new Tooltip.js instance
	   * @class Tooltip
	   * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
	   * @param {Object} options
	   * @param {String|PlacementFunction} options.placement=top
	   *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
	   *      left(-start, -end)`
	   * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
	   * @param {Number|Object} options.delay=0
	   *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
	   *      If a number is supplied, delay is applied to both hide/show.
	   *      Object structure is: `{ show: 500, hide: 100 }`
	   * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `textContent`.
	   * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
	   * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
	   *      Base HTML to used when creating the tooltip.
	   *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
	   *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
	   *      The outermost wrapper element should have the `.tooltip` class.
	   * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
	   * @param {String} [options.trigger='hover focus']
	   *      How tooltip is triggered - click, hover, focus, manual.
	   *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
	   * @param {String|HTMLElement} options.boundariesElement
	   *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
	   *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
	   * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
	   *      [offset docs](https://popper.js.org/popper-documentation.html)
	   * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
	   *      [options docs](https://popper.js.org/popper-documentation.html)
	   * @return {Object} instance - The generated tooltip instance
	   */
	  function Tooltip(reference, options) {
	    classCallCheck(this, Tooltip);
	
	    _initialiseProps.call(this);
	
	    // apply user options over default ones
	    options = _extends({}, DEFAULT_OPTIONS, options);
	
	    reference.jquery && (reference = reference[0]);
	
	    // cache reference and options
	    this.reference = reference;
	    this.options = options;
	
	    // get events list
	    var events = typeof options.trigger === 'string' ? options.trigger.split(' ').filter(function (trigger) {
	      return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
	    }) : [];
	
	    // set initial state
	    this._isOpen = false;
	    this._popperOptions = {};
	
	    // set event listeners
	    this._setEventListeners(reference, events, options);
	  }
	
	  //
	  // Public methods
	  //
	
	  /**
	   * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
	   * Tooltips with zero-length titles are never displayed.
	   * @method Tooltip#show
	   * @memberof Tooltip
	   */
	
	
	  /**
	   * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
	   * @method Tooltip#hide
	   * @memberof Tooltip
	   */
	
	
	  /**
	   * Hides and destroys an element’s tooltip.
	   * @method Tooltip#dispose
	   * @memberof Tooltip
	   */
	
	
	  /**
	   * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
	   * @method Tooltip#toggle
	   * @memberof Tooltip
	   */
	
	
	  /**
	   * Updates the tooltip's title content
	   * @method Tooltip#updateTitleContent
	   * @memberof Tooltip
	   * @param {String|HTMLElement} title - The new content to use for the title
	   */
	
	
	  //
	  // Defaults
	  //
	
	
	  //
	  // Private methods
	  //
	
	  createClass(Tooltip, [{
	    key: '_create',
	
	
	    /**
	     * Creates a new tooltip node
	     * @memberof Tooltip
	     * @private
	     * @param {HTMLElement} reference
	     * @param {String} template
	     * @param {String|HTMLElement|TitleFunction} title
	     * @param {Boolean} allowHtml
	     * @return {HTMLElement} tooltipNode
	     */
	    value: function _create(reference, template, title, allowHtml) {
	      // create tooltip element
	      var tooltipGenerator = window.document.createElement('div');
	      tooltipGenerator.innerHTML = template.trim();
	      var tooltipNode = tooltipGenerator.childNodes[0];
	
	      // add unique ID to our tooltip (needed for accessibility reasons)
	      tooltipNode.id = 'tooltip_' + Math.random().toString(36).substr(2, 10);
	
	      // set initial `aria-hidden` state to `false` (it's visible!)
	      tooltipNode.setAttribute('aria-hidden', 'false');
	
	      // add title to tooltip
	      var titleNode = tooltipGenerator.querySelector(this.innerSelector);
	      this._addTitleContent(reference, title, allowHtml, titleNode);
	
	      // return the generated tooltip node
	      return tooltipNode;
	    }
	  }, {
	    key: '_addTitleContent',
	    value: function _addTitleContent(reference, title, allowHtml, titleNode) {
	      if (title.nodeType === 1 || title.nodeType === 11) {
	        // if title is a element node or document fragment, append it only if allowHtml is true
	        allowHtml && titleNode.appendChild(title);
	      } else if (isFunction(title)) {
	        // if title is a function, call it and set textContent or innerHtml depending by `allowHtml` value
	        var titleText = title.call(reference);
	        allowHtml ? titleNode.innerHTML = titleText : titleNode.textContent = titleText;
	      } else {
	        // if it's just a simple text, set textContent or innerHtml depending by `allowHtml` value
	        allowHtml ? titleNode.innerHTML = title : titleNode.textContent = title;
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show(reference, options) {
	      // don't show if it's already visible
	      // or if it's not being showed
	      if (this._isOpen && !this._isOpening) {
	        return this;
	      }
	      this._isOpen = true;
	
	      // if the tooltipNode already exists, just show it
	      if (this._tooltipNode) {
	        this._tooltipNode.style.display = '';
	        this._tooltipNode.setAttribute('aria-hidden', 'false');
	        this.popperInstance.update();
	        return this;
	      }
	
	      // get title
	      var title = reference.getAttribute('title') || options.title;
	
	      // don't show tooltip if no title is defined
	      if (!title) {
	        return this;
	      }
	
	      // create tooltip node
	      var tooltipNode = this._create(reference, options.template, title, options.html);
	
	      // Add `aria-describedby` to our reference element for accessibility reasons
	      reference.setAttribute('aria-describedby', tooltipNode.id);
	
	      // append tooltip to container
	      var container = this._findContainer(options.container, reference);
	
	      this._append(tooltipNode, container);
	
	      this._popperOptions = _extends({}, options.popperOptions, {
	        placement: options.placement
	      });
	
	      this._popperOptions.modifiers = _extends({}, this._popperOptions.modifiers, {
	        arrow: {
	          element: this.arrowSelector
	        },
	        offset: {
	          offset: options.offset
	        }
	      });
	
	      if (options.boundariesElement) {
	        this._popperOptions.modifiers.preventOverflow = {
	          boundariesElement: options.boundariesElement
	        };
	      }
	
	      this.popperInstance = new Popper(reference, tooltipNode, this._popperOptions);
	
	      this._tooltipNode = tooltipNode;
	
	      return this;
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() /*reference, options*/{
	      // don't hide if it's already hidden
	      if (!this._isOpen) {
	        return this;
	      }
	
	      this._isOpen = false;
	
	      // hide tooltipNode
	      this._tooltipNode.style.display = 'none';
	      this._tooltipNode.setAttribute('aria-hidden', 'true');
	
	      return this;
	    }
	  }, {
	    key: '_dispose',
	    value: function _dispose() {
	      var _this = this;
	
	      // remove event listeners first to prevent any unexpected behaviour
	      this._events.forEach(function (_ref) {
	        var func = _ref.func,
	            event = _ref.event;
	
	        _this.reference.removeEventListener(event, func);
	      });
	      this._events = [];
	
	      if (this._tooltipNode) {
	        this._hide();
	
	        // destroy instance
	        this.popperInstance.destroy();
	
	        // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element
	        if (!this.popperInstance.options.removeOnDestroy) {
	          this._tooltipNode.parentNode.removeChild(this._tooltipNode);
	          this._tooltipNode = null;
	        }
	      }
	      return this;
	    }
	  }, {
	    key: '_findContainer',
	    value: function _findContainer(container, reference) {
	      // if container is a query, get the relative element
	      if (typeof container === 'string') {
	        container = window.document.querySelector(container);
	      } else if (container === false) {
	        // if container is `false`, set it to reference parent
	        container = reference.parentNode;
	      }
	      return container;
	    }
	
	    /**
	     * Append tooltip to container
	     * @memberof Tooltip
	     * @private
	     * @param {HTMLElement} tooltipNode
	     * @param {HTMLElement|String|false} container
	     */
	
	  }, {
	    key: '_append',
	    value: function _append(tooltipNode, container) {
	      container.appendChild(tooltipNode);
	    }
	  }, {
	    key: '_setEventListeners',
	    value: function _setEventListeners(reference, events, options) {
	      var _this2 = this;
	
	      var directEvents = [];
	      var oppositeEvents = [];
	
	      events.forEach(function (event) {
	        switch (event) {
	          case 'hover':
	            directEvents.push('mouseenter');
	            oppositeEvents.push('mouseleave');
	            break;
	          case 'focus':
	            directEvents.push('focus');
	            oppositeEvents.push('blur');
	            break;
	          case 'click':
	            directEvents.push('click');
	            oppositeEvents.push('click');
	            break;
	        }
	      });
	
	      // schedule show tooltip
	      directEvents.forEach(function (event) {
	        var func = function func(evt) {
	          if (_this2._isOpening === true) {
	            return;
	          }
	          evt.usedByTooltip = true;
	          _this2._scheduleShow(reference, options.delay, options, evt);
	        };
	        _this2._events.push({ event: event, func: func });
	        reference.addEventListener(event, func);
	      });
	
	      // schedule hide tooltip
	      oppositeEvents.forEach(function (event) {
	        var func = function func(evt) {
	          if (evt.usedByTooltip === true) {
	            return;
	          }
	          _this2._scheduleHide(reference, options.delay, options, evt);
	        };
	        _this2._events.push({ event: event, func: func });
	        reference.addEventListener(event, func);
	      });
	    }
	  }, {
	    key: '_scheduleShow',
	    value: function _scheduleShow(reference, delay, options /*, evt */) {
	      var _this3 = this;
	
	      this._isOpening = true;
	      // defaults to 0
	      var computedDelay = delay && delay.show || delay || 0;
	      this._showTimeout = window.setTimeout(function () {
	        return _this3._show(reference, options);
	      }, computedDelay);
	    }
	  }, {
	    key: '_scheduleHide',
	    value: function _scheduleHide(reference, delay, options, evt) {
	      var _this4 = this;
	
	      this._isOpening = false;
	      // defaults to 0
	      var computedDelay = delay && delay.hide || delay || 0;
	      window.setTimeout(function () {
	        window.clearTimeout(_this4._showTimeout);
	        if (_this4._isOpen === false) {
	          return;
	        }
	        if (!document.body.contains(_this4._tooltipNode)) {
	          return;
	        }
	
	        // if we are hiding because of a mouseleave, we must check that the new
	        // reference isn't the tooltip, because in this case we don't want to hide it
	        if (evt.type === 'mouseleave') {
	          var isSet = _this4._setTooltipNodeEvent(evt, reference, delay, options);
	
	          // if we set the new event, don't hide the tooltip yet
	          // the new event will take care to hide it if necessary
	          if (isSet) {
	            return;
	          }
	        }
	
	        _this4._hide(reference, options);
	      }, computedDelay);
	    }
	  }, {
	    key: '_updateTitleContent',
	    value: function _updateTitleContent(title) {
	      if (typeof this._tooltipNode === 'undefined') {
	        if (typeof this.options.title !== 'undefined') {
	          this.options.title = title;
	        }
	        return;
	      }
	      var titleNode = this._tooltipNode.parentNode.querySelector(this.innerSelector);
	      this._clearTitleContent(titleNode, this.options.html, this.reference.getAttribute('title') || this.options.title);
	      this._addTitleContent(this.reference, title, this.options.html, titleNode);
	      this.options.title = title;
	      this.popperInstance.update();
	    }
	  }, {
	    key: '_clearTitleContent',
	    value: function _clearTitleContent(titleNode, allowHtml, lastTitle) {
	      if (lastTitle.nodeType === 1 || lastTitle.nodeType === 11) {
	        allowHtml && titleNode.removeChild(lastTitle);
	      } else {
	        allowHtml ? titleNode.innerHTML = '' : titleNode.textContent = '';
	      }
	    }
	  }]);
	  return Tooltip;
	}();
	
	/**
	 * Placement function, its context is the Tooltip instance.
	 * @memberof Tooltip
	 * @callback PlacementFunction
	 * @param {HTMLElement} tooltip - tooltip DOM node.
	 * @param {HTMLElement} reference - reference DOM node.
	 * @return {String} placement - One of the allowed placement options.
	 */
	
	/**
	 * Title function, its context is the Tooltip instance.
	 * @memberof Tooltip
	 * @callback TitleFunction
	 * @return {String} placement - The desired title.
	 */
	
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.show = function () {
	    return _this5._show(_this5.reference, _this5.options);
	  };
	
	  this.hide = function () {
	    return _this5._hide();
	  };
	
	  this.dispose = function () {
	    return _this5._dispose();
	  };
	
	  this.toggle = function () {
	    if (_this5._isOpen) {
	      return _this5.hide();
	    } else {
	      return _this5.show();
	    }
	  };
	
	  this.updateTitleContent = function (title) {
	    return _this5._updateTitleContent(title);
	  };
	
	  this.arrowSelector = '.tooltip-arrow, .tooltip__arrow';
	  this.innerSelector = '.tooltip-inner, .tooltip__inner';
	  this._events = [];
	
	  this._setTooltipNodeEvent = function (evt, reference, delay, options) {
	    var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;
	
	    var callback = function callback(evt2) {
	      var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget;
	
	      // Remove event listener after call
	      _this5._tooltipNode.removeEventListener(evt.type, callback);
	
	      // If the new reference is not the reference element
	      if (!reference.contains(relatedreference2)) {
	        // Schedule to hide tooltip
	        _this5._scheduleHide(reference, options.delay, options, evt2);
	      }
	    };
	
	    if (_this5._tooltipNode.contains(relatedreference)) {
	      // listen to mouseleave on the tooltip element to be able to hide the tooltip
	      _this5._tooltipNode.addEventListener(evt.type, callback);
	      return true;
	    }
	
	    return false;
	  };
	};
	
	return Tooltip;
	
	})));
	//# sourceMappingURL=tooltip.js.map


/***/ },
/* 124 */,
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(3);
	var moment = __webpack_require__(5);
	
	var helpMenuTemplate = __webpack_require__(84)();
	var settingsMenuTemplate = __webpack_require__(106)();
	
	commonCtrl.$inject = ['$rootScope', '$scope', '$window', 'router', 'load', 'login', 'loadScript', 'storage'];
	
	function commonCtrl($rootScope, $scope, $window, router, load, login, loadScript, storage) {
	
	
	  $scope.router = router;
	  $scope.page = router.page().replace(/\//g, '-');
	
	  $scope.baseUrl = ("https://dev-planandgo.aws.di.no");
	
	  $scope.helpMenuTemplate = helpMenuTemplate;
	  $scope.settingsMenuTemplate = settingsMenuTemplate;
	
	  $scope.values = util.values;
	
	  $scope.closeModal = function () {
	    $scope._modal && $scope._modal.close();
	  };
	
	  $scope.loadCommonData = function () {
	    load.users();
	    load.driverUsers();
	    load.companies();
	    load.settings();
	  };
	
	  load.getDowntime();
	
	  $scope.handleDeviationsLink = function () {
	    return $rootScope.settings && $rootScope.settings.customerSystemSettings && $rootScope.settings.customerSystemSettings.some(function (css) {
	      return css.handleDevatiations;
	    });
	  };
	
	  $scope.commonDataLoaded = function() {
	    return $scope.companies && $scope.settings && true;
	  };
	
	  loadScript
	    .load('https://cdn.headwayapp.co/widget.js')
	    .then(function() {
	      $window.Headway.init();
	    });
	
	  $scope.login = login.login.bind(null, $scope);
	  $scope.forgotPasswordURL = function(username) {
	    //var includingUsername = username ? '&userNameOrEmail=' + username : '';
	    return ("https://dev-app.di.no") + '/auth/static/password/reset?appKey=plango';
	  };
	
	}
	
	module.exports = commonCtrl;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var distributionProgressTooltipTemplate = __webpack_require__(72)();
	var distributionRoutePlanProgressTooltipTemplate = __webpack_require__(73)();
	var distributionRoutesProgressTooltipTemplate = __webpack_require__(74)();
	var distributionOutdatedAppTooltipTemplate = __webpack_require__(71)();
	var routeStatusTooltipTemplate = __webpack_require__(26)();
	var routeInfoTooltipTemplate = __webpack_require__(100)();
	var deliveryInfoTooltipTemplate = __webpack_require__(21)();
	var notificationsTooltipTemplate = __webpack_require__(25)();
	var customerTimestampTooltipTemplate = __webpack_require__(20)();
	var customerCallLogTooltipTemplate = __webpack_require__(19)();
	var util = __webpack_require__(3);
	var moment = __webpack_require__(5);
	
	distributionCtrl.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$controller', 'load', 'editRoutePlan'];
	
	function distributionCtrl($scope, $rootScope, $routeParams, $location, $controller, load, editRoutePlan) {
	
	  $controller('commonCtrl', { $scope: $scope });
	
	  $scope.distributionProgressTooltipTemplate = distributionProgressTooltipTemplate;
	  $scope.distributionRoutePlanProgressTooltipTemplate = distributionRoutePlanProgressTooltipTemplate;
	  $scope.distributionOutdatedAppTooltipTemplate = distributionOutdatedAppTooltipTemplate;
	  $scope.distributionRoutesProgressTooltipTemplate = distributionRoutesProgressTooltipTemplate;
	  $scope.routeStatusTooltipTemplate = routeStatusTooltipTemplate;
	  $scope.routeInfoTooltipTemplate = routeInfoTooltipTemplate;
	  $scope.deliveryInfoTooltipTemplate = deliveryInfoTooltipTemplate;
	  $scope.notificationsTooltipTemplate = notificationsTooltipTemplate;
	  $scope.customerTimestampTooltipTemplate = customerTimestampTooltipTemplate;
	  $scope.customerCallLogTooltipTemplate = customerCallLogTooltipTemplate;
	
	  // EditRoutePlan-service (mappings)
	  $scope.openEditRoutePlan = editRoutePlan.openEditRoutePlan.bind(this, $scope);
	  $scope.saveRoutePlan = editRoutePlan.saveRoutePlan.bind(this, $scope);
	  $scope.deleteRoutePlan = editRoutePlan.deleteRoutePlan.bind(this, $scope);
	
	  $scope.archive = $location.hash() === 'archive';
	  $scope.isDeviationsPage = $scope.router.page() === 'distribution/deviations';
	  $scope.query = $routeParams.q;
	
	  $scope.search = {
	    delayed: undefined,
	    customer: $scope.query
	  };
	
	  var loadData = function(date, distrNo) {
	    $scope.customers = null;
	
	    if (date) {
	      $scope.distributions = null;
	      load.distribution(date, distrNo).then(loadCustomers);
	    } else {
	      $scope.distribution = null;
	      load.distributions();
	    }
	
	    load.customerSystems();
	    $scope.loadCommonData();
	  };
	
	  var loadCustomers = function(distribution) {
	
	    var setCustomers = function(customers) {
	      if ($scope.distribution) {
	        $scope.distribution.customers = customers;
	        $scope.customers = $scope.distribution.customers;
	      }
	    };
	
	    setCustomers(null);
	
	    if ($scope.isDeviationsPage) {
	      load.distributionCustomers(distribution, 'deviations').then(setCustomers);
	    } else if ($scope.query) {
	      load.distributionCustomers(distribution, 'search', $scope.query).then(setCustomers);
	    }
	  };
	
	  if ($rootScope.auth) {
	    loadData($routeParams.date, +$routeParams.distrNo);
	  }
	
	  $scope.dataLoaded = function() {
	    if (! $rootScope.auth) return true;
	    if (! $scope.commonDataLoaded()) return false;
	
	    if ($routeParams.date) {
	      return $scope.distribution &&
	             $scope.distribution.date === $routeParams.date &&
	             $scope.distribution.distrNo === +$routeParams.distrNo &&
	             ($scope.customers || ! ($scope.query || $scope.isDeviationsPage)) &&
	             true;
	    } else {
	      return $scope.distributions && true;
	    }
	  };
	
	  $scope.customerSystemNames = function(routePlans) {
	    var customerSystemIdMap = {};
	    routePlans.forEach(function(routePlan) {
	      routePlan.customerSystems.forEach(function (csId) {
	        customerSystemIdMap[csId] = csId;
	      });
	    });
	
	    var name = function(id) {
	      if ($scope.customerSystems && $scope.customerSystems[id]) {
	        return $scope.customerSystems[id].name;
	      }
	      return '???';
	    };
	
	    return (Object.keys(customerSystemIdMap) || [])
	      .map(name)
	      .filter(Boolean) // The routePlan may contain customerSystems not included in $scope.customerSystems
	      .sort();
	  };
	
	  $scope.estimatedTimeAdjustedByRoute = function(estimatedTimestamp, routeId) {
	    var route = $scope.distribution.findRoute(routeId);
	    if (route && route.delayInMinutes()) {
	      var minutes = route.delayInMinutes();
	      if (minutes) {
	        return moment(estimatedTimestamp).add(minutes, 'minutes');
	      }
	    }
	    return estimatedTimestamp;
	  };
	
	  $scope.delayedCustomer = function(actually, estimated) {
	    return util.delayForHumans(util.delayInMinutes(util.toDate(actually), util.toDate(estimated)));
	  };
	
	  $scope.formatPhone = __webpack_require__(3).formatPhone;
	
	  $scope.goToSearch = function() {
	    var url = $scope.router.link('distribution', null, $scope.distribution) + '/search';
	
	    $location.path(url.replace('#', '')).search('q', $scope.search.customer);
	  };
	
	}
	
	module.exports = distributionCtrl;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var editDriverUserTemplate = __webpack_require__(79)();
	var t = __webpack_require__(4).t;
	
	driverUsersCtrl.$inject = ['$scope', '$rootScope', '$controller', '$routeParams', '$filter', '$window', '$document', '$timeout', 'modal', 'load'];
	
	function driverUsersCtrl($scope, $rootScope, $controller, $routeParams, $filter, $window, $document, $timeout, modal, load) {
	
	  $controller('planCtrl', { $scope: $scope });
	
	  $scope.search = {
	    text: undefined
	  };
	
	  $scope.formatPhone = __webpack_require__(3).formatPhone;
	  var latinize = __webpack_require__(3).latinize;
	
	  $scope.filter = {
	    active: true
	  };
	
	  $scope.languages = [
	    { id: 'no', name: 'Norsk' },
	    { id: 'sv', name: 'Svenska' },
	    { id: 'fi', name: 'Suomalainen' },
	    { id: 'en', name: 'English' },
	    { id: 'fr', name: 'Français' }
	  ];
	
	  $scope.setStatus = function($event, active) {
	    $scope.filter.active = active;
	    $event.preventDefault();
	  };
	
	  $scope.countStatus = function(active) {
	    var users = $rootScope.driverUsers;
	
	    return $filter('filter')(users, {
	      active: active
	    }).length;
	  };
	
	  $scope.openEditUser = function(user) {
	
	    if (user) {
	      $scope.user = user.editClone();
	    } else {
	      $scope.user = {
	        userName: "",
	        regeneratePassword: true,
	        isNewUser: true
	      };
	    }
	
	    modal.open({
	      scope: $scope,
	      klass: 'edit-user',
	      title: t(user ? 'driverUsersHeaderEdit' : 'driverUsersHeaderNew'),
	      body: editDriverUserTemplate,
	      onClose: function() {
	        resetEdit(false);
	      }
	    });
	
	  };
	
	  var resetEdit = function(closeModalAndReload) {
	    // Reset errors
	    $scope.userNameUsed = false;
	    $scope.userNameIllegalCharacters = false;
	    $scope.userNameTooShort = false;
	    $scope.invalidPhone = false;
	    $scope.languageRequired = false;
	
	    if (closeModalAndReload) {
	      $scope.closeModal();
	      $window.location.reload(true);
	    }
	    $scope.isSaving = false;
	
	  };
	
	  $scope.deactivateDriverUser = function(user) {
	    $scope.saveDriverUser(user, false);
	  };
	  $scope.activateDriverUser = function(user) {
	    $scope.saveDriverUser(user, true);
	  };
	  $scope.closeDriverUserModal = function() {
	    resetEdit(true);
	  };
	
	  $scope.suggestUsername = function(user) {
	    if (user.userName == undefined || user.userName.length == 0) {
	      // Suggestion: 2 from first + 4 from last
	      var firstPart = (user.firstName ? user.firstName.substring(0, Math.min(2, user.firstName.length)).toLowerCase() : "");
	      var lastPart = (user.lastName ? user.lastName.substring(0, Math.min(4, user.lastName.length)).toLowerCase() : "");
	      user.userName = firstPart + lastPart;
	      // Replace invalid chars
	      user.userName = latinize(user.userName);
	      user.userName = user.userName.replace(/-/g, "")
	    }
	  };
	
	  $scope.saveDriverUser = function(user, newActiveState) {
	    $scope.isSaving = true;
	    for (var prop in user) {
	      user[prop] = user[prop] || null;
	    }
	
	    var generatePasswordForExistingUser = !user.isNewUser && user.regeneratePassword;
	
	    if (user.isNewUser) {
	      resetEdit(false);
	      if (user.userName.length < 5) {
	        $scope.userNameTooShort = true;
	        return;
	      }
	    }
	
	    if (newActiveState !== undefined)
	      user.active = newActiveState;
	
	    load.saveDriverUser(user).then(function(data) {
	
	      if (generatePasswordForExistingUser) {
	        load.generateAndSendPasswordForDriverUser(user.userName).then(function(data) {
	          // Existing user - Password regenerated
	          $scope.user.password = data.password;
	          $scope.user.regeneratePassword = false;
	          resetEdit(false);
	
	        }).catch(function(error) {
	          console.log("generateAndSendPasswordForDriverUser ERROR", error);
	        });
	      } else if (user.isNewUser) {
	        // New user - password was generated
	        $scope.user.password = data.password;
	        resetEdit(false);
	      } else {
	        // Existing user - no new password
	        resetEdit(true);
	      }
	
	    }).catch(function(error) {
	      if (error.ignoredStatus === 400) {  // 400 Bad request
	        if (error.data && error.data.errorKey) {
	          if (error.data.errorKey === 'username.is.already.in.use') {
	            $scope.userNameUsed = true;
	          } else if (error.data.errorKey === 'illegal.username') {
	            $scope.userNameIllegalCharacters = true;
	          } else if (error.data.errorKey === 'phone.not.valid') {
	            $scope.invalidPhone = true;
	          } else if (error.data.errorKey === 'language.required') {
	            $scope.languageRequired = true;
	          }
	        }
	        if (newActiveState !== undefined)
	          $scope.user.active = !$scope.user.active;
	
	        console.log("saveDriverUser", error);
	        $scope.isSaving = false;
	      }
	    });
	  };
	
	}
	
	module.exports = driverUsersCtrl;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var routeStatusTooltipTemplate = __webpack_require__(26)();
	var deliveryStatusTooltipTemplate = __webpack_require__(22)();
	var deliveryInfoTooltipTemplate = __webpack_require__(21)();
	var notificationsTooltipTemplate = __webpack_require__(25)();
	var customerTimestampTooltipTemplate = __webpack_require__(20)();
	var customerCallLogTooltipTemplate = __webpack_require__(19)();
	var driverInfoTooltipTemplate = __webpack_require__(76)();
	var routeProgressTooltipTemplate = __webpack_require__(103)();
	var routePrintedTooltipTemplate = __webpack_require__(102)();
	var util = __webpack_require__(3);
	var t = __webpack_require__(4).t;
	var moment = __webpack_require__(5);
	
	fleetCtrl.$inject = ['$scope', '$rootScope', '$controller', '$routeParams', '$filter', '$location', 'modal', 'clock', 'editRoute', 'editCustomer', 'load'];
	
	function fleetCtrl($scope, $rootScope, $controller, $routeParams, $filter, $location,  modal, clock, editRoute, editCustomer, load) {
	
	  $controller('planCtrl', { $scope: $scope });
	
	  $scope.openEditRoute = editRoute.openEditRoute.bind(this, $scope);
	  $scope.saveRoute = editRoute.saveRoute.bind(this, $scope);
	  $scope.deleteEmptyRoute = editRoute.deleteEmptyRoute.bind(this, $scope);
	
	  $scope.routeStatusTooltipTemplate = routeStatusTooltipTemplate;
	  $scope.deliveryStatusTooltipTemplate = deliveryStatusTooltipTemplate;
	  $scope.deliveryInfoTooltipTemplate = deliveryInfoTooltipTemplate;
	  $scope.notificationsTooltipTemplate = notificationsTooltipTemplate;
	  $scope.customerTimestampTooltipTemplate = customerTimestampTooltipTemplate;
	  $scope.customerCallLogTooltipTemplate = customerCallLogTooltipTemplate;
	  $scope.driverInfoTooltipTemplate = driverInfoTooltipTemplate;
	  $scope.routeProgressTooltipTemplate = routeProgressTooltipTemplate;
	  $scope.routePrintedTooltipTemplate = routePrintedTooltipTemplate;
	
	  // EditCustomer-service (mappings)
	  $scope.openEditCustomer = editCustomer.openEditCustomer.bind(this, $scope);
	  $scope.saveCustomer = editCustomer.saveCustomer.bind(this, $scope);
	  $scope.addDelivery = editCustomer.addDelivery.bind(this);
	  $scope.deleteDelivery = editCustomer.deleteDelivery.bind(this);
	  $scope.cancelDelivery = editCustomer.cancelDelivery.bind(this, $scope);
	  $scope.undoCancelDelivery = editCustomer.undoCancelDelivery.bind(this, $scope);
	  $scope.deleteCustomer = editCustomer.deleteCustomer.bind(this, $scope);
	  $scope.cancelCustomer = editCustomer.cancelCustomer.bind(this, $scope);
	  $scope.openMap = editCustomer.openMap.bind(this, $scope);
	
	  $scope.routeFilter = {
	    status: undefined
	  };
	
	  $scope.setRouteFilter = function($event, status) {
	    $scope.routeFilter.status = status;
	    $event.preventDefault();
	  };
	
	  $scope.countRouteFilter = function(status) {
	    return $filter('fleetRoutes')($scope.routePlan.routes, {
	      status: status
	    }).length;
	  };
	
	  $scope.filter = {
	    routeId: $routeParams.routeId,
	    status: $routeParams.status,
	    delayed: undefined
	  };
	
	  $scope.search = {
	    text: $routeParams.search
	  };
	
	  $scope.setStatus = function($event, status, delayed) {
	    $scope.filter.status = status;
	    $scope.filter.delayed = delayed;
	    $event.preventDefault();
	  };
	
	  $scope.countStatus = function(status, delayed) {
	    var customers = $filter('filter')($scope.routePlan.customers, {
	      routeId: $scope.filter.routeId
	    });
	
	    if (status === 'deviation') {
	      return customers.reduce(function(count, customer) {
	        return count + customer.filterDeliveries('deviation').length;
	      }, 0);
	    } else if (status === 'partiallyDelivered') {
	      return customers.reduce(function(count, customer) {
	        return count + customer.filterDeliveries('partiallyDelivered').length;
	      }, 0);
	    } else {
	      return $filter('fleetCustomers')(customers, {
	        status: status,
	        delayed: delayed
	      }).length;
	    }
	  };
	
	  $scope.routeStatusClass = function(route) {
	    var routeStatus = (route.timestampStop && 'finished') ||
	                      (route.timestampStart && 'started') ||
	                      'notStarted';
	
	    if (routeStatus === 'started' && route.noGPS(false)) {
	      routeStatus += ' no-gps';  // More than 5 minutes since the last GPS update
	    }
	
	    return routeStatus;
	  };
	
	  $scope.formatPhone = __webpack_require__(3).formatPhone;
	  $scope.driverName = __webpack_require__(3).driverName;
	
	  $scope.routeDelayByRouteId = function(routeId) {
	    var route = $scope.routePlan.findRoute(routeId);
	    if (route) {
	      return route.delayForHumans();
	    }
	    return null;
	  };
	
	  $scope.estimatedTimeAdjustedByRoute = function(estimatedTimestamp, routeId) {
	    var route = $scope.routePlan.findRoute(routeId);
	    if (route && route.delayInMinutes()) {
	      var minutes = route.delayInMinutes();
	      if (minutes) {
	        return moment(estimatedTimestamp).add(minutes, 'minutes');
	      }
	    }
	    return estimatedTimestamp;
	  };
	
	  $scope.delayedCustomer = function(actually, estimated) {
	    return util.delayForHumans(util.delayInMinutes(util.toDate(actually), util.toDate(estimated)));
	  };
	
	  $scope.exportPianoUrl = function() {
	    return $scope.baseUrl + '/pl/api/v-1/export/piano/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
	  };
	
	  $scope.exportRouteMetaUrl = function() {
	    return $scope.baseUrl + '/pl/api/v-1/export/routeMeta/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
	  };
	
	  $scope.exportDeliveryMetaUrl = function() {
	    return $scope.baseUrl + '/pl/api/v-1/export/deliveryMeta/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
	  };
	
	  $scope.exportDeviationMetaUrl = function() {
	    return $scope.baseUrl + '/pl/api/v-1/export/deviationMeta/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
	  };
	
	  // Force the page to update every whole minute (to update any delays)
	  clock.everyMinute(function() {
	    $scope.$apply();
	  });
	
	  // Make sure the customerSystem-name allways is populated (even after later reloads - i.e. editing a customer)
	  $scope.$watch('dataLoaded()', function(loaded) {
	    if (loaded) {
	      $scope.routePlan.customers.forEach(function(customer) {
	        // Enable search on customerSystem.name/shortName
	        customer.customerSystem = $scope.customerSystems[customer.customerSystemId];
	      });
	    }
	  });
	
	  $scope.canEditRouteInfo = function(routePlan) {
	    return $rootScope.auth.roles.fleetManager ||
	      ($rootScope.auth.roles.clientPlus && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds));
	  };
	
	  $scope.addPrint = function() {
	    var prints = {};
	    var username = $rootScope.username;
	    var routePlanId = $rootScope.routePlan.id;
	
	    if($rootScope.routePlan.prints.length){
	      prints = $rootScope.routePlan.prints;
	      function hasPrinted(print) {
	        return print.userName === username;
	      }
	      //var userHasPrinted = prints.find(hasPrinted);
	      var userHasPrinted = prints.filter(hasPrinted);
	      userHasPrinted ? userHasPrinted[0].numberOfPrints ++ : prints.push({
	        userName: username,
	        numberOfPrints: 1
	      });
	    } else{
	      prints = {
	        userName: username,
	        numberOfPrints: 1
	      };
	      $rootScope.routePlan.prints.push(prints);
	    }
	
	    load.incrementPrint(routePlanId, username);
	  };
	
	  $scope.unpublish = function(routePlan) {
	    modal.open({
	      scope: $scope,
	      title: t('planRoutesUnpublishBtn'),
	      body: t('planRoutesUnpublishBtnConfirm', routePlan.name, moment(routePlan.date).format('L')),
	      onConfirm: function() {
	        load.unpublishRoutePlan(routePlan.id).then(function() {
	          $location.path($scope.router.link('plans'));
	        });
	      }
	    });
	  };
	}
	
	module.exports = fleetCtrl;


/***/ },
/* 129 */
/***/ function(module, exports) {

	indexCtrl.$inject = ['$rootScope', '$location', '$window'];
	
	function indexCtrl($rootScope, $location, $window) {
	  if ($rootScope.auth && ($rootScope.auth.roles.clientPlus || $rootScope.auth.roles.customerService)) {
	    $window.location = '/v2/distribution';
	  } else {
	    $window.location = '/v2/plans';
	  }
	}
	
	module.exports = indexCtrl;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var customersPerHourTooltipTemplate = __webpack_require__(67)();
	var util = __webpack_require__(3);
	var t = __webpack_require__(4).t;
	
	planCtrl.$inject = ['$scope', '$rootScope', '$routeParams', '$location',
	                    '$controller', 'load', 'config', 'editRoutePlan'];
	
	function planCtrl($scope, $rootScope, $routeParams, $location,
	                  $controller, load, config, editRoutePlan) {
	
	  $controller('commonCtrl', { $scope: $scope });
	
	  $scope.customersPerHourTooltipTemplate = customersPerHourTooltipTemplate;
	  $scope.routeColors = config.routeColors;
	
	  $scope.getOptimizeStopsLimit = function() { return 3500; }; // Limit stops to prevent Spider-problems
	
	  var loadData = function(routePlanId) {
	    load.routePlans();
	    if (routePlanId) {
	      load.routePlan(routePlanId).then(function(data) {
	        load.drivers(data.companyId);
	        load.customerSystemsForCompany(data.companyId);
	      });
	    } else {
	      load.customerSystems();
	      $scope.routePlan = null;
	    }
	
	    $scope.loadCommonData();
	  };
	
	  if ($rootScope.auth) {
	    loadData($routeParams.routePlanId);
	  }
	
	  $scope.dataLoaded = function() {
	    if (! $rootScope.auth) return true;
	    if (! $scope.commonDataLoaded()) return false;
	
	    if ($routeParams.routePlanId) {
	      return $scope.routePlans && $scope.routePlan && $scope.routePlan.id === +$routeParams.routePlanId &&
	             $scope.customerSystems && $scope.drivers && true;
	    } else {
	      return $scope.routePlans && $scope.customerSystems && $scope.driverUsers && $scope.users && true;
	    }
	  };
	
	
	  $scope.archive = $location.hash() === 'archive';
	
	  // EditRoutePlan-service (mappings)
	  $scope.openEditRoutePlan = editRoutePlan.openEditRoutePlan.bind(this, $scope);
	  $scope.saveRoutePlan = editRoutePlan.saveRoutePlan.bind(this, $scope);
	  $scope.deleteRoutePlan = editRoutePlan.deleteRoutePlan.bind(this, $scope);
	
	  $scope.exportInvoiceDataAllPlansUrl = function() {
	    return $scope.baseUrl + '/pl/api/v-1/export/invoiceData?token=' + $rootScope.auth.token;
	  };
	
	  $scope.exportCompanyDeliveriesDataUrl = function() {
	    return $scope.baseUrl + '/pl/api/v-1/export/companyDeliveriesData/' + $rootScope.auth.companyId + '?token=' + $rootScope.auth.token;
	  };
	
	  $scope.exportGeoFenceMetaUrl = function() {
	    return $scope.baseUrl + '/pl/api/v-1/export/geoFencingMeta/' + $rootScope.auth.companyId + '?token=' + $rootScope.auth.token;
	  };
	
	  $scope.customerSystemNames = function(customerSystemIds) {
	
	    var name = function(id) {
	      return ($scope.customerSystems[id] || {}).name;
	    };
	
	    return (customerSystemIds || [])
	      .map(name)
	      .filter(Boolean) // The routePlan may contain customerSystems not included in $scope.customerSystems
	      .sort();
	  };
	
	  $scope.canDeleteFiles = function(routePlan) {
	    return routePlan.editable() &&
	      ($rootScope.auth.roles.plannerPlus || ($rootScope.auth.roles.clientPlus && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds))
	    );
	  };
	
	}
	
	module.exports = planCtrl;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var util = __webpack_require__(3);
	var File = __webpack_require__(7);
	var fileUploadTemplate = __webpack_require__(82)();
	var productsInFileTemplate = __webpack_require__(98)();
	var suggestedRoutesTemplate = __webpack_require__(109)();
	var optimizeTemplate = __webpack_require__(91)();
	var t = __webpack_require__(4).t;
	
	planCustomersCtrl.$inject = ['$scope', '$controller', '$routeParams', '$location', '$timeout',
	                             '$document', '$filter', 'modal', 'load', 'storage', 'serverError', 'editCustomer'];
	
	function planCustomersCtrl($scope, $controller, $routeParams, $location, $timeout,
	                           $document, $filter, modal, load, storage, serverError, editCustomer) {
	
	  $controller('planCtrl', { $scope: $scope });
	
	  $scope.activeTab =
	    $location.hash() ||
	    ($scope.page === 'plan-files' && 'files') ||
	    'all';
	
	
	  $scope.filter = {
	    latitude: $location.hash() === 'deviation' ? null : undefined
	  };
	
	  $scope.search = {
	    text: undefined
	  };
	
	  $scope.setFileFilter = function(fileId) {
	    if (fileId == null) {
	      $scope.filter.fileId = undefined;
	    } else {
	      $scope.filter.fileId = +fileId || fileId;
	    }
	  };
	
	  $scope.setFileFilter($routeParams.fileId);
	
	
	  $scope.allFiles = function() {
	    var hasIndividual = $scope.routePlan.customers.some(function(customer) {
	      return customer.fileId === File.individual.id;
	    });
	
	    return hasIndividual
	      ? [].concat($scope.routePlan.files, File.individual)
	      : $scope.routePlan.files;
	  };
	
	  $scope.customersInFile = function(file) {
	    return $filter('filter')($scope.routePlan.customers, { fileId: file.id });
	  };
	
	
	  $scope.customersLink = function(hash) {
	    var link = $scope.router.link('plan/customers', $scope.routePlan.id);
	
	    if ($scope.filter.fileId != null) link += '/' + $scope.filter.fileId;
	    if (hash) link += '#' + hash;
	
	    return link;
	  };
	
	
	  $scope.openFileUpload = function() {
	    $scope.newFile = {};
	
	    // Prepopulate customer system if only one
	    var custSysArr = $scope.values($scope.customerSystems);
	    if (custSysArr.length === 1) {
	      $scope.newFile.customerSystemId = custSysArr[0].id;
	    }
	
	    modal.open({
	      scope: $scope,
	      klass: 'file-upload',
	      title: t('fileModalHeader'),
	      body: fileUploadTemplate
	    });
	  };
	
	  $scope.saveFile = function(file) {
	    $scope.closeModal();
	
	    load.createFile($scope.routePlan.id, file.customerSystemId, file.file.name).then(function(data) {
	      load.uploadFile(data.id, file.file).catch(function(error) {
	        if (error.ignoredStatus === 400) {  // 400 Bad request
	          load.deleteFile(data);
	          serverError.error(null, null, {
	            errorKey: '"' + file.file.name + '":',
	            errorMap: data.errorMessage(error.data && error.data.errorKey, error.data && error.data.errorMap)
	          }, 'fileStatus_error');
	        }
	      });
	    });
	  };
	
	  $scope.deleteFile = function(file) {
	    modal.open({
	      scope: $scope,
	      title: t('planFilesDeleteFile'),
	      body: t('planFilesDeleteFileConfirm', file.name),
	      onConfirm: function() {
	        load.deleteFile(file);
	      }
	    });
	  };
	
	  $scope.openProducts = function(routePlan, file) {
	    var customerInFile = routePlan.customers
	      .filter(function(customer) {
	        return customer.fileId === file.id;
	      });
	
	    $scope.products = util.aggregateProductsForCustomers(customerInFile);
	
	    modal.open({
	      scope: $scope,
	      klass: 'products-in-file',
	      title: t('productsModalHeader'),
	      body: productsInFileTemplate
	    });
	  };
	
	  $scope.openSuggestedRoutes = function(routePlan) {
	    $scope.suggestedRoutes = routePlan.suggestedRoutes;
	
	    modal.open({
	      scope: $scope,
	      klass: 'suggested-routes',
	      title: t('suggestedRoutesModalHeader'),
	      body: suggestedRoutesTemplate
	    });
	  };
	
	  // EditCustomer-service (mappings)
	  $scope.openEditCustomer = editCustomer.openEditCustomer.bind(this, $scope);
	  $scope.saveCustomer = editCustomer.saveCustomer.bind(this, $scope);
	  $scope.addDelivery = editCustomer.addDelivery.bind(this);
	  $scope.deleteDelivery = editCustomer.deleteDelivery.bind(this);
	  $scope.cancelDelivery = editCustomer.cancelDelivery.bind(this, $scope);
	  $scope.undoCancelDelivery = editCustomer.undoCancelDelivery.bind(this, $scope);
	  $scope.deleteCustomer = editCustomer.deleteCustomer.bind(this, $scope);
	  $scope.cancelCustomer = editCustomer.cancelCustomer.bind(this, $scope);
	  $scope.openMap = editCustomer.openMap.bind(this, $scope);
	
	  $scope.activeCustomerId = null;
	
	
	  $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;
	  $scope.integerPattern = /^[1-9]\d*$/;
	  $scope.travellers = ['car', 'pedestrian'];
	
	  $scope.openOptimize = function(optimizeRoutes) {
	    $scope.optimizeRoutes = optimizeRoutes;
	    $scope.optimize = storage.local.get('optimize') || {};
	    if (! optimizeRoutes) {
	      $scope.optimize.type = 'time'; // Show time-interval when not optimizing
	    }
	    $scope.optimize.date = $scope.routePlan.date;
	    $scope.optimize.type = $scope.optimize.type || 'time';
	    $scope.optimize.showTraveller = $scope.settings.customerSystemSettings && $scope.settings.customerSystemSettings.some(function(css) {
	      return css.showTraveller;
	    });
	    $scope.optimize.traveller = $scope.optimize.traveller || 'car'; // Default car (if never selected before)
	    $scope.optimize.pickupLocations = $scope.optimize.pickupLocations || [];
	    $scope.optimize.countWarnings =
	      $filter('filter')($scope.routePlan.customers, { latitude: null }).length;
	
	    $scope.validateStartStopInterval = function(optimize) {
	      var start = util.toTime(optimize.start);
	      var stop = optimize.type === 'time' && util.toTime(optimize.stop);
	
	      if (start && stop && start >= stop) {
	        $scope.form.stop.$setValidity('interval', false);
	      } else {
	        $scope.form.stop.$setValidity('interval', true);
	      }
	    };
	
	    initPickupLocations($scope.optimize);
	
	    var title = t(optimizeRoutes ? 'optimizeModalHeaderOptimize' : 'optimizeModalHeaderCreateRoutes');
	
	    modal.open({
	      scope: $scope,
	      klass: 'optimize',
	      title: title,
	      body: optimizeTemplate
	    });
	  };
	
	  $scope.saveOptimization = function(optimize, optimizeRoutes) {
	
	    var startOptimization = function() {
	      var data = {
	        date: util.toDateNoon(optimize.date),
	        pickupLocations: optimize.pickupLocations,
	        limits: {
	          start: util.toDateWithTime(optimize.date, optimize.start),
	          stop: optimize.type === 'time' ? util.toDateWithTime(optimize.date, optimize.stop) : null,
	          routeCount: optimize.type === 'routes' ? +optimize.routeCount : null,
	          capacityPerRoute: optimize.type === 'routes' ? optimize.capacityPerRoute : null,
	          cluster: optimize.cluster || false,
	          traveller: optimize.traveller,
	          returnToPickupLocation: optimize.returnToPickupLocation || false,
	          optimizeRelocate: optimize.relocate
	        }
	      };
	
	      storage.local.set('optimize', {
	        type: optimize.type,
	        start: util.toTime(optimize.start),
	        stop: util.toTime(optimize.stop),
	        routeCount: data.limits.routeCount,
	        capacityPerRoute: data.limits.capacityPerRoute,
	        cluster: data.limits.cluster,
	        traveller: data.limits.traveller,
	        returnToPickupLocation: data.limits.returnToPickupLocation,
	        pickupLocations: optimize.pickupLocations
	      });
	
	      if (optimizeRoutes) {
	        load.startOptimization($scope.routePlan.id, data).then(function() {
	          $scope.closeModal();
	          $location.hash(null).path($scope.router.link('plans'));
	        }).catch(function(error) {
	          if (error.ignoredStatus === 417) {
	            msg = $scope.routePlan.errorMessage(error.data.errorKey, $scope.settings.boundaryBox);
	            //console.log('msg', msg);
	            serverError.error(null, null, {
	              errorMap: msg.message,
	              link: msg.link
	            }, msg.title);
	          }
	        });
	      } else {
	        load.createSuggestedRoutes($scope.routePlan.id, data).then(function() {
	          $scope.closeModal();
	          $location.hash(null).path($scope.router.link('plans'));
	        }).catch(function(error) {
	          if (error.ignoredStatus === 417) {
	            msg = $scope.routePlan.errorMessage(error.data.errorKey, $scope.settings.boundaryBox);
	            //console.log('msg', msg);
	            serverError.error(null, null, {
	              errorMap: msg.message,
	              link: msg.link
	            }, msg.title);
	          }
	        });
	      }
	    };
	
	    var complete = optimize.pickupLocations.every(function(location) {
	      return location.latitude;
	    });
	
	    if ($scope.form.$invalid || ! optimize.pickupLocations.length || ! complete || $scope.optimize.editMode()) {
	      return;
	    }
	
	    var warning = '';
	    if (optimize.type === 'time') {
	      var startTimestamp = util.toDateWithTime(optimize.date, optimize.start);
	      var stopTimestamp = util.toDateWithTime(optimize.date, optimize.stop);
	
	      var outside = $scope.routePlan.customers.filter(function(customer) {
	        return customer.outsideDeliveryWindow(startTimestamp, stopTimestamp);
	      });
	
	      if (outside.length) {
	        warning = t('optimizeModalTimeWindowOutsideError', outside.length);
	      }
	    }
	
	    var title = t(optimizeRoutes ? 'optimizeModalHeaderOptimize' : 'optimizeModalHeaderCreateRoutes');
	    var body = optimizeRoutes ? warning + t('optimizeModalConfirmOptimize') : warning + t('optimizeModalConfirmCreateRoutes', $scope.routePlan.suggestedRoutesCount());
	
	    modal.open({
	      scope: $scope,
	      title: title,
	      body: body,
	      onConfirm: startOptimization
	    });
	  };
	
	  var initPickupLocations = function(optimize) {
	
	    var closeAddressHelper = function() {
	      angular.element($document[0].getElementById('address-helper')).remove();
	      optimize.index = undefined;
	      optimize.pickupLocation = undefined;
	    };
	
	    var displayAddressHelper = function(index, location) {
	
	      var display = function() {
	        optimize.index = index;
	        optimize.pickupLocation = location ? angular.copy(location) : {};
	      };
	
	      if (optimize.pickupLocation) {
	        closeAddressHelper();
	        $timeout(display);
	      } else {
	        display();
	      }
	    };
	
	    var displayAddresses = function() {
	      if (optimize.pickupLocations.length < 2) {
	        displayAddressHelper(0, optimize.pickupLocations[0]);
	      } else {
	        closeAddressHelper();
	      }
	    };
	
	    optimize.toggleClusterInfo = function() {
	      angular.element($document[0].getElementById('cluster-info')).toggleClass('hide');
	    };
	
	    optimize.toggleRelocateInfo = function() {
	      angular.element($document[0].getElementById('relocate-info')).toggleClass('hide');
	    };
	
	    optimize.toggleCarsTimeWindowInfo = function() {
	      angular.element($document[0].getElementById('carstimewindow-info')).toggleClass('hide');
	    };
	
	    optimize.updateAddress = function(complete, address) {
	      if (! address) return;
	      delete address.suggestedRoute; // Cleanup for API
	      optimize.pickupLocation = address;
	      if (! optimize.editMode()) {
	        optimize.pickupLocations.splice(0, 1, address);
	      }
	    };
	
	    optimize.displayAddress = function(address) {
	      return address.address + ', ' + util.formatZip(address.zip, address.country) + ' ' + address.city;
	    };
	
	    optimize.editMode = function() {
	      return optimize.pickupLocation && (optimize.index > 0 || optimize.pickupLocations.length > 1);
	    };
	
	    optimize.newPickupLocation = function() {
	      displayAddressHelper(optimize.pickupLocations.length);
	    };
	
	    optimize.editPickupLocation = function(index) {
	      displayAddressHelper(index, optimize.pickupLocations[index]);
	    };
	
	    optimize.savePickupLocation = function() {
	      optimize.pickupLocations.splice(optimize.index, 1, optimize.pickupLocation);
	      displayAddresses();
	    };
	
	    optimize.cancelPickupLocation = function() {
	      displayAddresses();
	    };
	
	    optimize.deletePickupLocation = function(index) {
	      modal.open({
	        scope: $scope,
	        title: t('optimizeModalPickupPointDelete'),
	        body: t('optimizeModalPickupPointDeleteBody', optimize.displayAddress(optimize.pickupLocations[index])),
	        onConfirm: function() {
	          optimize.pickupLocations.splice(index, 1);
	          displayAddresses();
	        }
	      });
	    };
	
	    displayAddresses();
	  };
	
	
	}
	
	module.exports = planCustomersCtrl;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var StopLocation = __webpack_require__(15);
	var moveStopLocationTemplate = __webpack_require__(23)();
	var moveStopLocationsTemplate = __webpack_require__(24)();
	var optimizeRouteWithOptionsTemplate = __webpack_require__(92)();
	var t = __webpack_require__(4).t;
	var moment = __webpack_require__(5);
	
	planRoutesCtrl.$inject = ['$scope', '$rootScope', '$controller', '$route', '$location', 'modal', 'load', 'editRoute'];
	
	function planRoutesCtrl($scope, $rootScope, $controller, $route, $location, modal, load, editRoute) {
	
	  $controller('planCtrl', { $scope: $scope });
	
	  $scope.ctrlKey = window.navigator.platform.indexOf('Mac') === -1 ? 'ctrl' : 'cmd';
	
	  $scope.reserveRoutes = $route.current.reserveRoutes;
	
	  $scope.routeFilter = {
	    status: $scope.reserveRoutes ? 'reserved' : undefined
	  };
	
	  $scope.openEditRoute = editRoute.openEditRoute.bind(this, $scope);
	  $scope.saveRoute = editRoute.saveRoute.bind(this, $scope);
	  $scope.deleteEmptyRoute = editRoute.deleteEmptyRoute.bind(this, $scope);
	
	  $scope.expandedRoutes = {};
	  $scope.selectedStops = {};
	
	  $scope.toggleExpandRoute = function(event, route) {
	    event.preventDefault();
	    $scope.expandedRoutes[route.id] = ! $scope.expandedRoutes[route.id];
	  };
	
	  $scope.showFailedInfoRoutes = {};
	
	  $scope.toggleFailedInfo = function(route) {
	    $scope.showFailedInfoRoutes[route.id] = ! $scope.showFailedInfoRoutes[route.id];
	  };
	
	  $scope.openMoveStopLocation = function(stopLocation) {
	    $scope.prepareMove(stopLocation);
	    modal.open({
	      scope: $scope,
	      klass: 'move-stop-location',
	      title: t('moveModalHeader'),
	      body: moveStopLocationTemplate
	    });
	  };
	
	  $scope.prepareMove = function(stopLocation) {
	
	    var oldIndex = function(stop) {
	      return stop.routeSequence && stop.routeSequence - 1;
	    };
	
	    var stops;
	
	    if (stopLocation instanceof Array) {
	      stops = stopLocation;
	      stopLocation = stopLocation[0];
	    }
	
	    $scope.move && $scope.move.close && $scope.move.close();
	
	    $scope.move = {
	      stop: stopLocation,
	      route: stopLocation.route,
	      oldIndex: oldIndex(stopLocation),
	      newIndex: stopLocation.route && ('' + oldIndex(stopLocation)),
	      routeSelected: function(route) {
	        $scope.move.newIndex = route && '' + route.stopLocations.length;
	      },
	      routeFilter: {
	        type: (stopLocation.route && stopLocation.route.reserved ? 1 : 0)
	      }
	    };
	
	    if (stops && stops.length > 1) {
	      var index = 0;
	      $scope.move.next = function() {
	        if (! stops[++index]) index = 0;
	        $scope.move.stop = stops[index];
	        $scope.move.oldIndex = oldIndex(stops[index]);
	      };
	    }
	  };
	
	  $scope.moveStopLocation = function(stopLocation, oldIndex, newIndex, newRouteId) {
	
	    var updateSequence = function(route) {
	      route.stopLocations.forEach(function(stop, index) {
	        stop.routeSequence = index + 1;
	      });
	    };
	
	    var route = stopLocation.route;
	    var oldRouteId = route && route.id;
	    var updatedRoutes = route ? [route] : [];
	
	    ($scope.move && $scope.move.close) ? $scope.move.close() : $scope.closeModal();
	
	    if (route && route.id === newRouteId) newRouteId = null;
	    if (oldIndex === newIndex && ! newRouteId) return;
	
	    if (newRouteId) {
	      var newRoute = $scope.routePlan.findRoute(newRouteId);
	
	      stopLocation.route = newRoute;
	      stopLocation.customers.forEach(function(customer) {
	        customer.routeId = newRouteId;
	      });
	
	      updatedRoutes.push(newRoute);
	      newRoute.stopLocations.splice(newIndex, 0, stopLocation);
	      updateSequence(newRoute);
	
	      if (route) {
	        route.stopLocations.splice(oldIndex, 1);
	        updateSequence(route);
	      }
	
	      if ($scope.selectedStops[oldRouteId]) {
	        delete $scope.selectedStops[oldRouteId][stopLocation.id];
	      }
	    } else if (route) {
	      route.stopLocations.splice(newIndex, 0, route.stopLocations.splice(oldIndex, 1)[0]);
	      updateSequence(route);
	    }
	
	    load.saveRouteSequence($scope.routePlan.id, updatedRoutes);
	  };
	
	  $scope.prepareMultiMove = function(stopLocations, oldRoute) {
	    $scope.multiMove = {
	      stops: stopLocations,
	      route: null,
	      oldRoute: oldRoute,
	      customerCount: function() {
	        return stopLocations.reduce(function(count, stop) {
	          return count + stop.customerNotCancelledCount();
	        }, 0);
	      },
	      routeFilter: {
	        type: (oldRoute && oldRoute.reserved ? 1 : 0)
	      }
	    };
	  };
	
	  $scope.moveStopLocations = function(stopLocations, newRouteId) {
	
	    var updateSequence = function(route) {
	      route.stopLocations.forEach(function(stop, index) {
	        stop.routeSequence = index + 1;
	      });
	    };
	
	    $scope.multiMove.close ? $scope.multiMove.close() : $scope.closeModal();
	
	    if (newRouteId === undefined) return;
	
	    var newRoute = $scope.routePlan.findRoute(newRouteId);
	    var involvedRouteIds = {};
	    var updatedRoutes = [];
	
	    stopLocations.forEach(function(stopLocation) {
	      var oldRoute = stopLocation.route;
	
	      if (oldRoute && oldRoute.id !== newRouteId) { // Only do work if needed
	        var oldIndex = stopLocation.route.stopLocations
	          .map(function(stop) { return stop.id; })
	          .indexOf(stopLocation.id);
	
	        involvedRouteIds[oldRoute.id] = oldRoute.id;
	
	        stopLocation.route = newRoute;
	        stopLocation.customers.forEach(function(customer) {
	          customer.routeId = newRouteId;
	        });
	
	        oldRoute.stopLocations.splice(oldIndex, 1); // Remove from old route
	        newRoute.stopLocations.push(stopLocation);  // Add to (end of) new route
	      }
	    });
	
	    if (Object.keys(involvedRouteIds).length > 0) {
	      involvedRouteIds[newRouteId] = newRouteId; // The new route must also be included
	
	      Object.keys(involvedRouteIds).forEach(function(rId) {
	        var r = $scope.routePlan.findRoute(parseInt(rId, 10));
	
	        updateSequence(r);
	        updatedRoutes.push(r);
	
	        delete $scope.selectedStops[rId];
	      });
	
	      load.saveRouteSequence($scope.routePlan.id, updatedRoutes);
	    }
	  };
	
	  $scope.openMoveStopLocations = function(route) {
	    var stops = $scope.values($scope.selectedStops[route.id] || {});
	
	    var sortByRouteSequence = function(a, b) {
	      return a.routeSequence - b.routeSequence;
	    };
	
	    if (stops.length === 1) {
	      $scope.openMoveStopLocation(stops[0]);
	    } else if (stops.length) {
	      stops.sort(sortByRouteSequence);
	      $scope.prepareMultiMove(stops, route);
	      modal.open({
	        scope: $scope,
	        klass: 'move-stop-location',
	        title: t('moveModalHeader'),
	        body: moveStopLocationsTemplate
	      });
	    }
	  };
	
	  $scope.selectStop = function(event, stop) {
	    $scope.selectedStops[stop.route.id] = $scope.selectedStops[stop.route.id] || {};
	    if (event.target.checked) {
	      $scope.selectedStops[stop.route.id][stop.id] = stop;
	    } else {
	      delete $scope.selectedStops[stop.route.id][stop.id];
	    }
	  };
	
	  $scope.selectAllStops = function(event, route) {
	    route.stopLocations.forEach(function(stop) {
	      if (stop.anyUnAccountedDeliveries()) {
	        $scope.selectStop(event, stop);
	      }
	    });
	  };
	
	  $scope.allStopsSelected = function(route) {
	    return $scope.countStopsSelected(route) === route.stopLocations.length;
	  };
	
	  $scope.countStopsSelected = function(route) {
	    return Object.keys($scope.selectedStops[route.id] || {}).length;
	  };
	
	  $scope.toStopLocation = function(customer) {
	    return new StopLocation(customer);
	  };
	
	  $scope.canEditRouteInfo = function(routePlan) {
	    return $rootScope.auth.roles.fleetManager ||
	      ($rootScope.auth.roles.clientPlus && $scope.reserveRoutes && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds));
	  };
	
	  $scope.canMoveStops = function(routePlan) {
	    return $rootScope.auth.roles.planner ||
	      ($rootScope.auth.roles.fleetManager && $scope.reserveRoutes) ||
	      ($rootScope.auth.roles.clientPlus && $scope.reserveRoutes && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds));
	  };
	
	  $scope.showAskForDriverInput = function(routePlan) {
	    var hasSomeCustomerSystemsThatWantsDriverInput = $scope.settings.customerSystemSettings && $scope.settings.customerSystemSettings.some(function(css) {
	      return routePlan.customerSystems.indexOf(css.customerSystemId)>=0 && css.askForDriverInput;
	    });
	
	    return hasSomeCustomerSystemsThatWantsDriverInput && ! routePlan.readyForDriverInput;
	  };
	
	  $scope.askForDriverInput = function(routePlan) {
	    modal.open({
	      scope: $scope,
	      title: t('planRoutesAskForDriverInputBtn'),
	      body: t('planRoutesAskForDriverInputBtnConfirm', routePlan.name, moment(routePlan.date).format('L'), moment(routePlan.date).format('dddd'), moment(routePlan.date).fromNow()),
	      onConfirm: function() {
	        load.enableDriverInputForRoutePlan(routePlan.id).then(function() {
	          $location.path($scope.router.link('plans'));
	        });
	      }
	    });
	  };
	
	  $scope.publish = function(routePlan) {
	    modal.open({
	      scope: $scope,
	      title: t('planRoutesPublishBtn'),
	      body: t('planRoutesPublishBtnConfirm', routePlan.name, moment(routePlan.date).format('L'), moment(routePlan.date).format('dddd'), moment(routePlan.date).fromNow()),
	      onConfirm: function() {
	        load.publishRoutePlan(routePlan.id).then(function() {
	          $location.path($scope.router.link('plans'));
	        });
	      }
	    });
	  };
	
	  $scope.addRoute = function(event, routePlan) {
	    $scope.openEditRoute(event, { permitDriverComingSMS: true });
	  };
	
	  $scope.addReserveRoute = function(event, routePlan) {
	    $scope.openEditRoute(event, { permitDriverComingSMS: true, type: 1 });
	  };
	
	  $scope.deleteRoutes = function(routePlan) {
	    modal.open({
	      scope: $scope,
	      title: t('planRoutesDeleteAllRoutes'),
	      body: t('planRoutesDeleteAllRoutesConfirm'),
	      onConfirm: function() {
	        load.deleteRoutes(routePlan.id);
	        $location.path($scope.router.link('plan/customers', routePlan.id).replace('#', ''));
	      }
	    });
	  };
	
	  $scope.optimizeRoute = function(route) {
	    route.optimizationStatus = 1; // Default set to waiting
	    load.optimizeRoute(route.id);
	  };
	
	  $scope.openOptimizeRouteWithOptions = function(route) {
	    var selectedFirstStopLocation = $scope.routePlan.findStopLocation(route.id, route.forcedFirstStopLocationId);
	    var selectedLastStopLocation = $scope.routePlan.findStopLocation(route.id, route.forcedLastStopLocationId);
	    $scope.optimizeRouteOptions = {
	      route: route,
	      selectedFirstStopLocation: selectedFirstStopLocation,
	      selectedLastStopLocation: selectedLastStopLocation
	    };
	    modal.open({
	      scope: $scope,
	      klass: 'optimize-route-with-options',
	      title: t('optimizeRouteModalHeader', route.name),
	      body: optimizeRouteWithOptionsTemplate
	    });
	  };
	
	  $scope.optimizeRouteWithOptions = function(optimizeRouteOptions) {
	    var route = optimizeRouteOptions.route;
	    route.optimizationStatus = 1; // Default set to waiting
	    var firstStopId = optimizeRouteOptions.selectedFirstStopLocation ? optimizeRouteOptions.selectedFirstStopLocation.id : null;
	    var lastStopId = optimizeRouteOptions.selectedLastStopLocation ? optimizeRouteOptions.selectedLastStopLocation.id : null;
	    load.optimizeRouteWithOptions(route.id, firstStopId, lastStopId).then(function() {
	      $scope.closeModal();
	    });
	  };
	
	  $scope.optimizeAllNeededRoutes = function(routePlan) {
	    routePlan.routesThatNeedOptimization().forEach(function(route) {
	      return route.optimizationStatus = 1; // Default set to waiting
	    });
	    load.optimizeAllNeededRoutes(routePlan.id);
	  };
	
	  $scope.clearTimeWindowsAndOptimizeRoute = function(route) {
	    route.optimizationStatus = 1; // Default set to waiting
	    load.clearTimeWindowsAndOptimizeRoute(route.id);
	  };
	
	}
	
	module.exports = planRoutesCtrl;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var t = __webpack_require__(4).t;
	var moment = __webpack_require__(6);
	var util = __webpack_require__(3);
	
	
	settingsCtrl.$inject = ['$scope', '$rootScope', '$controller', 'load'];
	
	function settingsCtrl($scope, $rootScope, $controller, load) {
	
	  $controller('commonCtrl', { $scope: $scope });
	
	  $scope.dataLoaded = function() {
	    return $scope.settings && true;
	  };
	
	  if ($rootScope.auth) {
	    load.settings();
	  }
	
	  $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;
	  $scope.durationPattern = /^\d+$/;
	
	
	  $scope.createSystemWarning = function(downtime) {
	    downtime.problemsTimestamp = downtime.generalEnabled ? new Date() : null;
	
	    if (downtime.downtimeEnabled) {
	      var dateTimeStr =  downtime.date + 'T' + moment(downtime.time, "HH:mm").format('HH:mm:ss.SSSZ');
	      downtime.serverDownTimestamp = moment.utc(dateTimeStr);
	    } else {
	      downtime.serverDownTimestamp = null;
	      downtime.estimatedDownTimeMinutes = null;
	    }
	    load.saveDowntime(downtime.getCleanModel());
	  };
	}
	
	module.exports = settingsCtrl;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var t = __webpack_require__(4).t;
	
	usersCtrl.$inject = ['$scope', '$rootScope', '$controller', '$routeParams', '$filter'];
	
	function usersCtrl($scope, $rootScope, $controller, $routeParams, $filter) {
	
	  $controller('planCtrl', { $scope: $scope });
	
	  $scope.search = {
	    text: undefined
	  };
	
	  $scope.formatPhone = __webpack_require__(3).formatPhone;
	
	  $scope.filter = {
	    active: true
	  };
	
	  $scope.languages = [
	    { id: 'no', name: 'Norsk' },
	    { id: 'sv', name: 'Svenska' },
	    { id: 'fi', name: 'Suomalainen' },
	    { id: 'en', name: 'English' },
	    { id: 'fr', name: 'Français' }
	  ];
	
	  $scope.setStatus = function($event, active) {
	    $scope.filter.active = active;
	    $event.preventDefault();
	  };
	
	  $scope.countStatus = function(active) {
	    var users = $rootScope.users;
	
	    return $filter('filter')(users, {
	      active: active
	    }).length;
	  };
	
	}
	
	module.exports = usersCtrl;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/* global DI */
	
	var angular = __webpack_require__(2);
	
	var formatZip = __webpack_require__(3).formatZip;
	var translate = __webpack_require__(4);
	
	addressHelper.$inject = ['$document', 'loadScript'];
	
	function addressHelper($document, loadScript) {
	  var config = {
	    baseUrl: ("https://dev-ws.di.no"),
	    apiKey: '4nkm+qaIT1roMaf/eo+IkYaQp60B8oGf',
	    useGeoLocation: ("dev") !== 'dev',
	    lookOnlyForAddress: true,
	    disableHouseholdHelpPanel: true,
	    maxResultsDisplayed: 100
	  };
	
	  var initAddressHelper = function(element, countryCode, address, onChangeCallback) {
	    config.country = countryCode;
	    config.limitToOfficial = false;
	
	    var diah = new DI.AddressHelper(element.attr('id'), config);
	
	    try {
	      if (address.deliveryPointId) {
	        diah.initializeFromDeliverypointId(address.deliveryPointId);
	      } else if (address.address) {
	        diah.parseStreetAddressAndZipCity(address.address, address.zip, address.city);
	      }
	    } catch (e) {
	      // Hack to enable saving when diah fails:
	      // https://jira-di.atlassian.net/browse/DI-15989
	      console.log('initAddressHelper error', e, address);
	    }
	
	    diah.populateFailedEvent.subscribe(function() {
	      angular.element(element[0].querySelectorAll('.streetInput')).val(address.address);
	      // TODO populate element[0].querySelectorAll('.streetNumberInput');
	      angular.element(element[0].querySelectorAll('.zipLabel')).val(formatZip(address.zip, countryCode));
	      angular.element(element[0].querySelectorAll('.cityLabel')).val(address.city);
	      onChangeCallback(false, null);
	    });
	
	    diah.selectionChangeEvent.subscribe(function() {
	      var street = diah.getSelectedAddress().street || {};
	      var streetNumber = diah.getSelectedAddress().streetNumber || {};
	
	      if (diah.isComplete() && ! streetNumber.latitude) {
	        element.addClass('lat-long-error');
	      } else {
	        element.removeClass('lat-long-error');
	      }
	
	      onChangeCallback(diah.isComplete(), {
	        deliveryPointId: streetNumber.deliveryPointId || street.deliveryPointId,
	        latitude: streetNumber.latitude,
	        longitude: streetNumber.longitude,
	        country: countryCode,
	        city: street.city,
	        zip: parseInt((streetNumber.postalCode || street.postalCode), 10) || null,
	        address: [
	          (street.streetName || ''),
	          ' ',
	          (streetNumber.streetNo || ''),
	          (streetNumber.entrance || '')
	        ].join('').trim(),
	        suggestedRoute: null
	      });
	    });
	  };
	
	  // Cancel escape if an autocomplete element is open, to stop the modal from closing
	  var initCancelEscape = function(element) {
	
	    var cancelEscape = function(event) {
	      if (event.keyCode !== 27) return;
	
	      var acElements = element[0].querySelectorAll('.yui-ac-content');
	      var openAcElements = Array.prototype.filter.call(acElements, function(el) {
	        return el.offsetHeight;
	      });
	
	      if (openAcElements.length) event.stopImmediatePropagation();
	    };
	
	    $document.on('keydown', cancelEscape);
	
	    element.on('$destroy', function() {
	      $document.off('keydown', cancelEscape);
	    });
	  };
	
	  return {
	    template: __webpack_require__(64),
	    restrict: 'E',
	    replace: true,
	    scope: {
	      countryCode: '=',
	      deliveryPointId: '=',
	      address: '=',
	      zip: '=',
	      city: '=',
	      onChange: '='
	    },
	
	    link: function(scope, element) {
	      var address = {
	        deliveryPointId: scope.deliveryPointId,
	        address: scope.address,
	        zip: scope.zip,
	        city: scope.city
	      };
	      scope.t = translate.t;
	
	      loadScript.load('https://www.di.no/addresshelper/diah.js').then(function() {
	        initCancelEscape(element);
	        initAddressHelper(element, scope.countryCode, address, scope.onChange);
	      });
	    }
	  };
	
	}
	
	module.exports = addressHelper;


/***/ },
/* 136 */
/***/ function(module, exports) {

	animate.$inject = ['$timeout'];
	
	function animate($timeout) {
	
	  return function(scope, element, attr) {
	    scope.$watch(attr.animateOnChange, function() {
	      element.addClass('changed');
	      $timeout(function() {
	        element.removeClass('changed');
	      }, 300);
	    });
	  };
	
	}
	
	module.exports = animate;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var moment = __webpack_require__(5);
	
	calendar.$inject = ['$timeout', '$document', 'modal'];
	
	function calendar($timeout, $document, modal) {
	
	  var unwatch;
	
	  return {
	    template: __webpack_require__(90),
	    restrict: 'E',
	    replace: true,
	    scope: {
	      date: '='
	    },
	
	    link: function(scope, element, attrs) {
	      scope.today = moment().format('YYYY-MM-DD');
	      scope.date = scope.date || scope.today;
	      scope.dateString = scope.date;
	
	      scope.openCalendar = function() {
	        modal.open({
	          scope: scope,
	          klass: 'calendar-modal',
	          body: __webpack_require__(65)
	        });
	
	        $timeout(closeOnClickSelected, 0, false);
	      };
	
	      var closeOnClickSelected = function() {
	        var selected = $document[0].querySelector('.pickadate-active');
	        angular.element(selected).on('click', closeCalendar);
	      };
	
	      var closeCalendar = function() {
	        scope._modal && scope._modal.close();
	      };
	
	      unwatch && unwatch();
	      unwatch = scope.$watch('dateString', function(newDate, oldDate) {
	        closeCalendar();
	        if (newDate && newDate !== oldDate) {
	          scope.date = newDate;
	        }
	      });
	
	    }
	  };
	}
	
	module.exports = calendar;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(68),
	    restrict: 'E',
	    scope: { customer: '=' },
	    link: function(scope) {
	      scope.deliveryCountTooltipTemplate = __webpack_require__(69)();
	    }
	  };
	
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(70),
	    restrict: 'E',
	    replace: true
	  };
	
	};


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(75),
	    restrict: 'E',
	    replace: true,
	    transclude: true
	  };
	
	};


/***/ },
/* 141 */
/***/ function(module, exports) {

	// Angular does not support ng-change on input[type=file] elements:
	// https://github.com/angular/angular.js/issues/1375
	// http://stackoverflow.com/questions/17922557
	
	module.exports = function() {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	
	    link: function(scope, element, attrs, ngModel) {
	
	      var onChange = function(event) {
	        var files = event.target.files || [];
	        var value = attrs.multiple ? files : files[0];
	
	        scope.$apply(function() {
	          ngModel.$setViewValue(value);
	          ngModel.$render();
	        });
	      };
	
	      element.on('change', onChange);
	    }
	  };
	
	};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(83),
	    restrict: 'E',
	    replace: true
	  };
	
	};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var viewImageTemplate = __webpack_require__(111)();
	
	function imageModal() {
	
	  var controller = function($scope, modal) {
	
	    $scope.imageUrl = function(customer) {
	      return customer.imageUrl;
	    };
	
	    $scope.viewImage = function(customer) {
	      $scope.customer = customer;
	      modal.open({
	        scope: $scope,
	        klass: 'viewImage',
	        title: customer.name,
	        body: viewImageTemplate
	      });
	    };
	
	  };
	
	  controller.$inject = ['$scope', 'modal'];
	
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: { customer: '=' },
	    template: '<span class="viewImage" ng-click="viewImage(customer)" />',
	    controller: controller
	  };
	
	}
	
	module.exports = imageModal;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  var initials = function(name) {
	    if (typeof name === 'string') {
	      name = name.trim().split(/[ -]/);
	      return initial(name.shift()) + initial(name.pop());
	    }
	  };
	
	  var initial = function(name) {
	    return (name || '').charAt(0).toUpperCase();
	  };
	
	  return {
	    template: __webpack_require__(85),
	    restrict: 'E',
	    replace: true,
	    scope: { name: '@' },
	    link: function(scope) {
	      scope.initials = initials;
	    }
	  };
	
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/* global openLayersUrl */
	/* global googleMapsUrl */
	
	var Map = __webpack_require__(181);
	
	mapDirective.$inject = ['$rootScope', '$location', '$routeParams', '$compile', 'loadScript', 'modal', 'storage', 'clock', '$timeout'];
	
	function mapDirective($rootScope, $location, $routeParams, $compile, loadScript, modal, storage, clock, $timeout) {
	
	  return {
	    template: __webpack_require__(86),
	    restrict: 'E',
	    replace: true,
	    link: function(scope) {
	      loadScript.loadAll([openLayersUrl, googleMapsUrl]).then(function() {
	        //The $timeout is needed so you get the correct class on the map from ng-class.
	        //$timeout also runs $apply which will run angulars watchers, this is necessary in order to run translation.
	        $timeout(function() {
	          new Map(scope, $rootScope, $location, $compile, modal, storage, clock, +$routeParams.routeId, +$routeParams.routeSequence);
	        });
	      });
	    }
	  };
	};
	
	module.exports = mapDirective;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* global google */
	/* global googleMapsUrl */
	
	mapCoordinatesDirective.$inject = ['loadScript'];
	
	function mapCoordinatesDirective(loadScript) {
	
	  return {
	    template: __webpack_require__(87),
	    restrict: 'E',
	    replace: true,
	
	    scope: {
	      countryCode: '=',
	      city: '=',
	      address: '=',
	      onSave: '='
	    },
	
	    link: function(scope) {
	
	      scope.markerPlaced = function(address, position) {
	        scope.newAddress = address;
	        scope.position = position;
	        scope.$apply();
	      };
	
	      scope.save = function() {
	        scope.onSave(scope.position.lat(), scope.position.lng(), scope.newAddress);
	      };
	
	      loadScript
	        .load(googleMapsUrl)
	        .then(function() {
	          initializeMap(scope.countryCode, scope.city, scope.address, scope.markerPlaced);
	        });
	    }
	
	  };
	
	}
	
	module.exports = mapCoordinatesDirective;
	
	
	function initializeMap(countryCode, city, address, markerPlaced) {
	
	  var mapOptions = {
	    disableDefaultUI: true,
	    keyboardShortcuts: false,
	    clickableIcons: false,
	    draggableCursor: 'pointer',
	    tilt: 0,
	    center: { // Oslo
	      lat: 59.916600,
	      lng: 10.729400
	    },
	    zoom: 12,
	    zoomControl: true,
	    zoomControlOptions: {
	      position: google.maps.ControlPosition.TOP_RIGHT
	    }
	  };
	
	  var map = new google.maps.Map(document.getElementById('map'), mapOptions);
	  var marker;
	  var timer;
	
	  getCenter(countryCode, address, function(location, address, isAddress, searchAgain) {
	    if (searchAgain) {
	      // Try again, now only with city
	      getCenter(countryCode, city, function(location) {
	        map.setCenter(location);
	      });
	    } else {
	      map.setCenter(location);
	      if (isAddress) {
	        map.setZoom(16);
	        addMarker(location);
	        markerPlaced(address, location);
	      }
	    }
	  });
	
	  google.maps.event.addListener(map, 'click', function(event) {
	    timer = window.setTimeout(function() {
	      addMarker(event.latLng);
	      getPlace(event, markerPlaced);
	    }, 200);
	  });
	
	  google.maps.event.addListener(map, 'dblclick', function() {
	    window.clearTimeout(timer);
	  });
	
	  var addMarker = function(position) {
	    if (marker) {
	      google.maps.event.clearListeners(marker, 'dragend');
	      marker.setMap(null);
	    }
	
	    marker = new google.maps.Marker({
	      map: map,
	      position: position,
	      draggable: true,
	      crossOnDrag: false
	    });
	
	    google.maps.event.addListener(marker, 'dragend', function(event) {
	      getPlace(event, markerPlaced);
	    });
	  };
	
	}
	
	function getPlace(event, callback) {
	  geocode({
	    location: event.latLng
	  }, function(result) {
	    callback(removeCountry(result), event.latLng);
	  });
	}
	
	function getCenter(countryCode, address, callback) {
	  geocode({
	    address: address,
	    componentRestrictions: {
	      country: countryCode
	    }
	  }, function(result) { // successCallback
	    var isAddress = result.types.some(function(type) {
	      return type === 'street_address' || type === 'route';
	    });
	    var searchAgain = result.types.some(function(type) {
	      return type === 'country'; // If the result is of type "whole country", we want to search again
	    });
	    callback(result.geometry.location, removeCountry(result), isAddress, searchAgain);
	  }, function() { // emptyResultCallback
	    // Order a new call when result is empty
	    callback(null, null, false, true);
	  });
	}
	
	function geocode(request, successCallback, emptyResultCallback) {
	  new google.maps.Geocoder().geocode(request, function(results, status) {
	    if (status === google.maps.GeocoderStatus.OK) {
	      successCallback(results[0]);
	    } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
	      emptyResultCallback();
	    }
	  });
	}
	
	function removeCountry(address) {
	  return address.formatted_address.replace(/, \w+$/, '');
	}


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	var Sortable = __webpack_require__(31);
	
	// TODO cancel move on ESC
	
	module.exports = function() {
	
	  return {
	    restrict: 'A',
	
	    link: function(scope, element, attrs) {
	      var callback = scope[attrs.moveStopLocation];
	      var routeId = +attrs.routeId;
	
	      Sortable.create(element[0], {
	        group: '' + routeId,
	        handle: '.move',
	        draggable: '.stop-location',
	        animation: 300,
	        onEnd: function(event) {
	          var id = +event.item.getAttribute('data-stop-location-id');
	          var stopLocation = scope.routePlan.findStopLocation(routeId, id);
	
	          callback(stopLocation, event.oldIndex - 1, event.newIndex - 1, routeId);
	          scope.$apply();
	        }
	      });
	    }
	
	  };
	
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(93),
	    restrict: 'E',
	    transclude: true
	  };
	
	};


/***/ },
/* 149 */
/***/ function(module, exports) {

	module.exports = function() {
	
	  return {
	    template: '<div class="page-header"><div ng-transclude></div></div>',
	    restrict: 'E',
	    replace: true,
	    transclude: true
	  };
	
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(94),
	    restrict: 'E',
	    replace: true
	  };
	
	};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(95),
	    restrict: 'E',
	    replace: true
	  };
	
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(96),
	    restrict: 'E',
	    replace: true
	  };
	
	};


/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = function() {
	  return {
	    restrict: 'E',
	    link: function(scope) {
	      var interval = window.setInterval(function() {
	        if (scope.dataLoaded()) {
	          clearInterval(interval);
	          window.setTimeout(function() {
	            window.print();
	            window.setTimeout(window.close, 100);
	          });
	        }
	      }, 100);
	    }
	  };
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(99),
	    restrict: 'E',
	    replace: true,
	    scope: { max: '=', delivered: '=', deviation: '=', cancelled: '=' },
	    link: function(scope) {
	      scope.calcPercentage = function(count) {
	        return (count / scope.max) * 100 + '%';
	      };
	      scope.isFirst = function(item) {
	        if (item === 'cancelled') {
	          return (scope.cancelled);
	        } else if (item === 'delivered') {
	          return (! scope.cancelled);
	        } else if (item === 'deviation') {
	          return (! scope.cancelled && ! scope.delivered);
	        }
	      };
	      scope.isLast = function(item) {
	        if (item === 'cancelled') {
	          return (scope.cancelled === scope.max);
	        } else if (item === 'delivered') {
	          return (scope.cancelled + scope.delivered === scope.max);
	        } else if (item === 'deviation') {
	          return (scope.cancelled + scope.delivered + scope.deviation === scope.max);
	        }
	      };
	    }
	  };
	
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(101),
	    restrict: 'E',
	    replace: true,
	    link: function(scope, element, attrs) {
	      if (attrs.routeId) {
	        scope.route = scope.routePlan.findRoute(+attrs.routeId);
	      }
	    }
	  };
	
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	function sortable() {
	
	  var template = function(element) {
	    return '<TAG ng-click="sortBy()" ng-class="sortClass()"><ng-transclude /><span class="icon" /></TAG>'
	      .replace(/TAG/g, element.prop('tagName'));
	  };
	
	  var controller = function($scope, $element, $attrs) {
	    var key = $element.parent().attr('sortable-key');
	    var orderBy = $scope.$parent.orderBy = $scope.$parent.orderBy || {};
	
	    if (key) {
	      orderBy = $scope.$parent.orderBy[key] = $scope.$parent.orderBy[key] || {};
	    }
	
	    $scope.setOrderBy = function() {
	      orderBy.propertyName = $scope.propertyName;
	      orderBy.reverse = angular.isDefined($attrs.reverse);
	
	      if (angular.isDefined($attrs.function)) {
	        orderBy.property = function(object) {
	          return object[$scope.propertyName]();
	        };
	      } else {
	        orderBy.property = $scope.propertyName.split(' ');
	      }
	    };
	
	    $scope.sortBy = function() {
	      if (orderBy.propertyName === $scope.propertyName) {
	        orderBy.reverse = ! orderBy.reverse;
	      } else {
	        $scope.setOrderBy();
	      }
	    };
	
	    $scope.sortClass = function() {
	      if (orderBy.propertyName === $scope.propertyName) {
	        return {
	          sortable: true,
	          active: true,
	          reverse: orderBy.reverse
	        };
	      } else {
	        return 'sortable';
	      }
	    };
	
	  };
	
	  controller.$inject = ['$scope', '$element', '$attrs'];
	
	  var link = function(scope, element, attrs) {
	    if (angular.isDefined(scope.ngShow) && ! scope.ngShow) {
	      return;
	    }
	
	    if (angular.isDefined(attrs.default)) {
	      scope.setOrderBy();
	    }
	  };
	
	  return {
	    restrict: 'A',
	    replace: true,
	    transclude: true,
	    scope: {
	      propertyName: '@sortable',
	      ngShow: '='
	    },
	    template: template,
	    controller: controller,
	    link: link
	  };
	
	}
	
	module.exports = sortable;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(107),
	    restrict: 'E',
	    replace: true
	  };
	
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	
	  return {
	    template: __webpack_require__(108),
	    restrict: 'E',
	    link: function(scope) {
	      scope.deliveryStatusTooltipTemplate = __webpack_require__(22)();
	    }
	  };
	
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var tooltipTemplate = __webpack_require__(110)();
	
	tooltip.$inject = ['$compile', '$document', '$rootScope'];
	
	function tooltip($compile, $document, $rootScope) {
	
	  return {
	    restrict: 'A',
	    scope: true,
	
	    link: function(scope, element, attrs) {
	      var tooltipElement;
	
	      element.attr('ng-click', '_openTooltip($event)');
	      if (! attrs.mustClick) {
	        element.attr('ng-mouseenter', '_openTooltip($event)');
	        element.attr('ng-mouseleave', '_closeTooltip()');
	      }
	      element.removeAttr('tooltip');
	
	      $compile(element)(scope);
	
	      scope.$on('tooltipOpens', function(e, otherElem) {
	        if (otherElem !== element) {
	          scope._closeTooltip();
	        }
	      });
	
	      scope._openTooltip = function(event) {
	        var template = scope[attrs.tooltip];
	
	        if (tooltipElement || ! template) return;
	
	        $rootScope.$broadcast('tooltipOpens', element);
	
	        template = tooltipTemplate.replace('{{ body }}', template);
	        template = $compile(template)(scope);
	        tooltipElement = angular.element(template);
	        element
	          .addClass('tooltip-open')
	          .append(tooltipElement);
	
	        event.stopImmediatePropagation();
	        $document.on('keydown', closeOnEscape);
	        $document.on('click', scope._closeTooltip);
	      };
	
	      scope._closeTooltip = function() {
	        if (! tooltipElement) return;
	
	        tooltipElement.remove();
	        tooltipElement = null;
	        element.removeClass('tooltip-open');
	
	        $document.off('keydown', closeOnEscape);
	        $document.off('click', scope._closeTooltip);
	      };
	
	      var closeOnEscape = function(event) {
	        if (event.keyCode === 27) {  // ESC
	          scope._closeTooltip();
	        }
	      };
	
	    }
	
	  };
	
	}
	
	module.exports = tooltip;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(5);
	
	module.exports = function() {
	
	  return function(routePlans, archive) {
	    var today = moment().format('YYYY-MM-DD');
	
	    if (routePlans === undefined) return [];
	
	    return routePlans.filter(function(routePlan) {
	      var isActive = routePlan.date >= today;
	      return archive ? ! isActive : isActive;
	    });
	  };
	
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(5);
	
	module.exports = function() {
	
	  return function(minutes) {
	    if (! minutes) return null;
	
	    var duration = moment.duration(minutes, 'minutes');
	    var days = Math.floor(duration.asDays());
	    var hours = duration.hours() + (days * 24);
	
	    if (hours===0) {
	      return duration.minutes() + 'm ' + duration.seconds() + 's';
	    } else {
	      return hours + 't ' + duration.minutes() + 'm';
	    }
	
	  };
	
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(5);
	
	module.exports = function() {
	
	  return function(seconds) {
	    if (! seconds) return null;
	
	    var duration = moment.duration(seconds, 'seconds');
	    var days = Math.floor(duration.asDays());
	    var hours = duration.hours() + (days * 24);
	    var minutes = duration.minutes() + (hours * 60);
	
	    if (hours===0) {
	      return duration.minutes() + 'm' + (duration.seconds()>0 ? ' '+duration.seconds()+'s' : '');
	    } else if (minutes===0) {
	      return duration.seconds() + 's';
	    } else {
	      return hours + 't ' + duration.minutes() + 'm';
	    }
	
	  };
	
	};


/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports = function() {
	
	  return function(customers, filter) {
	    return customers.filter(function(customer) {
	      return (! filter.routeId || customer.routeId === +filter.routeId) &&
	             customer.filterDeliveries(filter.status, filter.delayed).length;
	    });
	  };
	
	};


/***/ },
/* 164 */
/***/ function(module, exports) {

	module.exports = function() {
	
	  return function(routes, filter) {
	    return routes.filter(function(route) {
	      var driverNotStarted = route.driverUsername && ! route.timestampStart; // Assigned driver + not startet
	      var startedButNotDone = route.timestampStart && ! route.timestampStop;
	
	      var filterNotStarted = filter.status!=='notStarted' || ! route.timestampStart; // With or without driver
	      var filterUnfinished = filter.status!=='unfinished' || startedButNotDone;
	      var filterDelayed = filter.status!=='delayed' || (!! route.delayForHumans() && (driverNotStarted || startedButNotDone));
	      var filterReserved = filter.status!=='reserved' || route.reserved;
	
	      return filterNotStarted && filterUnfinished && filterDelayed && filterReserved;
	    });
	  };
	
	};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(5);
	
	module.exports = function() {
	
	  return function(date, format) {
	    if (! date) return null;
	    return moment(date).format(format);
	  };
	
	};


/***/ },
/* 166 */
/***/ function(module, exports) {

	module.exports = function() {
	
	    return function(stops) {
	        return stops.reduce(function(result, stop) {
	            if(! stop.anyComingNotifications()) {
	                result.push(stop);
	            } else {
	                // clear the old result due to driver has skipped customers
	                result = [];
	            }
	            return result;
	        }, []);
	    };
	
	};


/***/ },
/* 167 */
/***/ function(module, exports) {

	module.exports = function() {
	
	  return function(gram) {
	    if (! gram) return null;
	
	    return Math.floor(gram / 1000) + ' kg';
	  };
	
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var DistributionRoutePlan = __webpack_require__(171);
	var DistributionRoute = __webpack_require__(170);
	
	function Distribution(distribution) {
	  angular.extend(this, distribution);
	  if(this.date) {
	    this.date = this.date.slice(0, 10); // YYYY-MM-DD
	  }
	  this.routes = (this.routes || []).map(function(route) {
	    return new DistributionRoute(route, this);
	  }, this);
	
	  this.routePlans = this.routePlans.map(function(routePlan) {
	    return new DistributionRoutePlan(routePlan, this.routes);
	  }, this);
	}
	
	Distribution.prototype.status = function() {
	  return this.publishedRoutePlans().length === this.routePlans.length ? 'published' : '';
	};
	
	Distribution.prototype.publishedRoutePlans = function() {
	  return this.routePlans.filter(function(routePlan) {
	    return routePlan.published;
	  });
	};
	
	Distribution.prototype.delayedRoutes = function() {
	  return this.routes.filter(function(route) {
	    return route.delayForHumans();
	  });
	};
	
	Distribution.prototype.delayedUnfinishedRoutes = function() {
	  return this.routes.filter(function(route) {
	    return route.delayForHumans() && route.status() !== 'finished' && !! route.driver.userName;
	  });
	};
	
	Distribution.prototype.sum = function(type) {
	  return this.routePlans.reduce(function(sum, routePlan) {
	    var count = typeof routePlan[type] === 'function'
	      ? routePlan[type]()
	      : routePlan[type];
	
	    return sum + count;
	  }, 0);
	};
	
	Distribution.prototype.findRoutePlan = function(routePlanId) {
	  return this.routePlans.filter(function(routePlan) {
	    return routePlan.id === routePlanId;
	  })[0];
	};
	
	Distribution.prototype.findRoute = function(routeId) {
	  return this.routes.filter(function(route) {
	    return route.id === routeId;
	  })[0];
	};
	
	Distribution.prototype.findCustomer = function(customerId) {
	  return this.customers && this.customers.filter(function(customer) {
	    return customer.id === customerId;
	  })[0];
	};
	
	Distribution.prototype.addCustomerNotification = function(customerId, notification) {
	  var customer = this.findCustomer(customerId);
	
	  customer && customer.addNotification(notification);
	};
	
	Distribution.prototype.updateCustomerClientTime = function(customerId, clientSideTimestampDone) {
	  var customer = this.findCustomer(customerId);
	  if (customer) {
	    customer.clientSideTimestampDone = clientSideTimestampDone;
	  }
	};
	
	Distribution.prototype.updateCustomerImage = function(customerId, image) {
	  var customer = this.findCustomer(customerId);
	
	  customer && customer.updateImage(image);
	};
	
	Distribution.prototype.updateCustomerCallLog = function(customerId, driverUsername, timestampCalled) {
	  var customer = this.findCustomer(customerId);
	
	  customer && customer.callLogs.push({ driverUsername: driverUsername, timestampCalled: timestampCalled });
	};
	
	Distribution.prototype.addCustomer = function(customer) {
	  this.customers && this.customers.push(customer);
	};
	
	module.exports = Distribution;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var Customer = __webpack_require__(9);
	var Delivery = __webpack_require__(12);
	var toDate = __webpack_require__(3).toDate;
	var formatZip = __webpack_require__(3).formatZip;
	
	function DistributionCustomer(customer, distribution) {
	  angular.extend(this, customer);
	
	  this.route = distribution.findRoute(customer.routeId);
	  this.estimatedTimestampDone = toDate(customer.estimatedTimestampDone);
	
	  this.deliveries = customer.deliveries
	    .map(function(delivery) {
	      return new Delivery(delivery, this);
	    }, this)
	    .sort(function(d1, d2) {
	      return d1.product.localeCompare(d2.product);
	    });
	
	  this.notCancelled = Customer.prototype.notCancelled;
	  this.delayed = Customer.prototype.delayed;
	  this.deliveryStatusTimestamp = Customer.prototype.deliveryStatusTimestamp;
	}
	
	DistributionCustomer.prototype.fullAddress = function() {
	  return this.address + ', ' + formatZip(this.zip, this.country) + ' ' + this.city;
	};
	
	DistributionCustomer.prototype.addNotification = function(notification) {
	  this.notifications.push(notification);
	};
	
	DistributionCustomer.prototype.updateImage = function(image) {
	  this.imageUrl = image.imageUrl;
	};
	
	DistributionCustomer.prototype.updateDelivery = function(delivery) {
	  var newDelivery = new Delivery(delivery, this);
	  var oldDelivery = this.findDelivery(delivery.id);
	
	  if (oldDelivery) {
	    angular.extend(oldDelivery, newDelivery);
	  } else {
	    // Could not find delivery, let's add it to the customer
	    this.deliveries.push(newDelivery);
	  }
	};
	
	DistributionCustomer.prototype.deleteDelivery = function(deliveryId) {
	  this.deliveries = this.deliveries.filter(function(delivery) {
	    return delivery.id !== deliveryId;
	  });
	};
	
	DistributionCustomer.prototype.findDelivery = function(deliveryId) {
	  return this.deliveries.filter(function(delivery) {
	    return delivery.id === deliveryId;
	  })[0];
	};
	
	module.exports = DistributionCustomer;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var toDate = __webpack_require__(3).toDate;
	var delayHuman = __webpack_require__(3).delayForHumans;
	var delayMinutes = __webpack_require__(3).delayInMinutes;
	var formatPhone = __webpack_require__(3).formatPhone;
	
	function DistributionRoute(route, distribution) {
	  this.update(route, distribution);
	}
	
	DistributionRoute.prototype.update = function(route, distribution) {
	  angular.extend(this, route);
	  this.estimatedTimestampStart = toDate(this.estimatedTimestampStart);
	  this.estimatedTimestampStop = toDate(this.estimatedTimestampStop);
	  this.estimatedTimestampDelivery = toDate(this.estimatedTimestampDelivery);
	  this.timestampStart = toDate(this.timestampStart);
	  this.timestampStop = toDate(this.timestampStop);
	  this.timestampDelivery = toDate(this.timestampDelivery);
	  this.companyName = companyName(route, distribution);
	};
	
	var companyName = function(route, distribution) {
	  return distribution.findRoutePlan(route.routePlanId).companyName;
	};
	
	DistributionRoute.prototype.delayInMinutes = function() {
	  if (! this.timestampStart) {
	    return delayMinutes(new Date(), this.estimatedTimestampStart);
	  }
	
	  if (this.timestampStop) {
	    return delayMinutes(this.timestampStop, this.estimatedTimestampStop);
	  }
	
	  if (this.timestampDelivery) {
	    return delayMinutes(this.timestampDelivery, this.estimatedTimestampDelivery);
	  }
	
	  return delayMinutes(this.timestampStart, this.estimatedTimestampStart);
	};
	DistributionRoute.prototype.delayForHumans = function() {
	  return delayHuman(this.delayInMinutes());
	};
	
	
	DistributionRoute.prototype.driverPhone = function() {
	  return this.driver.phone ? '(' + formatPhone(this.driver.phone) + ')' : '';
	};
	
	DistributionRoute.prototype.status = function() {
	  return (this.timestampStop && 'finished') ||
	         (this.timestampStart && 'started') ||
	         'notStarted';
	};
	
	DistributionRoute.prototype.sortableDelay = function() {
	
	  var delay = function(timestamp, estimatedTimestamp) {
	    if (timestamp && estimatedTimestamp && timestamp > estimatedTimestamp) {
	      return timestamp.getTime() - estimatedTimestamp.getTime();
	    }
	    return 0;
	  };
	
	  if (! this.timestampStart) {
	    return 300000000000 + delay(new Date(), this.estimatedTimestampStart);
	  }
	
	  if (this.timestampStop) {
	    return 100000000000 + delay(this.timestampStop, this.estimatedTimestampStop);
	  }
	
	  if (this.timestampDelivery) {
	    return 200000000000 + delay(this.timestampDelivery, this.estimatedTimestampDelivery);
	  }
	
	  return 200000000000 + delay(this.timestampStart, this.estimatedTimestampStart);
	};
	
	DistributionRoute.prototype.percentageHandled = function() {
	  return (this.customerCount - this.customerRemainingCount) / this.customerCount;
	};
	
	
	module.exports = DistributionRoute;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var RoutePlan = __webpack_require__(33);
	
	function DistributionRoutePlan(routePlan, routes) {
	  angular.extend(this, routePlan);
	
	  this.status = RoutePlan.prototype.status.bind(this);
	
	  this.routes = routes.filter(function(route) {
	    return route.routePlanId === this.id;
	  }, this);
	}
	
	DistributionRoutePlan.prototype.updateStatus = function(statusId) {
	  this.statusId = statusId;
	};
	
	DistributionRoutePlan.prototype.updateCounts = function(routePlan) {
	  this.deliveryCount = routePlan.deliveryCount;
	  this.customerCount = routePlan.customerCount;
	  this.routeCount = routePlan.routeCount;
	};
	
	DistributionRoutePlan.prototype.sortableStatus = function() {
	  return {
	    created: 1,
	    importing: 2,
	    imported: 3,
	    queued: 4,
	    failed: 5,
	    optimizing: 6,
	    routesimportqueued: 7,
	    routesimporting: 8,
	    generating: 9,
	    routesimported: 10,
	    optimized: 11,
	    readyfordriverinput: 12,
	    published: 13,
	    deleted: 14
	  }[this.status()];
	};
	
	DistributionRoutePlan.prototype.delayedRoutes = function() {
	  return this.routes.filter(function(route) {
	    return route.delayForHumans();
	  });
	};
	
	DistributionRoutePlan.prototype.delayedUnfinishedRoutes = function() {
	  return this.routes.filter(function(route) {
	    return route.delayForHumans() && route.status() !== 'finished' && !! route.driver.userName;
	  });
	};
	
	DistributionRoutePlan.prototype.finishedRouteCount = function() {
	  return this.routes.reduce(function(count, route) {
	    return route.timestampStop ? count + 1 : count;
	  }, 0);
	};
	
	DistributionRoutePlan.prototype.customerRemainingCount = function() {
	  return this.routes.length
	    ? this.sum('customerRemainingCount')
	    : this.customerCount;
	};
	
	DistributionRoutePlan.prototype.customerCancelledCount = function() {
	  return this.routes.length
	    ? this.sum('customerCancelledCount')
	    : 0;
	};
	
	DistributionRoutePlan.prototype.customerDeliveredCount = function() {
	  return this.routes.length
	    ? this.sum('customerDeliveredCount')
	    : 0;
	};
	
	DistributionRoutePlan.prototype.customerDeviationCount = function() {
	  return this.routes.length
	    ? this.sum('customerDeviationCount')
	    : 0;
	};
	
	DistributionRoutePlan.prototype.deviationCount = function() {
	  return this.sum('deviationCount');
	};
	
	DistributionRoutePlan.prototype.countOutdatedApps = function() {
	  return this.routes.reduce(function(count, route) {
	    return count + ((route.driver.shouldUpgradeApp !== null && route.driver.shouldUpgradeApp) ? 1 : 0);
	  }, 0);
	};
	
	DistributionRoutePlan.prototype.sum = function(type) {
	  return this.routes.reduce(function(sum, route) {
	    return sum + route[type];
	  }, 0);
	};
	
	DistributionRoutePlan.prototype.percentageHandled = function() {
	  return (this.customerCount - this.customerRemainingCount()) / this.customerCount;
	};
	
	module.exports = DistributionRoutePlan;


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	var moment = __webpack_require__(6);
	
	var storageKey = 'downtime.';
	
	function Downtime(downtime, storage) {
	  angular.extend(this, downtime);
	  this.storage = storage;
	}
	
	Downtime.prototype.display = function(key) {
	  if (key === 'first' || key === 'final') {
	    // If no planned downtime OR if user already hidden THAT planned downtime
	    if (!this.serverDownTimestamp || this.serverDownTimestamp == this.storage.local.get(storageKey+key)) return false;
	
	    var displayFirstWarningFrom = moment(this.serverDownTimestamp).subtract(7, 'days');
	    var displayFinalWarningFrom = moment(this.serverDownTimestamp).subtract(60, 'minutes');
	    if (key === 'first') {
	      if (moment().isAfter(displayFirstWarningFrom) && moment().isBefore(displayFinalWarningFrom)) return true;
	    } else if (key === 'final') {
	      if (moment().isAfter(displayFinalWarningFrom) && moment().isBefore(this.serverDownTimestamp)) return true;
	    }
	  } else if (key === 'general') {
	    // Is a problem and user not already hidden THAT problem
	    if (this.problemsTimestamp && this.problemsTimestamp !== this.storage.local.get(storageKey+key)){
	      return true;
	    }
	  }
	};
	
	Downtime.prototype.numberOfDisplays = function(pwdWarningCheck) {
	  var number = 0;
	  if(pwdWarningCheck) number++;
	  if(this.display('first')) number++;
	  if(this.display('final')) number++;
	  if(this.display('general')) number++;
	  return 'display-level-' + number;
	};
	
	Downtime.prototype.formatDowntime = function(){
	  return moment().to(this.serverDownTimestamp);
	};
	
	Downtime.prototype.localDowntime = function(){
	    var localDowntime = moment(this.serverDownTimestamp).local()
	    return moment(localDowntime).format('dddd HH:mm');
	};
	
	Downtime.prototype.getServerDownDate = function(){
	  if (! this.serverDownTimestamp) return moment().format('YYYY-MM-DD');
	  return moment(this.serverDownTimestamp).format('YYYY-MM-DD');
	};
	
	Downtime.prototype.getServerDownTime = function(){
	  if (! this.serverDownTimestamp) return '';
	  return moment(this.serverDownTimestamp).format('HH:mm');
	};
	
	Downtime.prototype.hide = function(key) {
	  if (key === 'first' || key === 'final') {
	    this.storage.local.set(storageKey+key, this.serverDownTimestamp);
	  } else if (key === 'general') {
	    this.storage.local.set(storageKey+key, this.problemsTimestamp);
	  }
	};
	
	Downtime.prototype.getCleanModel = function() {
	  return {
	    problemsTimestamp: this.problemsTimestamp,
	    serverDownTimestamp: this.serverDownTimestamp,
	    estimatedDownTimeMinutes: this.estimatedDownTimeMinutes
	  };
	};
	
	module.exports = Downtime;
	


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	function DriverUser(user) {
	  angular.extend(this, user);
	}
	
	DriverUser.prototype.editClone = function() {
	  var user = {};
	
	  var props = ['userName', 'firstName', 'lastName', 'phone', 'email', 'active', 'lastLoggedIn', 'language'];
	
	  props.forEach(function(prop) {
	    user[prop] = this[prop];
	  }, this);
	
	  return user;
	};
	
	module.exports = DriverUser;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var angular = __webpack_require__(2);
	var util = __webpack_require__(14);
	var style = __webpack_require__(13);
	
	function CarLayer(route, clock) {
	  this.route = route;
	  this.visible = true;
	  this.hover = false;
	
	  this.addFeature();
	  this.addLayer();
	  this.addOverlay();
	
	  this.updatePositionAndVisibility();
	  clock.everyMinute(this.updatePositionAndVisibility.bind(this));
	}
	
	CarLayer.prototype.addFeature = function() {
	  this.feature = new ol.Feature();
	  this.feature.set('route', this.route, true);
	  this.feature.set('layer', this, true);
	};
	
	CarLayer.prototype.addLayer = function() {
	  this.layer = new ol.layer.Vector({
	    source: new ol.source.Vector({
	      features: [this.feature]
	    }),
	    style: this.style.bind(this),
	    updateWhileAnimating: true,
	    updateWhileInteracting: true,
	    renderBuffer: 24
	  });
	
	  this.layer.set('route', this.route, true);
	};
	
	CarLayer.prototype.addOverlay = function() {
	  this.overlay = new ol.Overlay({
	    element: document.createElement('div'),
	    stopEvent: false,
	    className: 'car-overlay ol-overlay-container ol-selectable'
	  });
	
	  this.updateClass();
	};
	
	CarLayer.prototype.updateClass = function() {
	  var element = this.overlay.getElement();
	  var classes = ['car-icon', 'car-color-' + this.route.color];
	
	  if (this.hover) classes.push('hover');
	  angular.element(element.parentNode).toggleClass('hover', this.hover);
	
	  element.className = classes.join(' ');
	};
	
	CarLayer.prototype.updatePositionAndVisibility = function() {
	  var position = {
	    latitude: this.route.driverPositionLatitude,
	    longitude: this.route.driverPositionLongitude
	  };
	
	  var displayCar = this.visible &&
	    position.latitude &&
	    position.longitude &&
	    this.route.driverPositionIsRecent();
	
	  var coordinate = displayCar ? util.coordinate(position) : null;
	
	  if (! util.equalCoordinates(coordinate, this.overlay.getPosition())) {
	    this.overlay.setPosition(coordinate);
	    this.feature.setGeometry(displayCar ? util.point(position) : null);
	  }
	};
	
	CarLayer.prototype.setVisible = function(visible) {
	  this.visible = visible;
	  this.layer.setVisible(visible);
	  this.updatePositionAndVisibility();
	};
	
	CarLayer.prototype.setHover = function(hover) {
	  this.hover = hover;
	  this.updateClass();
	};
	
	CarLayer.prototype.style = function(feature, resolution) {
	  var options = {
	    radius: 11,
	    color: 'transparent'
	  };
	
	  return style(options, feature, resolution);
	};
	
	module.exports = CarLayer;


/***/ },
/* 175 */
/***/ function(module, exports) {

	/* global ol */
	
	/**
	 * If a route or car feature is double clicked, select and zoom to fit that route,
	 * otherwise zoom the map in one level (or out if the shift key is pressed).
	 */
	
	function DoubleClickZoomInteraction(map) {
	  this.map = map;
	
	  this.doubleClickZoom = new ol.interaction.DoubleClickZoom({
	    duration: 0
	  });
	
	  this.interaction = new ol.interaction.Interaction({
	    handleEvent: this.handleEvent.bind(this)
	  });
	}
	
	DoubleClickZoomInteraction.prototype.handleEvent = function(event) {
	  return ol.events.condition.doubleClick(event)
	    ? this.onDoubleClick(event)
	    : true;
	};
	
	DoubleClickZoomInteraction.prototype.onDoubleClick = function(event) {
	  var route = this.routeAtPixel(event);
	
	  if (route) {
	    this.map.scope.map.selectRoute(route);
	    this.map.routeZoomControl.zoomToFitRoute();
	    this.map.scope.$apply();
	    event.preventDefault();
	  } else {
	    this.doubleClickZoom.handleEvent(event);
	  }
	
	  return false;
	};
	
	DoubleClickZoomInteraction.prototype.routeAtPixel = function(event) {
	  return event.map.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
	    if(layer) return layer.get('route');
	  });
	};
	
	module.exports = DoubleClickZoomInteraction;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var StopLocation = __webpack_require__(15);
	
	function DummyStopLocation(features) {
	  var customers = [];
	
	  features.forEach(function(feature) {
	    feature.get('stop').customers.forEach(function(customer) {
	      customers.push(customer);
	    });
	  });
	
	  this.customers = customers;
	}
	
	DummyStopLocation.prototype = Object.create(StopLocation.prototype);
	DummyStopLocation.prototype.constructor = DummyStopLocation;
	
	module.exports = DummyStopLocation;


/***/ },
/* 177 */
/***/ function(module, exports) {

	/* global ol */
	
	function EditRouteInteraction(map) {
	  this.map = map;
	
	  this.interaction = new ol.interaction.Select({
	    addCondition: ol.events.condition.singleClick,
	    toggleCondition: ol.events.condition.never,
	    layers: [].concat(this.map.layers('routeLayers'), this.map.layers('carLayers')),
	    style: []
	  });
	
	  this.interaction.on('select', this.onSelect.bind(this));
	}
	
	EditRouteInteraction.prototype.onSelect = function(event) {
	  var selected = event.selected[0];
	  var route = selected.get('route') || selected.get('features')[0].get('stop').route;
	
	  this.interaction.getFeatures().clear(); // Makes the feature reselectable
	  this.map.tooltip.hideTooltip();
	  this.map.scope.openEditRoute(event, route);
	};
	
	module.exports = EditRouteInteraction;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var angular = __webpack_require__(2);
	
	function FullScreenControl(map) {
	  this.map = map;
	  this.closeOnEscape = this.closeOnEscape.bind(this);
	  this.toggleFullScreen = this.toggleFullScreen.bind(this);
	  this.control = this.initControl();
	}
	
	FullScreenControl.prototype.initControl = function() {
	  var $div = angular.element(
	    '<div class="ol-full-screen ol-unselectable ol-control"><button type="button" /></div>'
	  );
	
	  $div.find('button').on('click', this.toggleFullScreen);
	
	  return new ol.control.Control({
	    element: $div[0]
	  });
	};
	
	FullScreenControl.prototype.toggleFullScreen = function() {
	  var $body = angular.element(document.body);
	  var $document = angular.element(document);
	
	  if ($body.hasClass('map-full-screen')) {
	    $body.removeClass('map-full-screen');
	    $document.off('keydown', this.closeOnEscape);
	  } else {
	    $body.addClass('map-full-screen');
	    $document.on('keydown', this.closeOnEscape);
	  }
	
	  this.map.updateSize();
	};
	
	FullScreenControl.prototype.closeOnEscape = function(event) {
	  var toggleFullScreen = this.toggleFullScreen;
	
	  if (event.keyCode !== 27) return;
	
	  // Do not exit full-screen mode when using escape to close a modal
	  setTimeout(function() {
	    if (! event.isImmediatePropagationStopped()) {
	      toggleFullScreen();
	    }
	  });
	};
	
	module.exports = FullScreenControl;


/***/ },
/* 179 */
/***/ function(module, exports) {

	/* global google */
	/* global ol */
	
	var styleSaturated = {};
	var styleDesaturated = {
	  stylers: [{ saturation: -80 }]
	};
	
	var options = {
	  backgroundColor: '#f8fafb',
	  clickableIcons: false,
	  disableDefaultUI: true,
	  disableDoubleClickZoom: true,
	  gestureHandling: 'none',
	  keyboardShortcuts: false,
	  scrollwheel: false,
	  styles: [styleDesaturated]
	};
	
	var hiddenFeatures = [
	  'poi.attraction',
	  'poi.business',
	  // 'poi.government',
	  // 'poi.medical',
	  // 'poi.place_of_worship',
	  'poi.school',
	  'poi.sports_complex',
	  'transit.station.bus'
	];
	
	function GoogleMapsLayer(map) {
	  var openLayersElement = map.getTargetElement();
	
	  this.view = map.getView();
	
	  options.maxZoom = this.view.getMaxZoom();
	  options.minZoom = this.view.getMinZoom();
	  options.styles = [].concat(options.styles, this.hideFeatures());
	
	  this.googleMaps = new google.maps.Map(document.getElementById('googleMaps'), options);
	
	  if(openLayersElement){
	    openLayersElement.parentNode.removeChild(openLayersElement);
	  }
	
	  this.googleMaps.controls[google.maps.ControlPosition.TOP_LEFT].push(openLayersElement);
	
	  this.view.on('change:resolution', this.syncZoom.bind(this));
	  this.view.on('change:center', this.syncCenter.bind(this));
	  map.on('change:size', this.syncSize.bind(this));
	}
	
	GoogleMapsLayer.prototype.hideFeatures = function() {
	  return hiddenFeatures.map(function(featureType) {
	    return {
	      featureType: featureType,
	      stylers: [{ visibility: 'off' }]
	    };
	  });
	};
	
	GoogleMapsLayer.prototype.syncCenter = function() {
	  var center = this.view.getCenter();
	
	  center = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
	  center = new google.maps.LatLng(center[1], center[0]);
	
	  this.googleMaps.setCenter(center);
	};
	
	GoogleMapsLayer.prototype.syncZoom = function() {
	  this.googleMaps.setZoom(this.view.getZoom());
	};
	
	GoogleMapsLayer.prototype.syncSize = function() {
	  google.maps.event.trigger(this.googleMaps, 'resize');
	  this.syncCenter();
	};
	
	GoogleMapsLayer.prototype.toggleSaturation = function(saturated) {
	  options.styles[0] = saturated ? styleSaturated : styleDesaturated;
	  this.googleMaps.setOptions(options);
	};
	
	module.exports = GoogleMapsLayer;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var angular = __webpack_require__(2);
	
	function HoverRouteInteraction(map, layer, isCar) {
	  this.map = map;
	  this.layer = layer;
	  this.isCar = isCar;
	
	  this.layerStyle = layer.layer.getStyle();
	  this.stroke = new ol.style.Stroke({
	    color: 'white',
	    width: 2
	  });
	
	  this.interaction = new ol.interaction.Select({
	    condition: ol.events.condition.pointerMove,
	    toggleCondition: ol.events.condition.never,
	    layers: [this.layer.layer],
	    style: []
	  });
	
	  this.interaction.on('select', this.onSelect.bind(this));
	
	  this.clearHover = this.clearHover.bind(this);
	  this.map.map.on('movestart', this.clearHover); // TODO disable hover until moveend
	  angular.element(this.map.map.getViewport()).on('mouseout', this.clearHover);
	}
	
	HoverRouteInteraction.prototype.onSelect = function(event) {
	  var hover = ! this.routeSelected() && !! event.selected[0];
	  var siblingLayers = this.isCar ? this.map.routeLayers : this.map.carLayers;
	
	  this.setHover(hover);
	  if (siblingLayers) {
	    siblingLayers[this.layer.route.id].hoverInteraction.setHover(hover);
	  }
	};
	
	HoverRouteInteraction.prototype.clearHover = function() {
	  if (this.hover) {
	    this.interaction.getFeatures().clear();
	    this.setHover(false);
	  }
	};
	
	HoverRouteInteraction.prototype.setHover = function(hover) {
	  if (hover !== this.hover) {
	    this.hover = hover;
	    this.isCar && this.layer.setHover(hover);
	    this.updateClusterStyle();
	    this.map.selectStyle.redrawStyle();
	  }
	};
	
	HoverRouteInteraction.prototype.updateClusterStyle = function() {
	  var style = this.hover ? this.hoverStyle.bind(this) : this.layerStyle;
	
	  this.layer.layer.setStyle(style);
	  this.layer.layer.setZIndex(this.hover ? 2 : 0);
	};
	
	HoverRouteInteraction.prototype.routeSelected = function() {
	  return this.layer.route === this.map.scope.map.route;
	};
	
	HoverRouteInteraction.prototype.hoverStyle = function(feature, resolution) {
	  var style = this.layerStyle(feature, resolution);
	  var circle = style.length ? style[0] : style;
	
	  circle.setStroke(this.stroke);
	
	  return style;
	};
	
	module.exports = HoverRouteInteraction;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var GoogleMapsLayer = __webpack_require__(179);
	var PickupLocationLayer = __webpack_require__(186);
	var RouteLayer = __webpack_require__(187);
	var CarLayer = __webpack_require__(174);
	var SelectInteractionStyle = __webpack_require__(190);
	var HoverRouteInteraction = __webpack_require__(180);
	var DoubleClickZoomInteraction = __webpack_require__(175);
	var MoveStopsInteraction = __webpack_require__(185);
	var EditRouteInteraction = __webpack_require__(177);
	var Tooltip = __webpack_require__(192);
	var MapTooltipTemplate = __webpack_require__(183);
	var SelectRouteControl = __webpack_require__(191);
	var FullScreenControl = __webpack_require__(178);
	var SaturationControl = __webpack_require__(189);
	var RouteZoomControl = __webpack_require__(188);
	var MouseCursor = __webpack_require__(184);
	var MapState = __webpack_require__(182);
	
	var maxZoom = 20;
	var minZoom = 4;
	
	function Map(scope, $rootScope, $location, $compile, modal, storage, clock, routeId, routeSequence) {
	  this.scope = scope;
	  this.scope.map = {
	    selectRoute: this.initSelectRoute($location)
	  };
	
	  this.view = new ol.View({
	    maxZoom: maxZoom,
	    minZoom: minZoom
	  });
	
	  this.map = new ol.Map({
	    target: 'openLayers',
	    view: this.view,
	    interactions: this.initInteractions(),
	    controls: []
	  });
	
	  this.canEditRoute = scope.canEditRouteInfo(scope.routePlan);
	  this.canMoveStops = scope.canMoveStops && scope.canMoveStops(scope.routePlan);
	
	  this.googleMapsLayer = new GoogleMapsLayer(this.map);
	
	  this.addControls($compile, storage);
	  this.addPickupLocationLayers();
	  this.addRouteLayers(routeId, routeSequence);
	  this.addSelectInteractionStyle();
	  this.addHoverRouteInteraction(false);
	  this.addDoubleClickZoomInteraction();
	  this.addTooltip($compile);
	
	  if (this.scope.routePlan.published) {
	    this.addCarLayers(clock);
	    this.addHoverRouteInteraction(true);
	    this.addEditRouteInteraction();
	    new MouseCursor(this.map, this.canEditRoute);
	  } else {
	    this.addMoveStopsInteraction(modal);
	    new MouseCursor(this.map, this.canMoveStops);
	  }
	
	  this.addPusherListeners($rootScope, clock);
	
	  this.fitMap($rootScope, storage, routeId);
	}
	
	Map.prototype.initSelectRoute = function($location) {
	  var control = new SelectRouteControl(this, $location);
	
	  return control.selectRoute.bind(control);
	};
	
	Map.prototype.initInteractions = function() {
	  return [
	    new ol.interaction.DragPan({
	      kinetic: false
	    }),
	    new ol.interaction.DragZoom({
	      duration: 0
	    }),
	    new ol.interaction.MouseWheelZoom({
	      constrainResolution: true, // zoom to an integer
	      duration: 750
	    })
	  ];
	};
	
	Map.prototype.addControls = function($compile, storage) {
	  this.map.addControl(new ol.control.Zoom({
	    duration: 0
	  }));
	
	  this.fullScreenControl = new FullScreenControl(this.map);
	  this.map.addControl(this.fullScreenControl.control);
	
	  this.saturationControl = new SaturationControl(this.googleMapsLayer, storage);
	  this.map.addControl(this.saturationControl.control);
	
	  this.routeZoomControl = new RouteZoomControl(this, $compile);
	  this.map.addControl(this.routeZoomControl.control);
	};
	
	Map.prototype.addPickupLocationLayers = function() {
	  this.pickupLocationLayers = {};
	
	  this.scope.routePlan.pickupLocations.forEach(function(location) {
	    var layer = new PickupLocationLayer(location);
	
	    this.pickupLocationLayers[location.id] = layer;
	    this.map.addLayer(layer.layer);
	  }, this);
	};
	
	Map.prototype.addRouteLayers = function(routeId, routeSequence) {
	  this.routeLayers = {};
	
	  this.scope.routePlan.routes.forEach(function(route) {
	    var routeSequenceArgument = routeId === route.id ? routeSequence : null;
	    var layer = new RouteLayer(route, this.scope.routeColors[route.color], routeSequenceArgument);
	
	    this.routeLayers[route.id] = layer;
	    this.map.addLayer(layer.layer);
	  }, this);
	};
	
	Map.prototype.addCarLayers = function(clock) {
	  this.carLayers = {};
	
	  this.scope.routePlan.routes.forEach(function(route) {
	    var layer = new CarLayer(route, clock);
	
	    this.carLayers[route.id] = layer;
	    this.map.addLayer(layer.layer);
	    this.map.addOverlay(layer.overlay);
	  }, this);
	};
	
	Map.prototype.addSelectInteractionStyle = function() {
	  this.selectStyle = new SelectInteractionStyle(this.map);
	  this.map.addInteraction(this.selectStyle.interaction);
	};
	
	Map.prototype.addHoverRouteInteraction = function(isCar) {
	  var layers = isCar ? this.carLayers : this.routeLayers;
	
	  this.scope.routePlan.routes.forEach(function(route) {
	    var layer = layers[route.id];
	    var interaction = new HoverRouteInteraction(this, layer, isCar);
	
	    this.map.addInteraction(interaction.interaction);
	    layer.hoverInteraction = interaction;
	  }, this);
	};
	
	Map.prototype.addDoubleClickZoomInteraction = function() {
	  this.map.addInteraction(new DoubleClickZoomInteraction(this).interaction);
	};
	
	Map.prototype.addEditRouteInteraction = function() {
	  if (this.canEditRoute) {
	    this.map.addInteraction(new EditRouteInteraction(this).interaction);
	  }
	};
	
	Map.prototype.addMoveStopsInteraction = function(modal) {
	  if (this.canMoveStops) {
	    this.moveStopsInteraction = new MoveStopsInteraction(this, modal);
	    this.map.addInteraction(this.moveStopsInteraction.dragInteraction);
	    this.map.addInteraction(this.moveStopsInteraction.clickInteraction);
	  }
	};
	
	Map.prototype.addTooltip = function($compile) {
	  var mapTooltipTemplate = new MapTooltipTemplate(this.scope, $compile);
	
	  this.tooltip = new Tooltip(mapTooltipTemplate, this.map);
	  this.map.addOverlay(this.tooltip.overlay);
	  this.map.addInteraction(this.tooltip.interaction);
	};
	
	Map.prototype.addPusherListeners = function($rootScope, clock) {
	  var deregister = [
	    $rootScope.$on('deliveryStatusUpdated', this.handleDeliveryStatusUpdated.bind(this)),
	    $rootScope.$on('routeUpdated', this.handleRouteUpdated.bind(this)),
	    $rootScope.$on('routeSequenceUpdated', this.handleRouteSequenceUpdated.bind(this)),
	    $rootScope.$on('driverPositionUpdated', this.handleDriverPositionUpdated.bind(this)),
	    $rootScope.$on('published', this.handlePublished.bind(this, clock))
	  ];
	
	  this.scope.$on('$destroy', function() {
	    deregister.forEach(function(deregister) {
	      deregister();
	    });
	  });
	};
	
	Map.prototype.handleDeliveryStatusUpdated = function(event, delivery) {
	  var routeId = this.scope.routePlan.findCustomer(delivery.customerId).routeId;
	
	  this.routeLayers[routeId].redraw();
	  this.selectStyle.redrawStyle();
	};
	
	Map.prototype.handleRouteUpdated = function(event, routeId) {
	  var route = this.scope.routePlan.findRoute(routeId);
	  var routeLayer = this.routeLayers[routeId];
	  var carLayer = this.carLayers && this.carLayers[routeId];
	
	  if (routeLayer)
	    routeLayer.updateColor(this.scope.routeColors[route.color]);
	
	  if (carLayer) {
	    carLayer.updateClass();
	    carLayer.updatePositionAndVisibility();
	  }
	
	  this.selectStyle.redrawStyle();
	};
	
	Map.prototype.handleRouteSequenceUpdated = function(event, routeId) {
	  var routeLayer = this.routeLayers[routeId];
	  if (routeLayer)
	    routeLayer.redraw();
	
	  this.selectStyle.redrawStyle();
	};
	
	Map.prototype.handleDriverPositionUpdated = function(event, route) {
	  if (this.carLayers) {
	    this.carLayers[route.id].updatePositionAndVisibility();
	  }
	};
	
	Map.prototype.handlePublished = function(clock) {
	  this.addCarLayers(clock);
	  this.addHoverRouteInteraction(true);
	
	  if (this.moveStopsInteraction) {
	    this.map.removeInteraction(this.moveStopsInteraction.dragInteraction);
	    this.map.removeInteraction(this.moveStopsInteraction.clickInteraction);
	  }
	  this.addEditRouteInteraction();
	};
	
	Map.prototype.fitMap = function($rootScope, storage, routeId) {
	  var route = routeId && this.scope.routePlan.findRoute(routeId);
	
	  if (route) {
	    this.scope.map.selectRoute(route);
	    this.routeZoomControl.zoomToFitRoute();
	  }
	
	  if (! this.view.getCenter()) {
	    this.routeZoomControl.zoomToFitAllRoutes();
	  }
	
	  if (! this.view.getCenter()) {
	    this.view.setZoom(5);
	    this.view.setCenter(ol.proj.fromLonLat([10.743587, 59.915043]));
	  }
	
	  if (this.scope.routePlan.published) {
	    this.restoreMapState($rootScope, storage);
	  }
	};
	
	// Save the map state when going to the customers or dashboard page and
	// restore it when coming back
	Map.prototype.restoreMapState = function($rootScope, storage) {
	  var mapState = new MapState(this.view, this.scope, storage);
	
	  var deregister = $rootScope.$on('$routeChangeStart', function(event, next) {
	    if (next.page.indexOf('fleet') === 0) {
	      mapState.save();
	    } else {
	      mapState.remove();
	    }
	    deregister();
	  });
	
	  mapState.restore();
	  mapState.remove();
	};
	
	Map.prototype.layers = function(layerType) {
	  return this.scope.values(this[layerType]).map(function(layer) {
	    return layer.layer;
	  });
	};
	
	module.exports = Map;


/***/ },
/* 182 */
/***/ function(module, exports) {

	var storageKey = 'map';
	
	function MapState(view, scope, storage) {
	  this.view = view;
	  this.scope = scope;
	  this.storage = storage;
	}
	
	MapState.prototype.save = function() {
	  this.storage.session.set(storageKey, {
	    routeId: this.routeId(),
	    zoom: this.view.getZoom(),
	    center: this.view.getCenter()
	  });
	};
	
	MapState.prototype.remove = function() {
	  this.storage.session.remove(storageKey);
	};
	
	MapState.prototype.restore = function() {
	  var state = this.storage.session.get(storageKey);
	  var routeId = (state && +state.routeId) || null;
	
	  if (state && routeId === this.routeId()) {
	    this.view.setZoom(state.zoom);
	    this.view.setCenter(state.center);
	  }
	};
	
	MapState.prototype.routeId = function() {
	  return this.scope.map.route ? this.scope.map.route.id : null;
	};
	
	module.exports = MapState;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var Count = __webpack_require__(11);
	var mapTooltipTemplate = __webpack_require__(88)();
	
	var maxRoutesInColumn = 15;
	
	function MapTooltipTemplate(scope, $compile) {
	  this.scope = scope;
	  this.$compile = $compile;
	}
	
	MapTooltipTemplate.prototype.compile = function(selectedFeature) {
	  var template;
	
	  this.scope.mapTooltip = this.initScope(selectedFeature, this.scope.routePlan);
	  template = this.$compile(mapTooltipTemplate)(this.scope);
	  this.scope.$apply();
	
	  return template[0];
	};
	
	MapTooltipTemplate.prototype.initScope = function(selectedFeature, routePlan) {
	  var features = selectedFeature.get('features') || [];
	
	  var mapTooltip = {
	    pickupLocation: selectedFeature.get('pickupLocation'),
	    route: selectedFeature.get('route'),
	    isCluster: features.length > 1,
	    stops: features.map(function(feature) {
	      return feature.get('stop');
	    })
	  };
	
	  if (mapTooltip.pickupLocation) {
	    mapTooltip.nrOfRouteNameColumns = function() {
	      var routes = routePlan.routes.filter((function(route) {
	        return route.pickupLocationId === mapTooltip.pickupLocation.id;
	      }));
	      return Math.ceil(routes.length / maxRoutesInColumn);
	    };
	  }
	
	  if (mapTooltip.isCluster) {
	    angular.extend(mapTooltip, new Count(mapTooltip.stops));
	  }
	
	  return mapTooltip;
	};
	
	module.exports = MapTooltipTemplate;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var angular = __webpack_require__(2);
	
	function MouseCursor(map, canEdit) {
	  this.cursor = '';
	
	  this.map = map;
	  this.canEdit = canEdit;
	  this.$element = angular.element(document.getElementById('map'));
	
	  this.map.on('pointermove', this.handlePointerMove.bind(this));
	  this.map.on('click', this.handleClick.bind(this));
	  this.$element.on('mouseup', this.handleMouseUp.bind(this));
	}
	
	MouseCursor.prototype.handlePointerMove = function(event) {
	  var cursor =
	    this.zoomIn(event) && 'zoom-in' ||
	    this.grabbing(event) && 'grabbing' ||
	    this.pointer(event) && 'pointer';
	
	  this.updateCursor(cursor || '');
	};
	
	MouseCursor.prototype.handleClick = function() {
	  this.updateCursor('');
	};
	
	MouseCursor.prototype.handleMouseUp = function() {
	  if (this.cursor === 'zoom-in' || this.cursor === 'grabbing') {
	    this.updateCursor('');
	  }
	};
	
	MouseCursor.prototype.updateCursor = function(cursor) {
	  if (cursor !== this.cursor) {
	    this.cursor = cursor;
	    this.$element.removeClass('zoom-in grabbing pointer');
	    cursor && this.$element.addClass(cursor);
	  }
	};
	
	MouseCursor.prototype.zoomIn = function(event) {
	  return event.dragging &&
	    (this.cursor === 'zoom-in' || ol.events.condition.shiftKeyOnly(event));
	};
	
	MouseCursor.prototype.grabbing = function(event) {
	  return event.dragging && ol.events.condition.noModifierKeys(event);
	};
	
	MouseCursor.prototype.pointer = function(event) {
	  if (! this.canEdit) return false;
	
	  return this.map.forEachFeatureAtPixel(event.pixel, function(feature) {
	    return ! feature.get('pickupLocation');
	  });
	};
	
	module.exports = MouseCursor;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var moveStopLocationTemplate = __webpack_require__(23)();
	var moveStopLocationsTemplate = __webpack_require__(24)();
	
	function MoveStopsInteraction(map, modal) {
	  this.map = map;
	  this.modal = modal;
	
	  this.stroke = new ol.style.Stroke({
	    color: 'white',
	    width: 2,
	    lineDash: [2, 2],
	    lineCap: 'butt'
	  });
	
	  this.addClickInteraction();
	  this.addDragInteraction();
	
	  this.selectedStyle = this.selectedStyle.bind(this);
	  this.closeModal = this.closeModal.bind(this);
	
	  this.map.map.on('dblclick', this.closeModal);
	  this.map.view.on('change:resolution', this.closeModal);
	}
	
	MoveStopsInteraction.prototype.addClickInteraction = function() {
	  this.clickInteraction = new ol.interaction.Select({
	    addCondition: ol.events.condition.singleClick,
	    toggleCondition: ol.events.condition.never,
	    layers: this.map.layers('routeLayers'),
	    style: []
	  });
	
	  this.clickInteraction.on('select', this.onSelect.bind(this));
	};
	
	MoveStopsInteraction.prototype.addDragInteraction = function() {
	  this.dragInteraction = new ol.interaction.DragBox({
	    condition: ol.events.condition.platformModifierKeyOnly,
	    minArea: 22
	  });
	
	  this.dragInteraction.on('boxdrag', this.toggleCursor);
	  this.dragInteraction.on('boxend', this.onBoxend.bind(this));
	};
	
	MoveStopsInteraction.prototype.onSelect = function(event) {
	  var selectedFeatures = event.selected;
	  var selectedStops = this.selectedStops(selectedFeatures);
	
	  this.clickInteraction.getFeatures().clear(); // Makes the feature reselectable
	  this.map.tooltip.hideTooltip();
	  this.openMoveStopsModal(selectedStops, selectedFeatures);
	};
	
	MoveStopsInteraction.prototype.onBoxend = function() {
	  var extent = this.dragInteraction.getGeometry().getExtent();
	  var selectedFeatures = this.selectedFeatures(extent);
	  var selectedStops = this.selectedStops(selectedFeatures);
	
	  this.toggleCursor();
	
	  if (selectedStops.length) {
	    this.openMoveStopsModal(selectedStops, selectedFeatures);
	  }
	};
	
	MoveStopsInteraction.prototype.selectedFeatures = function(extent) {
	  return this.map.layers('routeLayers')
	    .filter(function(layer) {
	      return layer.getVisible();
	    })
	    .reduce(function(selected, layer) {
	      return selected.concat(layer.getSource().getFeaturesInExtent(extent));
	    }, []);
	};
	
	MoveStopsInteraction.prototype.selectedStops = function(selectedFeatures) {
	  return selectedFeatures.reduce(function(selected, feature) {
	    return selected.concat(
	      feature.get('features').map(function(feature) {
	        return feature.get('stop');
	      })
	    );
	  }, []);
	};
	
	MoveStopsInteraction.prototype.openMoveStopsModal = function(stops, features) {
	  var afterMove = this.afterMove.bind(this, features);
	
	  this.closeModal();
	
	  if (stops.length > 1) {
	    this.map.scope.prepareMultiMove(stops);
	    this.map.scope.multiMove.close = afterMove;
	  } else {
	    if (this.map.scope.move) {
	      // prepareMove will call the close function if it exists
	      this.map.scope.move.close = undefined;
	    }
	    this.map.scope.prepareMove(stops[0]);
	    this.map.scope.move.map = true;
	    this.map.scope.move.close = afterMove;
	  }
	
	  this.toggleStyle(features, true);
	
	  this.modal.open({
	    scope: this.map.scope,
	    moveable: true,
	    klass: 'map move-stop-location',
	    body: stops.length > 1 ? moveStopLocationsTemplate : moveStopLocationTemplate,
	    onClose: this.toggleStyle.bind(this, features)
	  });
	};
	
	MoveStopsInteraction.prototype.closeModal = function() {
	  this.map.scope._modal && this.map.scope._modal.close();
	};
	
	MoveStopsInteraction.prototype.afterMove = function(features) {
	  this.closeModal();
	  setTimeout(this.moveClusters.bind(this, features));
	};
	
	MoveStopsInteraction.prototype.moveClusters = function(features) {
	  features.forEach(function(feature) {
	    feature.get('features').forEach(function(feature) {
	      var oldLayer = feature.get('layer');
	      var newLayer = this.map.routeLayers[feature.get('stop').route.id];
	
	      oldLayer.layer.getSource().getSource().removeFeature(feature);
	      newLayer.layer.getSource().getSource().addFeature(feature);
	      feature.set('layer', newLayer);
	    }, this);
	  }, this);
	};
	
	MoveStopsInteraction.prototype.toggleCursor = function(event) {
	  document.getElementById('map').style.cursor = event ? 'move' : '';
	};
	
	MoveStopsInteraction.prototype.toggleStyle = function(features, on) {
	  features.forEach(function(feature) {
	    feature.setStyle(on ? this.selectedStyle : null);
	  }, this);
	};
	
	MoveStopsInteraction.prototype.selectedStyle = function(feature, resolution) {
	  var layer = feature.get('features')[0].get('layer');
	  var style = layer.layer.getStyle()(feature, resolution);
	  var circle = style.length ? style[0] : style;
	
	  circle.setStroke(this.stroke);
	
	  return style;
	};
	
	module.exports = MoveStopsInteraction;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var point = __webpack_require__(14).point;
	var style = __webpack_require__(13);
	
	function PickupLocationLayer(pickupLocation) {
	  this.pickupLocation = pickupLocation;
	
	  this.layer = new ol.layer.Vector({
	    source: new ol.source.Vector({
	      features: [this.initFeature()]
	    }),
	    style: style.bind(null, {
	      radius: 11,
	      color: 'black',
	      text: 'S'
	    }),
	    updateWhileAnimating: true,
	    updateWhileInteracting: true,
	    renderBuffer: 22
	  });
	}
	
	PickupLocationLayer.prototype.initFeature = function() {
	  var feature = new ol.Feature();
	
	  feature.setGeometry(point(this.pickupLocation));
	  feature.set('pickupLocation', this.pickupLocation, true);
	  feature.set('layer', this, true);
	
	  return feature;
	};
	
	module.exports = PickupLocationLayer;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var DummyStopLocation = __webpack_require__(176);
	var point = __webpack_require__(14).point;
	var style = __webpack_require__(13);
	
	function RouteLayer(route, color, highlightedRouteSequence) {
	  this.route = route;
	  this.color = color;
	  this.highLightedRouteSequence = highlightedRouteSequence;
	
	  this.layer = new ol.layer.Vector({
	    source: new ol.source.Cluster({
	      distance: 15,
	      source: new ol.source.Vector({
	        features: route.stopLocations
	          .filter(this.hasCoordinates)
	          .map(this.initFeature.bind(this))
	      })
	    }),
	    style: this.style.bind(this),
	    updateWhileAnimating: true,
	    updateWhileInteracting: true,
	    renderBuffer: 34
	  });
	
	  this.layer.set('route', this.route, true);
	}
	
	RouteLayer.prototype.initFeature = function(stop) {
	  var feature = new ol.Feature();
	
	  feature.setGeometry(point(stop));
	  feature.set('stop', stop, true);
	  feature.set('layer', this, true);
	  feature.set('highlighted', this.highLightedRouteSequence === stop.routeSequence);
	
	  return feature;
	};
	
	RouteLayer.prototype.hasCoordinates = function(stop) {
	  return stop.latitude && stop.longitude;
	};
	
	RouteLayer.prototype.style = function(feature, resolution) {
	  var features = feature.get('features');
	  var stop = features.length === 1 && features[0].get('stop');
	  var dummyStop = stop || new DummyStopLocation(features);
	  var cancelled = ! dummyStop.notCancelled();
	  var delivered = dummyStop.allDelivered();
	  var deviation = delivered && dummyStop.anyDeviations();
	
	  var options = {
	    radius: this.radius(features.length),
	    color: stop ? this.color : ol.color.asArray(this.color + 99),
	    text: stop ? '' + stop.routeSequence : null
	  };
	
	  if (cancelled) {
	    options.color = '#999';
	  } else if (deviation) {
	    options.deviation = true;
	  } else if (delivered) {
	    options.delivered = true;
	  }
	
	  if(this.shouldHighlight(features)){
	    options.highlight = true;
	  }
	  return style(options, feature, resolution);
	};
	
	RouteLayer.prototype.shouldHighlight = function (features){
	  return features.some(function(feature){
	    return feature.get('highlighted');
	  })
	};
	
	RouteLayer.prototype.radius = function(count) {
	  switch (true) {
	    case count > 29:
	      return 17;
	    case count > 19:
	      return 15;
	    case count > 9:
	      return 13;
	    default:
	      return 11;
	  }
	};
	
	RouteLayer.prototype.updateColor = function(color) {
	  this.color = color;
	  this.redraw();
	};
	
	RouteLayer.prototype.redraw = function() {
	  this.layer.changed();
	};
	
	module.exports = RouteLayer;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var routeZoomControlTemplate = __webpack_require__(104)();
	
	function RouteZoomControl(map, $compile) {
	  this.map = map;
	  this.$compile = $compile;
	  this.control = this.initControl();
	}
	
	RouteZoomControl.prototype.initControl = function() {
	  this.map.scope.map.overview = this.overview.bind(this);
	  this.map.scope.map.zoomToFitRoute = this.zoomToFitRoute.bind(this);
	
	  return new ol.control.Control({
	    element: this.$compile(routeZoomControlTemplate)(this.map.scope)[0]
	  });
	};
	
	RouteZoomControl.prototype.overview = function() {
	  this.map.scope.map.selectRoute(null);
	  this.zoomToFitAllRoutes();
	};
	
	RouteZoomControl.prototype.zoomToFitRoute = function() {
	  var route = this.map.scope.map.route;
	  var layers = [];
	
	  if (route) {
	    layers.push(this.map.routeLayers[route.id].layer);
	    this.map.carLayers && layers.push(this.map.carLayers[route.id].layer);
	
	    this.zoomToFitLayers(layers);
	  }
	};
	
	RouteZoomControl.prototype.zoomToFitAllRoutes = function() {
	  this.zoomToFitLayers(this.map.map.getLayers());
	};
	
	RouteZoomControl.prototype.zoomToFitLayers = function(layers) {
	  var extent = ol.extent.createEmpty();
	
	  layers.forEach(function(layer) {
	    var source = layer.getSource();
	
	    if (source.getSource) source = source.getSource();
	    ol.extent.extend(extent, source.getExtent());
	  });
	
	  if (ol.extent.isEmpty(extent)) return;
	
	  this.map.view.fit(extent, {
	    size: this.map.map.getSize(),
	    padding: [11, 11, 11, 11]
	  });
	};
	
	module.exports = RouteZoomControl;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var angular = __webpack_require__(2);
	
	var storageKey = 'saturatedMap';
	
	function SaturationControl(googleMaps, storage) {
	  this.googleMaps = googleMaps;
	  this.storage = storage;
	  this.control = this.initControl();
	
	  this.saturated = false;
	  if (this.storage.local.get(storageKey)) {
	    this.toggleSaturation();
	  }
	}
	
	SaturationControl.prototype.initControl = function() {
	  this.$element = angular.element(
	    '<div class="ol-saturation ol-unselectable ol-control"><button type="button" /></div>'
	  );
	
	  this.$element.find('button').on('click', this.toggleSaturation.bind(this));
	
	  return new ol.control.Control({
	    element: this.$element[0]
	  });
	};
	
	SaturationControl.prototype.toggleSaturation = function() {
	  this.saturated = ! this.saturated;
	  this.storage.local.set(storageKey, this.saturated);
	  this.googleMaps.toggleSaturation(this.saturated);
	  this.$element.toggleClass('saturated', this.saturated);
	};
	
	module.exports = SaturationControl;


/***/ },
/* 190 */
/***/ function(module, exports) {

	/* global ol */
	
	/**
	 * Sets the default style for all select interactions to the selected feature's layer style.
	 * (By default the feature's icon will be replaced with a blue dot on select.)
	 */
	
	function SelectInteractionStyle(map) {
	  this.map = map;
	
	  this.interaction = new ol.interaction.Select({
	    condition: ol.events.condition.pointerMove,
	    toggleCondition: ol.events.condition.never,
	    style: this.style
	  });
	}
	
	SelectInteractionStyle.prototype.style = function(feature, resolution) {
	  var features = feature.get('features');
	  var layer = (features ? features[0] : feature).get('layer');
	
	  return layer.layer.getStyle()(feature, resolution);
	};
	
	// Force the selected feature to redraw in case it's style is updated while hovering
	SelectInteractionStyle.prototype.redrawStyle = function() {
	  if (this.interaction.getFeatures().getLength()) {
	    this.interaction.setMap(null);
	    this.interaction.setMap(this.map);
	  }
	};
	
	module.exports = SelectInteractionStyle;


/***/ },
/* 191 */
/***/ function(module, exports) {

	function SelectRouteControl(map, $location) {
	  this.map = map;
	  this.scope = map.scope;
	  this.$location = $location;
	}
	
	SelectRouteControl.prototype.selectRoute = function(route) {
	  this.scope.route = route;
	  this.scope.map.route = route;
	
	  this.updateRouteParam();
	
	  Object.keys(this.map.pickupLocationLayers).forEach(function(pickupLocationId) {
	    var visible = ! route || route.pickupLocationId === +pickupLocationId;
	    this.map.pickupLocationLayers[pickupLocationId].layer.setVisible(visible);
	  }, this);
	
	  Object.keys(this.map.routeLayers).forEach(function(routeId) {
	    var visible = ! route || route.id === +routeId;
	    this.map.routeLayers[routeId].layer.setVisible(visible);
	  }, this);
	
	  Object.keys(this.map.carLayers || {}).forEach(function(routeId) {
	    var visible = ! route || route.id === +routeId;
	    this.map.carLayers[routeId].setVisible(visible);
	  }, this);
	};
	
	SelectRouteControl.prototype.updateRouteParam = function() {
	  var scopeRouteId = this.scope.route ? this.scope.route.id : null;
	  var paramRouteId = +this.$location.search().routeId || null;
	
	  if (scopeRouteId !== paramRouteId) {
	    this.$location.search('routeId', scopeRouteId).replace();
	  }
	
	  this.$location.search('routeSequence', null).replace();  // Always reset / remove selected stop from QS
	
	};
	
	module.exports = SelectRouteControl;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/* global ol */
	
	var angular = __webpack_require__(2);
	var PopperTooltip = __webpack_require__(123);
	var popperTooltipTemplate = __webpack_require__(97)();
	
	var options = {
	  template: popperTooltipTemplate,
	  html: true,
	  trigger: 'manual',
	  placement: 'auto',
	  delay: 400
	};
	
	function Tooltip(template, map) {
	  this.template = template;
	
	  options.container = document.body;
	
	  this.overlay = new ol.Overlay({
	    element: document.createElement('div')
	  });
	
	  this.interaction = new ol.interaction.Select({
	    condition: ol.events.condition.pointerMove,
	    toggleCondition: ol.events.condition.never,
	    style: []
	  });
	
	  this.interaction.on('select', this.onSelect.bind(this));
	
	  map.on('movestart', this.hideTooltip.bind(this)); // TODO disable tooltips until moveend
	}
	
	Tooltip.prototype.onSelect = function(event) {
	  var selectedFeature = event.selected[0];
	
	  clearTimeout(this.tooltipTimer);
	  this.hideTooltip();
	
	  if (selectedFeature && ol.events.condition.noModifierKeys(event.mapBrowserEvent)) {
	    this.tooltipTimer = setTimeout(
	      this.showTooltip.bind(this, selectedFeature),
	      options.delay
	    );
	  }
	};
	
	Tooltip.prototype.hideTooltip = function() {
	  if (this.tooltip) {
	    this.tooltip.dispose();
	    this.tooltip = null;
	  }
	};
	
	Tooltip.prototype.showTooltip = function(selectedFeature) {
	  if (selectedFeature && selectedFeature.getGeometry()) {
	    this.overlay.setPosition(selectedFeature.getGeometry().getCoordinates());
	
	    this.tooltip = new PopperTooltip(
	      this.overlay.getElement(),
	      angular.extend({ title: this.template.compile(selectedFeature) }, options)
	    );
	
	    this.tooltip.show();
	  } else {
	    console.log('showTooltip - Missing important args', selectedFeature);
	  }
	};
	
	module.exports = Tooltip;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	function SuggestedRoute(suggestedRoute) {
	  angular.extend(this, suggestedRoute);
	}
	
	module.exports = SuggestedRoute;

/***/ },
/* 194 */
/***/ function(module, exports) {

	clock.$inject = ['$rootScope', '$interval'];
	
	function clock($rootScope, $interval) {
	
	  this.everyMinute = function(callback) {
	    var minutes = new Date().getMinutes();
	
	    var interval = $interval(function() {
	      if (minutes !== new Date().getMinutes()) {
	        minutes = new Date().getMinutes();
	        callback();
	      }
	    }, 1000, null, false);
	
	    $rootScope.$on('$routeChangeStart', function() {
	      $interval.cancel(interval);
	    });
	
	  };
	
	}
	
	module.exports = clock;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var util = __webpack_require__(3);
	var File = __webpack_require__(7);
	var customer = __webpack_require__(9);
	var editCustomerTemplate = __webpack_require__(78)();
	var editCoordinatesTemplate = __webpack_require__(77)();
	var t = __webpack_require__(4).t;
	
	edit.$inject = ['$rootScope', '$timeout', '$document', 'load', '$filter', 'modal'];
	
	function edit($rootScope, $timeout, $document, load, $filter, modal) {
	  var self = this;
	
	  this.openEditCustomer = function($scope, customer, cancelled, routeId) {
	    $scope.isCollapsed = true;
	
	    $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;
	
	    $scope.editAddress = false; // Reset
	    $scope.cancelled = cancelled;
	
	    var focusOnInput = function() {
	      $timeout(function() {
	        if (focusSelector) {
	          var item = $document[0].querySelector(focusSelector);
	          item && item.focus();
	
	        }
	      });
	    };
	
	    var focusSelector;
	    var route = $scope.routePlan.findRoute(routeId);
	
	    if (customer) {
	      // Existing customer
	      $scope.activeCustomerId = customer.id;
	      $scope.customer = customer.editClone();
	
	      var stopLocation = customer.stopLocationId && $scope.routePlan.findStopLocation(routeId, customer.stopLocationId);
	      $scope.changeHolder = {
	        plan: $scope.routePlans.filter(function (routePlan) {
	          return routePlan.id === $scope.routePlan.id;
	        })[0],
	        routes: $scope.routePlan.routes,
	        selectedRoute: route,
	        selectedStop: stopLocation,
	        showStops: false
	      };
	      $scope.showMovePlan = true;
	      $scope.receivedComingSms = customer.hasReceivedComingSms();
	    } else {
	      // New customer
	      $scope.customer = {
	        routePlanId: $scope.routePlan.id,
	        editable: function() { return true; },
	        deliveries: [{}]
	      };
	      if ($scope.routePlan.routes.length > 0) {
	        // Plan has routes, force the user to choose route for new customer
	        $scope.changeHolder = {
	          routes: $scope.routePlan.routes,
	          selectedRoute: route,
	          selectedStop: null,
	          showStops: false
	        };
	        $scope.isCollapsed = false;
	        $scope.showMovePlan = true;
	        $scope.receivedComingSms = false;
	      }
	
	      focusSelector = '.edit-customer select';
	    }
	
	    // Timestamp to human readable time
	    $scope.customer.deliveryWindowStart = util.toTime($scope.customer.deliveryWindowStart);
	    $scope.customer.deliveryWindowStop = util.toTime($scope.customer.deliveryWindowStop);
	
	    $scope.enterEditAddressMode = function() {
	      $scope.editAddress = true;
	    };
	
	    $scope.toggleMoveToPlanRoute = function() {
	      $scope.isCollapsed = ! $scope.isCollapsed;
	    };
	
	    $scope.updateAddress = function(complete, address) {
	      if (address) {
	        angular.extend($scope.customer, address);
	        self.toggleCoordinatesClass(false);
	        $scope.$apply();
	      }
	
	      if (! focusSelector) {
	        focusSelector = (complete && $scope.customer.latitude) ? 'input.name' : 'input.streetInput';
	        focusOnInput();
	      }
	    };
	
	    $scope.updateRouteList = function() {
	      $scope.changeHolder.routes = [];
	      if ($scope.changeHolder.plan && $scope.changeHolder.plan.id) {
	        load.getPlanRoutes($scope.changeHolder.plan.id).then(function(routePlan) {
	          $scope.changeHolder.routes = routePlan.routes;
	        });
	      }
	      $scope.changeHolder.selectedStop = null;
	    };
	
	    $scope.routeChanged = function() {
	      if ($scope.changeHolder.selectedRoute) {
	        $scope.changeHolder.showStops = true;
	        $scope.changeHolder.filteredStopLocations = $filter('receivedSms')($scope.changeHolder.selectedRoute.stopLocations);
	        $scope.changeHolder.selectedStop = { id: 0 }; // Reset/default (if selecting first option)
	      }
	    };
	
	    modal.open({
	      scope: $scope,
	      klass: 'edit-customer',
	      title: t(customer ? 'customerModalHeaderEdit' : 'customerModalHeaderNew'),
	      body: editCustomerTemplate,
	      onClose: function() {
	        $timeout(function() {
	          $scope.activeCustomerId = null;
	        });
	      }
	    });
	
	    focusOnInput();
	  };
	
	
	  this.openMap = function($scope, event, customer) {
	    var close = $scope._modal.close;
	
	    // If the street is invalid, AH will force focus until the input is emptied.
	    var blurStreetInput = function() {
	      var streetContainer = angular.element($document[0].querySelector('.streetContainer .yui-ac-content'));
	      var streetInput = angular.element($document[0].querySelector('.streetInput'));
	      var street = streetInput.val();
	
	      streetInput.val('');
	      streetInput[0].blur();
	      streetInput.val(street);
	      streetContainer.css('display', 'none');
	    };
	
	    var importedCustomer = $scope.routePlan.findCustomer(customer.id);
	
	    if (importedCustomer) {
	      $scope.address = importedCustomer.fullAddress;
	      $scope.city = importedCustomer.city; // For geocode fallback (omitting zip to rule out zip-changes)
	    } else {
	      // Customer is not yet added, just found through Address Helper, let pre-populate to better center map
	      var streetElem = angular.element($document[0].querySelectorAll('.streetInput'));
	      var streetNumberElem = angular.element($document[0].querySelectorAll('.streetNumberInput'));
	      var cityElem = angular.element($document[0].querySelectorAll('.cityLabel'));
	      if (streetElem && streetNumberElem && cityElem) {
	        $scope.address = streetElem.val() + ' ' + streetNumberElem.val();
	        $scope.city = cityElem.val();
	      }
	    }
	
	    $scope.setCoordinates = function(latitude, longitude) {
	      $scope.closeModal();
	
	      customer.latitude = latitude;
	      customer.longitude = longitude;
	
	      self.toggleCoordinatesClass(!! latitude);
	      if (latitude) blurStreetInput();
	    };
	
	    event.stopPropagation();
	    event.preventDefault();
	
	    modal.open({
	      scope: $scope,
	      title: $scope.address,
	      klass: 'map-coordinates',
	      body: editCoordinatesTemplate,
	      onClose: function() {
	        // Hack to restore the editCustomer modal's onClose
	        $scope._modal.close = close;
	      }
	    });
	  };
	
	
	  var disableClose = function(event) {
	    event.stopImmediatePropagation();
	    event.preventDefault();
	  };
	
	
	  this.cancelDelivery = function($scope, event, deliveryId, customer) {
	    customer.findDelivery(deliveryId).deliveryStatus = 11; // CANCELLED
	    disableClose(event);
	  };
	
	
	  this.undoCancelDelivery = function($scope, event, deliveryId, customer) {
	    customer.findDelivery(deliveryId).deliveryStatus = 0; // UNDELIVERED
	    disableClose(event);
	  };
	
	
	  this.addDelivery = function(event, customer) {
	    customer.deliveries.push({});
	    disableClose(event);
	  };
	
	
	  this.deleteDelivery = function(event, index, customer) {
	    customer.deliveries.splice(index, 1);
	    if (! customer.deliveries.length) {
	      customer.deliveries.push({});
	    }
	    disableClose(event);
	  };
	
	  this.deleteCustomer = function($scope, customer) {
	    modal.open({
	      scope: $scope,
	      title: t('customerModalConfirmDeleteHeader'),
	      body: t('customerModalConfirmDeleteBody'),
	      onConfirm: function() {
	        $scope.closeModal();
	        load.deleteCustomer($scope, customer);
	      },
	      onClose: function() {
	        $timeout(function() {  // force $apply
	          $scope.activeCustomerId = null;
	        });
	      }
	    });
	  };
	
	  this.cancelCustomer = function($scope, customer) {
	    modal.open({
	      scope: $scope,
	      title: t('customerModalConfirmCancelHeader'),
	      body: t('customerModalConfirmCancelBody'),
	      onConfirm: function() {
	        $scope.closeModal();
	        load.cancelCustomer($scope, customer.id);
	      },
	      onClose: function() {
	        $timeout(function() {  // force $apply
	          $scope.activeCustomerId = null;
	        });
	      }
	    });
	  };
	
	  this.toggleCoordinatesClass = function(on) {
	    angular
	      .element($document[0].getElementById('address-helper'))
	      .toggleClass('manual-coordinates', on);
	  };
	
	
	  this.saveCustomer = function($scope, customer) {
	    // Fallback (if AH is not used/filled out)
	    customer.country = customer.country || $scope.routePlan.countryCode;
	    customer.address = customer.address || 'Unknown address, use map';
	    customer.zip = customer.zip || 1;
	    customer.city = customer.city || '????';
	
	    for (var prop in customer) {
	      customer[prop] = customer[prop] || null;
	    }
	
	    customer.deliveries.forEach(function(delivery) {
	      delivery.product = delivery.product || null;
	    });
	
	    customer.deliveries = customer.deliveries.filter(function(delivery) {
	      return delivery.getStatus === undefined || delivery.getStatus() !== 'cancelled';
	    });
	
	    // Human readable time to timestamp
	    customer.deliveryWindowStart = util.toDateWithTime($scope.routePlan.date, customer.deliveryWindowStart);
	    customer.deliveryWindowStop = util.toDateWithTime($scope.routePlan.date, customer.deliveryWindowStop);
	
	    customer.fileId = (customer.fileId === File.individual.id) ? null : customer.fileId;
	
	    if (customer.description) {
	      customer.description = customer.description.replace(/\n/g, '\\n');
	    }
	
	    if (! $scope.isCollapsed && $scope.changeHolder.selectedRoute != null) {
	
	      var selectedPlanId = $scope.changeHolder.plan ? $scope.changeHolder.plan.id : customer.routePlanId;
	      var selectedRouteId = $scope.changeHolder.selectedRoute.id;
	      var selectedStopId = $scope.changeHolder.selectedStop ? $scope.changeHolder.selectedStop.id : 0; // Fallback: 0: Start of route
	
	      // console.log('saveCustomer before', 'selectedStop', $scope.changeHolder.selectedStop, 'selectedStopId', selectedStopId);
	      // console.log('saveCustomer', 'customer.stopLocationId', customer.stopLocationId, 'selectedStopId', selectedStopId);
	
	      if ((customer.routePlanId != selectedPlanId) ||
	          (customer.routeId != selectedRouteId) ||
	          (customer.stopLocationId != selectedStopId) ) {
	        customer.routePlanId = selectedPlanId;
	        customer.routeId = selectedRouteId;
	        customer.stopLocationId = selectedStopId;
	      } else { // Cleanup for api if user has open the move to but not changed anything
	        delete customer.routeId;
	        delete customer.stopLocationId;
	      }
	    } else { // Cleanup for api if user has not opened move to
	      delete customer.routeId;
	      delete customer.stopLocationId;
	    }
	
	    // console.log('saveCustomer after', 'move?', !! customer.routeId, 'customer', customer);
	    load.saveCustomer($scope, customer);
	    $scope.closeModal();
	  };
	
	}
	
	module.exports = edit;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(3);
	var moment = __webpack_require__(5);
	var formatZip = __webpack_require__(3).formatZip;
	var editRouteTemplate = __webpack_require__(80)();
	var t = __webpack_require__(4).t;
	
	edit.$inject = ['$rootScope', 'load', 'modal'];
	
	function edit($rootScope, load, modal) {
	
	  this.openEditRoute = function($scope, event, route) {
	    event.preventDefault();
	    $scope.isSaving = false; // Reset
	
	    $scope.move && $scope.move.close && $scope.move.close();
	
	    $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;
	
	    $scope.pickupLocations = $scope.routePlan.pickupLocations.map(function(pl) {
	      // TODO Get right country
	      return {
	        id: pl.id,
	        address: pl.address + ', ' + formatZip(pl.zip, pl.country) + ' ' + pl.city
	      };
	    });
	
	    $scope.editRoute = {
	      id: route.id,
	      name: route.name,
	      type: route.type,
	      color: route.color || 0,
	      overriddenStart:  util.toTime(route.overriddenStart),
	      overriddenStartDayBefore: route.overriddenStart ? ! util.isSameDay(route.date, route.overriddenStart) : false,
	      driverUsername: route.driverUsername || null,
	      pickupLocationId: route.pickupLocationId || null,
	      permitDriverComingSMS: route.permitDriverComingSMS,
	      autoAssignedDriver: route.autoAssignedDriver
	    };
	
	    $scope.nameAndPhone = function(driver) {
	      return driver.name + (driver.phone ? ' (' + driver.phone +')' : '');
	    };
	
	    $scope.reserveRoute = (route.type === 1);
	    var titleKey = $scope.reserveRoute ? (route.id ? 'routeModalHeaderReserveEdit' : 'routeModalHeaderReserveNew') : (route.id ? 'routeModalHeaderEdit' : 'routeModalHeaderNew');
	
	    if (! $scope.editRoute.pickupLocationId && $scope.pickupLocations.length === 1) {
	      $scope.editRoute.pickupLocationId = $scope.pickupLocations[0].id;
	    }
	
	    modal.open({
	      scope: $scope,
	      klass: 'edit-route',
	      title: t(titleKey),
	      body: editRouteTemplate
	    });
	
	    $scope.routeColorChosen = function($index) {
	      $scope.editRoute.color = $index;
	    };
	  };
	
	  this.saveRoute = function($scope, route) {
	    $scope.isSaving = true;
	    if (route.fetchCustomers) {
	      route.transferCustomersFromRouteId = route.fetchCustomersFromRoute.id;
	    }
	
	    // Overridden time/date
	    var overriddenStart = util.toDateWithTime($scope.routePlan.date, route.overriddenStart);
	    if (route.overriddenStartDayBefore) {
	      overriddenStart = moment(overriddenStart).subtract(1, 'days');
	    }
	    route.overriddenStart = overriddenStart;
	
	    delete route.overriddenStartDayBefore;  // Cleanup for API
	    delete route.fetchCustomers;            // Cleanup for API
	    delete route.fetchCustomersFromRoute;   // Cleanup for API
	
	    if (route.id) {
	      load.saveRoute(route).then(function() {
	        $scope.closeModal();
	      });
	    } else {
	      load.addRoute($scope.routePlan.id, route).then(function() {
	        $scope.closeModal();
	      });
	    }
	  };
	
	  this.deleteEmptyRoute = function($scope, routeId) {
	    load.deleteRoute(routeId);
	    $scope.closeModal();
	  };
	
	}
	
	module.exports = edit;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(3);
	var editRoutePlanTemplate = __webpack_require__(81)();
	var t = __webpack_require__(4).t;
	
	edit.$inject = ['$rootScope', '$window', '$filter', 'load', 'modal'];
	
	function edit($rootScope, $window, $filter, load, modal) {
	
	  this.openEditRoutePlan = function($scope, routePlan, distribution, routePlans) {
	    var editRoutePlan = { distrNo: 0 };
	    if (routePlan) {
	      editRoutePlan.id = routePlan.id;
	      editRoutePlan.name = routePlan.name;
	      editRoutePlan.date = routePlan.date;
	      editRoutePlan.distrNo = routePlan.distrNo;
	    }
	
	    if ($scope.distribution != null && $scope.distribution.routePlans && $scope.distribution.routePlans[0]) {
	      editRoutePlan.date = $scope.distribution.routePlans[0].date;
	      editRoutePlan.distrNo = $scope.distribution.routePlans[0].distrNo;
	    }
	
	    if (distribution || $scope.distribution != null) {
	      $scope.showCompany = true;
	      if($scope.settings.companies.length == 1) {
	        editRoutePlan.companyId = $scope.settings.companies[0].id;
	      }
	    }
	
	    $scope.editRoutePlan = editRoutePlan;
	    modal.open({
	      scope: $scope,
	      klass: 'edit-route-plan',
	      title: distribution ? t('distributionModalNew') : t(routePlan ? 'planModalHeaderEdit' : 'planModalHeaderNew'),
	      body: editRoutePlanTemplate
	    });
	  };
	
	  this.saveRoutePlan = function($scope, routePlan) {
	    routePlan.date = util.toDateNoon(routePlan.date);
	
	    if (routePlan.id) {
	      load.saveRoutePlan(routePlan).then(function() {
	        $window.location.reload(true);
	      });
	    } else {
	      if ($scope.editRoutePlan.companyId) {
	        routePlan.companyId = $scope.editRoutePlan.companyId;
	      } else {
	        routePlan.companyId = $rootScope.auth.companyId;
	      }
	
	      load.saveRoutePlan(routePlan).then(function(data) {
	        $window.location.assign($scope.router.link('plan/files', data.id));
	      });
	    }
	  };
	
	  this.deleteRoutePlan = function($scope, routePlan) {
	    var name = $filter('moment')(routePlan.date, 'LL') +
	      (routePlan.name ? (', ' + routePlan.name) : '');
	
	    modal.open({
	      scope: $scope,
	      title: t('planDeletePlan'),
	      body: t('planDeletePlanConfirm', name),
	      onConfirm: function() {
	        load.deleteRoutePlan(routePlan.id);
	      }
	    });
	  };
	}
	
	module.exports = edit;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	httpService.$inject = ['$http', '$q', '$rootScope', 'serverError'];
	
	function httpService($http, $q, $rootScope, serverError) {
	
	  var http = function(method, urlArr, config, ignoreStatuses) {
	
	    var success = function(response) {
	      deferred.resolve(response.data);
	    };
	
	    var error = function(response) {
	      console.log('Http error:', response);
	
	      response.ignoredStatus = (ignoreStatuses || []).filter(function(status) {
	        return status === response.status;
	      })[0];
	
	      if (response.status === 401) {  // 401 Unauthorized
	        $rootScope.autoLogout();
	      } else if (response.ignoredStatus === undefined) {
	        serverError.error(response.status, response.statusText, response.data);
	      }
	
	      deferred.reject(response);
	    };
	
	    var deferred = $q.defer();
	
	    // Default path: '/pl/api/v-1'
	    var url = [("https://dev-planandgo.aws.di.no"), 'pl', 'api', 'v-1'].concat(urlArr).join('/');
	
	    // If first element is '/' then skip default path
	    if (urlArr[0] === '/') {
	      urlArr.shift();
	      url = [("https://dev-planandgo.aws.di.no")].concat(urlArr).join('/');
	    }
	
	    config = angular.extend({
	      method: method,
	      url: url
	    }, config);
	
	    if ($rootScope.auth) {
	
	      // Show login-screen if the local token isn't valid anymore
	      if ($rootScope.auth.token) {
	        var tmp = $rootScope.auth.token.split(":");
	        if (tmp.length === 3) {
	          var validUntil = new Date(parseInt(tmp[1], 10));
	          var now = new Date();
	          if (validUntil.getTime() < now.getTime()) {
	            $rootScope.autoLogout();
	          }
	        }
	      }
	
	      // Set auth-header
	      config.headers = config.headers || {};
	      config.headers['X-Auth-Token'] = $rootScope.auth.token;
	    }
	
	    $http(config).then(success, error);
	    return deferred.promise;
	  };
	
	  this.get = function(url, params, ignoreStatuses) {
	    return http('GET', url, { params: params }, ignoreStatuses);
	  };
	
	  this.post = function(url, data, ignoreStatuses) {
	    return http('POST', url, { data: data }, ignoreStatuses);
	  };
	
	  this.delete = function(url, ignoreStatuses) {
	    return http('DELETE', url, undefined, ignoreStatuses);
	  };
	
	  this.postMultipart = function(url, data, ignoreStatuses) {
	    return http('POST', url, {
	      data: data || {},
	      headers: {
	        'Content-Type': undefined  // Force the browser to provide the boundary by using
	                                   // undefined, and not 'multipart/form-data'
	      },
	      transformRequest: function(data) {  // Angular serializes the data as JSON by default
	        var formData = new FormData();
	        for (var key in data) {
	          formData.append(key, data[key]);
	        }
	        return formData;
	      }
	    }, ignoreStatuses);
	  };
	
	}
	
	module.exports = httpService;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var Delivery = __webpack_require__(12);
	var Customer = __webpack_require__(9);
	var Route = __webpack_require__(32);
	var File = __webpack_require__(7);
	var Distribution = __webpack_require__(168);
	var DistributionCustomer = __webpack_require__(169);
	var RoutePlan = __webpack_require__(33);
	var DriverUser = __webpack_require__(173);
	var Downtime = __webpack_require__(172);
	var toObject = __webpack_require__(3).toObject;
	var mapDrivers = __webpack_require__(3).mapDrivers;
	
	load.$inject = ['$rootScope', '$filter', '$q', '$timeout', '$window', 'http', 'pusher', 'router', 'storage'];
	
	function load($rootScope, $filter, $q, $timeout, $window, http, pusher, router, storage) {
	
	  var self = this;
	  var cache = {};
	
	  // Reset the cache and pusher subscriptions when switching between a distribution page and a plan page
	  $rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
	
	    var isDistributionPage = function(url) {
	      return url.indexOf('#/distribution') !== -1;
	    };
	
	    if (isDistributionPage(newUrl) !== isDistributionPage(oldUrl)) {
	      pusher.unsubscribeAll();
	      ['distributions', 'distribution', 'routePlans', 'routePlan', 'drivers'].forEach(resetCache);
	    }
	  });
	
	  var resetCache = function(key) {
	    cache[key] = null;
	    $rootScope[key] = null;
	  };
	
	  var loadAndCache = function(url, key, transformFunc) {
	
	    var success = function(data) {
	      cache[key] = transformFunc(data);
	      $rootScope[key] = cache[key];
	      return cache[key];
	    };
	
	    if (cache[key]) {
	      $rootScope[key] = cache[key];
	      return $q.when(cache[key]);
	    } else {
	      return http.get(url).then(success);
	    }
	  };
	
	  var loadAndCacheAdvanced = function(url, cacheKey, rootScopeKey, transformFunc) {
	
	    var success = function(data) {
	      cache[cacheKey] = transformFunc(data);
	      $rootScope[rootScopeKey] = cache[cacheKey];
	      return cache[cacheKey];
	    };
	
	    if (cache[cacheKey]) {
	      $rootScope[rootScopeKey] = cache[cacheKey];
	      return $q.when(cache[cacheKey]);
	    } else {
	      return http.get(url).then(success);
	    }
	  };
	
	  var updateCachedRoutePlan = function(routePlanId, updateCallback) {
	    cache.routePlans && cache.routePlans.forEach(function(routePlan) {
	      if (routePlan.id === routePlanId) {
	        updateCallback(routePlan);
	      }
	    });
	
	    if (cache.routePlan && cache.routePlan.id === routePlanId) {
	      updateCallback(cache.routePlan);
	    }
	  };
	
	  this.customerSystemsForCompany = function(aCompanyId) {
	    var url = companyId()
	      ? ['company', aCompanyId, 'customerSystems']
	      : ['customerSystem', customerSystemIdsStr(), 'company', aCompanyId, 'customerSystems'];
	    var rootScopeKey = 'customerSystems';
	    var cacheKey = 'customerSystems-' + aCompanyId;
	
	    loadAndCacheAdvanced(url, cacheKey, rootScopeKey, toObject);
	  };
	
	  this.customerSystems = function() {
	    var url = null;
	    if (companyId()) {
	      url = ['company', companyId(), 'customerSystems'];
	    } else if (customerSystemIdsStr()) {
	      url = ['customerSystem', customerSystemIdsStr(), 'customerSystems'];
	    } else {
	      $rootScope['customerSystems']=[];
	      return;
	    }
	
	    loadAndCache(url, 'customerSystems', toObject);
	  };
	
	  this.users = function() {
	    var toDriverUser = function(data) {
	      return data.map(function(driver) {
	        return new DriverUser(driver);
	      });
	    };
	
	    if (companyId() && $rootScope.auth.roles.planner) {
	      loadAndCache(['userAdmin', 'company', companyId(), 'users'], 'users', toDriverUser);
	    } else {
	      $rootScope.users = [];
	    }
	  };
	
	  this.driverUsers = function() {
	    var toDriverUser = function(data) {
	      return data.map(function(driver) {
	        return new DriverUser(driver);
	      });
	    };
	
	    if (companyId() && $rootScope.auth.roles.planner) {
	      loadAndCache(['userAdmin', 'company', companyId(), 'drivers'], 'driverUsers', toDriverUser);
	    } else {
	      $rootScope.driverUsers = [];
	    }
	  };
	
	  this.drivers = function(companyId) {
	    if (companyId) {
	      loadAndCache(['company', companyId, 'drivers'], 'drivers', mapDrivers);
	    } else {
	      $rootScope.drivers = [];
	    }
	  };
	
	  this.companies = function() {
	    if ($rootScope.auth.roles.di || ($rootScope.auth.roles.planner && $rootScope.auth.companyIds.length > 1)) {
	      loadAndCache(['companies'], 'companies', toObject);
	    } else {
	      $rootScope.companies = [];
	    }
	  };
	
	  this.settings = function() {
	    if ($rootScope.auth.roles.planner && companyId()) {
	      loadAndCache(['company', companyId(), 'settings'], 'settings', function(data) { return data; });
	    } else if (($rootScope.auth.roles.client || $rootScope.auth.roles.customerService) && customerSystemIdsStr()) {
	      loadAndCache(['customerSystem', customerSystemIdsStr(), 'settings'], 'settings', function(data) { return data; });
	    } else {
	      $rootScope.settings = [];
	    }
	  };
	
	  this.distributions = function() {
	
	    var toDistribution = function(data) {
	      return data.map(function(distribution) {
	        return new Distribution(distribution);
	      });
	    };
	
	    var subscribeActiveDistributionsToPusher = function(distributions) {
	      $filter('activeRoutePlans')(distributions).forEach(function(distribution) {
	        distribution.distrNos.forEach(function(distrNo) {
	          distribution.distrNo = distrNo;
	          subscribeDistributionToPusher(distribution);
	        });
	      });
	    };
	
	    var url = ['customerSystem', customerSystemIdsStr(), 'distributions'];
	
	    loadAndCache(url, 'distributions', toDistribution)
	      .then(subscribeActiveDistributionsToPusher);
	  };
	
	  this.distribution = function(date, distrNo, ignoreCache) {
	
	    var toDistribution = function(data) {
	      return new Distribution(data);
	    };
	
	    var url = ['customerSystem', customerSystemIdsStr(), 'distribution', date, distrNo];
	
	    if (ignoreCache) {
	      return http.get(url).then(toDistribution);
	    }
	
	    if (cache.distribution && (cache.distribution.date !== date || cache.distribution.distrNo !== distrNo)) {
	      cache.distribution = null;
	    }
	
	    return loadAndCache(url, 'distribution', toDistribution)
	      .then(subscribeDistributionToPusher);
	  };
	
	  this.distributionCustomers = function(distribution, type, query) {
	    var url = ['customerSystem', customerSystemIdsStr(), 'distribution', distribution.date, distribution.distrNo, type];
	    var params = query ? { q: query } : null;
	
	    return http.get(url, params).then(function(data) {
	      return data.map(function(customer) {
	        return new DistributionCustomer(customer, distribution);
	      });
	    });
	  };
	
	  this.routePlans = function() {
	
	    var toRoutePlan = function(data) {
	      return data
	        .filter(function(routePlan) {
	          return routePlan.statusId !== 6;  // 6 == deleted
	        })
	        .map(function(routePlan) {
	          return new RoutePlan(routePlan, true);
	        });
	    };
	
	    var subscribeActiveRoutePlansToPusher = function(routePlans) {
	      $filter('activeRoutePlans')(routePlans).forEach(function(routePlan) {
	        subscribeRoutePlanToPusher(routePlan);
	      });
	    };
	
	    var url = null;
	    if (companyId()) {
	      url = ['company', companyId(), 'routePlans'];
	    } else if (customerSystemIdsStr()) {
	      url = ['customerSystem', customerSystemIdsStr(), 'routePlans'];
	    } else {
	      $rootScope['routePlans']=[];
	      return;
	    }
	
	    if (! ($rootScope.auth.roles.planner || $rootScope.auth.roles.clientPlus)) url.push('published');
	
	    loadAndCache(url, 'routePlans', toRoutePlan)
	      .then(subscribeActiveRoutePlansToPusher);
	  };
	
	  this.routePlan = function(routePlanId) {
	
	    var toRoutePlan = function(data) {
	      return new RoutePlan(data);
	    };
	
	    var url;
	
	    if ($rootScope.auth.roles.planner) {
	      url = ['routePlan', routePlanId];
	    } else if (companyId()) {
	      url = ['company', companyId(), 'routePlan', routePlanId];
	    } else {
	      url = ['customerSystem', customerSystemIdsStr(), 'routePlan', routePlanId];
	    }
	
	    if (cache.routePlan && cache.routePlan.id !== +routePlanId) {
	      cache.routePlan = null;
	    }
	
	    return loadAndCache(url, 'routePlan', toRoutePlan)
	      .then(subscribeRoutePlanToPusher);
	  };
	
	  var shouldReloadRoutePlan = function(statusId) {
	    // 0 == created/imported, 5 == optimized, 11 == routesimported
	    return statusId === 0 || statusId === 5 || statusId === 11;
	  };
	
	  var toNotification = function(data) {
	    // Hack it so Pusher-data converts to documented notification-object
	    data.timestampSent = new Date();
	    data.customerId = data.id;
	    data.id = null;
	
	    return data;
	  };
	
	  var verifyAccess = function(custSysId) {
	    // If client: Check if client has no access to customer system
	    return ! ($rootScope.auth.roles.client && customerSystemId() && customerSystemId() !== custSysId);
	  };
	
	  var subscribeDistributionToPusher = function(distribution) {
	
	    var routePlanStatusUpdated = function(routePlanId, data) {
	
	      var findRoutePlan = function(distribution) {
	        return distribution && distribution.findRoutePlan(routePlanId);
	      };
	
	      var distributionIsCached = function() {
	        return cache.distribution &&
	          cache.distribution.date === distribution.date &&
	          cache.distribution.distrNo === distribution.distrNo;
	      };
	
	      var replaceDistribution = function() {
	        cache.distribution = null;
	        return self.distribution(distribution.date, distribution.distrNo);
	      };
	
	      var loadDistribution = function() {
	        return self.distribution(distribution.date, distribution.distrNo, true);
	      };
	
	      var updateRoutePlanCounts = function(newDistribution) {
	        var oldDistribution = cache.distributions && cache.distributions.filter(findRoutePlan)[0];
	        var oldRoutePlan = findRoutePlan(oldDistribution);
	        var newRoutePlan = findRoutePlan(newDistribution);
	
	        oldRoutePlan && newRoutePlan && oldRoutePlan.updateCounts(newRoutePlan);
	      };
	
	      var updateRoutePlanStatus = function(statusId) {
	        var oldRoutePlan = findRoutePlan(cache.distribution);
	
	        oldRoutePlan && oldRoutePlan.updateStatus(statusId);
	      };
	
	      if (shouldReloadRoutePlan(data.statusId)) {
	        if (distributionIsCached()) {
	          replaceDistribution().then(updateRoutePlanCounts);
	        } else if (cache.distributions) {
	          loadDistribution().then(updateRoutePlanCounts);
	        }
	      } else {
	        updateRoutePlanStatus(data.statusId);
	        $rootScope.$apply();
	      }
	    };
	
	    var setPublishedStateUpdated = function(publishedState, data) {
	      [].concat(cache.distribution, cache.distributions).forEach(function(distribution) {
	        var routePlan = distribution && distribution.findRoutePlan(data.id);
	        if (routePlan) routePlan.published = publishedState;
	      });
	
	      $rootScope.$apply();
	    };
	
	    var addCustomerNotification = function(data) {
	      if (cache.distribution) {
	        cache.distribution.addCustomerNotification(data.id, toNotification(data));
	        $rootScope.$apply();
	      }
	    };
	
	    var updateCustomerImage = function(data) {
	      if (cache.distribution) {
	        cache.distribution.updateCustomerImage(data.id, data);
	        $rootScope.$apply();
	      }
	    };
	
	    var updateCallLog = function(data) {
	      if (cache.distribution) {
	        cache.distribution.updateCustomerCallLog(data.id, data.driverUsername, data.timestampCalled);
	        $rootScope.$apply();
	      }
	    };
	
	    var updateCustomerClientTime = function(data) {
	      if (cache.distribution) {
	        cache.distribution.updateCustomerClientTime(data.id, data.clientSideTimestampDone);
	        $rootScope.$apply();
	      }
	    };
	
	    var updateDelivery = function(data) {
	      if (! verifyAccess(data.customerSystemId)) {
	        return;
	      }
	
	      if (! cache.distribution || ! cache.distribution.customers) {
	        // We're not on the search or deviations page
	        return;
	      }
	
	      var customer = cache.distribution.findCustomer(data.customerId);
	      var status = new Delivery({ deliveryStatus: data.statusId }, {}).status;
	
	      if (customer) {
	        http.get(['delivery', data.id]).then(customer.updateDelivery.bind(customer));
	      } else if (status === 'deviation' && router.page() === 'distribution/deviations') {
	        http.get(['distributionCustomer', data.customerId]).then(function(data) {
	          if (cache.distribution && router.page() === 'distribution/deviations') {
	            customer = new DistributionCustomer(data, cache.distribution);
	            cache.distribution.addCustomer(customer);
	          }
	        });
	      }
	    };
	
	    var deleteDelivery = function(data) {
	      if (! verifyAccess(data.customerSystemId)) {
	        return;
	      }
	
	      var customer = cache.distribution.findCustomer(data.customerId);
	      customer.deleteDelivery(data.id);
	      $rootScope.$apply();
	    };
	
	    var updateRoute = function(data) {
	      http.get(['customerSystem', customerSystemIdsStr(), 'distributionRoute', data.id]).then(function(data) {
	        var route = cache.distribution && cache.distribution.findRoute(data.id);
	        if (route) route.update(data, cache.distribution);
	      });
	    };
	
	    distribution.routePlans.forEach(function(routePlan) {
	      pusher.subscribeRoutePlan(routePlan, {
	        statusUpdated: routePlanStatusUpdated.bind(self, routePlan.id),
	        published: setPublishedStateUpdated.bind(self, true),
	        unpublished: setPublishedStateUpdated.bind(self, false),
	        customerClientTimeUpdated: updateCustomerClientTime,
	        customerNotified: addCustomerNotification,
	        customerImageUpdated: updateCustomerImage,
	        customerCallLogUpdated: updateCallLog,
	        deliveryUpdated: updateDelivery,
	        distributionRouteUpdated: updateRoute,
	        deliveryDeleted: deleteDelivery
	      });
	    });
	
	    return distribution;
	  };
	
	  var subscribeRoutePlanToPusher = function(routePlan) {
	
	    var updateRoutePlanStatus = function(data) {
	      if (shouldReloadRoutePlan(data.statusId)) {
	        self.reloadRoutePlan(routePlan.id, true);  // Fetch the generated routes or the added customers
	      } else {
	        updateCachedRoutePlan(routePlan.id, function(routePlan) {
	          routePlan.statusId = data.statusId;
	          if (data.placeInOptimizeQueue)
	            routePlan.placeInOptimizeQueue = data.placeInOptimizeQueue;
	        });
	      }
	      $rootScope.$apply();
	    };
	
	    var setPublishedStateUpdated = function(publishedState, data) {
	      updateCachedRoutePlan(routePlan.id, function(routePlan) {
	        routePlan.published = publishedState;
	      });
	
	      if (cache.routePlan && cache.routePlan.id === routePlan.id && publishedState) {
	        $rootScope.$emit('published');
	      }
	
	      $rootScope.$apply();
	    };
	
	    var updateFileStatus = function(data) {
	      if (! cache.routePlan || cache.routePlan.id !== routePlan.id) return;
	
	      var file = cache.routePlan.findFile(data.id);
	      if (file) {
	        file.progress = data.progress;
	
	        if (data.progress === 100) {
	          file.status = 2;
	          self.reloadRoutePlan(routePlan.id);
	        } else {
	          file.status = 1;
	        }
	
	        $rootScope.$apply();
	      }
	    };
	
	    var updateCustomerClientTime = function(data) {
	      if (! cache.routePlan) return;
	
	      cache.routePlan.updateCustomerClientTime(data.id, data.clientSideTimestampDone);
	      $rootScope.$apply();
	    };
	
	    var updateCustomerNotification = function(data) {
	      if (! cache.routePlan) return;
	
	      cache.routePlan.updateNotification(toNotification(data));
	      $rootScope.$apply();
	    };
	
	    var updateCustomerImage = function(data) {
	      if (! cache.routePlan) return;
	
	      cache.routePlan.updateCustomerImage(data.id, data.imageUrl);
	      $rootScope.$apply();
	    };
	
	    var updateCallLog = function(data) {
	      if (! cache.routePlan) return;
	
	      cache.routePlan.updateCustomerCallLog(data.id, data.driverUsername, data.timestampCalled);
	      $rootScope.$apply();
	    };
	
	    var updateRoute = function(data) {
	      http.get(['route', data.id]).then(function(data) {
	        if (! cache.routePlan) return;
	
	        // Preserve some data previously extracted from customers
	        var oldRoute = cache.routePlan.findRoute(data.id);
	        if (oldRoute)
	          data.customerTimeWindows = oldRoute.customerTimeWindows;
	
	        cache.routePlan.updateRoute(new Route(data, []));
	        $rootScope.$emit('routeUpdated', data.id);
	      });
	    };
	
	    var updateRouteDeliveries = function(data) {
	      var url = companyId()
	        ? ['company', companyId(), 'route', data.id]
	        : ['customerSystem', customerSystemIdsStr(), 'route', data.id];
	
	      http.get(url).then(function(data) {
	        data.forEach(function(del) {
	          var customer = cache.routePlan && cache.routePlan.findCustomer(del.customerId);
	          var delivery = customer && new Delivery(del, customer);
	
	          if (delivery) {
	            cache.routePlan.updateDelivery(delivery);
	            $rootScope.$emit('deliveryStatusUpdated', delivery);
	          }
	        });
	      });
	    };
	
	    var updateDeliveryEstimates = function(data) {
	      if (cache.routePlan) {
	        http.get(['route', data.id, 'estimates']).then(function(data) {
	          cache.routePlan && cache.routePlan.updateDeliveryEstimates(data);
	        });
	      }
	    };
	
	    var updateRouteOptimization = function(data) {
	      var routeId = data.id;
	      var statusId = data.statusId;
	      if (cache.routePlan) {
	        var route = cache.routePlan.findRoute(routeId);
	
	        if (! cache.routePlan.published || route.reserved) {
	          route.updateRouteOptimizationStatus(statusId);
	          $rootScope.$apply();
	
	          if (statusId === 0) {
	            // Refresh order for content on route
	            http.get(['route', routeId, 'customerSequence']).then(function(data) {
	              cache.routePlan.updateCustomerSequence(routeId, data);
	              route.resetStats();
	              $rootScope.$emit('routeSequenceUpdated', routeId);
	            });
	          }
	        }
	      }
	    };
	
	    var updateDriverPosition = function(data) {
	      var route = cache.routePlan && cache.routePlan.findRoute(data.id);
	      if (route) {
	        route.updateDriverPosition(data.latitude, data.longitude);
	        $rootScope.$emit('driverPositionUpdated', route);
	      }
	    };
	
	    var updateDelivery = function(data) {
	      if (! verifyAccess(data.customerSystemId)) {
	        return;
	      }
	
	      http.get(['delivery', data.id]).then(function(data) {
	        var customer = cache.routePlan && cache.routePlan.findCustomer(data.customerId);
	        var delivery = customer && new Delivery(data, customer);
	
	        if (delivery) {
	          cache.routePlan.updateDelivery(delivery);
	          $rootScope.$emit('deliveryStatusUpdated', delivery);
	        }
	      });
	    };
	
	    var deleteDelivery = function(data) {
	      if (! verifyAccess(data.customerSystemId)) {
	        return;
	      }
	
	      cache.routePlan.deleteDelivery(data.id, data.customerId);
	      $rootScope.$apply();
	    };
	
	    pusher.subscribeRoutePlan(routePlan, {
	      statusUpdated: updateRoutePlanStatus,
	      published: setPublishedStateUpdated.bind(self, true),
	      unpublished: setPublishedStateUpdated.bind(self, false),
	      fileUpdated: updateFileStatus,
	      customerClientTimeUpdated: updateCustomerClientTime,
	      customerNotified: updateCustomerNotification,
	      customerImageUpdated: updateCustomerImage,
	      customerCallLogUpdated: updateCallLog,
	      routeUpdated: updateRoute,
	      routeDeliveriesUpdated: updateRouteDeliveries,
	      estimatesOnRouteUpdated: updateDeliveryEstimates,
	      routeOptimizationStatusUpdated: updateRouteOptimization,
	      routePositionUpdated: updateDriverPosition,
	      deliveryUpdated: updateDelivery,
	      deliveryDeleted: deleteDelivery
	    });
	
	    return routePlan;
	  };
	
	  var subscribeSystemToPusher = function(downtime) {
	
	    var updateDowntime = function(data) {
	      cache['downtime'] = new Downtime(JSON.parse(data), storage);
	      $rootScope.downtime = cache['downtime'];
	    };
	
	    pusher.subscribeSystem({
	      downtimeUpdated: updateDowntime
	    });
	
	    return downtime;
	  };
	
	  this.saveRoutePlan = function(routePlan) {
	    return http.post('routePlan', routePlan).then(function(data) {
	      var routePlan = new RoutePlan(data, true);
	
	      cache.routePlans && cache.routePlans.push(routePlan);
	      subscribeRoutePlanToPusher(routePlan);
	      $rootScope.routePlans = cache.routePlans;
	
	      return routePlan;
	    });
	  };
	
	  this.saveRoute = function(route) {
	    var url = ['route', route.id];
	    var data = angular.extend({}, route);
	    var oldRoute = cache.routePlan.findRoute(route.id);
	
	    delete data.id;
	    delete data.autoAssignedDriver;
	
	    if (oldRoute.pickupLocationId !== route.pickupLocationId ||
	        oldRoute.overriddenStart !== route.overriddenStart) {
	      oldRoute.resetStats();
	    }
	
	    return http.post(url, data).then(function() {
	      route = angular.extend({}, oldRoute, route);
	
	      // Preserve some data previously extracted from customers
	      route.customerTimeWindows = oldRoute.customerTimeWindows;
	
	      // Reset auto-flagg only if driver changed
	      route.autoAssignedDriver = route.autoAssignedDriver && route.driverUsername === oldRoute.driverUsername;
	
	      cache.routePlan.updateRoute(new Route(route, []));
	      $rootScope.$emit('routeUpdated', route.id);
	    });
	  };
	
	  this.addRoute = function(routePlanId, route) {
	    var url = ['routePlan', routePlanId, 'route'];
	
	    return http.post(url, route).then(function() {
	      $window.location.reload(true);
	    });
	  };
	
	  this.startOptimization = function(routePlanId, data) {
	    var url = ['routePlan', routePlanId, 'startOptimize'];
	
	    return http.post(url, data, [417]).then(function() {
	      updateCachedRoutePlan(routePlanId, function(routePlan) {
	        routePlan.date = data.date.slice(0, 10);
	        if (! routePlan.statusId) {
	          routePlan.statusId = 1;  // in the Spider queue
	        }
	      });
	    });
	  };
	
	  this.createSuggestedRoutes = function(routePlanId, data) {
	    var url = ['routePlan', routePlanId, 'createSuggestedRoutes'];
	
	    return http.post(url, data, [417]).then(function() {
	      updateCachedRoutePlan(routePlanId, function(routePlan) {
	        routePlan.date = data.date.slice(0, 10);
	        if (! routePlan.statusId) {
	          routePlan.statusId = 9;  // in queue
	        }
	      });
	    });
	  };
	
	  this.saveRouteSequence = function(routePlanId, routes, reloadPlan) {
	    var data = routes.map(function(route) {
	      return {
	        routeId: route.id,
	        stopLocationIdSequence: route.stopLocations
	          .sort(function(stop1, stop2) {
	            return stop1.routeSequence - stop2.routeSequence;
	          })
	          .map(function(stop) {
	            return stop.id;
	          })
	      };
	    });
	
	    routes.forEach(function(route) {
	      route.resetStats();
	    });
	
	    // console.log('saveRouteSequence', data.length, 'routes', data.map(function(route) {
	    //   return route.routeId + ' hadde ' + route.stopLocationIdSequence.reduce(function(count, stopId){ return count + 1 }, 0) + ' stopp';
	    // }).join(', '));
	
	    http.post(['routePlan', routePlanId, 'routeSequences'], data).then(function() {
	      if (reloadPlan) self.reloadRoutePlan(routePlanId);
	    });
	  };
	
	  this.deleteRoutes = function(routePlanId) {
	    updateCachedRoutePlan(routePlanId, function(routePlan) {
	      routePlan.statusId = 0;
	      routePlan.routes = [];
	      routePlan.routeCount = 0;
	      routePlan.stopLocationCount = 0;
	    });
	
	    http.delete(['routePlan', routePlanId, 'routes']);
	  };
	
	  this.deleteRoutePlan = function(routePlanId) {
	    if (cache.routePlans) {
	      for (var i = 0; i < cache.routePlans.length; i++) {
	        if (cache.routePlans[i].id === routePlanId) {
	          cache.routePlans.splice(i, 1);
	          break;
	        }
	      }
	    }
	    if (cache.distribution) {
	      // console.log('cache.distribution', cache.distribution);
	      for (var i = 0; i < cache.distribution.routePlans.length; i++) {
	        if (cache.distribution.routePlans[i].id === routePlanId) {
	          cache.distribution.routePlans.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    if (cache.routePlan && cache.routePlan.id === routePlanId) {
	      cache.routePlan = null;
	    }
	
	    http.delete(['routePlan', routePlanId]);
	  };
	
	  this.deleteRoute = function(routeId) {
	    http.delete(['route', routeId]).then(function() {
	      updateCachedRoutePlan(cache.routePlan.id, function(routePlan) {
	        if (routePlan.routes) {
	          // "routes" exists for "cache.routePlan", but not for plan in "cache.routePlans"
	          routePlan.routes = routePlan.routes.filter(function(route) {
	            return route.id !== routeId;
	          });
	        }
	        routePlan.routeCount--;
	      });
	    });
	  };
	
	  this.enableDriverInputForRoutePlan = function(routePlanId) {
	    var url = ['routePlan', routePlanId, 'readyForDriverInput'];
	
	    return http.post(url).then(function() {
	      self.reloadRoutePlan(routePlanId);
	    });
	  };
	
	  this.publishRoutePlan = function(routePlanId) {
	    var url = ['routePlan', routePlanId, 'publish'];
	
	    return http.post(url).then(function() {
	      self.reloadRoutePlan(routePlanId);
	    });
	  };
	
	  this.unpublishRoutePlan = function(routePlanId) {
	    var url = ['routePlan', routePlanId, 'unpublish'];
	
	    return http.post(url).then(function() {
	      self.reloadRoutePlan(routePlanId);
	    });
	  };
	
	  this.reloadRoutePlan = function(routePlanId, force) {
	
	    var updateRoutePlans = function(routePlan) {
	      cache.routePlans && cache.routePlans.forEach(function(rp) {
	        if (rp.id === routePlanId) {
	          angular.extend(rp, new RoutePlan(routePlan, true));
	        }
	      });
	    };
	
	    if (! cache.routePlan || cache.routePlan.id === routePlanId) {
	      cache.routePlan = null;
	      return this.routePlan(routePlanId).then(function(routePlan) {
	        updateRoutePlans(routePlan);
	        return routePlan;
	      });
	    } else if (force) {
	      cache.routePlans = null;
	      this.routePlans();
	      $timeout(function() {
	        $rootScope.$apply();
	      });
	    }
	  };
	
	  this.createFile = function(routePlanId, customerSystemId, name) {
	
	    var addFile = function(data) {
	      var file = new File(data);
	
	      updateCachedRoutePlan(routePlanId, function(routePlan) {
	        routePlan.files && ! routePlan.findFile(file.id) && routePlan.files.push(file);
	      });
	
	      return file;
	    };
	
	    var url = ['routePlan', routePlanId, 'customerSystem', customerSystemId];
	
	    return http.post(url, { name: name }).then(addFile);
	  };
	
	  this.uploadFile = function(fileId, file) {
	    // 400 Bad request / 504 Gateway timeout / -1 Network error (probably)
	    return http.postMultipart(['file', fileId], { file: file }, [400, 504, -1]);
	  };
	
	  this.deleteFile = function(file) {
	    $rootScope.routePlan = null;
	    http.delete(['file', file.id])
	      .then(this.reloadRoutePlan.bind(this, file.routePlanId));
	  };
	
	  this.deleteCustomer = function($scope, customer) {
	    var currentPlanId = $scope.routePlan && $scope.routePlan.id;
	    if (currentPlanId) {
	      $scope.routePlan = null; // To get spinner
	      http.delete(['customer', customer.id]).then(function () {
	        cache.routePlans = null;
	        cache.routePlan = null;
	        self.reloadRoutePlan(currentPlanId).then(function (routePlan) {
	          if (currentPlanId === routePlan.id) { // Double-check that we still are on same plan, and havn't navigated to another
	            $scope.routePlan = routePlan;
	          }
	        });
	      });
	    }
	  };
	
	  this.cancelCustomer = function($scope, customerId) {
	    var currentPlanId = $scope.routePlan && $scope.routePlan.id;
	    if (currentPlanId) {
	      $scope.routePlan = null; // To get spinner
	      return http.post(['customer', customerId, 'cancel']).then(function () {
	        cache.routePlans = null; // To be sure that counts on plan are updated
	        cache.routePlan = null;
	        self.reloadRoutePlan(currentPlanId).then(function (routePlan) {
	          if (currentPlanId === routePlan.id) { // Double-check that we still are on same plan, and havn't navigated to another
	            $scope.routePlan = routePlan;
	          }
	        });
	      });
	    }
	  };
	
	  this.saveCustomer = function($scope, customer) {
	    var currentPlanId = $scope.routePlan && $scope.routePlan.id;
	    if (currentPlanId) {
	      $scope.routePlan = null; // To get spinner
	      return http.post(['routePlan', 'customer'], customer).then(function() {
	        cache.routePlans = null; // To be sure that counts on plan are updated
	        cache.routePlan = null;
	        self.reloadRoutePlan(currentPlanId).then(function(routePlan) {
	          if (currentPlanId === routePlan.id) { // Double-check that we still are on same plan, and havn't navigated to another
	            $scope.routePlan = routePlan;
	          }
	        });
	      });
	    }
	  };
	
	  this.saveDriverUser = function(user) {
	    var urlArr = ['userAdmin', 'company', companyId(), 'driver'];
	    if (!user.isNewUser)
	      urlArr.push(user.userName);
	
	    var cleanedUser = {
	      userName: user.userName,
	      firstName: user.firstName,
	      lastName: user.lastName,
	      phone: user.phone,
	      email: user.email,
	      active: user.active,
	      language: user.language,
	    };
	
	    return http.post(urlArr, cleanedUser, [400]);
	  };
	
	  this.generateAndSendPasswordForDriverUser = function(username) {
	    return http.post(['userAdmin', 'company', companyId(), 'driver', username, 'generatePassword']);
	  };
	
	  this.optimizeRoute = function(routeId) {
	    return http.post(['route', routeId, 'queueForOptimization']);
	  };
	
	  this.optimizeRouteWithOptions = function(routeId, firstStopId, lastStopId) {
	    return http.post(['route', routeId, 'queueForOptimization'], {
	      forcedFirstStopLocationId: firstStopId,
	      forcedLastStopLocationId: lastStopId
	    });
	  };
	
	  this.optimizeAllNeededRoutes = function(routePlanId) {
	    return http.post(['routePlan', routePlanId, 'queueAllNeededRoutesForOptimization']);
	  };
	
	  this.clearTimeWindowsAndOptimizeRoute = function(routeId) {
	    return http.post(['route', routeId, 'clearTimeWindowsAndQueueForOptimization']);
	  };
	
	  var companyId = function() {
	    return $rootScope.auth.companyId || $rootScope.auth.companyIds && $rootScope.auth.companyIds.length && $rootScope.auth.companyIds[0] || 0;
	  };
	
	  var customerSystemId = function() {
	    return $rootScope.auth.customerSystemIds && $rootScope.auth.customerSystemIds[0];
	  };
	
	  var customerSystemIdsStr = function() {
	    if ($rootScope.auth.customerSystemIds) {
	      return $rootScope.auth.customerSystemIds.reduce(function(idsStr, id) {
	        if (idsStr) idsStr += '-';
	        return idsStr + id;
	      }, '');
	    }
	    return $rootScope.auth.customerSystemIds;
	  };
	
	  this.getDowntime = function(){
	    var toDowntime = function(data) {
	      return new Downtime(data, storage);
	    };
	
	    return loadAndCache('downtime', 'downtime', toDowntime)
	      .then(subscribeSystemToPusher);
	  };
	
	  this.saveDowntime = function(downtime) {
	    return http.post(['downtime'], downtime);
	  };
	
	  this.incrementPrint = function(routePlanId, username) {
	    return http.post(['routePlan', routePlanId, 'incrementPrint', username]);
	  };
	
	  this.getPlanRoutes = function(routePlanId) {
	
	    var url;
	
	    if ($rootScope.auth.roles.planner) {
	        url = ['routePlan', routePlanId];
	    } else {
	        url = ['customerSystem', customerSystemIdsStr(), 'routePlan', routePlanId];
	    }
	
	    return http.get(url).then(function(data) {
	      return new RoutePlan(data);
	    });
	  };
	
	}
	
	module.exports = load;


/***/ },
/* 200 */
/***/ function(module, exports) {

	loadScript.$inject = ['$document', '$q'];
	
	function loadScript($document, $q) {
	
	  var scriptPromise = {};
	
	  var load = function(src) {
	    var script = $document[0].createElement('script');
	    var deferred = $q.defer();
	
	    script.onload = function() {
	      scriptPromise[src] = $q.when();
	      deferred.resolve();
	    };
	
	    script.onerror = function(error) {
	      scriptPromise[src] = null;
	      deferred.reject(error);
	    };
	
	    scriptPromise[src] = deferred.promise;
	
	    script.charset = 'utf-8';
	    script.async = true;
	    script.src = src;
	
	    $document[0].head.appendChild(script);
	  };
	
	  this.load = function(src) {
	    if (! scriptPromise[src]) {
	      load(src);
	    }
	
	    return scriptPromise[src];
	  };
	
	  this.loadAll = function(scripts) {
	    return $q.all(
	      scripts.map(function(src) {
	        return this.load(src);
	      }, this)
	    );
	  };
	
	}
	
	module.exports = loadScript;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	var translate = __webpack_require__(4);
	
	loginService.$inject = ['$rootScope', '$window', '$location', 'http', 'storage', 'config'];
	
	function loginService($rootScope, $window, $location, http, storage, config) {
	
	  $rootScope.username = storage.local.get('username');
	
	  $rootScope.autoLogout = function() {
	    storage.local.remove('auth');
	    storage.session.remove('companyId');
	    $window.location.reload();
	  };
	
	  $rootScope.logout = function() {
	    storage.local.remove('auth');
	    storage.session.remove('companyId');
	    $window.location = '#/';
	    $window.location.reload(true);
	  };
	
	  $rootScope.changeCompany = function(companyId) {
	    storage.session.set('companyId', companyId);
	    $window.location = '#/';
	    $window.location.reload(true);
	  };
	
	  $rootScope.changeLanguage = function(languageId) {
	    storage.local.set('languageId', languageId);
	    translate.setLanguage(languageId);
	  };
	
	  this.initLanguage = function() {
	    // Get language
	    var languageId = storage.local.get('languageId');
	    if (! languageId) {
	      // Default - set to first language and save to local storage
	      languageId = config.languages[0].id;
	      storage.local.set('languageId', languageId);
	    }
	    translate.setLanguage(languageId); // Set language
	    return languageId;
	  };
	
	  this.initLanguage();
	
	  $rootScope.languageId = translate.getLanguage();
	  $rootScope.languages = config.languages;
	
	  var auth = function(username, password) {
	    return http.post(['auth', 'generate'], {
	      username: username,
	      password: password
	    }, [403]);  // 403 Forbidden
	  };
	
	  this.login = function(scope, username, password) {
	    scope.isLoading = true;
	    auth(username, password)
	      .then(function(data) {
	        var auth = angular.extend({}, data);
	
	        var inRole = function(role) {
	          return !! data.roles.filter(function(r) {
	            return r === role;
	          })[0];
	        };
	
	        auth.roles = {
	          di: inRole('ROLE_di'),
	          plannerPlus: inRole('ROLE_di') || inRole('ROLE_role.planandgo.plannerplus'),
	          planner: inRole('ROLE_di') || inRole('ROLE_role.planandgo.plannerplus') || inRole('ROLE_role.planandgo.planner'),
	          fleetManager: inRole('ROLE_di') || inRole('ROLE_role.planandgo.plannerplus') || inRole('ROLE_role.planandgo.planner') || inRole('ROLE_role.planandgo.fleetmanager'),
	          clientPlus: !! auth.customerSystemIds && inRole('ROLE_role.planandgo.clientplus'),
	          client: !! auth.customerSystemIds && (inRole('ROLE_role.planandgo.clientplus') || inRole('ROLE_role.planandgo.client')),
	          customerService: inRole('ROLE_role.planandgo.customerservice')
	        };
	
	        if (auth.roles.client) auth.role = 'roleClient';
	        if (auth.roles.clientPlus) auth.role = 'roleClientPlus';
	        if (auth.roles.fleetManager) auth.role = 'roleFleetManager';
	        if (auth.roles.planner) auth.role = 'rolePlanner';
	        if (auth.roles.plannerPlus) auth.role = 'rolePlannerPlus';
	        if (auth.roles.customerService) auth.role = 'roleCustomerService';
	
	        if (! auth.role && inRole('ROLE_role.planandgo.driver')) {
	          // Only driver
	          scope.isLoading = false;
	          scope.errorMsg = translate.t('loginErrorOnlyDriver');
	
	        } else {
	          // Success
	          storage.local.set('auth', auth);
	          storage.local.set('username', username);
	          $rootScope.username = username;
	
	          $location.path('/');
	
	        }
	      })
	      .catch(function(error) {
	        console.warn('login', error);
	        scope.isLoading = false;
	        scope.errorMsg = null;
	        if (!! error.ignoredStatus) {
	          scope.errorMsg = translate.t('loginError'); // Default error
	          if (error.data && error.data.errorKey) {
	            if (error.data.errorKey === 'user.account.expired') {
	              scope.errorMsg = translate.t('loginErrorAccountExpired');
	            } else if (error.data.errorKey === 'user.password.expired') {
	              scope.errorMsg = translate.t('loginErrorPasswordExpired', scope.forgotPasswordURL(username));
	            }
	          }
	        }
	      });
	  };
	
	  var nextUrl;
	
	  this.checkAuth = function() {
	
	    var loadFromStorage = function() {
	      var auth = storage.local.get('auth');
	
	      if (auth) {
	        auth.companyId = storage.session.get('companyId') || auth.companyId || (auth.companyIds && auth.companyIds.length ? auth.companyIds[0] : 0);
	        $rootScope.auth = auth;
	      }
	    };
	
	    $rootScope.$on('$locationChangeStart', function(event, url) {
	      if (! $rootScope.auth) loadFromStorage();
	
	      if (! $rootScope.auth && ! /\blogin\b/.test(url)) {
	        nextUrl = $location.path();
	        $window.location = '/v2/login';
	      } else if ($rootScope.auth && nextUrl) {
	        $location.path(nextUrl).replace();
	        nextUrl = null;
	      }
	    });
	  };
	
	}
	
	module.exports = loginService;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	var modalTemplate = __webpack_require__(89)();
	var confirmTemplate = __webpack_require__(66)();
	
	modal.$inject = ['$compile', '$document'];
	
	function modal($compile, $document) {
	
	  // The options object may contain:
	  // scope [required]
	  // klass
	  // title
	  // body
	  // moveable [boolean]
	  // confirmClose [function]
	  // onClose [function]
	  // onConfirm [function]
	  this.open = function(options) {
	
	    var closeOnEscape = function(event) {
	      if (event.keyCode === 27) { // ESC
	        event.stopImmediatePropagation();
	        close();
	      }
	    };
	
	    var close = function(event) {
	      if (event && event.target !== event.currentTarget) return;
	
	      if (typeof options.confirmClose !== 'function' || options.confirmClose()) {
	        var modals = $document[0].getElementsByClassName('modal');
	
	        if (modals.length === 1) {
	          angular.element($document[0].body).removeClass('modal-open');
	        }
	
	        $document.off('keydown', closeOnEscape);
	        if (destroyMove) destroyMove();
	        angular.element(modals[0]).remove();
	
	        (options.onClose || angular.noop)();
	      }
	    };
	
	    var template = (options.onConfirm ? confirmTemplate : modalTemplate)
	      .replace('{{ klass }}', options.klass || '')
	      .replace('{{ body }}', options.body || '&nbsp;')
	      .replace(/{{ title }}/g, options.title || '&nbsp;');
	
	    var destroyMove;
	
	    options.scope._modal = {
	      close: close,
	      onConfirm: options.onConfirm && function() {
	        options.onConfirm();
	        close();
	      }
	    };
	
	    if (options.moveable) {
	      destroyMove = makeMoveable(options.scope._modal);
	    }
	
	    template = $compile(template)(options.scope);
	
	    angular.element($document[0].body)
	      .prepend(template)
	      .addClass('modal-open');
	
	    $document.on('keydown', closeOnEscape);
	  };
	
	}
	
	function makeMoveable(scope) {
	  var modalWindow = null;
	  var offsetX = 0;
	  var offsetY = 0;
	
	  var isInput = function(tag) {
	    return tag === 'BUTTON' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA';
	  };
	
	  var mouseMove = function(event) {
	    modalWindow.style.position = 'absolute';
	    modalWindow.style.top = (event.clientY - offsetY) + 'px';
	    modalWindow.style.left = (event.clientX - offsetX) + 'px';
	  };
	
	  scope.moveable = true;
	
	  scope.mouseDown = function(event) {
	    // The modal should not move while interacting with an input element
	    if (isInput(event.target.tagName)) return;
	
	    modalWindow = event.currentTarget;
	    offsetY = event.clientY - +modalWindow.offsetTop;
	    offsetX = event.clientX - +modalWindow.offsetLeft;
	
	    angular.element(document.body).addClass('modal-moving');
	    window.addEventListener('mousemove', mouseMove, true);
	  };
	
	  scope.mouseUp = function() {
	    angular.element(document.body).removeClass('modal-moving');
	    window.removeEventListener('mousemove', mouseMove, true);
	  };
	
	  return scope.mouseUp;
	}
	
	module.exports = modal;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var Pusher = __webpack_require__(28);
	
	function pusherService() {
	
	  var pusher = new Pusher(("d096e9f7641650e61051"));
	
	  var routePlanChannels = [];
	  var routePlanIds = {};
	
	  var systemChannel;
	
	  this.subscribeRoutePlan = function(routePlan, events) {
	    if (routePlanIds[routePlan.id]) return;  // Already subscribed
	
	    var channelName = 'routePlan_' + routePlan.id;
	    var channel = subscribe(pusher, [channelName], events);
	
	    routePlanIds[routePlan.id] = true;
	    routePlanChannels.push(channel);
	  };
	
	  this.subscribeSystem = function(events) {
	    if (systemChannel) {
	      return;  // Already subscribed
	    }
	
	    systemChannel = subscribe(pusher, ['system'], events)[0];
	  };
	
	  this.unsubscribeAll = function() {
	    unsubscribe(pusher, routePlanChannels);
	    routePlanIds = {};
	  };
	
	  var unsubscribe = function(pusher, channels) {
	    channels.forEach(function(channelName) {
	      pusher.unsubscribe(channelName);
	    });
	  };
	
	  var subscribe = function(pusher, channelNames, events) {
	    var channels = [];
	
	    channelNames.forEach(function(channelName) {
	      var channel = pusher.subscribe(channelName);
	
	      for (var event in events) {
	        bindEvent(channel, event, events[event]);
	      }
	      channels.push(channelName);
	    });
	
	    return channels;
	  };
	
	  var bindEvent = function(channel, event, callback) {
	    channel.bind(event, function(data) {
	      console.log('Pusher', event, data);
	      callback(data);
	    });
	  };
	
	}
	
	module.exports = pusherService;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	router.$inject = ['$route'];
	
	function router($route) {
	
	  this.config = function($routeProvider) {
	    $routeProvider
	      .when('/', {
	        template: '',
	        controller: 'indexCtrl',
	        page: 'index'
	      })
	      .when('/plans', {
	        template: __webpack_require__(52),
	        controller: 'planCtrl',
	        page: 'plans',
	        title: 'pagePlans'
	      })
	      .when('/settings/driverUsers', {
	        template: __webpack_require__(62),
	        controller: 'driverUsersCtrl',
	        page: 'driverUsers',
	        title: 'pageDrivers'
	      })
	      .when('/settings/users', {
	        template: __webpack_require__(63),
	        controller: 'usersCtrl',
	        page: 'users',
	        title: 'pageUsers'
	      })
	      .when('/settings/cAcknowledgements', {
	        template: __webpack_require__(53),
	        controller: 'settingsCtrl',
	        page: 'settingsCompanyAcknowledgements',
	        title: 'pageSettingsAcknowledgements'
	      })
	      .when('/settings/cNotifications', {
	        template: __webpack_require__(56),
	        controller: 'settingsCtrl',
	        page: 'settingsCompanyNotifications',
	        title: 'pageSettingsNotifications'
	      })
	      .when('/settings/cDeliveryTimes', {
	        template: __webpack_require__(54),
	        controller: 'settingsCtrl',
	        page: 'settingsCompanyDeliveryTimes',
	        title: 'pageSettingsDeliveryTimes'
	      })
	      .when('/settings/cGeneral', {
	        template: __webpack_require__(55),
	        controller: 'settingsCtrl',
	        page: 'settingsCompanyGeneral',
	        title: 'pageSettingsGeneral'
	      })
	      .when('/settings/csGeneral', {
	        template: __webpack_require__(59),
	        controller: 'settingsCtrl',
	        page: 'settingsCustomerSystemGeneral',
	        title: 'pageSettingsGeneral'
	      })
	      .when('/settings/csAcknowledgements', {
	        template: __webpack_require__(57),
	        controller: 'settingsCtrl',
	        page: 'settingsCustomerSystemAcknowledgements',
	        title: 'pageSettingsAcknowledgements'
	      })
	      .when('/settings/csNotifications', {
	        template: __webpack_require__(60),
	        controller: 'settingsCtrl',
	        page: 'settingsCustomerSystemNotifications',
	        title: 'pageSettingsNotifications'
	      })
	      .when('/settings/csDeliveryTimes', {
	        template: __webpack_require__(58),
	        controller: 'settingsCtrl',
	        page: 'settingsCustomerSystemDeliveryTimes',
	        title: 'pageSettingsDeliveryTimes'
	      })
	      .when('/settings/diSystemWarnings', {
	        template: __webpack_require__(61),
	        controller: 'settingsCtrl',
	        page: 'settingsSystemWarnings',
	        title: 'pageSettingsSystemWarnings'
	      })
	      .when('/distributions', {
	        template: __webpack_require__(43),
	        controller: 'distributionCtrl',
	        page: 'distributions',
	        title: 'pageDistributions'
	      })
	      .when('/distribution/:date/:distrNo', {
	        template: __webpack_require__(41),
	        controller: 'distributionCtrl',
	        page: 'distribution'
	      })
	      .when('/distribution/:date/:distrNo/routes', {
	        template: __webpack_require__(42),
	        controller: 'distributionCtrl',
	        page: 'distribution/routes',
	        title: 'pageDistributionRoutes'
	      })
	      .when('/distribution/:date/:distrNo/deviations', {
	        template: __webpack_require__(17),
	        controller: 'distributionCtrl',
	        page: 'distribution/deviations',
	        title: 'pageDistributionDeviations'
	      })
	      .when('/distribution/:date/:distrNo/search', {
	        template: __webpack_require__(17),
	        controller: 'distributionCtrl',
	        page: 'distribution/search'
	      })
	      .when('/plan/files/:routePlanId', {
	        template: __webpack_require__(50),
	        controller: 'planCustomersCtrl',
	        page: 'plan/files',
	        title: 'pageCustomers'
	      })
	      .when('/plan/customers/:routePlanId/:fileId?', {
	        template: __webpack_require__(49),
	        controller: 'planCustomersCtrl',
	        page: 'plan/customers',
	        title: 'pageCustomers'
	      })
	      .when('/plan/routes/map/:routePlanId', {
	        template: __webpack_require__(51),
	        controller: 'planRoutesCtrl',
	        reloadOnSearch: false,
	        page: 'plan/routes/map',
	        title: 'pageRoutesMap'
	      })
	      .when('/plan/routes/list/:routePlanId', {
	        template: __webpack_require__(18),
	        controller: 'planRoutesCtrl',
	        page: 'plan/routes/list',
	        title: 'pageRoutesList'
	      })
	      .when('/plan/reserveroutes/:routePlanId', {
	        template: __webpack_require__(18),
	        controller: 'planRoutesCtrl',
	        page: 'plan/routes/list',
	        title: 'pageReserveRoutes',
	        reserveRoutes: true
	      })
	      .when('/fleet/dashboard/list/:routePlanId', {
	        template: __webpack_require__(44),
	        controller: 'fleetCtrl',
	        page: 'fleet/dashboard/list',
	        title: 'pageDashboardList'
	      })
	      .when('/fleet/dashboard/map/:routePlanId', {
	        template: __webpack_require__(45),
	        controller: 'fleetCtrl',
	        reloadOnSearch: false,
	        page: 'fleet/dashboard/map',
	        title: 'pageDashboardMap'
	      })
	      .when('/fleet/deliveries/:routePlanId/:routeId?/:status?/:search?', {
	        template: __webpack_require__(46),
	        controller: 'fleetCtrl',
	        page: 'fleet/deliveries',
	        title: 'pageCustomers'
	      })
	      .when('/fleet/print/:routePlanId/:routeId?', {
	        template: __webpack_require__(47),
	        controller: 'fleetCtrl',
	        page: 'fleet/print',
	        title: 'pagePrint'
	      })
	      .when('/login', {
	        template: __webpack_require__(48),
	        controller: 'commonCtrl',
	        page: 'login',
	        title: 'pageLogin'
	      })
	      .otherwise({
	        redirectTo: '/'
	      });
	  };
	
	  this.page = function() {
	    return $route.current.page;
	  };
	
	  this.title = function(page) {
	    for (var path in $route.routes) {
	      if ($route.routes[path].page === page) {
	        return $route.routes[path].title;
	      }
	    }
	  };
	
	  this.link = function(page, routePlanId, distribution) {
	    if (page === 'index') return '#/';
	    else if (page === 'settingsUsers') return '#/settings/users';
	    else if (page === 'settingsDriverUsers') return '#/settings/driverUsers';
	    else if (page === 'settingsCompanyAcknowledgements') return '#/settings/cAcknowledgements';
	    else if (page === 'settingsCompanyNotifications') return '#/settings/cNotifications';
	    else if (page === 'settingsCompanyDeliveryTimes') return '#/settings/cDeliveryTimes';
	    else if (page === 'settingsCompanyGeneral') return '#/settings/cGeneral';
	    else if (page === 'settingsCustomerSystemGeneral') return '#/settings/csGeneral';
	    else if (page === 'settingsCustomerSystemAcknowledgements') return '#/settings/csAcknowledgements';
	    else if (page === 'settingsCustomerSystemNotifications') return '#/settings/csNotifications';
	    else if (page === 'settingsCustomerSystemDeliveryTimes') return '#/settings/csDeliveryTimes';
	    else if (page === 'settingsSystemWarnings') return '#/settings/diSystemWarnings';
	    else if (page === 'distributions') return '/v2/distribution';
	    else if (page === 'plans') return '/v2/plans';
	    else if (page === 'deviation') return '/v2/deviation';
	    else if (distribution) return '/v2/distribution/' + distribution.date + '/' + distribution.distrNo;
	    else if (page === 'reserveroutes') return '#/plan/reserveroutes/' + routePlanId;
	    return '#/' + page + '/' + routePlanId;
	  };
	
	  this.availablePages = function(routePlan) {
	    if (! routePlan) return;
	
	    if (routePlan.published) {
	      return ['fleet/dashboard/list', 'fleet/dashboard/map', 'fleet/deliveries'];
	    } else if (routePlan.routeCount) {
	      return ['plan/routes/map', 'plan/routes/list', 'plan/customers'];
	    } else if (routePlan.customerCount) {
	      return ['plan/customers'];
	    } else {
	      return ['plan/files'];
	    }
	  };
	
	  this.nextPage = function(routePlan) {
	    return this.availablePages(routePlan)[0];
	  };
	
	}
	
	module.exports = router;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var serverErrorTemplate = __webpack_require__(105)();
	var t = __webpack_require__(4).t;
	
	serverError.$inject = ['$rootScope', 'modal'];
	
	function serverError($rootScope, modal) {
	
	  var message = function(data) {
	    var match = data.match(/<h1>(.*?)<\/h1>/);
	    var message = match && match[1].replace(/HTTP Status \d+ - /, '');
	
	    return message || data;
	  };
	
	  this.error = function(status, statusText, data, title) {
	    $rootScope.serverError = {
	      status: status,
	      statusText: statusText,
	      data: (typeof data === 'object') && data,
	      message: (typeof data === 'string') ? message(data) : ''
	    };
	
	    modal.open({
	      scope: $rootScope,
	      klass: 'server-error',
	      title: t(title || 'generalErrorHeader'),
	      body: serverErrorTemplate
	    });
	  };
	
	  $rootScope.$on('$routeChangeStart', function() {
	    $rootScope.serverError = undefined;
	  });
	
	}
	
	module.exports = serverError;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var angular = __webpack_require__(2);
	
	storage.$inject = ['$window'];
	
	function storage($window) {
	
	  var prefix = 'DIPlanGo.';
	
	  function getItem(storage, key) {
	    var value = storage.getItem((prefix + key));
	    return value && angular.fromJson(value);
	  }
	
	  function setItem(storage, key, value) {
	    storage.setItem(prefix + key, angular.toJson(value));
	  }
	
	  function removeItem(storage, key) {
	    storage.removeItem(prefix + key);
	  }
	
	  this.local = {
	    get: getItem.bind(null, $window.localStorage),
	    set: setItem.bind(null, $window.localStorage),
	    remove: removeItem.bind(null, $window.localStorage)
	  };
	
	  this.session = {
	    get: getItem.bind(null, $window.sessionStorage),
	    set: setItem.bind(null, $window.sessionStorage),
	    remove: removeItem.bind(null, $window.sessionStorage)
	  };
	
	}
	
	module.exports = storage;


/***/ },
/* 207 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.min.js
 **/